/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  AboutPageDefaultContentTemplateDynamicZoneInput: { input: any; output: any };
  CookiesPageDefaultContentTemplateDynamicZoneInput: { input: any; output: any };
  CopyrightPageDefaultContentTemplateDynamicZoneInput: { input: any; output: any };
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: any; output: any };
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any };
  InsightDefaultContentTemplateDynamicZoneInput: { input: any; output: any };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any };
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  Long: { input: any; output: any };
  PodcastDefaultContentTemplateDynamicZoneInput: { input: any; output: any };
  PrivacyPolicyPageDefaultContentTemplateDynamicZoneInput: { input: any; output: any };
  ResourceDefaultContentTemplateDynamicZoneInput: { input: any; output: any };
  SurveyMethodologyDefaultContentTemplateDynamicZoneInput: { input: any; output: any };
  TermsAndConditionsPageDefaultContentTemplateDynamicZoneInput: { input: any; output: any };
  /** A time string with format HH:mm:ss.SSS */
  Time: { input: any; output: any };
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any };
  WellbeingAwarenessDaysCalendarPageDefaultContentTemplateDynamicZoneInput: { input: any; output: any };
};

export type AboutPage = {
  __typename?: 'AboutPage';
  DefaultContentTemplate: Array<Maybe<AboutPageDefaultContentTemplateDynamicZone>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  pageTitle: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AboutPageDefaultContentTemplateDynamicZone =
  | ComponentCommonAuthor
  | ComponentCommonAuthorDetailed
  | ComponentCommonBullet
  | ComponentCommonDivider
  | ComponentCommonDownloadableContentList
  | ComponentCommonEmbedded
  | ComponentCommonFaqComponent
  | ComponentCommonH3
  | ComponentCommonMedia
  | ComponentCommonQuote
  | ComponentCommonTextEditor
  | ComponentCommonTitle
  | Error;

export type AboutPageEntity = {
  __typename?: 'AboutPageEntity';
  attributes?: Maybe<AboutPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type AboutPageEntityResponse = {
  __typename?: 'AboutPageEntityResponse';
  data?: Maybe<AboutPageEntity>;
};

export type AboutPageInput = {
  DefaultContentTemplate?: InputMaybe<Array<Scalars['AboutPageDefaultContentTemplateDynamicZoneInput']['input']>>;
  pageTitle?: InputMaybe<Scalars['String']['input']>;
};

export type AdminOnboarding = {
  __typename?: 'AdminOnboarding';
  ActivationPoster: ComponentAdminOnboradingActivationPoster;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dashboard?: Maybe<ComponentAdminOnboradingDashboard>;
  schoolManagement: ComponentAdminOnboradingSchoolManagement;
  step1: ComponentAdminOnboradingStep1;
  step2: ComponentAdminOnboradingStep2;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AdminOnboardingEntity = {
  __typename?: 'AdminOnboardingEntity';
  attributes?: Maybe<AdminOnboarding>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type AdminOnboardingEntityResponse = {
  __typename?: 'AdminOnboardingEntityResponse';
  data?: Maybe<AdminOnboardingEntity>;
};

export type AdminOnboardingInput = {
  ActivationPoster?: InputMaybe<ComponentAdminOnboradingActivationPosterInput>;
  dashboard?: InputMaybe<ComponentAdminOnboradingDashboardInput>;
  schoolManagement?: InputMaybe<ComponentAdminOnboradingSchoolManagementInput>;
  step1?: InputMaybe<ComponentAdminOnboradingStep1Input>;
  step2?: InputMaybe<ComponentAdminOnboradingStep2Input>;
};

export type Answer = {
  __typename?: 'Answer';
  answer?: Maybe<Scalars['Int']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  question?: Maybe<QuestionEntityResponse>;
  school?: Maybe<SchoolEntityResponse>;
  survey?: Maybe<SurveyEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<UsersPermissionsUserEntityResponse>;
};

export type AnswerEntity = {
  __typename?: 'AnswerEntity';
  attributes?: Maybe<Answer>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type AnswerEntityResponse = {
  __typename?: 'AnswerEntityResponse';
  data?: Maybe<AnswerEntity>;
};

export type AnswerEntityResponseCollection = {
  __typename?: 'AnswerEntityResponseCollection';
  data: Array<AnswerEntity>;
  meta: ResponseCollectionMeta;
};

export type AnswerFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<AnswerFiltersInput>>>;
  answer?: InputMaybe<IntFilterInput>;
  comment?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<AnswerFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<AnswerFiltersInput>>>;
  question?: InputMaybe<QuestionFiltersInput>;
  school?: InputMaybe<SchoolFiltersInput>;
  survey?: InputMaybe<SurveyFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type AnswerInput = {
  answer?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['ID']['input']>;
  school?: InputMaybe<Scalars['ID']['input']>;
  survey?: InputMaybe<Scalars['ID']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type AnswerRelationResponseCollection = {
  __typename?: 'AnswerRelationResponseCollection';
  data: Array<AnswerEntity>;
};

export type AppVersionSetting = {
  __typename?: 'AppVersionSetting';
  androidAppLink?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currentAndroidAppVersion?: Maybe<Scalars['String']['output']>;
  currentIOSAppVersion?: Maybe<Scalars['String']['output']>;
  iosAppLink?: Maybe<Scalars['String']['output']>;
  updateModal?: Maybe<ComponentCommonConfirmModal>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AppVersionSettingEntity = {
  __typename?: 'AppVersionSettingEntity';
  attributes?: Maybe<AppVersionSetting>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type AppVersionSettingEntityResponse = {
  __typename?: 'AppVersionSettingEntityResponse';
  data?: Maybe<AppVersionSettingEntity>;
};

export type AppVersionSettingInput = {
  androidAppLink?: InputMaybe<Scalars['String']['input']>;
  currentAndroidAppVersion?: InputMaybe<Scalars['String']['input']>;
  currentIOSAppVersion?: InputMaybe<Scalars['String']['input']>;
  iosAppLink?: InputMaybe<Scalars['String']['input']>;
  updateModal?: InputMaybe<ComponentCommonConfirmModalInput>;
};

export type Author = {
  __typename?: 'Author';
  avatar: UploadFileEntityResponse;
  bio?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  role?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AuthorEntity = {
  __typename?: 'AuthorEntity';
  attributes?: Maybe<Author>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type AuthorEntityResponse = {
  __typename?: 'AuthorEntityResponse';
  data?: Maybe<AuthorEntity>;
};

export type AuthorEntityResponseCollection = {
  __typename?: 'AuthorEntityResponseCollection';
  data: Array<AuthorEntity>;
  meta: ResponseCollectionMeta;
};

export type AuthorFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<AuthorFiltersInput>>>;
  bio?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<AuthorFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<AuthorFiltersInput>>>;
  role?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type AuthorInput = {
  avatar?: InputMaybe<Scalars['ID']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorRelationResponseCollection = {
  __typename?: 'AuthorRelationResponseCollection';
  data: Array<AuthorEntity>;
};

export type BooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  contains?: InputMaybe<Scalars['Boolean']['input']>;
  containsi?: InputMaybe<Scalars['Boolean']['input']>;
  endsWith?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  eqi?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nei?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BooleanFilterInput>;
  notContains?: InputMaybe<Scalars['Boolean']['input']>;
  notContainsi?: InputMaybe<Scalars['Boolean']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  startsWith?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Calendar = {
  __typename?: 'Calendar';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  eventDays?: Maybe<Array<Maybe<ComponentCommonDays>>>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type CalendarEventDaysArgs = {
  filters?: InputMaybe<ComponentCommonDaysFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CalendarEntity = {
  __typename?: 'CalendarEntity';
  attributes?: Maybe<Calendar>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CalendarEntityResponse = {
  __typename?: 'CalendarEntityResponse';
  data?: Maybe<CalendarEntity>;
};

export type CalendarEntityResponseCollection = {
  __typename?: 'CalendarEntityResponseCollection';
  data: Array<CalendarEntity>;
  meta: ResponseCollectionMeta;
};

export type CalendarFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CalendarFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  eventDays?: InputMaybe<ComponentCommonDaysFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<CalendarFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CalendarFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  year?: InputMaybe<IntFilterInput>;
};

export type CalendarInput = {
  eventDays?: InputMaybe<Array<InputMaybe<ComponentCommonDaysInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type Category = {
  __typename?: 'Category';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CategoryEntity = {
  __typename?: 'CategoryEntity';
  attributes?: Maybe<Category>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CategoryEntityResponse = {
  __typename?: 'CategoryEntityResponse';
  data?: Maybe<CategoryEntity>;
};

export type CategoryEntityResponseCollection = {
  __typename?: 'CategoryEntityResponseCollection';
  data: Array<CategoryEntity>;
  meta: ResponseCollectionMeta;
};

export type CategoryFiltersInput = {
  _softDeletedAt?: InputMaybe<DateTimeFilterInput>;
  _softDeletedById?: InputMaybe<IntFilterInput>;
  _softDeletedByType?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<CategoryFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CategoryFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CategoryInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CompletedTask = {
  __typename?: 'CompletedTask';
  answer?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  day: Scalars['Date']['output'];
  done: Scalars['Boolean']['output'];
  metadata: Scalars['JSON']['output'];
  relationID: Scalars['Int']['output'];
  type: Enum_Completedtask_Type;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<UsersPermissionsUserEntityResponse>;
};

export type CompletedTaskEntity = {
  __typename?: 'CompletedTaskEntity';
  attributes?: Maybe<CompletedTask>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CompletedTaskEntityResponse = {
  __typename?: 'CompletedTaskEntityResponse';
  data?: Maybe<CompletedTaskEntity>;
};

export type CompletedTaskEntityResponseCollection = {
  __typename?: 'CompletedTaskEntityResponseCollection';
  data: Array<CompletedTaskEntity>;
  meta: ResponseCollectionMeta;
};

export type CompletedTaskFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CompletedTaskFiltersInput>>>;
  answer?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  day?: InputMaybe<DateFilterInput>;
  done?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  metadata?: InputMaybe<JsonFilterInput>;
  not?: InputMaybe<CompletedTaskFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CompletedTaskFiltersInput>>>;
  relationID?: InputMaybe<IntFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type CompletedTaskInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  day?: InputMaybe<Scalars['Date']['input']>;
  done?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  relationID?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Enum_Completedtask_Type>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentAdminOnboradingActivationPoster = {
  __typename?: 'ComponentAdminOnboradingActivationPoster';
  id: Scalars['ID']['output'];
  pdfTemplate: Scalars['String']['output'];
};

export type ComponentAdminOnboradingActivationPosterInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  pdfTemplate?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentAdminOnboradingChartsTitles = {
  __typename?: 'ComponentAdminOnboradingChartsTitles';
  dailyUsers?: Maybe<Scalars['String']['output']>;
  featureUsage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mostUsedFeatures?: Maybe<Scalars['String']['output']>;
  schoolMood?: Maybe<Scalars['String']['output']>;
};

export type ComponentAdminOnboradingChartsTitlesInput = {
  dailyUsers?: InputMaybe<Scalars['String']['input']>;
  featureUsage?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  mostUsedFeatures?: InputMaybe<Scalars['String']['input']>;
  schoolMood?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentAdminOnboradingDashboard = {
  __typename?: 'ComponentAdminOnboradingDashboard';
  allSchools?: Maybe<Scalars['String']['output']>;
  chartsTitles?: Maybe<ComponentAdminOnboradingChartsTitles>;
  header?: Maybe<ComponentAdminOnboradingHeader>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentAdminOnboradingDashboardInput = {
  allSchools?: InputMaybe<Scalars['String']['input']>;
  chartsTitles?: InputMaybe<ComponentAdminOnboradingChartsTitlesInput>;
  header?: InputMaybe<ComponentAdminOnboradingHeaderInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentAdminOnboradingFinishingCardEmotionWheel = {
  __typename?: 'ComponentAdminOnboradingFinishingCardEmotionWheel';
  days?: Maybe<Scalars['String']['output']>;
  emotions?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  trackAgain?: Maybe<Scalars['String']['output']>;
  youHaveTracked?: Maybe<Scalars['String']['output']>;
  yourCalendar?: Maybe<Scalars['String']['output']>;
  yourStreak?: Maybe<Scalars['String']['output']>;
};

export type ComponentAdminOnboradingFinishingCardEmotionWheelInput = {
  days?: InputMaybe<Scalars['String']['input']>;
  emotions?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  trackAgain?: InputMaybe<Scalars['String']['input']>;
  youHaveTracked?: InputMaybe<Scalars['String']['input']>;
  yourCalendar?: InputMaybe<Scalars['String']['input']>;
  yourStreak?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentAdminOnboradingHeader = {
  __typename?: 'ComponentAdminOnboradingHeader';
  engagementPastWeek?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  overallMood?: Maybe<Scalars['String']['output']>;
  surveysResponse?: Maybe<Scalars['String']['output']>;
  totalUsers?: Maybe<Scalars['String']['output']>;
};

export type ComponentAdminOnboradingHeaderInput = {
  engagementPastWeek?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  overallMood?: InputMaybe<Scalars['String']['input']>;
  surveysResponse?: InputMaybe<Scalars['String']['input']>;
  totalUsers?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentAdminOnboradingInvitationPreview = {
  __typename?: 'ComponentAdminOnboradingInvitationPreview';
  closeBtn?: Maybe<Scalars['String']['output']>;
  dialogTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  sendInvitationBtn?: Maybe<Scalars['String']['output']>;
  userPreviewEmailLabel?: Maybe<Scalars['String']['output']>;
  userPreviewForenameLabel?: Maybe<Scalars['String']['output']>;
  userPreviewNoStaffLabel?: Maybe<Scalars['String']['output']>;
  userPreviewSurnameLabel?: Maybe<Scalars['String']['output']>;
};

export type ComponentAdminOnboradingInvitationPreviewInput = {
  closeBtn?: InputMaybe<Scalars['String']['input']>;
  dialogTitle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  sendInvitationBtn?: InputMaybe<Scalars['String']['input']>;
  userPreviewEmailLabel?: InputMaybe<Scalars['String']['input']>;
  userPreviewForenameLabel?: InputMaybe<Scalars['String']['input']>;
  userPreviewNoStaffLabel?: InputMaybe<Scalars['String']['input']>;
  userPreviewSurnameLabel?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentAdminOnboradingInvitationUsingFile = {
  __typename?: 'ComponentAdminOnboradingInvitationUsingFile';
  button?: Maybe<Scalars['String']['output']>;
  closeBtn?: Maybe<Scalars['String']['output']>;
  dialogTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  seePreviewBtn?: Maybe<Scalars['String']['output']>;
  sendInvitationBtn?: Maybe<Scalars['String']['output']>;
  uploadFileBtn?: Maybe<Scalars['String']['output']>;
  uploadSpreadsheetBtn?: Maybe<Scalars['String']['output']>;
  warningMsgDialog?: Maybe<Scalars['String']['output']>;
};

export type ComponentAdminOnboradingInvitationUsingFileInput = {
  button?: InputMaybe<Scalars['String']['input']>;
  closeBtn?: InputMaybe<Scalars['String']['input']>;
  dialogTitle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  seePreviewBtn?: InputMaybe<Scalars['String']['input']>;
  sendInvitationBtn?: InputMaybe<Scalars['String']['input']>;
  uploadFileBtn?: InputMaybe<Scalars['String']['input']>;
  uploadSpreadsheetBtn?: InputMaybe<Scalars['String']['input']>;
  warningMsgDialog?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentAdminOnboradingSchoolManagement = {
  __typename?: 'ComponentAdminOnboradingSchoolManagement';
  btnCopyCodeTxt: Scalars['String']['output'];
  btnCopyMessagTxt: Scalars['String']['output'];
  btnDownloadPdf: Scalars['String']['output'];
  btnImportStaffWondeTxt?: Maybe<Scalars['String']['output']>;
  btnInviteStaffTxt?: Maybe<Scalars['String']['output']>;
  btnShareCodeTxt: Scalars['String']['output'];
  copyPasteTitle: Scalars['String']['output'];
  copyTxtSubTItle: Scalars['String']['output'];
  downloadQrCode: Scalars['String']['output'];
  downloadQrCodeDescription: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invitationPreview?: Maybe<ComponentAdminOnboradingInvitationPreview>;
  invitationUsingFile?: Maybe<ComponentAdminOnboradingInvitationUsingFile>;
  orText?: Maybe<Scalars['String']['output']>;
  sendEmailSubTitle: Scalars['String']['output'];
  shareCodeTitle: Scalars['String']['output'];
  tabs?: Maybe<ComponentAdminOnboradingTabs>;
  template: Scalars['String']['output'];
  toastErrorDownloadingPDFTitle?: Maybe<Scalars['String']['output']>;
  toastPDFDownloadedDescription?: Maybe<Scalars['String']['output']>;
  toastPDFDownloadedTitle?: Maybe<Scalars['String']['output']>;
  toastStaffImportedDescription?: Maybe<Scalars['String']['output']>;
  toastStaffImportedTitle?: Maybe<Scalars['String']['output']>;
  toastStaffInvitedDescription?: Maybe<Scalars['String']['output']>;
  toastStaffInvitedTitle?: Maybe<Scalars['String']['output']>;
  tooltipCopiedMessage?: Maybe<Scalars['String']['output']>;
  welcomeDescription: Scalars['String']['output'];
  welcomeTitle: Scalars['String']['output'];
  yourAccessCode: Scalars['String']['output'];
};

export type ComponentAdminOnboradingSchoolManagementInput = {
  btnCopyCodeTxt?: InputMaybe<Scalars['String']['input']>;
  btnCopyMessagTxt?: InputMaybe<Scalars['String']['input']>;
  btnDownloadPdf?: InputMaybe<Scalars['String']['input']>;
  btnImportStaffWondeTxt?: InputMaybe<Scalars['String']['input']>;
  btnInviteStaffTxt?: InputMaybe<Scalars['String']['input']>;
  btnShareCodeTxt?: InputMaybe<Scalars['String']['input']>;
  copyPasteTitle?: InputMaybe<Scalars['String']['input']>;
  copyTxtSubTItle?: InputMaybe<Scalars['String']['input']>;
  downloadQrCode?: InputMaybe<Scalars['String']['input']>;
  downloadQrCodeDescription?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  invitationPreview?: InputMaybe<ComponentAdminOnboradingInvitationPreviewInput>;
  invitationUsingFile?: InputMaybe<ComponentAdminOnboradingInvitationUsingFileInput>;
  orText?: InputMaybe<Scalars['String']['input']>;
  sendEmailSubTitle?: InputMaybe<Scalars['String']['input']>;
  shareCodeTitle?: InputMaybe<Scalars['String']['input']>;
  tabs?: InputMaybe<ComponentAdminOnboradingTabsInput>;
  template?: InputMaybe<Scalars['String']['input']>;
  toastErrorDownloadingPDFTitle?: InputMaybe<Scalars['String']['input']>;
  toastPDFDownloadedDescription?: InputMaybe<Scalars['String']['input']>;
  toastPDFDownloadedTitle?: InputMaybe<Scalars['String']['input']>;
  toastStaffImportedDescription?: InputMaybe<Scalars['String']['input']>;
  toastStaffImportedTitle?: InputMaybe<Scalars['String']['input']>;
  toastStaffInvitedDescription?: InputMaybe<Scalars['String']['input']>;
  toastStaffInvitedTitle?: InputMaybe<Scalars['String']['input']>;
  tooltipCopiedMessage?: InputMaybe<Scalars['String']['input']>;
  welcomeDescription?: InputMaybe<Scalars['String']['input']>;
  welcomeTitle?: InputMaybe<Scalars['String']['input']>;
  yourAccessCode?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentAdminOnboradingStep1 = {
  __typename?: 'ComponentAdminOnboradingStep1';
  buttonTxt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: UploadFileEntityResponse;
  title: Scalars['String']['output'];
};

export type ComponentAdminOnboradingStep1Input = {
  buttonTxt?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentAdminOnboradingStep2 = {
  __typename?: 'ComponentAdminOnboradingStep2';
  autumTermTitle: Scalars['String']['output'];
  btnText: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  springTerm: Scalars['String']['output'];
  subTitle: Scalars['String']['output'];
  summerTerm: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ComponentAdminOnboradingStep2Input = {
  autumTermTitle?: InputMaybe<Scalars['String']['input']>;
  btnText?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  springTerm?: InputMaybe<Scalars['String']['input']>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  summerTerm?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentAdminOnboradingTabs = {
  __typename?: 'ComponentAdminOnboradingTabs';
  adminManagementTabName?: Maybe<Scalars['String']['output']>;
  announcementsTabName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  manageStaffTabName?: Maybe<Scalars['String']['output']>;
  reportingDashboardTabName?: Maybe<Scalars['String']['output']>;
  surveyDashboardTabName?: Maybe<Scalars['String']['output']>;
};

export type ComponentAdminOnboradingTabsInput = {
  adminManagementTabName?: InputMaybe<Scalars['String']['input']>;
  announcementsTabName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  manageStaffTabName?: InputMaybe<Scalars['String']['input']>;
  reportingDashboardTabName?: InputMaybe<Scalars['String']['input']>;
  surveyDashboardTabName?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentCalendarCalendarFeedbackMessage = {
  __typename?: 'ComponentCalendarCalendarFeedbackMessage';
  calendarNotFound?: Maybe<Scalars['String']['output']>;
  calendarPermissionDenied?: Maybe<Scalars['String']['output']>;
  eventAddedSuccessApple?: Maybe<Scalars['String']['output']>;
  eventAddedSuccessGeneric?: Maybe<Scalars['String']['output']>;
  eventAddedSuccessGoogle?: Maybe<Scalars['String']['output']>;
  eventAlreadyExists?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentCalendarCalendarFeedbackMessageInput = {
  calendarNotFound?: InputMaybe<Scalars['String']['input']>;
  calendarPermissionDenied?: InputMaybe<Scalars['String']['input']>;
  eventAddedSuccessApple?: InputMaybe<Scalars['String']['input']>;
  eventAddedSuccessGeneric?: InputMaybe<Scalars['String']['input']>;
  eventAddedSuccessGoogle?: InputMaybe<Scalars['String']['input']>;
  eventAlreadyExists?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentCalendarPodcast = {
  __typename?: 'ComponentCalendarPodcast';
  id: Scalars['ID']['output'];
  podcast?: Maybe<PodcastEntityResponse>;
};

export type ComponentCalendarRelatedcontentcalendar = {
  __typename?: 'ComponentCalendarRelatedcontentcalendar';
  id: Scalars['ID']['output'];
};

export type ComponentCalendarResource = {
  __typename?: 'ComponentCalendarResource';
  id: Scalars['ID']['output'];
  resource?: Maybe<ResourceEntityResponse>;
};

export type ComponentCommonAudio = {
  __typename?: 'ComponentCommonAudio';
  audio: UploadFileEntityResponse;
  id: Scalars['ID']['output'];
  transcription?: Maybe<Scalars['String']['output']>;
};

export type ComponentCommonAudioFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonAudioFiltersInput>>>;
  not?: InputMaybe<ComponentCommonAudioFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonAudioFiltersInput>>>;
  transcription?: InputMaybe<StringFilterInput>;
};

export type ComponentCommonAudioInput = {
  audio?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  transcription?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentCommonAuthor = {
  __typename?: 'ComponentCommonAuthor';
  author?: Maybe<AuthorEntityResponse>;
  id: Scalars['ID']['output'];
  publicationDate: Scalars['Date']['output'];
};

export type ComponentCommonAuthorDetailed = {
  __typename?: 'ComponentCommonAuthorDetailed';
  authors?: Maybe<AuthorRelationResponseCollection>;
  id: Scalars['ID']['output'];
};

export type ComponentCommonAuthorDetailedAuthorsArgs = {
  filters?: InputMaybe<AuthorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentCommonBreadcrumb = {
  __typename?: 'ComponentCommonBreadcrumb';
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type ComponentCommonBullet = {
  __typename?: 'ComponentCommonBullet';
  id: Scalars['ID']['output'];
  item: Array<Maybe<ComponentCommonList>>;
};

export type ComponentCommonBulletItemArgs = {
  filters?: InputMaybe<ComponentCommonListFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentCommonButton = {
  __typename?: 'ComponentCommonButton';
  id: Scalars['ID']['output'];
  link: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type ComponentCommonButtonInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentCommonConfirmModal = {
  __typename?: 'ComponentCommonConfirmModal';
  cancelButton?: Maybe<Scalars['String']['output']>;
  confirmButton?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentCommonConfirmModalInput = {
  cancelButton?: InputMaybe<Scalars['String']['input']>;
  confirmButton?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentCommonContentTemplateLabels = {
  __typename?: 'ComponentCommonContentTemplateLabels';
  downloadableContentLabel?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentCommonContentTemplateLabelsInput = {
  downloadableContentLabel?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentCommonDays = {
  __typename?: 'ComponentCommonDays';
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  related_podcast?: Maybe<PodcastEntityResponse>;
  related_resource?: Maybe<ResourceEntityResponse>;
  startDate: Scalars['Date']['output'];
  wholeMonth?: Maybe<Scalars['Boolean']['output']>;
};

export type ComponentCommonDaysFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonDaysFiltersInput>>>;
  endDate?: InputMaybe<DateFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCommonDaysFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonDaysFiltersInput>>>;
  related_podcast?: InputMaybe<PodcastFiltersInput>;
  related_resource?: InputMaybe<ResourceFiltersInput>;
  startDate?: InputMaybe<DateFilterInput>;
  wholeMonth?: InputMaybe<BooleanFilterInput>;
};

export type ComponentCommonDaysInput = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  related_podcast?: InputMaybe<Scalars['ID']['input']>;
  related_resource?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  wholeMonth?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentCommonDefaultContentTemplate = {
  __typename?: 'ComponentCommonDefaultContentTemplate';
  divider?: Maybe<Array<Maybe<ComponentCommonDivider>>>;
  downloadableContentSection?: Maybe<ComponentDefaultContentTemplateSectionDownloadableContent>;
  id: Scalars['ID']['output'];
};

export type ComponentCommonDefaultContentTemplateDividerArgs = {
  filters?: InputMaybe<ComponentCommonDividerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentCommonDivider = {
  __typename?: 'ComponentCommonDivider';
  id: Scalars['ID']['output'];
};

export type ComponentCommonDividerFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonDividerFiltersInput>>>;
  not?: InputMaybe<ComponentCommonDividerFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonDividerFiltersInput>>>;
};

export type ComponentCommonDownloadableContent = {
  __typename?: 'ComponentCommonDownloadableContent';
  content: UploadFileEntityResponse;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ComponentCommonDownloadableContentFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonDownloadableContentFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCommonDownloadableContentFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonDownloadableContentFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentCommonDownloadableContentInput = {
  content?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentCommonDownloadableContentList = {
  __typename?: 'ComponentCommonDownloadableContentList';
  id: Scalars['ID']['output'];
  list?: Maybe<Array<Maybe<ComponentCommonDownloadableContent>>>;
};

export type ComponentCommonDownloadableContentListListArgs = {
  filters?: InputMaybe<ComponentCommonDownloadableContentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentCommonEmailSent = {
  __typename?: 'ComponentCommonEmailSent';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentCommonEmailSentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentCommonEmbedded = {
  __typename?: 'ComponentCommonEmbedded';
  id: Scalars['ID']['output'];
  link: Scalars['String']['output'];
  provider: Enum_Componentcommonembedded_Provider;
};

export type ComponentCommonEmbeddedFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonEmbeddedFiltersInput>>>;
  link?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCommonEmbeddedFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonEmbeddedFiltersInput>>>;
  provider?: InputMaybe<StringFilterInput>;
};

export type ComponentCommonEmbeddedInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Enum_Componentcommonembedded_Provider>;
};

export type ComponentCommonFaq = {
  __typename?: 'ComponentCommonFaq';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ComponentCommonFaqComponent = {
  __typename?: 'ComponentCommonFaqComponent';
  faq?: Maybe<Array<Maybe<ComponentCommonFaq>>>;
  id: Scalars['ID']['output'];
};

export type ComponentCommonFaqComponentFaqArgs = {
  filters?: InputMaybe<ComponentCommonFaqFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentCommonFaqFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonFaqFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCommonFaqFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonFaqFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentCommonFaqInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentCommonField = {
  __typename?: 'ComponentCommonField';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  placeholder: Scalars['String']['output'];
};

export type ComponentCommonFieldInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentCommonFieldSelect = {
  __typename?: 'ComponentCommonFieldSelect';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<ComponentCommonText>>>;
  placeholder: Scalars['String']['output'];
};

export type ComponentCommonFieldSelectOptionsArgs = {
  filters?: InputMaybe<ComponentCommonTextFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentCommonFieldSelectInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<ComponentCommonTextInput>>>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentCommonGender = {
  __typename?: 'ComponentCommonGender';
  id: Scalars['ID']['output'];
  option: Scalars['String']['output'];
};

export type ComponentCommonH3 = {
  __typename?: 'ComponentCommonH3';
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export type ComponentCommonInPartnershipWith = {
  __typename?: 'ComponentCommonInPartnershipWith';
  id: Scalars['ID']['output'];
  partnership: Scalars['String']['output'];
};

export type ComponentCommonLink = {
  __typename?: 'ComponentCommonLink';
  file?: Maybe<UploadFileEntityResponse>;
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ComponentCommonLinkFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonLinkFiltersInput>>>;
  not?: InputMaybe<ComponentCommonLinkFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonLinkFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type ComponentCommonLinkInput = {
  file?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentCommonLinkList = {
  __typename?: 'ComponentCommonLinkList';
  course?: Maybe<CourseEntityResponse>;
  id: Scalars['ID']['output'];
  mindfulExercise?: Maybe<MeditationEntityResponse>;
  podcast?: Maybe<PodcastEntityResponse>;
  redirectToCalendar?: Maybe<Scalars['Boolean']['output']>;
  redirectToCurrentInsight?: Maybe<Scalars['Boolean']['output']>;
  redirectToCurrentMindfulMinute?: Maybe<Scalars['Boolean']['output']>;
  redirectToEmotionWheel?: Maybe<Scalars['Boolean']['output']>;
  resource?: Maybe<ResourceEntityResponse>;
};

export type ComponentCommonLinkListFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonLinkListFiltersInput>>>;
  course?: InputMaybe<CourseFiltersInput>;
  mindfulExercise?: InputMaybe<MeditationFiltersInput>;
  not?: InputMaybe<ComponentCommonLinkListFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonLinkListFiltersInput>>>;
  podcast?: InputMaybe<PodcastFiltersInput>;
  redirectToCalendar?: InputMaybe<BooleanFilterInput>;
  redirectToCurrentInsight?: InputMaybe<BooleanFilterInput>;
  redirectToCurrentMindfulMinute?: InputMaybe<BooleanFilterInput>;
  redirectToEmotionWheel?: InputMaybe<BooleanFilterInput>;
  resource?: InputMaybe<ResourceFiltersInput>;
};

export type ComponentCommonLinkListInput = {
  course?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  mindfulExercise?: InputMaybe<Scalars['ID']['input']>;
  podcast?: InputMaybe<Scalars['ID']['input']>;
  redirectToCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  redirectToCurrentInsight?: InputMaybe<Scalars['Boolean']['input']>;
  redirectToCurrentMindfulMinute?: InputMaybe<Scalars['Boolean']['input']>;
  redirectToEmotionWheel?: InputMaybe<Scalars['Boolean']['input']>;
  resource?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentCommonList = {
  __typename?: 'ComponentCommonList';
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export type ComponentCommonListFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonListFiltersInput>>>;
  not?: InputMaybe<ComponentCommonListFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonListFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
};

export type ComponentCommonMedia = {
  __typename?: 'ComponentCommonMedia';
  id: Scalars['ID']['output'];
  media: UploadFileEntityResponse;
};

export type ComponentCommonMediaFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonMediaFiltersInput>>>;
  not?: InputMaybe<ComponentCommonMediaFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonMediaFiltersInput>>>;
};

export type ComponentCommonMediaInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  media?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentCommonMessageSection = {
  __typename?: 'ComponentCommonMessageSection';
  comeBackTitle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  youAreDoneTitle: Scalars['String']['output'];
};

export type ComponentCommonMessageSectionInput = {
  comeBackTitle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  youAreDoneTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentCommonMinutes = {
  __typename?: 'ComponentCommonMinutes';
  id: Scalars['ID']['output'];
  minute?: Maybe<Scalars['Int']['output']>;
};

export type ComponentCommonMinutesFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonMinutesFiltersInput>>>;
  minute?: InputMaybe<IntFilterInput>;
  not?: InputMaybe<ComponentCommonMinutesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonMinutesFiltersInput>>>;
};

export type ComponentCommonMinutesInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  minute?: InputMaybe<Scalars['Int']['input']>;
};

export type ComponentCommonMonth = {
  __typename?: 'ComponentCommonMonth';
  days?: Maybe<Array<Maybe<ComponentCommonDays>>>;
  id: Scalars['ID']['output'];
  month: Scalars['String']['output'];
};

export type ComponentCommonMonthDaysArgs = {
  filters?: InputMaybe<ComponentCommonDaysFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentCommonObjectives = {
  __typename?: 'ComponentCommonObjectives';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentCommonObjectivesFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonObjectivesFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCommonObjectivesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonObjectivesFiltersInput>>>;
};

export type ComponentCommonObjectivesInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentCommonObjectivesSection = {
  __typename?: 'ComponentCommonObjectivesSection';
  id: Scalars['ID']['output'];
  objectives?: Maybe<Array<Maybe<ComponentCommonObjectives>>>;
  title: Scalars['String']['output'];
};

export type ComponentCommonObjectivesSectionObjectivesArgs = {
  filters?: InputMaybe<ComponentCommonObjectivesFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentCommonObjectivesSectionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonObjectivesSectionFiltersInput>>>;
  not?: InputMaybe<ComponentCommonObjectivesSectionFiltersInput>;
  objectives?: InputMaybe<ComponentCommonObjectivesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonObjectivesSectionFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentCommonObjectivesSectionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  objectives?: InputMaybe<Array<InputMaybe<ComponentCommonObjectivesInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentCommonQuote = {
  __typename?: 'ComponentCommonQuote';
  id: Scalars['ID']['output'];
  quote: Scalars['String']['output'];
};

export type ComponentCommonRawTextWithLinks = {
  __typename?: 'ComponentCommonRawTextWithLinks';
  finalState?: Maybe<ComponentEmotionWheelFinalState>;
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type ComponentCommonRawTextWithLinksInput = {
  finalState?: InputMaybe<ComponentEmotionWheelFinalStateInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentCommonRelatedContent = {
  __typename?: 'ComponentCommonRelatedContent';
  id: Scalars['ID']['output'];
};

export type ComponentCommonRoles = {
  __typename?: 'ComponentCommonRoles';
  id: Scalars['ID']['output'];
  role?: Maybe<Scalars['String']['output']>;
};

export type ComponentCommonRolesFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonRolesFiltersInput>>>;
  not?: InputMaybe<ComponentCommonRolesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonRolesFiltersInput>>>;
  role?: InputMaybe<StringFilterInput>;
};

export type ComponentCommonRolesInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentCommonSearchSection = {
  __typename?: 'ComponentCommonSearchSection';
  chooseATopicTitle: Scalars['String']['output'];
  chooseCollectionTitle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  searchInput: Scalars['String']['output'];
  themes?: Maybe<ThemeRelationResponseCollection>;
  title: Scalars['String']['output'];
  topics?: Maybe<TopicRelationResponseCollection>;
  types?: Maybe<Array<Maybe<ComponentCommonTypes>>>;
  whatKindTitle: Scalars['String']['output'];
};

export type ComponentCommonSearchSectionThemesArgs = {
  filters?: InputMaybe<ThemeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentCommonSearchSectionTopicsArgs = {
  filters?: InputMaybe<TopicFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentCommonSearchSectionTypesArgs = {
  filters?: InputMaybe<ComponentCommonTypesFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentCommonSearchSectionInput = {
  chooseATopicTitle?: InputMaybe<Scalars['String']['input']>;
  chooseCollectionTitle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  searchInput?: InputMaybe<Scalars['String']['input']>;
  themes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  topics?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<ComponentCommonTypesInput>>>;
  whatKindTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentCommonSidebarMenu = {
  __typename?: 'ComponentCommonSidebarMenu';
  aboutTitle?: Maybe<Scalars['String']['output']>;
  favouriteTitle?: Maybe<Scalars['String']['output']>;
  helpTitle?: Maybe<Scalars['String']['output']>;
  helpUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logOutTitle?: Maybe<Scalars['String']['output']>;
  profileTitle?: Maybe<Scalars['String']['output']>;
  rateTheAppTitle?: Maybe<Scalars['String']['output']>;
  searchTitle?: Maybe<Scalars['String']['output']>;
  settingTitle?: Maybe<Scalars['String']['output']>;
  wellbeingAwarenessDaysTitle?: Maybe<Scalars['String']['output']>;
};

export type ComponentCommonSidebarMenuInput = {
  aboutTitle?: InputMaybe<Scalars['String']['input']>;
  favouriteTitle?: InputMaybe<Scalars['String']['input']>;
  helpTitle?: InputMaybe<Scalars['String']['input']>;
  helpUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  logOutTitle?: InputMaybe<Scalars['String']['input']>;
  profileTitle?: InputMaybe<Scalars['String']['input']>;
  rateTheAppTitle?: InputMaybe<Scalars['String']['input']>;
  searchTitle?: InputMaybe<Scalars['String']['input']>;
  settingTitle?: InputMaybe<Scalars['String']['input']>;
  wellbeingAwarenessDaysTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentCommonSteps = {
  __typename?: 'ComponentCommonSteps';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: UploadFileEntityResponse;
  textBtn: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ComponentCommonStepsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonStepsFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCommonStepsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonStepsFiltersInput>>>;
  textBtn?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentCommonStepsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  textBtn?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentCommonTags = {
  __typename?: 'ComponentCommonTags';
  id: Scalars['ID']['output'];
};

export type ComponentCommonText = {
  __typename?: 'ComponentCommonText';
  id: Scalars['ID']['output'];
  option: Scalars['String']['output'];
};

export type ComponentCommonTextEditor = {
  __typename?: 'ComponentCommonTextEditor';
  id: Scalars['ID']['output'];
  markdownText?: Maybe<Scalars['String']['output']>;
};

export type ComponentCommonTextEditorFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonTextEditorFiltersInput>>>;
  markdownText?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCommonTextEditorFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonTextEditorFiltersInput>>>;
};

export type ComponentCommonTextEditorInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  markdownText?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentCommonTextFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonTextFiltersInput>>>;
  not?: InputMaybe<ComponentCommonTextFiltersInput>;
  option?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonTextFiltersInput>>>;
};

export type ComponentCommonTextInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  option?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentCommonTheme = {
  __typename?: 'ComponentCommonTheme';
  id: Scalars['ID']['output'];
  theme?: Maybe<Scalars['String']['output']>;
};

export type ComponentCommonTitle = {
  __typename?: 'ComponentCommonTitle';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ComponentCommonTitleText = {
  __typename?: 'ComponentCommonTitleText';
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ComponentCommonToast = {
  __typename?: 'ComponentCommonToast';
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentCommonToastInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentCommonTranscript = {
  __typename?: 'ComponentCommonTranscript';
  id: Scalars['ID']['output'];
};

export type ComponentCommonTranslations = {
  __typename?: 'ComponentCommonTranslations';
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ComponentCommonTypes = {
  __typename?: 'ComponentCommonTypes';
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type ComponentCommonTypesFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCommonTypesFiltersInput>>>;
  not?: InputMaybe<ComponentCommonTypesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCommonTypesFiltersInput>>>;
  type?: InputMaybe<StringFilterInput>;
};

export type ComponentCommonTypesInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentCommonWelcomePageMessage = {
  __typename?: 'ComponentCommonWelcomePageMessage';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ComponentCommonWelcomePageMessageInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentCoursePageLesson = {
  __typename?: 'ComponentCoursePageLesson';
  beginButtonLabel?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lockedButtonlabel?: Maybe<Scalars['String']['output']>;
  watchAgainButtonlabel?: Maybe<Scalars['String']['output']>;
};

export type ComponentCoursePageLessonInput = {
  beginButtonLabel?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lockedButtonlabel?: InputMaybe<Scalars['String']['input']>;
  watchAgainButtonlabel?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentDailyBubblePageActivitySection = {
  __typename?: 'ComponentDailyBubblePageActivitySection';
  btnText: Scalars['String']['output'];
  completedImage?: Maybe<UploadFileEntityResponse>;
  cover: UploadFileEntityResponse;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  subTitle: Scalars['String']['output'];
  thumbnailDefault?: Maybe<UploadFileEntityResponse>;
  title: Scalars['String']['output'];
};

export type ComponentDailyBubblePageDailyInsightSection = {
  __typename?: 'ComponentDailyBubblePageDailyInsightSection';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ComponentDailyBubblePageFinishingCard = {
  __typename?: 'ComponentDailyBubblePageFinishingCard';
  finishingCardEmotionWheel?: Maybe<ComponentAdminOnboradingFinishingCardEmotionWheel>;
  finishingCardInsight?: Maybe<ComponentDailyBubblePageFinishingCardInsight>;
  finishingCardMindfulMinute?: Maybe<ComponentDailyBubblePageFinishingCardMindfulMinute>;
  finishingCardSurvey?: Maybe<ComponentDailyBubblePageFinishingCardSurvey>;
  id: Scalars['ID']['output'];
};

export type ComponentDailyBubblePageFinishingCardInput = {
  finishingCardEmotionWheel?: InputMaybe<ComponentAdminOnboradingFinishingCardEmotionWheelInput>;
  finishingCardInsight?: InputMaybe<ComponentDailyBubblePageFinishingCardInsightInput>;
  finishingCardMindfulMinute?: InputMaybe<ComponentDailyBubblePageFinishingCardMindfulMinuteInput>;
  finishingCardSurvey?: InputMaybe<ComponentDailyBubblePageFinishingCardSurveyInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentDailyBubblePageFinishingCardInsight = {
  __typename?: 'ComponentDailyBubblePageFinishingCardInsight';
  days?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insights?: Maybe<Scalars['String']['output']>;
  readAgain?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  trendingArticles?: Maybe<Scalars['String']['output']>;
  youHaveRead?: Maybe<Scalars['String']['output']>;
  yourStreak?: Maybe<Scalars['String']['output']>;
};

export type ComponentDailyBubblePageFinishingCardInsightInput = {
  days?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  insights?: InputMaybe<Scalars['String']['input']>;
  readAgain?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  trendingArticles?: InputMaybe<Scalars['String']['input']>;
  youHaveRead?: InputMaybe<Scalars['String']['input']>;
  yourStreak?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentDailyBubblePageFinishingCardMindfulMinute = {
  __typename?: 'ComponentDailyBubblePageFinishingCardMindfulMinute';
  days?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  minutes?: Maybe<Scalars['String']['output']>;
  relatedContent?: Maybe<Scalars['String']['output']>;
  startAgain?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  youHaveWatched?: Maybe<Scalars['String']['output']>;
  yourStreak?: Maybe<Scalars['String']['output']>;
};

export type ComponentDailyBubblePageFinishingCardMindfulMinuteInput = {
  days?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  minutes?: InputMaybe<Scalars['String']['input']>;
  relatedContent?: InputMaybe<Scalars['String']['input']>;
  startAgain?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  youHaveWatched?: InputMaybe<Scalars['String']['input']>;
  yourStreak?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentDailyBubblePageFinishingCardSurvey = {
  __typename?: 'ComponentDailyBubblePageFinishingCardSurvey';
  hideThisCard?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  learnMore?: Maybe<Scalars['String']['output']>;
  questions?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  youHaveAnswered?: Maybe<Scalars['String']['output']>;
};

export type ComponentDailyBubblePageFinishingCardSurveyInput = {
  hideThisCard?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  learnMore?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  youHaveAnswered?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentDailyBubblePageHeaderSection = {
  __typename?: 'ComponentDailyBubblePageHeaderSection';
  completedActivitiesMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

export type ComponentDailyBubblePageHeaderSectionInput = {
  completedActivitiesMessage?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentDailyBubblePageOnboardingQuestions = {
  __typename?: 'ComponentDailyBubblePageOnboardingQuestions';
  btnLabel: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ComponentDailyBubblePageOnboardingQuestionsInput = {
  btnLabel?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentDailyBubblePageWelcomeCard = {
  __typename?: 'ComponentDailyBubblePageWelcomeCard';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: UploadFileEntityResponse;
  title: Scalars['String']['output'];
};

export type ComponentDailyBubblePageWelcomeCardInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentDefaultContentTemplateDailyInsightTemplates = {
  __typename?: 'ComponentDefaultContentTemplateDailyInsightTemplates';
  dailyInsightHeading?: Maybe<Scalars['String']['output']>;
  dailyInsightMessage: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentDefaultContentTemplateDailyInsightTemplatesFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentDefaultContentTemplateDailyInsightTemplatesFiltersInput>>>;
  dailyInsightHeading?: InputMaybe<StringFilterInput>;
  dailyInsightMessage?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentDefaultContentTemplateDailyInsightTemplatesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentDefaultContentTemplateDailyInsightTemplatesFiltersInput>>>;
};

export type ComponentDefaultContentTemplateDailyInsightTemplatesInput = {
  dailyInsightHeading?: InputMaybe<Scalars['String']['input']>;
  dailyInsightMessage?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentDefaultContentTemplateEmotionalWheelTemplates = {
  __typename?: 'ComponentDefaultContentTemplateEmotionalWheelTemplates';
  emotionalWheelHeading?: Maybe<Scalars['String']['output']>;
  emotionalWheelMessage: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentDefaultContentTemplateEmotionalWheelTemplatesFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentDefaultContentTemplateEmotionalWheelTemplatesFiltersInput>>>;
  emotionalWheelHeading?: InputMaybe<StringFilterInput>;
  emotionalWheelMessage?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentDefaultContentTemplateEmotionalWheelTemplatesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentDefaultContentTemplateEmotionalWheelTemplatesFiltersInput>>>;
};

export type ComponentDefaultContentTemplateEmotionalWheelTemplatesInput = {
  emotionalWheelHeading?: InputMaybe<Scalars['String']['input']>;
  emotionalWheelMessage?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentDefaultContentTemplateMindfulMinuteTemplates = {
  __typename?: 'ComponentDefaultContentTemplateMindfulMinuteTemplates';
  id: Scalars['ID']['output'];
  mindfulMinuteHeading?: Maybe<Scalars['String']['output']>;
  mindfulMinuteMessage: Scalars['String']['output'];
};

export type ComponentDefaultContentTemplateMindfulMinuteTemplatesFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentDefaultContentTemplateMindfulMinuteTemplatesFiltersInput>>>;
  mindfulMinuteHeading?: InputMaybe<StringFilterInput>;
  mindfulMinuteMessage?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentDefaultContentTemplateMindfulMinuteTemplatesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentDefaultContentTemplateMindfulMinuteTemplatesFiltersInput>>>;
};

export type ComponentDefaultContentTemplateMindfulMinuteTemplatesInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  mindfulMinuteHeading?: InputMaybe<Scalars['String']['input']>;
  mindfulMinuteMessage?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentDefaultContentTemplateNotificationTemplateList = {
  __typename?: 'ComponentDefaultContentTemplateNotificationTemplateList';
  id: Scalars['ID']['output'];
  notificationHeading?: Maybe<Scalars['String']['output']>;
  notificationMessage: Scalars['String']['output'];
};

export type ComponentDefaultContentTemplateNotificationTemplateListFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentDefaultContentTemplateNotificationTemplateListFiltersInput>>>;
  not?: InputMaybe<ComponentDefaultContentTemplateNotificationTemplateListFiltersInput>;
  notificationHeading?: InputMaybe<StringFilterInput>;
  notificationMessage?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentDefaultContentTemplateNotificationTemplateListFiltersInput>>>;
};

export type ComponentDefaultContentTemplateNotificationTemplateListInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  notificationHeading?: InputMaybe<Scalars['String']['input']>;
  notificationMessage?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentDefaultContentTemplatePodcastNotification = {
  __typename?: 'ComponentDefaultContentTemplatePodcastNotification';
  id: Scalars['ID']['output'];
  podcastNotificationHeading?: Maybe<Scalars['String']['output']>;
  podcastNotificationMessage: Scalars['String']['output'];
};

export type ComponentDefaultContentTemplatePodcastNotificationInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  podcastNotificationHeading?: InputMaybe<Scalars['String']['input']>;
  podcastNotificationMessage?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentDefaultContentTemplateResourceNotification = {
  __typename?: 'ComponentDefaultContentTemplateResourceNotification';
  id: Scalars['ID']['output'];
  resourceNotificationHeading?: Maybe<Scalars['String']['output']>;
  resourceNotificationMessage: Scalars['String']['output'];
};

export type ComponentDefaultContentTemplateResourceNotificationInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  resourceNotificationHeading?: InputMaybe<Scalars['String']['input']>;
  resourceNotificationMessage?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentDefaultContentTemplateSectionDownloadableContent = {
  __typename?: 'ComponentDefaultContentTemplateSectionDownloadableContent';
  downlodable_content?: Maybe<Array<Maybe<ComponentCommonDownloadableContent>>>;
  id: Scalars['ID']['output'];
  layout_order?: Maybe<Scalars['Int']['output']>;
};

export type ComponentDefaultContentTemplateSectionDownloadableContentDownlodable_ContentArgs = {
  filters?: InputMaybe<ComponentCommonDownloadableContentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentEmailTemplateWelcomeEmailStaff = {
  __typename?: 'ComponentEmailTemplateWelcomeEmailStaff';
  content?: Maybe<Scalars['String']['output']>;
  fromEmail?: Maybe<Scalars['String']['output']>;
  fromName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  subject?: Maybe<Scalars['String']['output']>;
};

export type ComponentEmailTemplateWelcomeEmailStaffInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  fromEmail?: InputMaybe<Scalars['String']['input']>;
  fromName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentEmotionWheelFinalState = {
  __typename?: 'ComponentEmotionWheelFinalState';
  course?: Maybe<CourseEntityResponse>;
  id: Scalars['ID']['output'];
  mindfulExercise?: Maybe<MeditationEntityResponse>;
  podcast?: Maybe<PodcastEntityResponse>;
  redirectToCalendar?: Maybe<Scalars['Boolean']['output']>;
  redirectToCurrentInsight?: Maybe<Scalars['Boolean']['output']>;
  redirectToCurrentMindfulMinute?: Maybe<Scalars['Boolean']['output']>;
  resource?: Maybe<ResourceEntityResponse>;
};

export type ComponentEmotionWheelFinalStateFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentEmotionWheelFinalStateFiltersInput>>>;
  course?: InputMaybe<CourseFiltersInput>;
  mindfulExercise?: InputMaybe<MeditationFiltersInput>;
  not?: InputMaybe<ComponentEmotionWheelFinalStateFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentEmotionWheelFinalStateFiltersInput>>>;
  podcast?: InputMaybe<PodcastFiltersInput>;
  redirectToCalendar?: InputMaybe<BooleanFilterInput>;
  redirectToCurrentInsight?: InputMaybe<BooleanFilterInput>;
  redirectToCurrentMindfulMinute?: InputMaybe<BooleanFilterInput>;
  resource?: InputMaybe<ResourceFiltersInput>;
};

export type ComponentEmotionWheelFinalStateInput = {
  course?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  mindfulExercise?: InputMaybe<Scalars['ID']['input']>;
  podcast?: InputMaybe<Scalars['ID']['input']>;
  redirectToCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  redirectToCurrentInsight?: InputMaybe<Scalars['Boolean']['input']>;
  redirectToCurrentMindfulMinute?: InputMaybe<Scalars['Boolean']['input']>;
  resource?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentEmotionWheelLevel = {
  __typename?: 'ComponentEmotionWheelLevel';
  description: Scalars['String']['output'];
  emotion: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentEmotionWheelLevelFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentEmotionWheelLevelFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  emotion?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentEmotionWheelLevelFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentEmotionWheelLevelFiltersInput>>>;
};

export type ComponentEmotionWheelLevelInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  emotion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentEmotionWheelLevels = {
  __typename?: 'ComponentEmotionWheelLevels';
  L3?: Maybe<Array<Maybe<ComponentEmotionWheelLevel>>>;
  advice?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  emotion: Scalars['String']['output'];
  finalState?: Maybe<ComponentEmotionWheelFinalState>;
  id: Scalars['ID']['output'];
};

export type ComponentEmotionWheelLevelsL3Args = {
  filters?: InputMaybe<ComponentEmotionWheelLevelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentEmotionWheelLevelsFiltersInput = {
  L3?: InputMaybe<ComponentEmotionWheelLevelFiltersInput>;
  advice?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentEmotionWheelLevelsFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  emotion?: InputMaybe<StringFilterInput>;
  finalState?: InputMaybe<ComponentEmotionWheelFinalStateFiltersInput>;
  not?: InputMaybe<ComponentEmotionWheelLevelsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentEmotionWheelLevelsFiltersInput>>>;
};

export type ComponentEmotionWheelLevelsInput = {
  L3?: InputMaybe<Array<InputMaybe<ComponentEmotionWheelLevelInput>>>;
  advice?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  emotion?: InputMaybe<Scalars['String']['input']>;
  finalState?: InputMaybe<ComponentEmotionWheelFinalStateInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentEmotionWheelMessages = {
  __typename?: 'ComponentEmotionWheelMessages';
  L1?: Maybe<Scalars['String']['output']>;
  L1Title?: Maybe<Scalars['String']['output']>;
  L2?: Maybe<Scalars['String']['output']>;
  L2Title?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initial?: Maybe<Scalars['String']['output']>;
  initialTitle?: Maybe<Scalars['String']['output']>;
  privacyStatement?: Maybe<Scalars['String']['output']>;
};

export type ComponentEmotionWheelMessagesInput = {
  L1?: InputMaybe<Scalars['String']['input']>;
  L1Title?: InputMaybe<Scalars['String']['input']>;
  L2?: InputMaybe<Scalars['String']['input']>;
  L2Title?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  initial?: InputMaybe<Scalars['String']['input']>;
  initialTitle?: InputMaybe<Scalars['String']['input']>;
  privacyStatement?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentEmotionWheelOnboarding = {
  __typename?: 'ComponentEmotionWheelOnboarding';
  id: Scalars['ID']['output'];
  steps?: Maybe<Array<Maybe<ComponentCommonSteps>>>;
};

export type ComponentEmotionWheelOnboardingStepsArgs = {
  filters?: InputMaybe<ComponentCommonStepsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentEmotionWheelOnboardingInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  steps?: InputMaybe<Array<InputMaybe<ComponentCommonStepsInput>>>;
};

export type ComponentEmotionWheelTypeSection = {
  __typename?: 'ComponentEmotionWheelTypeSection';
  id: Scalars['ID']['output'];
  mainGradientFrom: Scalars['String']['output'];
  mainGradientTo: Scalars['String']['output'];
  secondaryGradientFrom: Scalars['String']['output'];
  secondaryGradientTo: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type ComponentEmotionWheelTypeSectionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentEmotionWheelTypeSectionFiltersInput>>>;
  mainGradientFrom?: InputMaybe<StringFilterInput>;
  mainGradientTo?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentEmotionWheelTypeSectionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentEmotionWheelTypeSectionFiltersInput>>>;
  secondaryGradientFrom?: InputMaybe<StringFilterInput>;
  secondaryGradientTo?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
};

export type ComponentEmotionWheelTypeSectionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  mainGradientFrom?: InputMaybe<Scalars['String']['input']>;
  mainGradientTo?: InputMaybe<Scalars['String']['input']>;
  secondaryGradientFrom?: InputMaybe<Scalars['String']['input']>;
  secondaryGradientTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentHomeDailySection = {
  __typename?: 'ComponentHomeDailySection';
  dailyQuoteThankYouTitle?: Maybe<Scalars['String']['output']>;
  dailyQuoteTitle: Scalars['String']['output'];
  emotionWheelBtnLabel: Scalars['String']['output'];
  emotionWheelDescription: Scalars['String']['output'];
  emotionWheelTItle: Scalars['String']['output'];
  emotionWheelThankYouTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insightBtnLabel: Scalars['String']['output'];
  insightDescription: Scalars['String']['output'];
  insightThankYouTitle?: Maybe<Scalars['String']['output']>;
  insightTitle: Scalars['String']['output'];
  mindfulMinuteBtnLabel: Scalars['String']['output'];
  mindfulMinuteDescription: Scalars['String']['output'];
  mindfulMinuteThankYouTitle?: Maybe<Scalars['String']['output']>;
  mindfulMinuteTitle: Scalars['String']['output'];
  prefixInsightCard?: Maybe<Scalars['String']['output']>;
  prefixMindfulMinuteCard?: Maybe<Scalars['String']['output']>;
  questionsFeedbackDescription?: Maybe<Scalars['String']['output']>;
  questionsFeedbackImage?: Maybe<UploadFileEntityResponse>;
  questionsFeedbackPlaceholder?: Maybe<Scalars['String']['output']>;
  questionsFeedbackThanksDisclaimer?: Maybe<Scalars['String']['output']>;
  questionsFeedbackThanksMessage?: Maybe<Scalars['String']['output']>;
  questionsFeedbackTitle?: Maybe<Scalars['String']['output']>;
  questionsSubTitle?: Maybe<Scalars['String']['output']>;
  questionsThankYouTitle?: Maybe<Scalars['String']['output']>;
  questionsTitle?: Maybe<Scalars['String']['output']>;
  titleInsightCard?: Maybe<Scalars['String']['output']>;
  titleMindfulMinuteCard?: Maybe<Scalars['String']['output']>;
};

export type ComponentHomeDailySectionInput = {
  dailyQuoteThankYouTitle?: InputMaybe<Scalars['String']['input']>;
  dailyQuoteTitle?: InputMaybe<Scalars['String']['input']>;
  emotionWheelBtnLabel?: InputMaybe<Scalars['String']['input']>;
  emotionWheelDescription?: InputMaybe<Scalars['String']['input']>;
  emotionWheelTItle?: InputMaybe<Scalars['String']['input']>;
  emotionWheelThankYouTitle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  insightBtnLabel?: InputMaybe<Scalars['String']['input']>;
  insightDescription?: InputMaybe<Scalars['String']['input']>;
  insightThankYouTitle?: InputMaybe<Scalars['String']['input']>;
  insightTitle?: InputMaybe<Scalars['String']['input']>;
  mindfulMinuteBtnLabel?: InputMaybe<Scalars['String']['input']>;
  mindfulMinuteDescription?: InputMaybe<Scalars['String']['input']>;
  mindfulMinuteThankYouTitle?: InputMaybe<Scalars['String']['input']>;
  mindfulMinuteTitle?: InputMaybe<Scalars['String']['input']>;
  prefixInsightCard?: InputMaybe<Scalars['String']['input']>;
  prefixMindfulMinuteCard?: InputMaybe<Scalars['String']['input']>;
  questionsFeedbackDescription?: InputMaybe<Scalars['String']['input']>;
  questionsFeedbackImage?: InputMaybe<Scalars['ID']['input']>;
  questionsFeedbackPlaceholder?: InputMaybe<Scalars['String']['input']>;
  questionsFeedbackThanksDisclaimer?: InputMaybe<Scalars['String']['input']>;
  questionsFeedbackThanksMessage?: InputMaybe<Scalars['String']['input']>;
  questionsFeedbackTitle?: InputMaybe<Scalars['String']['input']>;
  questionsSubTitle?: InputMaybe<Scalars['String']['input']>;
  questionsThankYouTitle?: InputMaybe<Scalars['String']['input']>;
  questionsTitle?: InputMaybe<Scalars['String']['input']>;
  titleInsightCard?: InputMaybe<Scalars['String']['input']>;
  titleMindfulMinuteCard?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentHomeDoneSection = {
  __typename?: 'ComponentHomeDoneSection';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  recommendationTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentHomeDoneSectionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  recommendationTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentHomeSections = {
  __typename?: 'ComponentHomeSections';
  id: Scalars['ID']['output'];
  latestPodcastTitle: Scalars['String']['output'];
  learnTitle: Scalars['String']['output'];
  trendingThisWeekTitle: Scalars['String']['output'];
  wildcardTitle?: Maybe<Scalars['String']['output']>;
  yourDailyBubbleTitle: Scalars['String']['output'];
  yourWeeklyQuestionDescription?: Maybe<Scalars['String']['output']>;
  yourWeeklyQuestionOnboardingTitle?: Maybe<Scalars['String']['output']>;
  yourWeeklyquestionTitle: Scalars['String']['output'];
};

export type ComponentHomeSectionsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  latestPodcastTitle?: InputMaybe<Scalars['String']['input']>;
  learnTitle?: InputMaybe<Scalars['String']['input']>;
  trendingThisWeekTitle?: InputMaybe<Scalars['String']['input']>;
  wildcardTitle?: InputMaybe<Scalars['String']['input']>;
  yourDailyBubbleTitle?: InputMaybe<Scalars['String']['input']>;
  yourWeeklyQuestionDescription?: InputMaybe<Scalars['String']['input']>;
  yourWeeklyQuestionOnboardingTitle?: InputMaybe<Scalars['String']['input']>;
  yourWeeklyquestionTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentHomeStatsAndStreaks = {
  __typename?: 'ComponentHomeStatsAndStreaks';
  emotionWheelTitle: Scalars['String']['output'];
  emotionWheelTotalLabel: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  insightTitle: Scalars['String']['output'];
  insightTotalLabel: Scalars['String']['output'];
  maxStreakDaysLabel: Scalars['String']['output'];
  maxStreakTitle: Scalars['String']['output'];
  mindfulMinuteTitle: Scalars['String']['output'];
  mindfulMinuteTotalLabel: Scalars['String']['output'];
  streakDaysLabel: Scalars['String']['output'];
  streakTitle: Scalars['String']['output'];
  surveyTitle: Scalars['String']['output'];
  surveyTotalLabel: Scalars['String']['output'];
};

export type ComponentHomeStatsAndStreaksInput = {
  emotionWheelTitle?: InputMaybe<Scalars['String']['input']>;
  emotionWheelTotalLabel?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  insightTitle?: InputMaybe<Scalars['String']['input']>;
  insightTotalLabel?: InputMaybe<Scalars['String']['input']>;
  maxStreakDaysLabel?: InputMaybe<Scalars['String']['input']>;
  maxStreakTitle?: InputMaybe<Scalars['String']['input']>;
  mindfulMinuteTitle?: InputMaybe<Scalars['String']['input']>;
  mindfulMinuteTotalLabel?: InputMaybe<Scalars['String']['input']>;
  streakDaysLabel?: InputMaybe<Scalars['String']['input']>;
  streakTitle?: InputMaybe<Scalars['String']['input']>;
  surveyTitle?: InputMaybe<Scalars['String']['input']>;
  surveyTotalLabel?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentHomeWelcomeOverlay = {
  __typename?: 'ComponentHomeWelcomeOverlay';
  btnLabel: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  statsAndStreaks?: Maybe<ComponentHomeStatsAndStreaks>;
  title: Scalars['String']['output'];
};

export type ComponentHomeWelcomeOverlayInput = {
  btnLabel?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  statsAndStreaks?: InputMaybe<ComponentHomeStatsAndStreaksInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentKnowledgeHubAllTimePopularFavouritesSection = {
  __typename?: 'ComponentKnowledgeHubAllTimePopularFavouritesSection';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ComponentKnowledgeHubAllTimePopularFavouritesSectionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentKnowledgeHubHighlightOfTheWeek = {
  __typename?: 'ComponentKnowledgeHubHighlightOfTheWeek';
  id: Scalars['ID']['output'];
};

export type ComponentKnowledgeHubHighlightSections = {
  __typename?: 'ComponentKnowledgeHubHighlightSections';
  allTimePopularFavouritesSection?: Maybe<ComponentKnowledgeHubAllTimePopularFavouritesSection>;
  id: Scalars['ID']['output'];
  trendingThisWeekSection?: Maybe<ComponentKnowledgeHubTrendingThisWeekSection>;
  wellbeingAwarenessDaysSection?: Maybe<ComponentKnowledgeHubWellbeingAwarenessDaysSection>;
};

export type ComponentKnowledgeHubHighlightSectionsInput = {
  allTimePopularFavouritesSection?: InputMaybe<ComponentKnowledgeHubAllTimePopularFavouritesSectionInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  trendingThisWeekSection?: InputMaybe<ComponentKnowledgeHubTrendingThisWeekSectionInput>;
  wellbeingAwarenessDaysSection?: InputMaybe<ComponentKnowledgeHubWellbeingAwarenessDaysSectionInput>;
};

export type ComponentKnowledgeHubResourcesRelated = {
  __typename?: 'ComponentKnowledgeHubResourcesRelated';
  exercises?: Maybe<MeditationRelationResponseCollection>;
  id: Scalars['ID']['output'];
  podcasts?: Maybe<PodcastRelationResponseCollection>;
  resources?: Maybe<ResourceRelationResponseCollection>;
};

export type ComponentKnowledgeHubResourcesRelatedExercisesArgs = {
  filters?: InputMaybe<MeditationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentKnowledgeHubResourcesRelatedPodcastsArgs = {
  filters?: InputMaybe<PodcastFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentKnowledgeHubResourcesRelatedResourcesArgs = {
  filters?: InputMaybe<ResourceFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentKnowledgeHubTrendingThisWeekSection = {
  __typename?: 'ComponentKnowledgeHubTrendingThisWeekSection';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ComponentKnowledgeHubTrendingThisWeekSectionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentKnowledgeHubWellbeingAwarenessDaysSection = {
  __typename?: 'ComponentKnowledgeHubWellbeingAwarenessDaysSection';
  id: Scalars['ID']['output'];
  linkLabel?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ComponentKnowledgeHubWellbeingAwarenessDaysSectionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  linkLabel?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentLearnCourseCategory = {
  __typename?: 'ComponentLearnCourseCategory';
  category?: Maybe<CategoryEntityResponse>;
  id: Scalars['ID']['output'];
};

export type ComponentLearnCourseCompletedSection = {
  __typename?: 'ComponentLearnCourseCompletedSection';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ComponentLearnCourseCompletedSectionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentLearnCourseCompletedSectionFiltersInput>>>;
  message?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentLearnCourseCompletedSectionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentLearnCourseCompletedSectionFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentLearnCourseCompletedSectionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentLearnCourseFields = {
  __typename?: 'ComponentLearnCourseFields';
  field?: Maybe<Enum_Componentlearncoursefields_Field>;
  id: Scalars['ID']['output'];
};

export type ComponentLearnCourseInfoBox = {
  __typename?: 'ComponentLearnCourseInfoBox';
  id: Scalars['ID']['output'];
};

export type ComponentLearnCourseLesson = {
  __typename?: 'ComponentLearnCourseLesson';
  authors?: Maybe<AuthorRelationResponseCollection>;
  description: Scalars['String']['output'];
  downloadableContent?: Maybe<Array<Maybe<ComponentCommonDownloadableContent>>>;
  duration?: Maybe<Scalars['String']['output']>;
  faq?: Maybe<Array<Maybe<ComponentCommonFaq>>>;
  highlightContent?: Maybe<ComponentLearnHighlightContent>;
  id: Scalars['ID']['output'];
  objectivesSection?: Maybe<ComponentCommonObjectivesSection>;
  textContent?: Maybe<ComponentCommonTextEditor>;
  thumbnail: UploadFileEntityResponse;
  title: Scalars['String']['output'];
};

export type ComponentLearnCourseLessonAuthorsArgs = {
  filters?: InputMaybe<AuthorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentLearnCourseLessonDownloadableContentArgs = {
  filters?: InputMaybe<ComponentCommonDownloadableContentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentLearnCourseLessonFaqArgs = {
  filters?: InputMaybe<ComponentCommonFaqFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentLearnCourseLessonFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentLearnCourseLessonFiltersInput>>>;
  authors?: InputMaybe<AuthorFiltersInput>;
  description?: InputMaybe<StringFilterInput>;
  downloadableContent?: InputMaybe<ComponentCommonDownloadableContentFiltersInput>;
  duration?: InputMaybe<StringFilterInput>;
  faq?: InputMaybe<ComponentCommonFaqFiltersInput>;
  highlightContent?: InputMaybe<ComponentLearnHighlightContentFiltersInput>;
  not?: InputMaybe<ComponentLearnCourseLessonFiltersInput>;
  objectivesSection?: InputMaybe<ComponentCommonObjectivesSectionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentLearnCourseLessonFiltersInput>>>;
  textContent?: InputMaybe<ComponentCommonTextEditorFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentLearnCourseLessonInput = {
  authors?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  downloadableContent?: InputMaybe<Array<InputMaybe<ComponentCommonDownloadableContentInput>>>;
  duration?: InputMaybe<Scalars['String']['input']>;
  faq?: InputMaybe<Array<InputMaybe<ComponentCommonFaqInput>>>;
  highlightContent?: InputMaybe<ComponentLearnHighlightContentInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  objectivesSection?: InputMaybe<ComponentCommonObjectivesSectionInput>;
  textContent?: InputMaybe<ComponentCommonTextEditorInput>;
  thumbnail?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentLearnCourseModule = {
  __typename?: 'ComponentLearnCourseModule';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lessons?: Maybe<Array<Maybe<ComponentLearnCourseLesson>>>;
  title: Scalars['String']['output'];
};

export type ComponentLearnCourseModuleLessonsArgs = {
  filters?: InputMaybe<ComponentLearnCourseLessonFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentLearnCourseModuleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentLearnCourseModuleFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  lessons?: InputMaybe<ComponentLearnCourseLessonFiltersInput>;
  not?: InputMaybe<ComponentLearnCourseModuleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentLearnCourseModuleFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentLearnCourseModuleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lessons?: InputMaybe<Array<InputMaybe<ComponentLearnCourseLessonInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentLearnCourseRelatedContent = {
  __typename?: 'ComponentLearnCourseRelatedContent';
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentLearnFeebackSection = {
  __typename?: 'ComponentLearnFeebackSection';
  description: Scalars['String']['output'];
  enterYourFeedback: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  sendFeedback: Scalars['String']['output'];
  submitYourFeedback?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ComponentLearnFeebackSectionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  enterYourFeedback?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  sendFeedback?: InputMaybe<Scalars['String']['input']>;
  submitYourFeedback?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentLearnFeedback = {
  __typename?: 'ComponentLearnFeedback';
  answer?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  question?: Maybe<Scalars['String']['output']>;
};

export type ComponentLearnFeedbackFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentLearnFeedbackFiltersInput>>>;
  answer?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentLearnFeedbackFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentLearnFeedbackFiltersInput>>>;
  question?: InputMaybe<StringFilterInput>;
};

export type ComponentLearnFeedbackInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentLearnHighlightContent = {
  __typename?: 'ComponentLearnHighlightContent';
  audio?: Maybe<ComponentCommonAudio>;
  embedded?: Maybe<ComponentCommonEmbedded>;
  id: Scalars['ID']['output'];
  image?: Maybe<ComponentCommonMedia>;
};

export type ComponentLearnHighlightContentFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentLearnHighlightContentFiltersInput>>>;
  audio?: InputMaybe<ComponentCommonAudioFiltersInput>;
  embedded?: InputMaybe<ComponentCommonEmbeddedFiltersInput>;
  image?: InputMaybe<ComponentCommonMediaFiltersInput>;
  not?: InputMaybe<ComponentLearnHighlightContentFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentLearnHighlightContentFiltersInput>>>;
};

export type ComponentLearnHighlightContentInput = {
  audio?: InputMaybe<ComponentCommonAudioInput>;
  embedded?: InputMaybe<ComponentCommonEmbeddedInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<ComponentCommonMediaInput>;
};

export type ComponentLearnMarkAsCompleteButton = {
  __typename?: 'ComponentLearnMarkAsCompleteButton';
  completedLabel?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  markAsCompleteLabel?: Maybe<Scalars['String']['output']>;
};

export type ComponentLearnMarkAsCompleteButtonInput = {
  completedLabel?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  markAsCompleteLabel?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentLearnModalLeavePage = {
  __typename?: 'ComponentLearnModalLeavePage';
  cancelButton: Scalars['String']['output'];
  confirmButton: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ComponentLearnModalLeavePageInput = {
  cancelButton?: InputMaybe<Scalars['String']['input']>;
  confirmButton?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentLearnNextLesson = {
  __typename?: 'ComponentLearnNextLesson';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ComponentLearnQuestions = {
  __typename?: 'ComponentLearnQuestions';
  id: Scalars['ID']['output'];
  question: Scalars['String']['output'];
};

export type ComponentLearnQuestionsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentLearnQuestionsFiltersInput>>>;
  not?: InputMaybe<ComponentLearnQuestionsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentLearnQuestionsFiltersInput>>>;
  question?: InputMaybe<StringFilterInput>;
};

export type ComponentLearnQuestionsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentLoginLoginFieldErrors = {
  __typename?: 'ComponentLoginLoginFieldErrors';
  id: Scalars['ID']['output'];
  identifierRequired?: Maybe<Scalars['String']['output']>;
  passwordRequired?: Maybe<Scalars['String']['output']>;
};

export type ComponentLoginLoginFieldErrorsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  identifierRequired?: InputMaybe<Scalars['String']['input']>;
  passwordRequired?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentLoginToastMessagesLogin = {
  __typename?: 'ComponentLoginToastMessagesLogin';
  error?: Maybe<ComponentCommonToast>;
  id: Scalars['ID']['output'];
  success?: Maybe<ComponentCommonToast>;
};

export type ComponentLoginToastMessagesLoginInput = {
  error?: InputMaybe<ComponentCommonToastInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  success?: InputMaybe<ComponentCommonToastInput>;
};

export type ComponentMeditationHeader = {
  __typename?: 'ComponentMeditationHeader';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: UploadFileEntityResponse;
  title: Scalars['String']['output'];
};

export type ComponentMeditationHeaderInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentMindfulMinuteCalmBreathing = {
  __typename?: 'ComponentMindfulMinuteCalmBreathing';
  id: Scalars['ID']['output'];
  prompt: Scalars['String']['output'];
  spokenGuidance?: Maybe<UploadFileEntityResponse>;
  title: Scalars['String']['output'];
};

export type ComponentMindfulMinuteCalmBreathingFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentMindfulMinuteCalmBreathingFiltersInput>>>;
  not?: InputMaybe<ComponentMindfulMinuteCalmBreathingFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMindfulMinuteCalmBreathingFiltersInput>>>;
  prompt?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentMindfulMinuteCalmBreathingInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  spokenGuidance?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentMindfulMinuteCalmBreathingPage = {
  __typename?: 'ComponentMindfulMinuteCalmBreathingPage';
  backDailyBubbleButton: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  minutes: Array<Maybe<ComponentCommonMinutes>>;
  pauseButtonLabel?: Maybe<Scalars['String']['output']>;
  playButtonLabel?: Maybe<Scalars['String']['output']>;
  restartButtonLabel?: Maybe<Scalars['String']['output']>;
  startExerciseButton: Scalars['String']['output'];
  stopButtonLabel?: Maybe<Scalars['String']['output']>;
  thankYouTitle: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentMindfulMinuteCalmBreathingPageMinutesArgs = {
  filters?: InputMaybe<ComponentCommonMinutesFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentMindfulMinuteCalmBreathingPageInput = {
  backDailyBubbleButton?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  minutes?: InputMaybe<Array<InputMaybe<ComponentCommonMinutesInput>>>;
  pauseButtonLabel?: InputMaybe<Scalars['String']['input']>;
  playButtonLabel?: InputMaybe<Scalars['String']['input']>;
  restartButtonLabel?: InputMaybe<Scalars['String']['input']>;
  startExerciseButton?: InputMaybe<Scalars['String']['input']>;
  stopButtonLabel?: InputMaybe<Scalars['String']['input']>;
  thankYouTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentMindfulMinuteQuote = {
  __typename?: 'ComponentMindfulMinuteQuote';
  durationInSeconds?: Maybe<Scalars['Long']['output']>;
  id: Scalars['ID']['output'];
  prompt: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ComponentMindfulMinuteQuoteFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentMindfulMinuteQuoteFiltersInput>>>;
  durationInSeconds?: InputMaybe<LongFilterInput>;
  not?: InputMaybe<ComponentMindfulMinuteQuoteFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMindfulMinuteQuoteFiltersInput>>>;
  prompt?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentMindfulMinuteQuoteInput = {
  durationInSeconds?: InputMaybe<Scalars['Long']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentMindfulMinuteQuotePage = {
  __typename?: 'ComponentMindfulMinuteQuotePage';
  backDailyBubbleButton: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  pauseButtonLabel?: Maybe<Scalars['String']['output']>;
  playButtonLabel?: Maybe<Scalars['String']['output']>;
  restartButtonLabel?: Maybe<Scalars['String']['output']>;
  startExerciseButton: Scalars['String']['output'];
  stopButtonLabel?: Maybe<Scalars['String']['output']>;
  thankYouTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentMindfulMinuteQuotePageInput = {
  backDailyBubbleButton?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  pauseButtonLabel?: InputMaybe<Scalars['String']['input']>;
  playButtonLabel?: InputMaybe<Scalars['String']['input']>;
  restartButtonLabel?: InputMaybe<Scalars['String']['input']>;
  startExerciseButton?: InputMaybe<Scalars['String']['input']>;
  stopButtonLabel?: InputMaybe<Scalars['String']['input']>;
  thankYouTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentMindfulMinuteVideo = {
  __typename?: 'ComponentMindfulMinuteVideo';
  id: Scalars['ID']['output'];
  thumbnail?: Maybe<UploadFileEntityResponse>;
  video: UploadFileEntityResponse;
  videoTitle: Scalars['String']['output'];
};

export type ComponentMindfulMinuteVideoFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentMindfulMinuteVideoFiltersInput>>>;
  not?: InputMaybe<ComponentMindfulMinuteVideoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMindfulMinuteVideoFiltersInput>>>;
  videoTitle?: InputMaybe<StringFilterInput>;
};

export type ComponentMindfulMinuteVideoInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  thumbnail?: InputMaybe<Scalars['ID']['input']>;
  video?: InputMaybe<Scalars['ID']['input']>;
  videoTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentMindfulMinuteVideoPage = {
  __typename?: 'ComponentMindfulMinuteVideoPage';
  backDailyBubbleButton: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  thankYouTitle: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentMindfulMinuteVideoPageInput = {
  backDailyBubbleButton?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  thankYouTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentNotificationPreferencePreferences = {
  __typename?: 'ComponentNotificationPreferencePreferences';
  id: Scalars['ID']['output'];
  type: Enum_Componentnotificationpreferencepreferences_Type;
  value: Scalars['Boolean']['output'];
};

export type ComponentOnBoardingOnBoardingContainer = {
  __typename?: 'ComponentOnBoardingOnBoardingContainer';
  button?: Maybe<ComponentCommonButton>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  title: Scalars['String']['output'];
};

export type ComponentOnBoardingOnBoardingContainerInput = {
  button?: InputMaybe<ComponentCommonButtonInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentOnBoardingTimes = {
  __typename?: 'ComponentOnBoardingTimes';
  id: Scalars['ID']['output'];
  time: Scalars['Time']['output'];
  title: Scalars['String']['output'];
};

export type ComponentPodEmailTemplatePoscast = {
  __typename?: 'ComponentPodEmailTemplatePoscast';
  content?: Maybe<Scalars['String']['output']>;
  fromEmail?: Maybe<Scalars['String']['output']>;
  fromName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  subject?: Maybe<Scalars['String']['output']>;
  toEmail?: Maybe<Scalars['String']['output']>;
};

export type ComponentPodEmailTemplatePoscastInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  fromEmail?: InputMaybe<Scalars['String']['input']>;
  fromName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  toEmail?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentPodcastEmailTemplate = {
  __typename?: 'ComponentPodcastEmailTemplate';
  admin?: Maybe<ComponentPodEmailTemplatePoscast>;
  id: Scalars['ID']['output'];
  user?: Maybe<ComponentPodEmailTemplatePoscast>;
};

export type ComponentPodcastEmailTemplateInput = {
  admin?: InputMaybe<ComponentPodEmailTemplatePoscastInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  user?: InputMaybe<ComponentPodEmailTemplatePoscastInput>;
};

export type ComponentPodcastGetInTouch = {
  __typename?: 'ComponentPodcastGetInTouch';
  boxText: Scalars['String']['output'];
  buttonText: Scalars['String']['output'];
  descriptionModal: Scalars['String']['output'];
  emailPlaceholder: Scalars['String']['output'];
  guests?: Maybe<GuestRelationResponseCollection>;
  id: Scalars['ID']['output'];
  submitText: Scalars['String']['output'];
  thanksDescription: Scalars['String']['output'];
  thanksTitle: Scalars['String']['output'];
  titleModal: Scalars['String']['output'];
  yourTextPlaceholder: Scalars['String']['output'];
};

export type ComponentPodcastGetInTouchGuestsArgs = {
  filters?: InputMaybe<GuestFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentPodcastGetInTouchInput = {
  boxText?: InputMaybe<Scalars['String']['input']>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  descriptionModal?: InputMaybe<Scalars['String']['input']>;
  emailPlaceholder?: InputMaybe<Scalars['String']['input']>;
  guests?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  submitText?: InputMaybe<Scalars['String']['input']>;
  thanksDescription?: InputMaybe<Scalars['String']['input']>;
  thanksTitle?: InputMaybe<Scalars['String']['input']>;
  titleModal?: InputMaybe<Scalars['String']['input']>;
  yourTextPlaceholder?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentPodcastIntro = {
  __typename?: 'ComponentPodcastIntro';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  thumbnail: UploadFileEntityResponse;
  title: Scalars['String']['output'];
};

export type ComponentPodcastIntroInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  thumbnail?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentProfileEmotionTrackingSection = {
  __typename?: 'ComponentProfileEmotionTrackingSection';
  btnStartTrackingLabel: Scalars['String']['output'];
  btnStopTrackingLabel: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  notRecordedDescription?: Maybe<Scalars['String']['output']>;
  notRecordedIcon: UploadFileEntityResponse;
  notRecordedLabel: Scalars['String']['output'];
  notTrackingIcon: UploadFileEntityResponse;
  title: Scalars['String']['output'];
};

export type ComponentProfileEmotionTrackingSectionInput = {
  btnStartTrackingLabel?: InputMaybe<Scalars['String']['input']>;
  btnStopTrackingLabel?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  notRecordedDescription?: InputMaybe<Scalars['String']['input']>;
  notRecordedIcon?: InputMaybe<Scalars['ID']['input']>;
  notRecordedLabel?: InputMaybe<Scalars['String']['input']>;
  notTrackingIcon?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentProfilePageFinishingCardEmotions = {
  __typename?: 'ComponentProfilePageFinishingCardEmotions';
  emotions?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentProfilePageFinishingCardEmotionsInput = {
  emotions?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentProfilePageFinishingCardInsights = {
  __typename?: 'ComponentProfilePageFinishingCardInsights';
  id: Scalars['ID']['output'];
  insights?: Maybe<Scalars['String']['output']>;
};

export type ComponentProfilePageFinishingCardInsightsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  insights?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentProfilePageFinishingCardMaxStreak = {
  __typename?: 'ComponentProfilePageFinishingCardMaxStreak';
  days?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentProfilePageFinishingCardMaxStreakInput = {
  days?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentProfilePageFinishingCardMindfulMinutes = {
  __typename?: 'ComponentProfilePageFinishingCardMindfulMinutes';
  id: Scalars['ID']['output'];
  minutes?: Maybe<Scalars['String']['output']>;
};

export type ComponentProfilePageFinishingCardMindfulMinutesInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  minutes?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentProfilePageFinishingCardStreak = {
  __typename?: 'ComponentProfilePageFinishingCardStreak';
  days?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentProfilePageFinishingCardStreakInput = {
  days?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentProfilePageFinishingCardSurvey = {
  __typename?: 'ComponentProfilePageFinishingCardSurvey';
  id: Scalars['ID']['output'];
  questions?: Maybe<Scalars['String']['output']>;
};

export type ComponentProfilePageFinishingCardSurveyInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  questions?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentProfilePageStatsAndStreaks = {
  __typename?: 'ComponentProfilePageStatsAndStreaks';
  finishingCardEmotionWheel?: Maybe<ComponentProfilePageFinishingCardEmotions>;
  finishingCardInsight?: Maybe<ComponentProfilePageFinishingCardInsights>;
  finishingCardMaxStreak?: Maybe<ComponentProfilePageFinishingCardMaxStreak>;
  finishingCardMindfulMinute?: Maybe<ComponentProfilePageFinishingCardMindfulMinutes>;
  finishingCardStreak?: Maybe<ComponentProfilePageFinishingCardStreak>;
  finishingCardSurvey?: Maybe<ComponentProfilePageFinishingCardSurvey>;
  id: Scalars['ID']['output'];
};

export type ComponentProfilePageStatsAndStreaksInput = {
  finishingCardEmotionWheel?: InputMaybe<ComponentProfilePageFinishingCardEmotionsInput>;
  finishingCardInsight?: InputMaybe<ComponentProfilePageFinishingCardInsightsInput>;
  finishingCardMaxStreak?: InputMaybe<ComponentProfilePageFinishingCardMaxStreakInput>;
  finishingCardMindfulMinute?: InputMaybe<ComponentProfilePageFinishingCardMindfulMinutesInput>;
  finishingCardStreak?: InputMaybe<ComponentProfilePageFinishingCardStreakInput>;
  finishingCardSurvey?: InputMaybe<ComponentProfilePageFinishingCardSurveyInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentProfilePolicyLinksSection = {
  __typename?: 'ComponentProfilePolicyLinksSection';
  cookiesTitle?: Maybe<Scalars['String']['output']>;
  copyrightTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  privacyPolicyTitle?: Maybe<Scalars['String']['output']>;
  sectionTitle?: Maybe<Scalars['String']['output']>;
  surveyMethodology?: Maybe<Scalars['String']['output']>;
  termsAndConditionsTitle?: Maybe<Scalars['String']['output']>;
};

export type ComponentProfilePolicyLinksSectionInput = {
  cookiesTitle?: InputMaybe<Scalars['String']['input']>;
  copyrightTitle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  privacyPolicyTitle?: InputMaybe<Scalars['String']['input']>;
  sectionTitle?: InputMaybe<Scalars['String']['input']>;
  surveyMethodology?: InputMaybe<Scalars['String']['input']>;
  termsAndConditionsTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentProfileProfileInfoSection = {
  __typename?: 'ComponentProfileProfileInfoSection';
  editYourInfoCta: Scalars['String']['output'];
  forenamePlaceholder: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  memberSinceTitle: Scalars['String']['output'];
  saveYourChangesCta: Scalars['String']['output'];
  surnamePlaceholder: Scalars['String']['output'];
  youLocationTitle: Scalars['String']['output'];
};

export type ComponentProfileProfileInfoSectionInput = {
  editYourInfoCta?: InputMaybe<Scalars['String']['input']>;
  forenamePlaceholder?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  memberSinceTitle?: InputMaybe<Scalars['String']['input']>;
  saveYourChangesCta?: InputMaybe<Scalars['String']['input']>;
  surnamePlaceholder?: InputMaybe<Scalars['String']['input']>;
  youLocationTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentProfileProfileNotificationsSection = {
  __typename?: 'ComponentProfileProfileNotificationsSection';
  confirmYourChangesCta: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  yourNotificationsTitle: Scalars['String']['output'];
};

export type ComponentProfileProfileNotificationsSectionInput = {
  confirmYourChangesCta?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  yourNotificationsTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentProfileProfilePasswordSection = {
  __typename?: 'ComponentProfileProfilePasswordSection';
  confirmYourChangesCta: Scalars['String']['output'];
  confirmYourPasswordField: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  yourCurrentPasswordField: Scalars['String']['output'];
  yourNewPasswordField: Scalars['String']['output'];
  yourPasswordTitle: Scalars['String']['output'];
};

export type ComponentProfileProfilePasswordSectionInput = {
  confirmYourChangesCta?: InputMaybe<Scalars['String']['input']>;
  confirmYourPasswordField?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  yourCurrentPasswordField?: InputMaybe<Scalars['String']['input']>;
  yourNewPasswordField?: InputMaybe<Scalars['String']['input']>;
  yourPasswordTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentProfileProfileThemesSection = {
  __typename?: 'ComponentProfileProfileThemesSection';
  confirmYouChangesCta: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  whichAreasTitle: Scalars['String']['output'];
  yourFocusTitle: Scalars['String']['output'];
};

export type ComponentProfileProfileThemesSectionInput = {
  confirmYouChangesCta?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  whichAreasTitle?: InputMaybe<Scalars['String']['input']>;
  yourFocusTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentRegisterFeedbackFeedback = {
  __typename?: 'ComponentRegisterFeedbackFeedback';
  emailSent?: Maybe<ComponentCommonEmailSent>;
  id: Scalars['ID']['output'];
  passwordResetError?: Maybe<ComponentCommonEmailSent>;
  passwordResetSuccess?: Maybe<ComponentCommonEmailSent>;
};

export type ComponentRegisterFeedbackFeedbackInput = {
  emailSent?: InputMaybe<ComponentCommonEmailSentInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  passwordResetError?: InputMaybe<ComponentCommonEmailSentInput>;
  passwordResetSuccess?: InputMaybe<ComponentCommonEmailSentInput>;
};

export type ComponentRegisterRegisterFieldErrors = {
  __typename?: 'ComponentRegisterRegisterFieldErrors';
  confirmPasswordDidNotMatch?: Maybe<Scalars['String']['output']>;
  confirmPasswordRequired?: Maybe<Scalars['String']['output']>;
  emailRequired?: Maybe<Scalars['String']['output']>;
  forenameRequired?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  passwordRequired?: Maybe<Scalars['String']['output']>;
  schoolCodeRequired?: Maybe<Scalars['String']['output']>;
  surnameRequired?: Maybe<Scalars['String']['output']>;
  termsAndConditionsRequired?: Maybe<Scalars['String']['output']>;
};

export type ComponentRegisterRegisterFieldErrorsInput = {
  confirmPasswordDidNotMatch?: InputMaybe<Scalars['String']['input']>;
  confirmPasswordRequired?: InputMaybe<Scalars['String']['input']>;
  emailRequired?: InputMaybe<Scalars['String']['input']>;
  forenameRequired?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  passwordRequired?: InputMaybe<Scalars['String']['input']>;
  schoolCodeRequired?: InputMaybe<Scalars['String']['input']>;
  surnameRequired?: InputMaybe<Scalars['String']['input']>;
  termsAndConditionsRequired?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentRegisterToastMessagesRegister = {
  __typename?: 'ComponentRegisterToastMessagesRegister';
  error?: Maybe<ComponentCommonToast>;
  id: Scalars['ID']['output'];
  success?: Maybe<ComponentCommonToast>;
};

export type ComponentRegisterToastMessagesRegisterInput = {
  error?: InputMaybe<ComponentCommonToastInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  success?: InputMaybe<ComponentCommonToastInput>;
};

export type ComponentReportingToolsStaffStatus = {
  __typename?: 'ComponentReportingToolsStaffStatus';
  id: Scalars['ID']['output'];
  invitedPendingSignUpColor?: Maybe<Scalars['String']['output']>;
  invitedPendingSignUpMessage?: Maybe<Scalars['String']['output']>;
  pendingInviteColor?: Maybe<Scalars['String']['output']>;
  pendingInviteMessage?: Maybe<Scalars['String']['output']>;
  registeredOnboardedColor?: Maybe<Scalars['String']['output']>;
  registeredOnboardedMessage?: Maybe<Scalars['String']['output']>;
  registeredPendingOnboardingColor?: Maybe<Scalars['String']['output']>;
  registeredPendingOnboardingMessage?: Maybe<Scalars['String']['output']>;
};

export type ComponentReportingToolsStaffStatusInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  invitedPendingSignUpColor?: InputMaybe<Scalars['String']['input']>;
  invitedPendingSignUpMessage?: InputMaybe<Scalars['String']['input']>;
  pendingInviteColor?: InputMaybe<Scalars['String']['input']>;
  pendingInviteMessage?: InputMaybe<Scalars['String']['input']>;
  registeredOnboardedColor?: InputMaybe<Scalars['String']['input']>;
  registeredOnboardedMessage?: InputMaybe<Scalars['String']['input']>;
  registeredPendingOnboardingColor?: InputMaybe<Scalars['String']['input']>;
  registeredPendingOnboardingMessage?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentReportingToolsUsersEmptyState = {
  __typename?: 'ComponentReportingToolsUsersEmptyState';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentReportingToolsUsersEmptyStateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSchollDomains = {
  __typename?: 'ComponentSchollDomains';
  domain: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentSchollDomainsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSchollDomainsFiltersInput>>>;
  domain?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSchollDomainsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSchollDomainsFiltersInput>>>;
};

export type ComponentSchollDomainsInput = {
  domain?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentSchollTermDates = {
  __typename?: 'ComponentSchollTermDates';
  autumnTermEndDate?: Maybe<Scalars['Date']['output']>;
  autumnTermStartDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  springTermEndDate?: Maybe<Scalars['Date']['output']>;
  springTermStartDate?: Maybe<Scalars['Date']['output']>;
  summerTermEndDate?: Maybe<Scalars['Date']['output']>;
  summerTermStartDate?: Maybe<Scalars['Date']['output']>;
};

export type ComponentSchollTermDatesFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSchollTermDatesFiltersInput>>>;
  autumnTermEndDate?: InputMaybe<DateFilterInput>;
  autumnTermStartDate?: InputMaybe<DateFilterInput>;
  not?: InputMaybe<ComponentSchollTermDatesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSchollTermDatesFiltersInput>>>;
  springTermEndDate?: InputMaybe<DateFilterInput>;
  springTermStartDate?: InputMaybe<DateFilterInput>;
  summerTermEndDate?: InputMaybe<DateFilterInput>;
  summerTermStartDate?: InputMaybe<DateFilterInput>;
};

export type ComponentSchollTermDatesInput = {
  autumnTermEndDate?: InputMaybe<Scalars['Date']['input']>;
  autumnTermStartDate?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  springTermEndDate?: InputMaybe<Scalars['Date']['input']>;
  springTermStartDate?: InputMaybe<Scalars['Date']['input']>;
  summerTermEndDate?: InputMaybe<Scalars['Date']['input']>;
  summerTermStartDate?: InputMaybe<Scalars['Date']['input']>;
};

export type ComponentSchollWondeRoles = {
  __typename?: 'ComponentSchollWondeRoles';
  id: Scalars['ID']['output'];
  role?: Maybe<Scalars['String']['output']>;
};

export type ComponentSchollWondeRolesFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSchollWondeRolesFiltersInput>>>;
  not?: InputMaybe<ComponentSchollWondeRolesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSchollWondeRolesFiltersInput>>>;
  role?: InputMaybe<StringFilterInput>;
};

export type ComponentSchollWondeRolesInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedMetaSocial = {
  __typename?: 'ComponentSharedMetaSocial';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  socialNetwork: Enum_Componentsharedmetasocial_Socialnetwork;
  title: Scalars['String']['output'];
};

export type ComponentSharedMetaSocialFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedMetaSocialFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedMetaSocialFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedMetaSocialFiltersInput>>>;
  socialNetwork?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedSeo = {
  __typename?: 'ComponentSharedSeo';
  canonicalURL?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  keywords?: Maybe<Scalars['String']['output']>;
  metaDescription: Scalars['String']['output'];
  metaImage?: Maybe<UploadFileEntityResponse>;
  metaRobots?: Maybe<Scalars['String']['output']>;
  metaSocial?: Maybe<Array<Maybe<ComponentSharedMetaSocial>>>;
  metaTitle: Scalars['String']['output'];
  metaViewport?: Maybe<Scalars['String']['output']>;
  structuredData?: Maybe<Scalars['JSON']['output']>;
};

export type ComponentSharedSeoMetaSocialArgs = {
  filters?: InputMaybe<ComponentSharedMetaSocialFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSurveyAnswers = {
  __typename?: 'ComponentSurveyAnswers';
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  option?: Maybe<Scalars['String']['output']>;
  scale?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Enum_Componentsurveyanswers_Type>;
};

export type ComponentSurveyAnswersFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSurveyAnswersFiltersInput>>>;
  color?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSurveyAnswersFiltersInput>;
  option?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSurveyAnswersFiltersInput>>>;
  scale?: InputMaybe<IntFilterInput>;
  type?: InputMaybe<StringFilterInput>;
};

export type ComponentSurveyAnswersInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  option?: InputMaybe<Scalars['String']['input']>;
  scale?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Enum_Componentsurveyanswers_Type>;
};

export type ComponentSurveyDashboardDownloadButton = {
  __typename?: 'ComponentSurveyDashboardDownloadButton';
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export type ComponentSurveyDashboardDownloadButtonInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSurveyDashboardSchoolsFilter = {
  __typename?: 'ComponentSurveyDashboardSchoolsFilter';
  allSchools: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  schoolsSelected: Scalars['String']['output'];
};

export type ComponentSurveyDashboardSchoolsFilterInput = {
  allSchools?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  schoolsSelected?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSurveyDashboardTableCategories = {
  __typename?: 'ComponentSurveyDashboardTableCategories';
  answers: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  questionCategory: Scalars['String']['output'];
  questions: Scalars['String']['output'];
  responses: Scalars['String']['output'];
};

export type ComponentSurveyDashboardTableCategoriesInput = {
  answers?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  questionCategory?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Scalars['String']['input']>;
  responses?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSurveyDashboardTableQuestion = {
  __typename?: 'ComponentSurveyDashboardTableQuestion';
  answers: Scalars['String']['output'];
  date: Scalars['String']['output'];
  day: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  questions: Scalars['String']['output'];
  responses: Scalars['String']['output'];
};

export type ComponentSurveyDashboardTableQuestionInput = {
  answers?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  day?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  questions?: InputMaybe<Scalars['String']['input']>;
  responses?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSurveyDashboardTableResponses = {
  __typename?: 'ComponentSurveyDashboardTableResponses';
  category: Scalars['String']['output'];
  date: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  question: Scalars['String']['output'];
  total: Scalars['String']['output'];
};

export type ComponentSurveyDashboardTableResponsesInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  total?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSurveyDashboardTabs = {
  __typename?: 'ComponentSurveyDashboardTabs';
  id: Scalars['ID']['output'];
  responseTable: Scalars['String']['output'];
  surveyResponses: Scalars['String']['output'];
};

export type ComponentSurveyDashboardTabsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  responseTable?: InputMaybe<Scalars['String']['input']>;
  surveyResponses?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSurveyDashboardToggle = {
  __typename?: 'ComponentSurveyDashboardToggle';
  categories: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  questions: Scalars['String']['output'];
};

export type ComponentSurveyDashboardToggleInput = {
  categories?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  questions?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSurveyHolidays = {
  __typename?: 'ComponentSurveyHolidays';
  date: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentSurveyRepetableSurvey = {
  __typename?: 'ComponentSurveyRepetableSurvey';
  endDate?: Maybe<Scalars['DateTime']['output']>;
  frequency?: Maybe<Enum_Componentsurveyrepetablesurvey_Frequency>;
  id: Scalars['ID']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ComponentSurveySingleSurvey = {
  __typename?: 'ComponentSurveySingleSurvey';
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ComponentWildcardAnnouncementActions = {
  __typename?: 'ComponentWildcardAnnouncementActions';
  deleteBtn?: Maybe<Scalars['String']['output']>;
  duplicateBtn?: Maybe<Scalars['String']['output']>;
  editBtn?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  publishBtn?: Maybe<Scalars['String']['output']>;
  unpublishBtn?: Maybe<Scalars['String']['output']>;
};

export type ComponentWildcardAnnouncementActionsInput = {
  deleteBtn?: InputMaybe<Scalars['String']['input']>;
  duplicateBtn?: InputMaybe<Scalars['String']['input']>;
  editBtn?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  publishBtn?: InputMaybe<Scalars['String']['input']>;
  unpublishBtn?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentWildcardAnnouncementDeleteDialog = {
  __typename?: 'ComponentWildcardAnnouncementDeleteDialog';
  cancelBtn?: Maybe<Scalars['String']['output']>;
  confirmBtn?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentWildcardAnnouncementDeleteDialogInput = {
  cancelBtn?: InputMaybe<Scalars['String']['input']>;
  confirmBtn?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentWildcardAnnouncementForm = {
  __typename?: 'ComponentWildcardAnnouncementForm';
  charactersLabel?: Maybe<Scalars['String']['output']>;
  createBtn?: Maybe<Scalars['String']['output']>;
  createError?: Maybe<Scalars['String']['output']>;
  createSuccess?: Maybe<Scalars['String']['output']>;
  createSuccessDescription?: Maybe<Scalars['String']['output']>;
  datesDescription?: Maybe<Scalars['String']['output']>;
  datesTitle?: Maybe<Scalars['String']['output']>;
  defaultSchoolTitle?: Maybe<Scalars['String']['output']>;
  descriptionPlaceholder?: Maybe<Scalars['String']['output']>;
  descriptionSubtitle?: Maybe<Scalars['String']['output']>;
  descriptionTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logoDescription?: Maybe<Scalars['String']['output']>;
  logoRequired?: Maybe<Scalars['String']['output']>;
  logoRequiredDescription?: Maybe<Scalars['String']['output']>;
  logoSelected?: Maybe<Scalars['String']['output']>;
  logoTitle?: Maybe<Scalars['String']['output']>;
  logoUploadBtn?: Maybe<Scalars['String']['output']>;
  logoUploadPrompt?: Maybe<Scalars['String']['output']>;
  savingBtn?: Maybe<Scalars['String']['output']>;
  schoolsDescription?: Maybe<Scalars['String']['output']>;
  schoolsTitle?: Maybe<Scalars['String']['output']>;
  updateBtn?: Maybe<Scalars['String']['output']>;
  updateError?: Maybe<Scalars['String']['output']>;
  updateSuccess?: Maybe<Scalars['String']['output']>;
  updateSuccessDescription?: Maybe<Scalars['String']['output']>;
  validations?: Maybe<ComponentWildcardValidation>;
};

export type ComponentWildcardAnnouncementFormInput = {
  charactersLabel?: InputMaybe<Scalars['String']['input']>;
  createBtn?: InputMaybe<Scalars['String']['input']>;
  createError?: InputMaybe<Scalars['String']['input']>;
  createSuccess?: InputMaybe<Scalars['String']['input']>;
  createSuccessDescription?: InputMaybe<Scalars['String']['input']>;
  datesDescription?: InputMaybe<Scalars['String']['input']>;
  datesTitle?: InputMaybe<Scalars['String']['input']>;
  defaultSchoolTitle?: InputMaybe<Scalars['String']['input']>;
  descriptionPlaceholder?: InputMaybe<Scalars['String']['input']>;
  descriptionSubtitle?: InputMaybe<Scalars['String']['input']>;
  descriptionTitle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  logoDescription?: InputMaybe<Scalars['String']['input']>;
  logoRequired?: InputMaybe<Scalars['String']['input']>;
  logoRequiredDescription?: InputMaybe<Scalars['String']['input']>;
  logoSelected?: InputMaybe<Scalars['String']['input']>;
  logoTitle?: InputMaybe<Scalars['String']['input']>;
  logoUploadBtn?: InputMaybe<Scalars['String']['input']>;
  logoUploadPrompt?: InputMaybe<Scalars['String']['input']>;
  savingBtn?: InputMaybe<Scalars['String']['input']>;
  schoolsDescription?: InputMaybe<Scalars['String']['input']>;
  schoolsTitle?: InputMaybe<Scalars['String']['input']>;
  updateBtn?: InputMaybe<Scalars['String']['input']>;
  updateError?: InputMaybe<Scalars['String']['input']>;
  updateSuccess?: InputMaybe<Scalars['String']['input']>;
  updateSuccessDescription?: InputMaybe<Scalars['String']['input']>;
  validations?: InputMaybe<ComponentWildcardValidationInput>;
};

export type ComponentWildcardAnnouncementPreview = {
  __typename?: 'ComponentWildcardAnnouncementPreview';
  deleteError?: Maybe<Scalars['String']['output']>;
  deleteErrorDescription?: Maybe<Scalars['String']['output']>;
  deleteSuccess?: Maybe<Scalars['String']['output']>;
  deleteSuccessDescription?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  like?: Maybe<Scalars['String']['output']>;
  liveFromLabel?: Maybe<Scalars['String']['output']>;
  liveLabel?: Maybe<Scalars['String']['output']>;
  publishError?: Maybe<Scalars['String']['output']>;
  publishErrorDescription?: Maybe<Scalars['String']['output']>;
  publishSuccess?: Maybe<Scalars['String']['output']>;
  publishSuccessDescription?: Maybe<Scalars['String']['output']>;
  scheduledLabel?: Maybe<Scalars['String']['output']>;
  totalLikesLabel?: Maybe<Scalars['String']['output']>;
  unpublishError?: Maybe<Scalars['String']['output']>;
  unpublishErrorDescription?: Maybe<Scalars['String']['output']>;
  unpublishSuccess?: Maybe<Scalars['String']['output']>;
  unpublishSuccessDescription?: Maybe<Scalars['String']['output']>;
  untilLabel?: Maybe<Scalars['String']['output']>;
};

export type ComponentWildcardAnnouncementPreviewInput = {
  deleteError?: InputMaybe<Scalars['String']['input']>;
  deleteErrorDescription?: InputMaybe<Scalars['String']['input']>;
  deleteSuccess?: InputMaybe<Scalars['String']['input']>;
  deleteSuccessDescription?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  liveFromLabel?: InputMaybe<Scalars['String']['input']>;
  liveLabel?: InputMaybe<Scalars['String']['input']>;
  publishError?: InputMaybe<Scalars['String']['input']>;
  publishErrorDescription?: InputMaybe<Scalars['String']['input']>;
  publishSuccess?: InputMaybe<Scalars['String']['input']>;
  publishSuccessDescription?: InputMaybe<Scalars['String']['input']>;
  scheduledLabel?: InputMaybe<Scalars['String']['input']>;
  totalLikesLabel?: InputMaybe<Scalars['String']['input']>;
  unpublishError?: InputMaybe<Scalars['String']['input']>;
  unpublishErrorDescription?: InputMaybe<Scalars['String']['input']>;
  unpublishSuccess?: InputMaybe<Scalars['String']['input']>;
  unpublishSuccessDescription?: InputMaybe<Scalars['String']['input']>;
  untilLabel?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentWildcardCta = {
  __typename?: 'ComponentWildcardCta';
  course?: Maybe<CourseEntityResponse>;
  id: Scalars['ID']['output'];
  mindfulExercise?: Maybe<MeditationEntityResponse>;
  podcast?: Maybe<PodcastEntityResponse>;
  redirectToCalendar?: Maybe<Scalars['Boolean']['output']>;
  redirectToCurrentInsight?: Maybe<Scalars['Boolean']['output']>;
  redirectToCurrentMindfulMinute?: Maybe<Scalars['Boolean']['output']>;
  redirectToEmotionWheel?: Maybe<Scalars['Boolean']['output']>;
  resource?: Maybe<ResourceEntityResponse>;
};

export type ComponentWildcardCtaFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentWildcardCtaFiltersInput>>>;
  course?: InputMaybe<CourseFiltersInput>;
  mindfulExercise?: InputMaybe<MeditationFiltersInput>;
  not?: InputMaybe<ComponentWildcardCtaFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentWildcardCtaFiltersInput>>>;
  podcast?: InputMaybe<PodcastFiltersInput>;
  redirectToCalendar?: InputMaybe<BooleanFilterInput>;
  redirectToCurrentInsight?: InputMaybe<BooleanFilterInput>;
  redirectToCurrentMindfulMinute?: InputMaybe<BooleanFilterInput>;
  redirectToEmotionWheel?: InputMaybe<BooleanFilterInput>;
  resource?: InputMaybe<ResourceFiltersInput>;
};

export type ComponentWildcardCtaInput = {
  course?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  mindfulExercise?: InputMaybe<Scalars['ID']['input']>;
  podcast?: InputMaybe<Scalars['ID']['input']>;
  redirectToCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  redirectToCurrentInsight?: InputMaybe<Scalars['Boolean']['input']>;
  redirectToCurrentMindfulMinute?: InputMaybe<Scalars['Boolean']['input']>;
  redirectToEmotionWheel?: InputMaybe<Scalars['Boolean']['input']>;
  resource?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentWildcardValidation = {
  __typename?: 'ComponentWildcardValidation';
  dateRangeLimit?: Maybe<Scalars['String']['output']>;
  descriptionMaxLength?: Maybe<Scalars['String']['output']>;
  descriptionRequired?: Maybe<Scalars['String']['output']>;
  endDateAfterStart?: Maybe<Scalars['String']['output']>;
  endDateValid?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logoDimensions?: Maybe<Scalars['String']['output']>;
  logoRequired?: Maybe<Scalars['String']['output']>;
  logoSize?: Maybe<Scalars['String']['output']>;
  schoolRequired?: Maybe<Scalars['String']['output']>;
  startDateFuture?: Maybe<Scalars['String']['output']>;
};

export type ComponentWildcardValidationInput = {
  dateRangeLimit?: InputMaybe<Scalars['String']['input']>;
  descriptionMaxLength?: InputMaybe<Scalars['String']['input']>;
  descriptionRequired?: InputMaybe<Scalars['String']['input']>;
  endDateAfterStart?: InputMaybe<Scalars['String']['input']>;
  endDateValid?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  logoDimensions?: InputMaybe<Scalars['String']['input']>;
  logoRequired?: InputMaybe<Scalars['String']['input']>;
  logoSize?: InputMaybe<Scalars['String']['input']>;
  schoolRequired?: InputMaybe<Scalars['String']['input']>;
  startDateFuture?: InputMaybe<Scalars['String']['input']>;
};

export type CookiesPage = {
  __typename?: 'CookiesPage';
  DefaultContentTemplate: Array<Maybe<CookiesPageDefaultContentTemplateDynamicZone>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CookiesPageDefaultContentTemplateDynamicZone =
  | ComponentCommonAuthor
  | ComponentCommonAuthorDetailed
  | ComponentCommonBullet
  | ComponentCommonDivider
  | ComponentCommonDownloadableContentList
  | ComponentCommonEmbedded
  | ComponentCommonFaqComponent
  | ComponentCommonH3
  | ComponentCommonMedia
  | ComponentCommonQuote
  | ComponentCommonTextEditor
  | ComponentCommonTitle
  | Error;

export type CookiesPageEntity = {
  __typename?: 'CookiesPageEntity';
  attributes?: Maybe<CookiesPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CookiesPageEntityResponse = {
  __typename?: 'CookiesPageEntityResponse';
  data?: Maybe<CookiesPageEntity>;
};

export type CookiesPageInput = {
  DefaultContentTemplate?: InputMaybe<Array<Scalars['CookiesPageDefaultContentTemplateDynamicZoneInput']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CopyrightPage = {
  __typename?: 'CopyrightPage';
  DefaultContentTemplate: Array<Maybe<CopyrightPageDefaultContentTemplateDynamicZone>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CopyrightPageDefaultContentTemplateDynamicZone =
  | ComponentCommonAuthor
  | ComponentCommonAuthorDetailed
  | ComponentCommonBullet
  | ComponentCommonDivider
  | ComponentCommonDownloadableContentList
  | ComponentCommonEmbedded
  | ComponentCommonFaqComponent
  | ComponentCommonH3
  | ComponentCommonMedia
  | ComponentCommonQuote
  | ComponentCommonTextEditor
  | ComponentCommonTitle
  | Error;

export type CopyrightPageEntity = {
  __typename?: 'CopyrightPageEntity';
  attributes?: Maybe<CopyrightPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CopyrightPageEntityResponse = {
  __typename?: 'CopyrightPageEntityResponse';
  data?: Maybe<CopyrightPageEntity>;
};

export type CopyrightPageInput = {
  DefaultContentTemplate?: InputMaybe<Array<Scalars['CopyrightPageDefaultContentTemplateDynamicZoneInput']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Course = {
  __typename?: 'Course';
  courseCompletedSection?: Maybe<ComponentLearnCourseCompletedSection>;
  course_category?: Maybe<CourseCategoryEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  duration?: Maybe<Scalars['String']['output']>;
  feedback?: Maybe<CourseFeedbackRelationResponseCollection>;
  feedbackQuestions?: Maybe<Array<Maybe<ComponentLearnQuestions>>>;
  hero: UploadFileEntityResponse;
  modules?: Maybe<Array<Maybe<ComponentLearnCourseModule>>>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  textContent?: Maybe<ComponentCommonTextEditor>;
  themes?: Maybe<ThemeRelationResponseCollection>;
  thumbnail: UploadFileEntityResponse;
  title: Scalars['String']['output'];
  type?: Maybe<CourseTypeEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CourseFeedbackArgs = {
  filters?: InputMaybe<CourseFeedbackFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CourseFeedbackQuestionsArgs = {
  filters?: InputMaybe<ComponentLearnQuestionsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CourseModulesArgs = {
  filters?: InputMaybe<ComponentLearnCourseModuleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CourseThemesArgs = {
  filters?: InputMaybe<ThemeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CourseCategory = {
  __typename?: 'CourseCategory';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CourseCategoryEntity = {
  __typename?: 'CourseCategoryEntity';
  attributes?: Maybe<CourseCategory>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CourseCategoryEntityResponse = {
  __typename?: 'CourseCategoryEntityResponse';
  data?: Maybe<CourseCategoryEntity>;
};

export type CourseCategoryEntityResponseCollection = {
  __typename?: 'CourseCategoryEntityResponseCollection';
  data: Array<CourseCategoryEntity>;
  meta: ResponseCollectionMeta;
};

export type CourseCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CourseCategoryFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CourseCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CourseCategoryFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CourseCategoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CourseEntity = {
  __typename?: 'CourseEntity';
  attributes?: Maybe<Course>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CourseEntityResponse = {
  __typename?: 'CourseEntityResponse';
  data?: Maybe<CourseEntity>;
};

export type CourseEntityResponseCollection = {
  __typename?: 'CourseEntityResponseCollection';
  data: Array<CourseEntity>;
  meta: ResponseCollectionMeta;
};

export type CourseFeedback = {
  __typename?: 'CourseFeedback';
  answers?: Maybe<Array<Maybe<ComponentLearnFeedback>>>;
  course?: Maybe<CourseEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  submittedDate?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<UsersPermissionsUserEntityResponse>;
};

export type CourseFeedbackAnswersArgs = {
  filters?: InputMaybe<ComponentLearnFeedbackFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CourseFeedbackEntity = {
  __typename?: 'CourseFeedbackEntity';
  attributes?: Maybe<CourseFeedback>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CourseFeedbackEntityResponse = {
  __typename?: 'CourseFeedbackEntityResponse';
  data?: Maybe<CourseFeedbackEntity>;
};

export type CourseFeedbackEntityResponseCollection = {
  __typename?: 'CourseFeedbackEntityResponseCollection';
  data: Array<CourseFeedbackEntity>;
  meta: ResponseCollectionMeta;
};

export type CourseFeedbackFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CourseFeedbackFiltersInput>>>;
  answers?: InputMaybe<ComponentLearnFeedbackFiltersInput>;
  course?: InputMaybe<CourseFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<CourseFeedbackFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CourseFeedbackFiltersInput>>>;
  submittedDate?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type CourseFeedbackInput = {
  answers?: InputMaybe<Array<InputMaybe<ComponentLearnFeedbackInput>>>;
  course?: InputMaybe<Scalars['ID']['input']>;
  submittedDate?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type CourseFeedbackRelationResponseCollection = {
  __typename?: 'CourseFeedbackRelationResponseCollection';
  data: Array<CourseFeedbackEntity>;
};

export type CourseFiltersInput = {
  _softDeletedAt?: InputMaybe<DateTimeFilterInput>;
  _softDeletedById?: InputMaybe<IntFilterInput>;
  _softDeletedByType?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<CourseFiltersInput>>>;
  courseCompletedSection?: InputMaybe<ComponentLearnCourseCompletedSectionFiltersInput>;
  course_category?: InputMaybe<CourseCategoryFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  duration?: InputMaybe<StringFilterInput>;
  feedback?: InputMaybe<CourseFeedbackFiltersInput>;
  feedbackQuestions?: InputMaybe<ComponentLearnQuestionsFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  modules?: InputMaybe<ComponentLearnCourseModuleFiltersInput>;
  not?: InputMaybe<CourseFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CourseFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  textContent?: InputMaybe<ComponentCommonTextEditorFiltersInput>;
  themes?: InputMaybe<ThemeFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<CourseTypeFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CourseInput = {
  courseCompletedSection?: InputMaybe<ComponentLearnCourseCompletedSectionInput>;
  course_category?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  feedback?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  feedbackQuestions?: InputMaybe<Array<InputMaybe<ComponentLearnQuestionsInput>>>;
  hero?: InputMaybe<Scalars['ID']['input']>;
  modules?: InputMaybe<Array<InputMaybe<ComponentLearnCourseModuleInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  textContent?: InputMaybe<ComponentCommonTextEditorInput>;
  themes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  thumbnail?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['ID']['input']>;
};

export type CoursePage = {
  __typename?: 'CoursePage';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  lesson?: Maybe<ComponentCoursePageLesson>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CoursePageEntity = {
  __typename?: 'CoursePageEntity';
  attributes?: Maybe<CoursePage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CoursePageEntityResponse = {
  __typename?: 'CoursePageEntityResponse';
  data?: Maybe<CoursePageEntity>;
};

export type CoursePageInput = {
  lesson?: InputMaybe<ComponentCoursePageLessonInput>;
};

export type CourseRelationResponseCollection = {
  __typename?: 'CourseRelationResponseCollection';
  data: Array<CourseEntity>;
};

export type CourseType = {
  __typename?: 'CourseType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CourseTypeEntity = {
  __typename?: 'CourseTypeEntity';
  attributes?: Maybe<CourseType>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CourseTypeEntityResponse = {
  __typename?: 'CourseTypeEntityResponse';
  data?: Maybe<CourseTypeEntity>;
};

export type CourseTypeEntityResponseCollection = {
  __typename?: 'CourseTypeEntityResponseCollection';
  data: Array<CourseTypeEntity>;
  meta: ResponseCollectionMeta;
};

export type CourseTypeFiltersInput = {
  _softDeletedAt?: InputMaybe<DateTimeFilterInput>;
  _softDeletedById?: InputMaybe<IntFilterInput>;
  _softDeletedByType?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<CourseTypeFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CourseTypeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CourseTypeFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CourseTypeInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CurrentSurveyResult = {
  __typename?: 'CurrentSurveyResult';
  questions?: Maybe<Array<Maybe<QuestionEntity>>>;
  survey?: Maybe<SurveyEntity>;
};

export type CustomMeasure = {
  __typename?: 'CustomMeasure';
  name?: Maybe<Scalars['String']['output']>;
  questions?: Maybe<Array<Maybe<CustomQuestion>>>;
};

export type CustomQuestion = {
  __typename?: 'CustomQuestion';
  name?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Array<Maybe<CustomResult>>>;
};

export type CustomResult = {
  __typename?: 'CustomResult';
  option?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  scale?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type DailyBubbleFinishedPage = {
  __typename?: 'DailyBubbleFinishedPage';
  continueYourWeelbeingJourneyTitle: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  messageSection: ComponentCommonMessageSection;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  resourceDescription: Scalars['String']['output'];
  resourcesTitle: Scalars['String']['output'];
  toolkitsDescription: Scalars['String']['output'];
  toolkitsTitle: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DailyBubbleFinishedPageEntity = {
  __typename?: 'DailyBubbleFinishedPageEntity';
  attributes?: Maybe<DailyBubbleFinishedPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type DailyBubbleFinishedPageEntityResponse = {
  __typename?: 'DailyBubbleFinishedPageEntityResponse';
  data?: Maybe<DailyBubbleFinishedPageEntity>;
};

export type DailyBubbleFinishedPageInput = {
  continueYourWeelbeingJourneyTitle?: InputMaybe<Scalars['String']['input']>;
  messageSection?: InputMaybe<ComponentCommonMessageSectionInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  resourceDescription?: InputMaybe<Scalars['String']['input']>;
  resourcesTitle?: InputMaybe<Scalars['String']['input']>;
  toolkitsDescription?: InputMaybe<Scalars['String']['input']>;
  toolkitsTitle?: InputMaybe<Scalars['String']['input']>;
};

export type DailyBubblePage = {
  __typename?: 'DailyBubblePage';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dailySection: ComponentHomeDailySection;
  doneSection?: Maybe<ComponentHomeDoneSection>;
  finishingCard?: Maybe<ComponentDailyBubblePageFinishingCard>;
  headerSection: ComponentDailyBubblePageHeaderSection;
  onboardingQuestions?: Maybe<ComponentDailyBubblePageOnboardingQuestions>;
  sections: ComponentHomeSections;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  welcomeCard?: Maybe<ComponentDailyBubblePageWelcomeCard>;
  welcomeOverlay?: Maybe<ComponentHomeWelcomeOverlay>;
};

export type DailyBubblePageEntity = {
  __typename?: 'DailyBubblePageEntity';
  attributes?: Maybe<DailyBubblePage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type DailyBubblePageEntityResponse = {
  __typename?: 'DailyBubblePageEntityResponse';
  data?: Maybe<DailyBubblePageEntity>;
};

export type DailyBubblePageInput = {
  dailySection?: InputMaybe<ComponentHomeDailySectionInput>;
  doneSection?: InputMaybe<ComponentHomeDoneSectionInput>;
  finishingCard?: InputMaybe<ComponentDailyBubblePageFinishingCardInput>;
  headerSection?: InputMaybe<ComponentDailyBubblePageHeaderSectionInput>;
  onboardingQuestions?: InputMaybe<ComponentDailyBubblePageOnboardingQuestionsInput>;
  sections?: InputMaybe<ComponentHomeSectionsInput>;
  welcomeCard?: InputMaybe<ComponentDailyBubblePageWelcomeCardInput>;
  welcomeOverlay?: InputMaybe<ComponentHomeWelcomeOverlayInput>;
};

export type DateFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  contains?: InputMaybe<Scalars['Date']['input']>;
  containsi?: InputMaybe<Scalars['Date']['input']>;
  endsWith?: InputMaybe<Scalars['Date']['input']>;
  eq?: InputMaybe<Scalars['Date']['input']>;
  eqi?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nei?: InputMaybe<Scalars['Date']['input']>;
  not?: InputMaybe<DateFilterInput>;
  notContains?: InputMaybe<Scalars['Date']['input']>;
  notContainsi?: InputMaybe<Scalars['Date']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  startsWith?: InputMaybe<Scalars['Date']['input']>;
};

export type DateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  contains?: InputMaybe<Scalars['DateTime']['input']>;
  containsi?: InputMaybe<Scalars['DateTime']['input']>;
  endsWith?: InputMaybe<Scalars['DateTime']['input']>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  eqi?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  ne?: InputMaybe<Scalars['DateTime']['input']>;
  nei?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeFilterInput>;
  notContains?: InputMaybe<Scalars['DateTime']['input']>;
  notContainsi?: InputMaybe<Scalars['DateTime']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  startsWith?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Day = {
  __typename?: 'Day';
  day?: Maybe<Scalars['Date']['output']>;
  emotion?: Maybe<Scalars['String']['output']>;
};

export type DayManager = {
  __typename?: 'DayManager';
  day?: Maybe<Scalars['Date']['output']>;
  emotions?: Maybe<Array<Maybe<EmotionsSizeManager>>>;
};

export enum Enum_Completedtask_Type {
  EmotionalWheel = 'EMOTIONAL_WHEEL',
  Game = 'GAME',
  Insight = 'INSIGHT',
  Meditation = 'MEDITATION',
  MindfulMinute = 'MINDFUL_MINUTE',
  Quote = 'QUOTE',
  WeeklyQuestion = 'WEEKLY_QUESTION',
}

export enum Enum_Componentcommonembedded_Provider {
  Vimeo = 'VIMEO',
  Youtube = 'YOUTUBE',
}

export enum Enum_Componentlearncoursefields_Field {
  Authors = 'authors',
  CourseCategory = 'course_category',
  Description = 'description',
  Hero = 'hero',
  Modules = 'modules',
  Slug = 'slug',
  Thumbnail = 'thumbnail',
  Title = 'title',
  Type = 'type',
}

export enum Enum_Componentnotificationpreferencepreferences_Type {
  Courses = 'COURSES',
  NewContentNotification = 'NEW_CONTENT_NOTIFICATION',
  Reminder = 'REMINDER',
}

export enum Enum_Componentsharedmetasocial_Socialnetwork {
  Facebook = 'Facebook',
  Twitter = 'Twitter',
}

export enum Enum_Componentsurveyanswers_Type {
  Negative = 'NEGATIVE',
  Neutral = 'NEUTRAL',
  Positive = 'POSITIVE',
}

export enum Enum_Componentsurveyrepetablesurvey_Frequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY',
}

export enum Enum_Edwinstrapiauditlogsauditlog_Action {
  Create = 'CREATE',
  Delete = 'DELETE',
  DeleteMany = 'DELETE_MANY',
  Update = 'UPDATE',
  UpdateMany = 'UPDATE_MANY',
}

export enum Enum_Emailsent_Status {
  ScheduledWorkingDay = 'SCHEDULED_WORKING_DAY',
  Sent = 'SENT',
}

export enum Enum_Emailsent_Type {
  OnboardingNotCompleted = 'ONBOARDING_NOT_COMPLETED',
  Reinvitation_3Days = 'REINVITATION_3_DAYS',
  Reinvitation_6Days = 'REINVITATION_6_DAYS',
}

export enum Enum_Favorite_Type {
  Insight = 'INSIGHT',
  Learn = 'LEARN',
  Podcast = 'PODCAST',
  Resource = 'RESOURCE',
  Wildcard = 'WILDCARD',
}

export enum Enum_Importeduser_Origin {
  Spreadsheet = 'SPREADSHEET',
  Wonde = 'WONDE',
}

export enum Enum_Interactionsga_Feature {
  Bookmarks = 'BOOKMARKS',
  Dailyinsight = 'DAILYINSIGHT',
  Emotionwheel = 'EMOTIONWHEEL',
  Knowledgehub = 'KNOWLEDGEHUB',
  Learn = 'LEARN',
  Mindfulexercise = 'MINDFULEXERCISE',
  Mindfulminute = 'MINDFULMINUTE',
  Ordinarymagic = 'ORDINARYMAGIC',
  Podcast = 'PODCAST',
  Search = 'SEARCH',
  Wellbeingawareness = 'WELLBEINGAWARENESS',
}

export enum Enum_Interactionsga_Metric {
  ActiveUsers = 'activeUsers',
  AverageEngagementTimePerSession = 'averageEngagementTimePerSession',
  AverageSessionDuration = 'averageSessionDuration',
  BounceRate = 'bounceRate',
  EngagedSessions = 'engagedSessions',
  EngagedSessionsPerUser = 'engagedSessionsPerUser',
  EngagementRate = 'engagementRate',
  EventCount = 'eventCount',
  PageViews = 'pageViews',
  ScreenPageViews = 'screenPageViews',
  Sessions = 'sessions',
  SessionsPerUser = 'sessionsPerUser',
  UserEngagement = 'userEngagement',
  UserEngagementDuration = 'userEngagementDuration',
}

export enum Enum_Like_Type {
  Insight = 'INSIGHT',
  Learn = 'LEARN',
  Podcast = 'PODCAST',
  Resource = 'RESOURCE',
  Wildcard = 'WILDCARD',
}

export enum Enum_Meditation_Type {
  Audio = 'AUDIO',
  Video = 'VIDEO',
}

export enum Enum_Mindfulminute_Type {
  Breathing = 'BREATHING',
  Prompt = 'PROMPT',
  Video = 'VIDEO',
}

export enum Enum_Notificationlog_Status {
  Error = 'ERROR',
  NotFound = 'NOT_FOUND',
  Success = 'SUCCESS',
}

export enum Enum_Notificationlog_Type {
  PodcastNotification = 'PODCAST_NOTIFICATION',
  ResourceNotification = 'RESOURCE_NOTIFICATION',
}

export enum Enum_Podcastinteraction_Type {
  Question = 'QUESTION',
  Suggestion = 'SUGGESTION',
}

export enum Enum_Userspermissionsuser_Registrationdevice {
  Mobile = 'mobile',
  Tablet = 'tablet',
  Web = 'web',
}

export enum Enum_Wildcard_Status {
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
}

export type EdwinPluginSsoV4Roles = {
  __typename?: 'EdwinPluginSsoV4Roles';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  oauth_type: Scalars['String']['output'];
  roles?: Maybe<Scalars['JSON']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EdwinPluginSsoV4RolesEntity = {
  __typename?: 'EdwinPluginSsoV4RolesEntity';
  attributes?: Maybe<EdwinPluginSsoV4Roles>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type EdwinPluginSsoV4RolesEntityResponse = {
  __typename?: 'EdwinPluginSsoV4RolesEntityResponse';
  data?: Maybe<EdwinPluginSsoV4RolesEntity>;
};

export type EdwinPluginSsoV4RolesEntityResponseCollection = {
  __typename?: 'EdwinPluginSsoV4RolesEntityResponseCollection';
  data: Array<EdwinPluginSsoV4RolesEntity>;
  meta: ResponseCollectionMeta;
};

export type EdwinPluginSsoV4RolesFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<EdwinPluginSsoV4RolesFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<EdwinPluginSsoV4RolesFiltersInput>;
  oauth_type?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<EdwinPluginSsoV4RolesFiltersInput>>>;
  roles?: InputMaybe<JsonFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type EdwinPluginSsoV4RolesInput = {
  oauth_type?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Scalars['JSON']['input']>;
};

export type EdwinStrapiAuditLogsAuditLog = {
  __typename?: 'EdwinStrapiAuditLogsAuditLog';
  action?: Maybe<Enum_Edwinstrapiauditlogsauditlog_Action>;
  collection?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  payload?: Maybe<Scalars['JSON']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<Scalars['String']['output']>;
};

export type EdwinStrapiAuditLogsAuditLogEntity = {
  __typename?: 'EdwinStrapiAuditLogsAuditLogEntity';
  attributes?: Maybe<EdwinStrapiAuditLogsAuditLog>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type EdwinStrapiAuditLogsAuditLogEntityResponse = {
  __typename?: 'EdwinStrapiAuditLogsAuditLogEntityResponse';
  data?: Maybe<EdwinStrapiAuditLogsAuditLogEntity>;
};

export type EdwinStrapiAuditLogsAuditLogEntityResponseCollection = {
  __typename?: 'EdwinStrapiAuditLogsAuditLogEntityResponseCollection';
  data: Array<EdwinStrapiAuditLogsAuditLogEntity>;
  meta: ResponseCollectionMeta;
};

export type EdwinStrapiAuditLogsAuditLogFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<EdwinStrapiAuditLogsAuditLogFiltersInput>>>;
  collection?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  date?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<EdwinStrapiAuditLogsAuditLogFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<EdwinStrapiAuditLogsAuditLogFiltersInput>>>;
  payload?: InputMaybe<JsonFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<StringFilterInput>;
};

export type EdwinStrapiAuditLogsAuditLogInput = {
  action?: InputMaybe<Enum_Edwinstrapiauditlogsauditlog_Action>;
  collection?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  payload?: InputMaybe<Scalars['JSON']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type EmailSent = {
  __typename?: 'EmailSent';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  sentDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Enum_Emailsent_Status>;
  type?: Maybe<Enum_Emailsent_Type>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users?: Maybe<Scalars['JSON']['output']>;
};

export type EmailSentEntity = {
  __typename?: 'EmailSentEntity';
  attributes?: Maybe<EmailSent>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type EmailSentEntityResponse = {
  __typename?: 'EmailSentEntityResponse';
  data?: Maybe<EmailSentEntity>;
};

export type EmailSentEntityResponseCollection = {
  __typename?: 'EmailSentEntityResponseCollection';
  data: Array<EmailSentEntity>;
  meta: ResponseCollectionMeta;
};

export type EmailSentFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<EmailSentFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<EmailSentFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<EmailSentFiltersInput>>>;
  sentDate?: InputMaybe<DateTimeFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<JsonFilterInput>;
};

export type EmailSentInput = {
  sentDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Enum_Emailsent_Status>;
  type?: InputMaybe<Enum_Emailsent_Type>;
  users?: InputMaybe<Scalars['JSON']['input']>;
};

export type EmailTemplate = {
  __typename?: 'EmailTemplate';
  activateMyAccountEmail?: Maybe<ComponentEmailTemplateWelcomeEmailStaff>;
  adminWelcomeEmail?: Maybe<ComponentEmailTemplateWelcomeEmailStaff>;
  codeDistributionStaffEmail?: Maybe<ComponentEmailTemplateWelcomeEmailStaff>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  onboardingNotCompleted?: Maybe<ComponentEmailTemplateWelcomeEmailStaff>;
  reInviteUsersAfter3Days?: Maybe<ComponentEmailTemplateWelcomeEmailStaff>;
  reInviteUsersAfter6Days?: Maybe<ComponentEmailTemplateWelcomeEmailStaff>;
  resetPassword?: Maybe<ComponentEmailTemplateWelcomeEmailStaff>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EmailTemplateEntity = {
  __typename?: 'EmailTemplateEntity';
  attributes?: Maybe<EmailTemplate>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type EmailTemplateEntityResponse = {
  __typename?: 'EmailTemplateEntityResponse';
  data?: Maybe<EmailTemplateEntity>;
};

export type EmailTemplateInput = {
  activateMyAccountEmail?: InputMaybe<ComponentEmailTemplateWelcomeEmailStaffInput>;
  adminWelcomeEmail?: InputMaybe<ComponentEmailTemplateWelcomeEmailStaffInput>;
  codeDistributionStaffEmail?: InputMaybe<ComponentEmailTemplateWelcomeEmailStaffInput>;
  onboardingNotCompleted?: InputMaybe<ComponentEmailTemplateWelcomeEmailStaffInput>;
  reInviteUsersAfter3Days?: InputMaybe<ComponentEmailTemplateWelcomeEmailStaffInput>;
  reInviteUsersAfter6Days?: InputMaybe<ComponentEmailTemplateWelcomeEmailStaffInput>;
  resetPassword?: InputMaybe<ComponentEmailTemplateWelcomeEmailStaffInput>;
};

export type EmotionCount = {
  __typename?: 'EmotionCount';
  count?: Maybe<Scalars['Int']['output']>;
  emotion?: Maybe<Scalars['String']['output']>;
  overallMoodIcon?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type EmotionTrackerResult = {
  __typename?: 'EmotionTrackerResult';
  day?: Maybe<Scalars['String']['output']>;
  emotion?: Maybe<Scalars['String']['output']>;
  isDisabledTracking?: Maybe<Scalars['Boolean']['output']>;
};

export type EmotionWheel = {
  __typename?: 'EmotionWheel';
  L2?: Maybe<Array<Maybe<ComponentEmotionWheelLevels>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  emotion: Scalars['String']['output'];
  overallMoodIcon?: Maybe<UploadFileEntityResponse>;
  typeSection: ComponentEmotionWheelTypeSection;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EmotionWheelL2Args = {
  filters?: InputMaybe<ComponentEmotionWheelLevelsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EmotionWheelEntity = {
  __typename?: 'EmotionWheelEntity';
  attributes?: Maybe<EmotionWheel>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type EmotionWheelEntityResponse = {
  __typename?: 'EmotionWheelEntityResponse';
  data?: Maybe<EmotionWheelEntity>;
};

export type EmotionWheelEntityResponseCollection = {
  __typename?: 'EmotionWheelEntityResponseCollection';
  data: Array<EmotionWheelEntity>;
  meta: ResponseCollectionMeta;
};

export type EmotionWheelFiltersInput = {
  L2?: InputMaybe<ComponentEmotionWheelLevelsFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<EmotionWheelFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  emotion?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<EmotionWheelFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<EmotionWheelFiltersInput>>>;
  typeSection?: InputMaybe<ComponentEmotionWheelTypeSectionFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type EmotionWheelInput = {
  L2?: InputMaybe<Array<InputMaybe<ComponentEmotionWheelLevelsInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  emotion?: InputMaybe<Scalars['String']['input']>;
  overallMoodIcon?: InputMaybe<Scalars['ID']['input']>;
  typeSection?: InputMaybe<ComponentEmotionWheelTypeSectionInput>;
};

export type EmotionWheelPage = {
  __typename?: 'EmotionWheelPage';
  EmotionNotFound?: Maybe<ComponentCommonRawTextWithLinks>;
  bottomText?: Maybe<Scalars['String']['output']>;
  calendarTitle?: Maybe<Scalars['String']['output']>;
  changeMyAnswerCta: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  goToYourMoodTracker?: Maybe<Scalars['String']['output']>;
  howAreYouFeelingTitle: Scalars['String']['output'];
  howAreYouTitle: Scalars['String']['output'];
  messages?: Maybe<ComponentEmotionWheelMessages>;
  onboarding?: Maybe<ComponentEmotionWheelOnboarding>;
  relatedContent?: Maybe<TopicEntityResponse>;
  relatedContentTitle?: Maybe<Scalars['String']['output']>;
  relatedContentViewAllLabel?: Maybe<Scalars['String']['output']>;
  resetTheWheel?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  wellDoneTitle: Scalars['String']['output'];
  youAreTitle: Scalars['String']['output'];
};

export type EmotionWheelPageEntity = {
  __typename?: 'EmotionWheelPageEntity';
  attributes?: Maybe<EmotionWheelPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type EmotionWheelPageEntityResponse = {
  __typename?: 'EmotionWheelPageEntityResponse';
  data?: Maybe<EmotionWheelPageEntity>;
};

export type EmotionWheelPageInput = {
  EmotionNotFound?: InputMaybe<ComponentCommonRawTextWithLinksInput>;
  bottomText?: InputMaybe<Scalars['String']['input']>;
  calendarTitle?: InputMaybe<Scalars['String']['input']>;
  changeMyAnswerCta?: InputMaybe<Scalars['String']['input']>;
  goToYourMoodTracker?: InputMaybe<Scalars['String']['input']>;
  howAreYouFeelingTitle?: InputMaybe<Scalars['String']['input']>;
  howAreYouTitle?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<ComponentEmotionWheelMessagesInput>;
  onboarding?: InputMaybe<ComponentEmotionWheelOnboardingInput>;
  relatedContent?: InputMaybe<Scalars['ID']['input']>;
  relatedContentTitle?: InputMaybe<Scalars['String']['input']>;
  relatedContentViewAllLabel?: InputMaybe<Scalars['String']['input']>;
  resetTheWheel?: InputMaybe<Scalars['String']['input']>;
  wellDoneTitle?: InputMaybe<Scalars['String']['input']>;
  youAreTitle?: InputMaybe<Scalars['String']['input']>;
};

export type EmotionsPerDay = {
  __typename?: 'EmotionsPerDay';
  days?: Maybe<Array<Maybe<Day>>>;
};

export type EmotionsPerDayManager = {
  __typename?: 'EmotionsPerDayManager';
  days?: Maybe<Array<Maybe<DayManager>>>;
  school?: Maybe<Scalars['String']['output']>;
};

export type EmotionsSizeManager = {
  __typename?: 'EmotionsSizeManager';
  emotion?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
};

export type Error = {
  __typename?: 'Error';
  code: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type Favorite = {
  __typename?: 'Favorite';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  relationId: Scalars['Long']['output'];
  type: Enum_Favorite_Type;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<UsersPermissionsUserEntityResponse>;
};

export type FavoriteEntity = {
  __typename?: 'FavoriteEntity';
  attributes?: Maybe<Favorite>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type FavoriteEntityResponse = {
  __typename?: 'FavoriteEntityResponse';
  data?: Maybe<FavoriteEntity>;
};

export type FavoriteEntityResponseCollection = {
  __typename?: 'FavoriteEntityResponseCollection';
  data: Array<FavoriteEntity>;
  meta: ResponseCollectionMeta;
};

export type FavoriteFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<FavoriteFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  metadata?: InputMaybe<JsonFilterInput>;
  not?: InputMaybe<FavoriteFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<FavoriteFiltersInput>>>;
  relationId?: InputMaybe<LongFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type FavoriteInput = {
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  relationId?: InputMaybe<Scalars['Long']['input']>;
  type?: InputMaybe<Enum_Favorite_Type>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type FavouritePage = {
  __typename?: 'FavouritePage';
  addFavourite: Scalars['String']['output'];
  courseTitle?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  noCoursesFoundMsg?: Maybe<Scalars['String']['output']>;
  noPodcastsFoundMsg: Scalars['String']['output'];
  noResourcesFoundMsg: Scalars['String']['output'];
  podcastTitle: Scalars['String']['output'];
  removeFavourtieBtn: Scalars['String']['output'];
  resourcesTitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  yourFavouriteTitle: Scalars['String']['output'];
};

export type FavouritePageEntity = {
  __typename?: 'FavouritePageEntity';
  attributes?: Maybe<FavouritePage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type FavouritePageEntityResponse = {
  __typename?: 'FavouritePageEntityResponse';
  data?: Maybe<FavouritePageEntity>;
};

export type FavouritePageInput = {
  addFavourite?: InputMaybe<Scalars['String']['input']>;
  courseTitle?: InputMaybe<Scalars['String']['input']>;
  noCoursesFoundMsg?: InputMaybe<Scalars['String']['input']>;
  noPodcastsFoundMsg?: InputMaybe<Scalars['String']['input']>;
  noResourcesFoundMsg?: InputMaybe<Scalars['String']['input']>;
  podcastTitle?: InputMaybe<Scalars['String']['input']>;
  removeFavourtieBtn?: InputMaybe<Scalars['String']['input']>;
  resourcesTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  yourFavouriteTitle?: InputMaybe<Scalars['String']['input']>;
};

export type FeatureFrequency = {
  __typename?: 'FeatureFrequency';
  averageUseInSeconds?: Maybe<Scalars['Int']['output']>;
  feature?: Maybe<Scalars['String']['output']>;
  schoolId?: Maybe<Scalars['String']['output']>;
  schoolName?: Maybe<Scalars['String']['output']>;
};

export type FeatureUsage = {
  __typename?: 'FeatureUsage';
  feature?: Maybe<Scalars['String']['output']>;
  pageViewsCount?: Maybe<Scalars['Int']['output']>;
  schoolId?: Maybe<Scalars['String']['output']>;
  schoolName?: Maybe<Scalars['String']['output']>;
};

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contains?: InputMaybe<Scalars['Float']['input']>;
  containsi?: InputMaybe<Scalars['Float']['input']>;
  endsWith?: InputMaybe<Scalars['Float']['input']>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  eqi?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nei?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<FloatFilterInput>;
  notContains?: InputMaybe<Scalars['Float']['input']>;
  notContainsi?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  startsWith?: InputMaybe<Scalars['Float']['input']>;
};

export type ForgotPassword = {
  __typename?: 'ForgotPassword';
  backToLoginCta: Scalars['String']['output'];
  chooseANewPasswordTitle: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  feedback?: Maybe<ComponentRegisterFeedbackFeedback>;
  forgotPasswordTItle: Scalars['String']['output'];
  letUsKnowDescription: Scalars['String']['output'];
  logo: UploadFileEntityResponse;
  passwordsShouldBeDescription: Scalars['String']['output'];
  repeatYourPassword: Scalars['String']['output'];
  resetMyPasswordCta: Scalars['String']['output'];
  sendMeCta: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  yourEmail: Scalars['String']['output'];
  yourNewPassword: Scalars['String']['output'];
};

export type ForgotPasswordEntity = {
  __typename?: 'ForgotPasswordEntity';
  attributes?: Maybe<ForgotPassword>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ForgotPasswordEntityResponse = {
  __typename?: 'ForgotPasswordEntityResponse';
  data?: Maybe<ForgotPasswordEntity>;
};

export type ForgotPasswordInput = {
  backToLoginCta?: InputMaybe<Scalars['String']['input']>;
  chooseANewPasswordTitle?: InputMaybe<Scalars['String']['input']>;
  feedback?: InputMaybe<ComponentRegisterFeedbackFeedbackInput>;
  forgotPasswordTItle?: InputMaybe<Scalars['String']['input']>;
  letUsKnowDescription?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['ID']['input']>;
  passwordsShouldBeDescription?: InputMaybe<Scalars['String']['input']>;
  repeatYourPassword?: InputMaybe<Scalars['String']['input']>;
  resetMyPasswordCta?: InputMaybe<Scalars['String']['input']>;
  sendMeCta?: InputMaybe<Scalars['String']['input']>;
  yourEmail?: InputMaybe<Scalars['String']['input']>;
  yourNewPassword?: InputMaybe<Scalars['String']['input']>;
};

export type Frequency = {
  __typename?: 'Frequency';
  days?: Maybe<Scalars['Int']['output']>;
  feature?: Maybe<Scalars['String']['output']>;
  streaks?: Maybe<Streak>;
};

export type FrequencyBySchool = {
  __typename?: 'FrequencyBySchool';
  frequency?: Maybe<Frequency>;
  school?: Maybe<Scalars['Int']['output']>;
};

export type GenericMorph =
  | AboutPage
  | AdminOnboarding
  | Answer
  | AppVersionSetting
  | Author
  | Calendar
  | Category
  | CompletedTask
  | ComponentAdminOnboradingActivationPoster
  | ComponentAdminOnboradingChartsTitles
  | ComponentAdminOnboradingDashboard
  | ComponentAdminOnboradingFinishingCardEmotionWheel
  | ComponentAdminOnboradingHeader
  | ComponentAdminOnboradingInvitationPreview
  | ComponentAdminOnboradingInvitationUsingFile
  | ComponentAdminOnboradingSchoolManagement
  | ComponentAdminOnboradingStep1
  | ComponentAdminOnboradingStep2
  | ComponentAdminOnboradingTabs
  | ComponentCalendarCalendarFeedbackMessage
  | ComponentCalendarPodcast
  | ComponentCalendarRelatedcontentcalendar
  | ComponentCalendarResource
  | ComponentCommonAudio
  | ComponentCommonAuthor
  | ComponentCommonAuthorDetailed
  | ComponentCommonBreadcrumb
  | ComponentCommonBullet
  | ComponentCommonButton
  | ComponentCommonConfirmModal
  | ComponentCommonContentTemplateLabels
  | ComponentCommonDays
  | ComponentCommonDefaultContentTemplate
  | ComponentCommonDivider
  | ComponentCommonDownloadableContent
  | ComponentCommonDownloadableContentList
  | ComponentCommonEmailSent
  | ComponentCommonEmbedded
  | ComponentCommonFaq
  | ComponentCommonFaqComponent
  | ComponentCommonField
  | ComponentCommonFieldSelect
  | ComponentCommonGender
  | ComponentCommonH3
  | ComponentCommonInPartnershipWith
  | ComponentCommonLink
  | ComponentCommonLinkList
  | ComponentCommonList
  | ComponentCommonMedia
  | ComponentCommonMessageSection
  | ComponentCommonMinutes
  | ComponentCommonMonth
  | ComponentCommonObjectives
  | ComponentCommonObjectivesSection
  | ComponentCommonQuote
  | ComponentCommonRawTextWithLinks
  | ComponentCommonRelatedContent
  | ComponentCommonRoles
  | ComponentCommonSearchSection
  | ComponentCommonSidebarMenu
  | ComponentCommonSteps
  | ComponentCommonTags
  | ComponentCommonText
  | ComponentCommonTextEditor
  | ComponentCommonTheme
  | ComponentCommonTitle
  | ComponentCommonTitleText
  | ComponentCommonToast
  | ComponentCommonTranscript
  | ComponentCommonTranslations
  | ComponentCommonTypes
  | ComponentCommonWelcomePageMessage
  | ComponentCoursePageLesson
  | ComponentDailyBubblePageActivitySection
  | ComponentDailyBubblePageDailyInsightSection
  | ComponentDailyBubblePageFinishingCard
  | ComponentDailyBubblePageFinishingCardInsight
  | ComponentDailyBubblePageFinishingCardMindfulMinute
  | ComponentDailyBubblePageFinishingCardSurvey
  | ComponentDailyBubblePageHeaderSection
  | ComponentDailyBubblePageOnboardingQuestions
  | ComponentDailyBubblePageWelcomeCard
  | ComponentDefaultContentTemplateDailyInsightTemplates
  | ComponentDefaultContentTemplateEmotionalWheelTemplates
  | ComponentDefaultContentTemplateMindfulMinuteTemplates
  | ComponentDefaultContentTemplateNotificationTemplateList
  | ComponentDefaultContentTemplatePodcastNotification
  | ComponentDefaultContentTemplateResourceNotification
  | ComponentDefaultContentTemplateSectionDownloadableContent
  | ComponentEmailTemplateWelcomeEmailStaff
  | ComponentEmotionWheelFinalState
  | ComponentEmotionWheelLevel
  | ComponentEmotionWheelLevels
  | ComponentEmotionWheelMessages
  | ComponentEmotionWheelOnboarding
  | ComponentEmotionWheelTypeSection
  | ComponentHomeDailySection
  | ComponentHomeDoneSection
  | ComponentHomeSections
  | ComponentHomeStatsAndStreaks
  | ComponentHomeWelcomeOverlay
  | ComponentKnowledgeHubAllTimePopularFavouritesSection
  | ComponentKnowledgeHubHighlightOfTheWeek
  | ComponentKnowledgeHubHighlightSections
  | ComponentKnowledgeHubResourcesRelated
  | ComponentKnowledgeHubTrendingThisWeekSection
  | ComponentKnowledgeHubWellbeingAwarenessDaysSection
  | ComponentLearnCourseCategory
  | ComponentLearnCourseCompletedSection
  | ComponentLearnCourseFields
  | ComponentLearnCourseInfoBox
  | ComponentLearnCourseLesson
  | ComponentLearnCourseModule
  | ComponentLearnCourseRelatedContent
  | ComponentLearnFeebackSection
  | ComponentLearnFeedback
  | ComponentLearnHighlightContent
  | ComponentLearnMarkAsCompleteButton
  | ComponentLearnModalLeavePage
  | ComponentLearnNextLesson
  | ComponentLearnQuestions
  | ComponentLoginLoginFieldErrors
  | ComponentLoginToastMessagesLogin
  | ComponentMeditationHeader
  | ComponentMindfulMinuteCalmBreathing
  | ComponentMindfulMinuteCalmBreathingPage
  | ComponentMindfulMinuteQuote
  | ComponentMindfulMinuteQuotePage
  | ComponentMindfulMinuteVideo
  | ComponentMindfulMinuteVideoPage
  | ComponentNotificationPreferencePreferences
  | ComponentOnBoardingOnBoardingContainer
  | ComponentOnBoardingTimes
  | ComponentPodEmailTemplatePoscast
  | ComponentPodcastEmailTemplate
  | ComponentPodcastGetInTouch
  | ComponentPodcastIntro
  | ComponentProfileEmotionTrackingSection
  | ComponentProfilePageFinishingCardEmotions
  | ComponentProfilePageFinishingCardInsights
  | ComponentProfilePageFinishingCardMaxStreak
  | ComponentProfilePageFinishingCardMindfulMinutes
  | ComponentProfilePageFinishingCardStreak
  | ComponentProfilePageFinishingCardSurvey
  | ComponentProfilePageStatsAndStreaks
  | ComponentProfilePolicyLinksSection
  | ComponentProfileProfileInfoSection
  | ComponentProfileProfileNotificationsSection
  | ComponentProfileProfilePasswordSection
  | ComponentProfileProfileThemesSection
  | ComponentRegisterFeedbackFeedback
  | ComponentRegisterRegisterFieldErrors
  | ComponentRegisterToastMessagesRegister
  | ComponentReportingToolsStaffStatus
  | ComponentReportingToolsUsersEmptyState
  | ComponentSchollDomains
  | ComponentSchollTermDates
  | ComponentSchollWondeRoles
  | ComponentSharedMetaSocial
  | ComponentSharedSeo
  | ComponentSurveyAnswers
  | ComponentSurveyDashboardDownloadButton
  | ComponentSurveyDashboardSchoolsFilter
  | ComponentSurveyDashboardTableCategories
  | ComponentSurveyDashboardTableQuestion
  | ComponentSurveyDashboardTableResponses
  | ComponentSurveyDashboardTabs
  | ComponentSurveyDashboardToggle
  | ComponentSurveyHolidays
  | ComponentSurveyRepetableSurvey
  | ComponentSurveySingleSurvey
  | ComponentWildcardAnnouncementActions
  | ComponentWildcardAnnouncementDeleteDialog
  | ComponentWildcardAnnouncementForm
  | ComponentWildcardAnnouncementPreview
  | ComponentWildcardCta
  | ComponentWildcardValidation
  | CookiesPage
  | CopyrightPage
  | Course
  | CourseCategory
  | CourseFeedback
  | CoursePage
  | CourseType
  | DailyBubbleFinishedPage
  | DailyBubblePage
  | EdwinPluginSsoV4Roles
  | EdwinStrapiAuditLogsAuditLog
  | EmailSent
  | EmailTemplate
  | EmotionWheel
  | EmotionWheelPage
  | Favorite
  | FavouritePage
  | ForgotPassword
  | GlobalFooter
  | GlobalMenu
  | Guest
  | I18NLocale
  | ImportarDailyGame
  | ImportedUser
  | Insight
  | InsightPage
  | InteractionsGa
  | InvitedUser
  | KnowledgeHubPage
  | Learn
  | LearnItem
  | LearnPage
  | Like
  | LoginPage
  | LoginTracker
  | ManageUsersPage
  | Measure
  | Meditation
  | MeditationDetailPage
  | MeditationPage
  | MindfulExerciseType
  | MindfulMinute
  | MindfulMinutePage
  | MobileLogo
  | MobileSidebar
  | NotFoundPage
  | NotificationLog
  | NotificationsTemplate
  | OnBoardingPage
  | Podcast
  | PodcastEmailTemplate
  | PodcastInteraction
  | PodcastListeningTime
  | PodcastPage
  | PrivacyPolicyPage
  | ProfilePage
  | Question
  | Quote
  | QuotePage
  | RegisterPage
  | Resource
  | ResourceType
  | Scale
  | School
  | SearchPage
  | Setting
  | Step1
  | Step2
  | Step3
  | Step4
  | Step5
  | Subscription
  | Survey
  | SurveyDashboardPage
  | SurveyMethodology
  | SurveyUser
  | TermAndCondition
  | TermsAndConditionsPage
  | Theme
  | Topic
  | Tracking
  | UploadFile
  | UploadFolder
  | UserEmotionWheelTrackingDisabled
  | UsersPermissionsPermission
  | UsersPermissionsRole
  | UsersPermissionsUser
  | WellbeingAwarenessDaysCalendarPage
  | Wildcard
  | WildcardAdminPage
  | WordPictureGame
  | WordPictureGamePage
  | WsPermission;

export type GlobalFooter = {
  __typename?: 'GlobalFooter';
  copyright?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  edwinGroupLogo: UploadFileEntityResponse;
  facebookUrl?: Maybe<Scalars['String']['output']>;
  instagramUrl?: Maybe<Scalars['String']['output']>;
  linkedinUrl?: Maybe<Scalars['String']['output']>;
  links?: Maybe<Array<Maybe<ComponentCommonLink>>>;
  stillHumanlogo: UploadFileEntityResponse;
  twitterUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GlobalFooterLinksArgs = {
  filters?: InputMaybe<ComponentCommonLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GlobalFooterEntity = {
  __typename?: 'GlobalFooterEntity';
  attributes?: Maybe<GlobalFooter>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type GlobalFooterEntityResponse = {
  __typename?: 'GlobalFooterEntityResponse';
  data?: Maybe<GlobalFooterEntity>;
};

export type GlobalFooterInput = {
  copyright?: InputMaybe<Scalars['String']['input']>;
  edwinGroupLogo?: InputMaybe<Scalars['ID']['input']>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  instagramUrl?: InputMaybe<Scalars['String']['input']>;
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<InputMaybe<ComponentCommonLinkInput>>>;
  stillHumanlogo?: InputMaybe<Scalars['ID']['input']>;
  twitterUrl?: InputMaybe<Scalars['String']['input']>;
};

export type GlobalMenu = {
  __typename?: 'GlobalMenu';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  links?: Maybe<Array<Maybe<ComponentCommonLink>>>;
  logo: UploadFileEntityResponse;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GlobalMenuLinksArgs = {
  filters?: InputMaybe<ComponentCommonLinkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GlobalMenuEntity = {
  __typename?: 'GlobalMenuEntity';
  attributes?: Maybe<GlobalMenu>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type GlobalMenuEntityResponse = {
  __typename?: 'GlobalMenuEntityResponse';
  data?: Maybe<GlobalMenuEntity>;
};

export type GlobalMenuInput = {
  links?: InputMaybe<Array<InputMaybe<ComponentCommonLinkInput>>>;
  logo?: InputMaybe<Scalars['ID']['input']>;
};

export type Guest = {
  __typename?: 'Guest';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  podcasts?: Maybe<PodcastRelationResponseCollection>;
  questions?: Maybe<PodcastInteractionRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GuestPodcastsArgs = {
  filters?: InputMaybe<PodcastFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GuestQuestionsArgs = {
  filters?: InputMaybe<PodcastInteractionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GuestEntity = {
  __typename?: 'GuestEntity';
  attributes?: Maybe<Guest>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type GuestEntityResponse = {
  __typename?: 'GuestEntityResponse';
  data?: Maybe<GuestEntity>;
};

export type GuestEntityResponseCollection = {
  __typename?: 'GuestEntityResponseCollection';
  data: Array<GuestEntity>;
  meta: ResponseCollectionMeta;
};

export type GuestFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<GuestFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<GuestFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<GuestFiltersInput>>>;
  podcasts?: InputMaybe<PodcastFiltersInput>;
  questions?: InputMaybe<PodcastInteractionFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type GuestInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  podcasts?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  questions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type GuestRelationResponseCollection = {
  __typename?: 'GuestRelationResponseCollection';
  data: Array<GuestEntity>;
};

export type I18NLocale = {
  __typename?: 'I18NLocale';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type I18NLocaleEntity = {
  __typename?: 'I18NLocaleEntity';
  attributes?: Maybe<I18NLocale>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type I18NLocaleEntityResponse = {
  __typename?: 'I18NLocaleEntityResponse';
  data?: Maybe<I18NLocaleEntity>;
};

export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  data: Array<I18NLocaleEntity>;
  meta: ResponseCollectionMeta;
};

export type I18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<I18NLocaleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  containsi?: InputMaybe<Scalars['ID']['input']>;
  endsWith?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  eqi?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  nei?: InputMaybe<Scalars['ID']['input']>;
  not?: InputMaybe<IdFilterInput>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
  notContainsi?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startsWith?: InputMaybe<Scalars['ID']['input']>;
};

export type ImportarDailyGame = {
  __typename?: 'ImportarDailyGame';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  pictures: UploadFileEntityResponse;
  tips: UploadFileEntityResponse;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ImportarDailyGameEntity = {
  __typename?: 'ImportarDailyGameEntity';
  attributes?: Maybe<ImportarDailyGame>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ImportarDailyGameEntityResponse = {
  __typename?: 'ImportarDailyGameEntityResponse';
  data?: Maybe<ImportarDailyGameEntity>;
};

export type ImportarDailyGameInput = {
  pictures?: InputMaybe<Scalars['ID']['input']>;
  tips?: InputMaybe<Scalars['ID']['input']>;
};

export type ImportedUser = {
  __typename?: 'ImportedUser';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  forename?: Maybe<Scalars['String']['output']>;
  invitationEmailSent?: Maybe<Scalars['Boolean']['output']>;
  origin?: Maybe<Enum_Importeduser_Origin>;
  school?: Maybe<SchoolEntityResponse>;
  surname?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ImportedUserEntity = {
  __typename?: 'ImportedUserEntity';
  attributes?: Maybe<ImportedUser>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ImportedUserEntityResponse = {
  __typename?: 'ImportedUserEntityResponse';
  data?: Maybe<ImportedUserEntity>;
};

export type ImportedUserEntityResponseCollection = {
  __typename?: 'ImportedUserEntityResponseCollection';
  data: Array<ImportedUserEntity>;
  meta: ResponseCollectionMeta;
};

export type ImportedUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ImportedUserFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  forename?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  invitationEmailSent?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<ImportedUserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ImportedUserFiltersInput>>>;
  origin?: InputMaybe<StringFilterInput>;
  school?: InputMaybe<SchoolFiltersInput>;
  surname?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ImportedUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  forename?: InputMaybe<Scalars['String']['input']>;
  invitationEmailSent?: InputMaybe<Scalars['Boolean']['input']>;
  origin?: InputMaybe<Enum_Importeduser_Origin>;
  school?: InputMaybe<Scalars['ID']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type ImportedUserRelationResponseCollection = {
  __typename?: 'ImportedUserRelationResponseCollection';
  data: Array<ImportedUserEntity>;
};

export type Insight = {
  __typename?: 'Insight';
  DefaultContentTemplate?: Maybe<Array<Maybe<InsightDefaultContentTemplateDynamicZone>>>;
  cover?: Maybe<UploadFileEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  day: Scalars['Date']['output'];
  duration: Scalars['String']['output'];
  forceUpdateFromOriginalResource?: Maybe<Scalars['Boolean']['output']>;
  resource?: Maybe<ResourceEntityResponse>;
  subHeader?: Maybe<Scalars['String']['output']>;
  themes?: Maybe<ThemeRelationResponseCollection>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type InsightThemesArgs = {
  filters?: InputMaybe<ThemeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type InsightDefaultContentTemplateDynamicZone =
  | ComponentCommonAuthor
  | ComponentCommonAuthorDetailed
  | ComponentCommonButton
  | ComponentCommonDivider
  | ComponentCommonDownloadableContentList
  | ComponentCommonEmbedded
  | ComponentCommonH3
  | ComponentCommonMedia
  | ComponentCommonTextEditor
  | ComponentCommonTheme
  | ComponentCommonTitle
  | ComponentCommonTranscript
  | Error;

export type InsightEntity = {
  __typename?: 'InsightEntity';
  attributes?: Maybe<Insight>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type InsightEntityResponse = {
  __typename?: 'InsightEntityResponse';
  data?: Maybe<InsightEntity>;
};

export type InsightEntityResponseCollection = {
  __typename?: 'InsightEntityResponseCollection';
  data: Array<InsightEntity>;
  meta: ResponseCollectionMeta;
};

export type InsightFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<InsightFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  day?: InputMaybe<DateFilterInput>;
  duration?: InputMaybe<StringFilterInput>;
  forceUpdateFromOriginalResource?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<InsightFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<InsightFiltersInput>>>;
  resource?: InputMaybe<ResourceFiltersInput>;
  subHeader?: InputMaybe<StringFilterInput>;
  themes?: InputMaybe<ThemeFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type InsightInput = {
  DefaultContentTemplate?: InputMaybe<Array<Scalars['InsightDefaultContentTemplateDynamicZoneInput']['input']>>;
  cover?: InputMaybe<Scalars['ID']['input']>;
  day?: InputMaybe<Scalars['Date']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  forceUpdateFromOriginalResource?: InputMaybe<Scalars['Boolean']['input']>;
  resource?: InputMaybe<Scalars['ID']['input']>;
  subHeader?: InputMaybe<Scalars['String']['input']>;
  themes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type InsightPage = {
  __typename?: 'InsightPage';
  btnViewFullContentLabel?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  relatedContentTitle?: Maybe<Scalars['String']['output']>;
  relatedContentViewAllLabel?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type InsightPageEntity = {
  __typename?: 'InsightPageEntity';
  attributes?: Maybe<InsightPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type InsightPageEntityResponse = {
  __typename?: 'InsightPageEntityResponse';
  data?: Maybe<InsightPageEntity>;
};

export type InsightPageInput = {
  btnViewFullContentLabel?: InputMaybe<Scalars['String']['input']>;
  relatedContentTitle?: InputMaybe<Scalars['String']['input']>;
  relatedContentViewAllLabel?: InputMaybe<Scalars['String']['input']>;
};

export type InsightRelationResponseCollection = {
  __typename?: 'InsightRelationResponseCollection';
  data: Array<InsightEntity>;
};

export type IntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  contains?: InputMaybe<Scalars['Int']['input']>;
  containsi?: InputMaybe<Scalars['Int']['input']>;
  endsWith?: InputMaybe<Scalars['Int']['input']>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  eqi?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  nei?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntFilterInput>;
  notContains?: InputMaybe<Scalars['Int']['input']>;
  notContainsi?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startsWith?: InputMaybe<Scalars['Int']['input']>;
};

export type InteractionsGaGetActiveUsers = {
  __typename?: 'InteractionsGAGetActiveUsers';
  countUniqueUsers?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  eventName?: Maybe<Scalars['String']['output']>;
  schoolId?: Maybe<Scalars['String']['output']>;
  schoolName?: Maybe<Scalars['String']['output']>;
};

export type InteractionsGaGetActiveUsersData = {
  __typename?: 'InteractionsGAGetActiveUsersData';
  data?: Maybe<Array<Maybe<InteractionsGaGetActiveUsers>>>;
  totalActiveUsers?: Maybe<Scalars['Int']['output']>;
  totalUsers?: Maybe<Scalars['Int']['output']>;
};

export type InteractionsGa = {
  __typename?: 'InteractionsGa';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  deviceCategory?: Maybe<Scalars['String']['output']>;
  eventName: Scalars['String']['output'];
  feature?: Maybe<Enum_Interactionsga_Feature>;
  metric?: Maybe<Enum_Interactionsga_Metric>;
  metricValue: Scalars['String']['output'];
  pageTitle?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  schoolId: Scalars['String']['output'];
  unifiedScreenName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type InteractionsGaEntity = {
  __typename?: 'InteractionsGaEntity';
  attributes?: Maybe<InteractionsGa>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type InteractionsGaEntityResponse = {
  __typename?: 'InteractionsGaEntityResponse';
  data?: Maybe<InteractionsGaEntity>;
};

export type InteractionsGaEntityResponseCollection = {
  __typename?: 'InteractionsGaEntityResponseCollection';
  data: Array<InteractionsGaEntity>;
  meta: ResponseCollectionMeta;
};

export type InteractionsGaFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<InteractionsGaFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  date?: InputMaybe<DateFilterInput>;
  deviceCategory?: InputMaybe<StringFilterInput>;
  eventName?: InputMaybe<StringFilterInput>;
  feature?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  metric?: InputMaybe<StringFilterInput>;
  metricValue?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<InteractionsGaFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<InteractionsGaFiltersInput>>>;
  pageTitle?: InputMaybe<StringFilterInput>;
  path?: InputMaybe<StringFilterInput>;
  schoolId?: InputMaybe<StringFilterInput>;
  unifiedScreenName?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  userId?: InputMaybe<StringFilterInput>;
};

export type InteractionsGaInput = {
  date?: InputMaybe<Scalars['Date']['input']>;
  deviceCategory?: InputMaybe<Scalars['String']['input']>;
  eventName?: InputMaybe<Scalars['String']['input']>;
  feature?: InputMaybe<Enum_Interactionsga_Feature>;
  metric?: InputMaybe<Enum_Interactionsga_Metric>;
  metricValue?: InputMaybe<Scalars['String']['input']>;
  pageTitle?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  schoolId?: InputMaybe<Scalars['String']['input']>;
  unifiedScreenName?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type InvitedUser = {
  __typename?: 'InvitedUser';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  forename?: Maybe<Scalars['String']['output']>;
  invitationDate?: Maybe<Scalars['Date']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  school?: Maybe<SchoolEntityResponse>;
  surname?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type InvitedUserEntity = {
  __typename?: 'InvitedUserEntity';
  attributes?: Maybe<InvitedUser>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type InvitedUserEntityResponse = {
  __typename?: 'InvitedUserEntityResponse';
  data?: Maybe<InvitedUserEntity>;
};

export type InvitedUserEntityResponseCollection = {
  __typename?: 'InvitedUserEntityResponseCollection';
  data: Array<InvitedUserEntity>;
  meta: ResponseCollectionMeta;
};

export type InvitedUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<InvitedUserFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  forename?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  invitationDate?: InputMaybe<DateFilterInput>;
  not?: InputMaybe<InvitedUserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<InvitedUserFiltersInput>>>;
  role?: InputMaybe<StringFilterInput>;
  school?: InputMaybe<SchoolFiltersInput>;
  surname?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type InvitedUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  forename?: InputMaybe<Scalars['String']['input']>;
  invitationDate?: InputMaybe<Scalars['Date']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  school?: InputMaybe<Scalars['ID']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type InvitedUserRelationResponseCollection = {
  __typename?: 'InvitedUserRelationResponseCollection';
  data: Array<InvitedUserEntity>;
};

export type JsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  contains?: InputMaybe<Scalars['JSON']['input']>;
  containsi?: InputMaybe<Scalars['JSON']['input']>;
  endsWith?: InputMaybe<Scalars['JSON']['input']>;
  eq?: InputMaybe<Scalars['JSON']['input']>;
  eqi?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  ne?: InputMaybe<Scalars['JSON']['input']>;
  nei?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<JsonFilterInput>;
  notContains?: InputMaybe<Scalars['JSON']['input']>;
  notContainsi?: InputMaybe<Scalars['JSON']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  startsWith?: InputMaybe<Scalars['JSON']['input']>;
};

export type KnowledgeHubPage = {
  __typename?: 'KnowledgeHubPage';
  chooseAThemeTitle: Scalars['String']['output'];
  contentTemplateLabels?: Maybe<ComponentCommonContentTemplateLabels>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  highlightOfTheWeekTitle: Scalars['String']['output'];
  highlightSections?: Maybe<ComponentKnowledgeHubHighlightSections>;
  highlightTopicLabel?: Maybe<Scalars['String']['output']>;
  highlights?: Maybe<ResourceRelationResponseCollection>;
  latestTitle: Scalars['String']['output'];
  moreButotnTItle: Scalars['String']['output'];
  searchSection?: Maybe<ComponentCommonSearchSection>;
  topics?: Maybe<TopicRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  welcomePageMessage?: Maybe<ComponentCommonWelcomePageMessage>;
};

export type KnowledgeHubPageHighlightsArgs = {
  filters?: InputMaybe<ResourceFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type KnowledgeHubPageTopicsArgs = {
  filters?: InputMaybe<TopicFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type KnowledgeHubPageEntity = {
  __typename?: 'KnowledgeHubPageEntity';
  attributes?: Maybe<KnowledgeHubPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type KnowledgeHubPageEntityResponse = {
  __typename?: 'KnowledgeHubPageEntityResponse';
  data?: Maybe<KnowledgeHubPageEntity>;
};

export type KnowledgeHubPageInput = {
  chooseAThemeTitle?: InputMaybe<Scalars['String']['input']>;
  contentTemplateLabels?: InputMaybe<ComponentCommonContentTemplateLabelsInput>;
  highlightOfTheWeekTitle?: InputMaybe<Scalars['String']['input']>;
  highlightSections?: InputMaybe<ComponentKnowledgeHubHighlightSectionsInput>;
  highlightTopicLabel?: InputMaybe<Scalars['String']['input']>;
  highlights?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  latestTitle?: InputMaybe<Scalars['String']['input']>;
  moreButotnTItle?: InputMaybe<Scalars['String']['input']>;
  searchSection?: InputMaybe<ComponentCommonSearchSectionInput>;
  topics?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  welcomePageMessage?: InputMaybe<ComponentCommonWelcomePageMessageInput>;
};

export type Learn = {
  __typename?: 'Learn';
  completed?: Maybe<Scalars['Boolean']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  course?: Maybe<CourseEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  learn_items?: Maybe<LearnItemRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users_permissions_user?: Maybe<UsersPermissionsUserEntityResponse>;
};

export type LearnLearn_ItemsArgs = {
  filters?: InputMaybe<LearnItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LearnEntity = {
  __typename?: 'LearnEntity';
  attributes?: Maybe<Learn>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type LearnEntityResponse = {
  __typename?: 'LearnEntityResponse';
  data?: Maybe<LearnEntity>;
};

export type LearnEntityResponseCollection = {
  __typename?: 'LearnEntityResponseCollection';
  data: Array<LearnEntity>;
  meta: ResponseCollectionMeta;
};

export type LearnFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LearnFiltersInput>>>;
  completed?: InputMaybe<BooleanFilterInput>;
  completedAt?: InputMaybe<DateTimeFilterInput>;
  course?: InputMaybe<CourseFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  learn_items?: InputMaybe<LearnItemFiltersInput>;
  not?: InputMaybe<LearnFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LearnFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users_permissions_user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type LearnInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  course?: InputMaybe<Scalars['ID']['input']>;
  learn_items?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  users_permissions_user?: InputMaybe<Scalars['ID']['input']>;
};

export type LearnItem = {
  __typename?: 'LearnItem';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  idLesson: Scalars['String']['output'];
  idModule: Scalars['String']['output'];
  learn?: Maybe<LearnEntityResponse>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LearnItemEntity = {
  __typename?: 'LearnItemEntity';
  attributes?: Maybe<LearnItem>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type LearnItemEntityResponse = {
  __typename?: 'LearnItemEntityResponse';
  data?: Maybe<LearnItemEntity>;
};

export type LearnItemEntityResponseCollection = {
  __typename?: 'LearnItemEntityResponseCollection';
  data: Array<LearnItemEntity>;
  meta: ResponseCollectionMeta;
};

export type LearnItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LearnItemFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  idLesson?: InputMaybe<StringFilterInput>;
  idModule?: InputMaybe<StringFilterInput>;
  learn?: InputMaybe<LearnFiltersInput>;
  metadata?: InputMaybe<JsonFilterInput>;
  not?: InputMaybe<LearnItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LearnItemFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type LearnItemInput = {
  idLesson?: InputMaybe<Scalars['String']['input']>;
  idModule?: InputMaybe<Scalars['String']['input']>;
  learn?: InputMaybe<Scalars['ID']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
};

export type LearnItemRelationResponseCollection = {
  __typename?: 'LearnItemRelationResponseCollection';
  data: Array<LearnItemEntity>;
};

export type LearnPage = {
  __typename?: 'LearnPage';
  contentTemplateLabels?: Maybe<ComponentCommonContentTemplateLabels>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  emptyCompletedCoursesMessage?: Maybe<Scalars['String']['output']>;
  emptyInProgressCoursesMessage?: Maybe<Scalars['String']['output']>;
  feedbackSection?: Maybe<ComponentLearnFeebackSection>;
  markCourseAsCompleted?: Maybe<ComponentLearnMarkAsCompleteButton>;
  markLessonAsCompleteButton?: Maybe<ComponentLearnMarkAsCompleteButton>;
  modalLeavePage?: Maybe<ComponentLearnModalLeavePage>;
  modalMarkCourseAsCompleted?: Maybe<ComponentCommonConfirmModal>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  searchSection?: Maybe<ComponentCommonSearchSection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  welcomePageMessage?: Maybe<ComponentCommonWelcomePageMessage>;
};

export type LearnPageEntity = {
  __typename?: 'LearnPageEntity';
  attributes?: Maybe<LearnPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type LearnPageEntityResponse = {
  __typename?: 'LearnPageEntityResponse';
  data?: Maybe<LearnPageEntity>;
};

export type LearnPageInput = {
  contentTemplateLabels?: InputMaybe<ComponentCommonContentTemplateLabelsInput>;
  emptyCompletedCoursesMessage?: InputMaybe<Scalars['String']['input']>;
  emptyInProgressCoursesMessage?: InputMaybe<Scalars['String']['input']>;
  feedbackSection?: InputMaybe<ComponentLearnFeebackSectionInput>;
  markCourseAsCompleted?: InputMaybe<ComponentLearnMarkAsCompleteButtonInput>;
  markLessonAsCompleteButton?: InputMaybe<ComponentLearnMarkAsCompleteButtonInput>;
  modalLeavePage?: InputMaybe<ComponentLearnModalLeavePageInput>;
  modalMarkCourseAsCompleted?: InputMaybe<ComponentCommonConfirmModalInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  searchSection?: InputMaybe<ComponentCommonSearchSectionInput>;
  welcomePageMessage?: InputMaybe<ComponentCommonWelcomePageMessageInput>;
};

export type Like = {
  __typename?: 'Like';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  lessonId?: Maybe<Scalars['Long']['output']>;
  moduleId?: Maybe<Scalars['Long']['output']>;
  relationID: Scalars['Long']['output'];
  type: Enum_Like_Type;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<UsersPermissionsUserEntityResponse>;
};

export type LikeEntity = {
  __typename?: 'LikeEntity';
  attributes?: Maybe<Like>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type LikeEntityResponse = {
  __typename?: 'LikeEntityResponse';
  data?: Maybe<LikeEntity>;
};

export type LikeEntityResponseCollection = {
  __typename?: 'LikeEntityResponseCollection';
  data: Array<LikeEntity>;
  meta: ResponseCollectionMeta;
};

export type LikeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LikeFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  lessonId?: InputMaybe<LongFilterInput>;
  moduleId?: InputMaybe<LongFilterInput>;
  not?: InputMaybe<LikeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LikeFiltersInput>>>;
  relationID?: InputMaybe<LongFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type LikeInput = {
  lessonId?: InputMaybe<Scalars['Long']['input']>;
  moduleId?: InputMaybe<Scalars['Long']['input']>;
  relationID?: InputMaybe<Scalars['Long']['input']>;
  type?: InputMaybe<Enum_Like_Type>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type LoginPage = {
  __typename?: 'LoginPage';
  confirmEmailTitle: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fieldErrors?: Maybe<ComponentLoginLoginFieldErrors>;
  forgotYourPasswordCta: Scalars['String']['output'];
  loginCta: Scalars['String']['output'];
  loginTitle: Scalars['String']['output'];
  logo: UploadFileEntityResponse;
  pleaseLoginTItle: Scalars['String']['output'];
  popUpMessages?: Maybe<ComponentLoginToastMessagesLogin>;
  rememberMeTitle: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  yourEmailTitle: Scalars['String']['output'];
  yourPasswordTitle: Scalars['String']['output'];
};

export type LoginPageEntity = {
  __typename?: 'LoginPageEntity';
  attributes?: Maybe<LoginPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type LoginPageEntityResponse = {
  __typename?: 'LoginPageEntityResponse';
  data?: Maybe<LoginPageEntity>;
};

export type LoginPageInput = {
  confirmEmailTitle?: InputMaybe<Scalars['String']['input']>;
  fieldErrors?: InputMaybe<ComponentLoginLoginFieldErrorsInput>;
  forgotYourPasswordCta?: InputMaybe<Scalars['String']['input']>;
  loginCta?: InputMaybe<Scalars['String']['input']>;
  loginTitle?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['ID']['input']>;
  pleaseLoginTItle?: InputMaybe<Scalars['String']['input']>;
  popUpMessages?: InputMaybe<ComponentLoginToastMessagesLoginInput>;
  rememberMeTitle?: InputMaybe<Scalars['String']['input']>;
  yourEmailTitle?: InputMaybe<Scalars['String']['input']>;
  yourPasswordTitle?: InputMaybe<Scalars['String']['input']>;
};

export type LoginTracker = {
  __typename?: 'LoginTracker';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  day?: Maybe<Scalars['Date']['output']>;
  streakCounter?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<UsersPermissionsUserEntityResponse>;
};

export type LoginTrackerEntity = {
  __typename?: 'LoginTrackerEntity';
  attributes?: Maybe<LoginTracker>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type LoginTrackerEntityResponse = {
  __typename?: 'LoginTrackerEntityResponse';
  data?: Maybe<LoginTrackerEntity>;
};

export type LoginTrackerEntityResponseCollection = {
  __typename?: 'LoginTrackerEntityResponseCollection';
  data: Array<LoginTrackerEntity>;
  meta: ResponseCollectionMeta;
};

export type LoginTrackerFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LoginTrackerFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  day?: InputMaybe<DateFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<LoginTrackerFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LoginTrackerFiltersInput>>>;
  streakCounter?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type LoginTrackerInput = {
  day?: InputMaybe<Scalars['Date']['input']>;
  streakCounter?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type LongFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  contains?: InputMaybe<Scalars['Long']['input']>;
  containsi?: InputMaybe<Scalars['Long']['input']>;
  endsWith?: InputMaybe<Scalars['Long']['input']>;
  eq?: InputMaybe<Scalars['Long']['input']>;
  eqi?: InputMaybe<Scalars['Long']['input']>;
  gt?: InputMaybe<Scalars['Long']['input']>;
  gte?: InputMaybe<Scalars['Long']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  lt?: InputMaybe<Scalars['Long']['input']>;
  lte?: InputMaybe<Scalars['Long']['input']>;
  ne?: InputMaybe<Scalars['Long']['input']>;
  nei?: InputMaybe<Scalars['Long']['input']>;
  not?: InputMaybe<LongFilterInput>;
  notContains?: InputMaybe<Scalars['Long']['input']>;
  notContainsi?: InputMaybe<Scalars['Long']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  startsWith?: InputMaybe<Scalars['Long']['input']>;
};

export type ManageUsersPage = {
  __typename?: 'ManageUsersPage';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  staffEmptyState?: Maybe<ComponentReportingToolsUsersEmptyState>;
  staffListTitle?: Maybe<Scalars['String']['output']>;
  staffStatus?: Maybe<ComponentReportingToolsStaffStatus>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ManageUsersPageEntity = {
  __typename?: 'ManageUsersPageEntity';
  attributes?: Maybe<ManageUsersPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ManageUsersPageEntityResponse = {
  __typename?: 'ManageUsersPageEntityResponse';
  data?: Maybe<ManageUsersPageEntity>;
};

export type ManageUsersPageInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  staffEmptyState?: InputMaybe<ComponentReportingToolsUsersEmptyStateInput>;
  staffListTitle?: InputMaybe<Scalars['String']['input']>;
  staffStatus?: InputMaybe<ComponentReportingToolsStaffStatusInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Measure = {
  __typename?: 'Measure';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  measure: Scalars['String']['output'];
  questions?: Maybe<QuestionRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MeasureQuestionsArgs = {
  filters?: InputMaybe<QuestionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MeasureEntity = {
  __typename?: 'MeasureEntity';
  attributes?: Maybe<Measure>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type MeasureEntityResponse = {
  __typename?: 'MeasureEntityResponse';
  data?: Maybe<MeasureEntity>;
};

export type MeasureEntityResponseCollection = {
  __typename?: 'MeasureEntityResponseCollection';
  data: Array<MeasureEntity>;
  meta: ResponseCollectionMeta;
};

export type MeasureFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<MeasureFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  measure?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<MeasureFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<MeasureFiltersInput>>>;
  questions?: InputMaybe<QuestionFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type MeasureInput = {
  measure?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type Meditation = {
  __typename?: 'Meditation';
  audio?: Maybe<ComponentCommonAudio>;
  briefDescription: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  duration: Scalars['String']['output'];
  mindful_exercise_type?: Maybe<MindfulExerciseTypeEntityResponse>;
  presentedBy: Scalars['String']['output'];
  publicationDate?: Maybe<Scalars['Date']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  relatedContent?: Maybe<MeditationRelationResponseCollection>;
  slug?: Maybe<Scalars['String']['output']>;
  subHeader: Scalars['String']['output'];
  themes?: Maybe<ThemeRelationResponseCollection>;
  title: Scalars['String']['output'];
  type: Enum_Meditation_Type;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  video?: Maybe<UploadFileEntityResponse>;
};

export type MeditationRelatedContentArgs = {
  filters?: InputMaybe<MeditationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MeditationThemesArgs = {
  filters?: InputMaybe<ThemeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MeditationDetailPage = {
  __typename?: 'MeditationDetailPage';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  goToTheMeditationBtn: Scalars['String']['output'];
  moreBtn: Scalars['String']['output'];
  pauseBtn: Scalars['String']['output'];
  startBtn?: Maybe<Scalars['String']['output']>;
  stopBtn: Scalars['String']['output'];
  thankYou?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  youMayAlsoLikeTitle: Scalars['String']['output'];
};

export type MeditationDetailPageEntity = {
  __typename?: 'MeditationDetailPageEntity';
  attributes?: Maybe<MeditationDetailPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type MeditationDetailPageEntityResponse = {
  __typename?: 'MeditationDetailPageEntityResponse';
  data?: Maybe<MeditationDetailPageEntity>;
};

export type MeditationDetailPageInput = {
  goToTheMeditationBtn?: InputMaybe<Scalars['String']['input']>;
  moreBtn?: InputMaybe<Scalars['String']['input']>;
  pauseBtn?: InputMaybe<Scalars['String']['input']>;
  startBtn?: InputMaybe<Scalars['String']['input']>;
  stopBtn?: InputMaybe<Scalars['String']['input']>;
  thankYou?: InputMaybe<Scalars['String']['input']>;
  youMayAlsoLikeTitle?: InputMaybe<Scalars['String']['input']>;
};

export type MeditationEntity = {
  __typename?: 'MeditationEntity';
  attributes?: Maybe<Meditation>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type MeditationEntityResponse = {
  __typename?: 'MeditationEntityResponse';
  data?: Maybe<MeditationEntity>;
};

export type MeditationEntityResponseCollection = {
  __typename?: 'MeditationEntityResponseCollection';
  data: Array<MeditationEntity>;
  meta: ResponseCollectionMeta;
};

export type MeditationFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<MeditationFiltersInput>>>;
  audio?: InputMaybe<ComponentCommonAudioFiltersInput>;
  briefDescription?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  duration?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  mindful_exercise_type?: InputMaybe<MindfulExerciseTypeFiltersInput>;
  not?: InputMaybe<MeditationFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<MeditationFiltersInput>>>;
  presentedBy?: InputMaybe<StringFilterInput>;
  publicationDate?: InputMaybe<DateFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  relatedContent?: InputMaybe<MeditationFiltersInput>;
  slug?: InputMaybe<StringFilterInput>;
  subHeader?: InputMaybe<StringFilterInput>;
  themes?: InputMaybe<ThemeFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type MeditationInput = {
  audio?: InputMaybe<ComponentCommonAudioInput>;
  briefDescription?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  mindful_exercise_type?: InputMaybe<Scalars['ID']['input']>;
  presentedBy?: InputMaybe<Scalars['String']['input']>;
  publicationDate?: InputMaybe<Scalars['Date']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  relatedContent?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subHeader?: InputMaybe<Scalars['String']['input']>;
  themes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Enum_Meditation_Type>;
  video?: InputMaybe<Scalars['ID']['input']>;
};

export type MeditationPage = {
  __typename?: 'MeditationPage';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  goToTheMeditationBtn: Scalars['String']['output'];
  header: ComponentMeditationHeader;
  moreBtn: Scalars['String']['output'];
  sectionLabel?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MeditationPageEntity = {
  __typename?: 'MeditationPageEntity';
  attributes?: Maybe<MeditationPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type MeditationPageEntityResponse = {
  __typename?: 'MeditationPageEntityResponse';
  data?: Maybe<MeditationPageEntity>;
};

export type MeditationPageInput = {
  goToTheMeditationBtn?: InputMaybe<Scalars['String']['input']>;
  header?: InputMaybe<ComponentMeditationHeaderInput>;
  moreBtn?: InputMaybe<Scalars['String']['input']>;
  sectionLabel?: InputMaybe<Scalars['String']['input']>;
};

export type MeditationRelationResponseCollection = {
  __typename?: 'MeditationRelationResponseCollection';
  data: Array<MeditationEntity>;
};

export type MindfulExerciseType = {
  __typename?: 'MindfulExerciseType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MindfulExerciseTypeEntity = {
  __typename?: 'MindfulExerciseTypeEntity';
  attributes?: Maybe<MindfulExerciseType>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type MindfulExerciseTypeEntityResponse = {
  __typename?: 'MindfulExerciseTypeEntityResponse';
  data?: Maybe<MindfulExerciseTypeEntity>;
};

export type MindfulExerciseTypeEntityResponseCollection = {
  __typename?: 'MindfulExerciseTypeEntityResponseCollection';
  data: Array<MindfulExerciseTypeEntity>;
  meta: ResponseCollectionMeta;
};

export type MindfulExerciseTypeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<MindfulExerciseTypeFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<MindfulExerciseTypeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<MindfulExerciseTypeFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type MindfulExerciseTypeInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MindfulMinute = {
  __typename?: 'MindfulMinute';
  calmBreathing?: Maybe<ComponentMindfulMinuteCalmBreathing>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  date: Scalars['Date']['output'];
  prompt?: Maybe<ComponentMindfulMinuteQuote>;
  type: Enum_Mindfulminute_Type;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  video?: Maybe<ComponentMindfulMinuteVideo>;
};

export type MindfulMinuteEntity = {
  __typename?: 'MindfulMinuteEntity';
  attributes?: Maybe<MindfulMinute>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type MindfulMinuteEntityResponse = {
  __typename?: 'MindfulMinuteEntityResponse';
  data?: Maybe<MindfulMinuteEntity>;
};

export type MindfulMinuteEntityResponseCollection = {
  __typename?: 'MindfulMinuteEntityResponseCollection';
  data: Array<MindfulMinuteEntity>;
  meta: ResponseCollectionMeta;
};

export type MindfulMinuteFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<MindfulMinuteFiltersInput>>>;
  calmBreathing?: InputMaybe<ComponentMindfulMinuteCalmBreathingFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  date?: InputMaybe<DateFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<MindfulMinuteFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<MindfulMinuteFiltersInput>>>;
  prompt?: InputMaybe<ComponentMindfulMinuteQuoteFiltersInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  video?: InputMaybe<ComponentMindfulMinuteVideoFiltersInput>;
};

export type MindfulMinuteInput = {
  calmBreathing?: InputMaybe<ComponentMindfulMinuteCalmBreathingInput>;
  date?: InputMaybe<Scalars['Date']['input']>;
  prompt?: InputMaybe<ComponentMindfulMinuteQuoteInput>;
  type?: InputMaybe<Enum_Mindfulminute_Type>;
  video?: InputMaybe<ComponentMindfulMinuteVideoInput>;
};

export type MindfulMinutePage = {
  __typename?: 'MindfulMinutePage';
  CalmBreathingPage?: Maybe<ComponentMindfulMinuteCalmBreathingPage>;
  QuotePage?: Maybe<ComponentMindfulMinuteQuotePage>;
  VideoPage?: Maybe<ComponentMindfulMinuteVideoPage>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  goToTheMeditationBtn?: Maybe<Scalars['String']['output']>;
  mindfulExerciseRelatedContent?: Maybe<MeditationRelationResponseCollection>;
  onboarding?: Maybe<ComponentEmotionWheelOnboarding>;
  relatedContent?: Maybe<TopicEntityResponse>;
  relatedContentTitle?: Maybe<Scalars['String']['output']>;
  relatedContentViewAllLabel?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MindfulMinutePageMindfulExerciseRelatedContentArgs = {
  filters?: InputMaybe<MeditationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MindfulMinutePageEntity = {
  __typename?: 'MindfulMinutePageEntity';
  attributes?: Maybe<MindfulMinutePage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type MindfulMinutePageEntityResponse = {
  __typename?: 'MindfulMinutePageEntityResponse';
  data?: Maybe<MindfulMinutePageEntity>;
};

export type MindfulMinutePageInput = {
  CalmBreathingPage?: InputMaybe<ComponentMindfulMinuteCalmBreathingPageInput>;
  QuotePage?: InputMaybe<ComponentMindfulMinuteQuotePageInput>;
  VideoPage?: InputMaybe<ComponentMindfulMinuteVideoPageInput>;
  goToTheMeditationBtn?: InputMaybe<Scalars['String']['input']>;
  mindfulExerciseRelatedContent?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  onboarding?: InputMaybe<ComponentEmotionWheelOnboardingInput>;
  relatedContent?: InputMaybe<Scalars['ID']['input']>;
  relatedContentTitle?: InputMaybe<Scalars['String']['input']>;
  relatedContentViewAllLabel?: InputMaybe<Scalars['String']['input']>;
};

export type MobileLogo = {
  __typename?: 'MobileLogo';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  forgotPassword: UploadFileEntityResponse;
  login: UploadFileEntityResponse;
  register: UploadFileEntityResponse;
  resetPassword: UploadFileEntityResponse;
  startApplicationBottom: UploadFileEntityResponse;
  startApplicationMiddle: UploadFileEntityResponse;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MobileLogoEntity = {
  __typename?: 'MobileLogoEntity';
  attributes?: Maybe<MobileLogo>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type MobileLogoEntityResponse = {
  __typename?: 'MobileLogoEntityResponse';
  data?: Maybe<MobileLogoEntity>;
};

export type MobileLogoInput = {
  forgotPassword?: InputMaybe<Scalars['ID']['input']>;
  login?: InputMaybe<Scalars['ID']['input']>;
  register?: InputMaybe<Scalars['ID']['input']>;
  resetPassword?: InputMaybe<Scalars['ID']['input']>;
  startApplicationBottom?: InputMaybe<Scalars['ID']['input']>;
  startApplicationMiddle?: InputMaybe<Scalars['ID']['input']>;
};

export type MobileSidebar = {
  __typename?: 'MobileSidebar';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  sidebarMenu?: Maybe<ComponentCommonSidebarMenu>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MobileSidebarEntity = {
  __typename?: 'MobileSidebarEntity';
  attributes?: Maybe<MobileSidebar>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type MobileSidebarEntityResponse = {
  __typename?: 'MobileSidebarEntityResponse';
  data?: Maybe<MobileSidebarEntity>;
};

export type MobileSidebarInput = {
  sidebarMenu?: InputMaybe<ComponentCommonSidebarMenuInput>;
};

export type MoodData = {
  __typename?: 'MoodData';
  emotion?: Maybe<Scalars['String']['output']>;
  idUser?: Maybe<Scalars['String']['output']>;
  schoolId?: Maybe<Scalars['String']['output']>;
  schoolName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<UsersPermissionsLoginPayload>;
  createAnswer?: Maybe<AnswerEntityResponse>;
  createAuthor?: Maybe<AuthorEntityResponse>;
  createCalendar?: Maybe<CalendarEntityResponse>;
  createCategory?: Maybe<CategoryEntityResponse>;
  createCompletedTask?: Maybe<CompletedTaskEntityResponse>;
  createCourse?: Maybe<CourseEntityResponse>;
  createCourseCategory?: Maybe<CourseCategoryEntityResponse>;
  createCourseFeedback?: Maybe<CourseFeedbackEntityResponse>;
  createCourseType?: Maybe<CourseTypeEntityResponse>;
  createEdwinPluginSsoV4Roles?: Maybe<EdwinPluginSsoV4RolesEntityResponse>;
  createEdwinStrapiAuditLogsAuditLog?: Maybe<EdwinStrapiAuditLogsAuditLogEntityResponse>;
  createEmailSent?: Maybe<EmailSentEntityResponse>;
  createEmotionWheel?: Maybe<EmotionWheelEntityResponse>;
  createFavorite?: Maybe<FavoriteEntityResponse>;
  createGuest?: Maybe<GuestEntityResponse>;
  createImportedUser?: Maybe<ImportedUserEntityResponse>;
  createInsight?: Maybe<InsightEntityResponse>;
  createInteractionsGa?: Maybe<InteractionsGaEntityResponse>;
  createInvitedUser?: Maybe<InvitedUserEntityResponse>;
  createLearn?: Maybe<LearnEntityResponse>;
  createLearnItem?: Maybe<LearnItemEntityResponse>;
  createLike?: Maybe<LikeEntityResponse>;
  createLoginTracker?: Maybe<LoginTrackerEntityResponse>;
  createMeasure?: Maybe<MeasureEntityResponse>;
  createMeditation?: Maybe<MeditationEntityResponse>;
  createMindfulExerciseType?: Maybe<MindfulExerciseTypeEntityResponse>;
  createMindfulMinute?: Maybe<MindfulMinuteEntityResponse>;
  createNotificationLog?: Maybe<NotificationLogEntityResponse>;
  createPodcast?: Maybe<PodcastEntityResponse>;
  createPodcastInteraction?: Maybe<PodcastInteractionEntityResponse>;
  createPodcastListeningTime?: Maybe<PodcastListeningTimeEntityResponse>;
  createQuestion?: Maybe<QuestionEntityResponse>;
  createQuote?: Maybe<QuoteEntityResponse>;
  createResource?: Maybe<ResourceEntityResponse>;
  createResourceType?: Maybe<ResourceTypeEntityResponse>;
  createScale?: Maybe<ScaleEntityResponse>;
  createSchool?: Maybe<SchoolEntityResponse>;
  createSetting?: Maybe<SettingEntityResponse>;
  createSubscription?: Maybe<SubscriptionEntityResponse>;
  createSurvey?: Maybe<SurveyEntityResponse>;
  createSurveyUser?: Maybe<SurveyUserEntityResponse>;
  createTheme?: Maybe<ThemeEntityResponse>;
  createTopic?: Maybe<TopicEntityResponse>;
  createTracking?: Maybe<TrackingEntityResponse>;
  createUploadFile?: Maybe<UploadFileEntityResponse>;
  createUploadFolder?: Maybe<UploadFolderEntityResponse>;
  createUserEmotionWheelTrackingDisabled?: Maybe<UserEmotionWheelTrackingDisabledEntityResponse>;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  createWildcard?: Maybe<WildcardEntityResponse>;
  createWordPictureGame?: Maybe<WordPictureGameEntityResponse>;
  createWsPermission?: Maybe<WsPermissionEntityResponse>;
  deleteAboutPage?: Maybe<AboutPageEntityResponse>;
  deleteAdminOnboarding?: Maybe<AdminOnboardingEntityResponse>;
  deleteAnswer?: Maybe<AnswerEntityResponse>;
  deleteAppVersionSetting?: Maybe<AppVersionSettingEntityResponse>;
  deleteAuthor?: Maybe<AuthorEntityResponse>;
  deleteCalendar?: Maybe<CalendarEntityResponse>;
  deleteCategory?: Maybe<CategoryEntityResponse>;
  deleteCompletedTask?: Maybe<CompletedTaskEntityResponse>;
  deleteCookiesPage?: Maybe<CookiesPageEntityResponse>;
  deleteCopyrightPage?: Maybe<CopyrightPageEntityResponse>;
  deleteCourse?: Maybe<CourseEntityResponse>;
  deleteCourseCategory?: Maybe<CourseCategoryEntityResponse>;
  deleteCourseFeedback?: Maybe<CourseFeedbackEntityResponse>;
  deleteCoursePage?: Maybe<CoursePageEntityResponse>;
  deleteCourseType?: Maybe<CourseTypeEntityResponse>;
  deleteDailyBubbleFinishedPage?: Maybe<DailyBubbleFinishedPageEntityResponse>;
  deleteDailyBubblePage?: Maybe<DailyBubblePageEntityResponse>;
  deleteEdwinPluginSsoV4Roles?: Maybe<EdwinPluginSsoV4RolesEntityResponse>;
  deleteEdwinStrapiAuditLogsAuditLog?: Maybe<EdwinStrapiAuditLogsAuditLogEntityResponse>;
  deleteEmailSent?: Maybe<EmailSentEntityResponse>;
  deleteEmailTemplate?: Maybe<EmailTemplateEntityResponse>;
  deleteEmotionWheel?: Maybe<EmotionWheelEntityResponse>;
  deleteEmotionWheelPage?: Maybe<EmotionWheelPageEntityResponse>;
  deleteFavorite?: Maybe<FavoriteEntityResponse>;
  deleteFavouritePage?: Maybe<FavouritePageEntityResponse>;
  deleteForgotPassword?: Maybe<ForgotPasswordEntityResponse>;
  deleteGlobalFooter?: Maybe<GlobalFooterEntityResponse>;
  deleteGlobalMenu?: Maybe<GlobalMenuEntityResponse>;
  deleteGuest?: Maybe<GuestEntityResponse>;
  deleteImportarDailyGame?: Maybe<ImportarDailyGameEntityResponse>;
  deleteImportedUser?: Maybe<ImportedUserEntityResponse>;
  deleteInsight?: Maybe<InsightEntityResponse>;
  deleteInsightPage?: Maybe<InsightPageEntityResponse>;
  deleteInteractionsGa?: Maybe<InteractionsGaEntityResponse>;
  deleteInvitedUser?: Maybe<InvitedUserEntityResponse>;
  deleteKnowledgeHubPage?: Maybe<KnowledgeHubPageEntityResponse>;
  deleteLearn?: Maybe<LearnEntityResponse>;
  deleteLearnItem?: Maybe<LearnItemEntityResponse>;
  deleteLearnPage?: Maybe<LearnPageEntityResponse>;
  deleteLike?: Maybe<LikeEntityResponse>;
  deleteLoginPage?: Maybe<LoginPageEntityResponse>;
  deleteLoginTracker?: Maybe<LoginTrackerEntityResponse>;
  deleteManageUsersPage?: Maybe<ManageUsersPageEntityResponse>;
  deleteMeasure?: Maybe<MeasureEntityResponse>;
  deleteMeditation?: Maybe<MeditationEntityResponse>;
  deleteMeditationDetailPage?: Maybe<MeditationDetailPageEntityResponse>;
  deleteMeditationPage?: Maybe<MeditationPageEntityResponse>;
  deleteMindfulExerciseType?: Maybe<MindfulExerciseTypeEntityResponse>;
  deleteMindfulMinute?: Maybe<MindfulMinuteEntityResponse>;
  deleteMindfulMinutePage?: Maybe<MindfulMinutePageEntityResponse>;
  deleteMobileLogo?: Maybe<MobileLogoEntityResponse>;
  deleteMobileSidebar?: Maybe<MobileSidebarEntityResponse>;
  deleteNotFoundPage?: Maybe<NotFoundPageEntityResponse>;
  deleteNotificationLog?: Maybe<NotificationLogEntityResponse>;
  deleteNotificationsTemplate?: Maybe<NotificationsTemplateEntityResponse>;
  deleteOnBoardingPage?: Maybe<OnBoardingPageEntityResponse>;
  deletePodcast?: Maybe<PodcastEntityResponse>;
  deletePodcastEmailTemplate?: Maybe<PodcastEmailTemplateEntityResponse>;
  deletePodcastInteraction?: Maybe<PodcastInteractionEntityResponse>;
  deletePodcastListeningTime?: Maybe<PodcastListeningTimeEntityResponse>;
  deletePodcastPage?: Maybe<PodcastPageEntityResponse>;
  deletePrivacyPolicyPage?: Maybe<PrivacyPolicyPageEntityResponse>;
  deleteProfilePage?: Maybe<ProfilePageEntityResponse>;
  deleteQuestion?: Maybe<QuestionEntityResponse>;
  deleteQuote?: Maybe<QuoteEntityResponse>;
  deleteQuotePage?: Maybe<QuotePageEntityResponse>;
  deleteRegisterPage?: Maybe<RegisterPageEntityResponse>;
  deleteResource?: Maybe<ResourceEntityResponse>;
  deleteResourceType?: Maybe<ResourceTypeEntityResponse>;
  deleteScale?: Maybe<ScaleEntityResponse>;
  deleteSchool?: Maybe<SchoolEntityResponse>;
  deleteSearchPage?: Maybe<SearchPageEntityResponse>;
  deleteSetting?: Maybe<SettingEntityResponse>;
  deleteStep1?: Maybe<Step1EntityResponse>;
  deleteStep2?: Maybe<Step2EntityResponse>;
  deleteStep3?: Maybe<Step3EntityResponse>;
  deleteStep4?: Maybe<Step4EntityResponse>;
  deleteStep5?: Maybe<Step5EntityResponse>;
  deleteSubscription?: Maybe<SubscriptionEntityResponse>;
  deleteSurvey?: Maybe<SurveyEntityResponse>;
  deleteSurveyDashboardPage?: Maybe<SurveyDashboardPageEntityResponse>;
  deleteSurveyMethodology?: Maybe<SurveyMethodologyEntityResponse>;
  deleteSurveyUser?: Maybe<SurveyUserEntityResponse>;
  deleteTermAndCondition?: Maybe<TermAndConditionEntityResponse>;
  deleteTermsAndConditionsPage?: Maybe<TermsAndConditionsPageEntityResponse>;
  deleteTheme?: Maybe<ThemeEntityResponse>;
  deleteTopic?: Maybe<TopicEntityResponse>;
  deleteTracking?: Maybe<TrackingEntityResponse>;
  deleteUploadFile?: Maybe<UploadFileEntityResponse>;
  deleteUploadFolder?: Maybe<UploadFolderEntityResponse>;
  deleteUserEmotionWheelTrackingDisabled?: Maybe<UserEmotionWheelTrackingDisabledEntityResponse>;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  deleteWellbeingAwarenessDaysCalendarPage?: Maybe<WellbeingAwarenessDaysCalendarPageEntityResponse>;
  deleteWildcard?: Maybe<WildcardEntityResponse>;
  deleteWildcardAdminPage?: Maybe<WildcardAdminPageEntityResponse>;
  deleteWordPictureGame?: Maybe<WordPictureGameEntityResponse>;
  deleteWordPictureGamePage?: Maybe<WordPictureGamePageEntityResponse>;
  deleteWsPermission?: Maybe<WsPermissionEntityResponse>;
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
  login: UsersPermissionsLoginPayload;
  multipleUpload: Array<Maybe<UploadFileEntityResponse>>;
  /** Register a user */
  register: UsersPermissionsLoginPayload;
  removeFile?: Maybe<UploadFileEntityResponse>;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  updateAboutPage?: Maybe<AboutPageEntityResponse>;
  updateAdminOnboarding?: Maybe<AdminOnboardingEntityResponse>;
  updateAnswer?: Maybe<AnswerEntityResponse>;
  updateAppVersionSetting?: Maybe<AppVersionSettingEntityResponse>;
  updateAuthor?: Maybe<AuthorEntityResponse>;
  updateCalendar?: Maybe<CalendarEntityResponse>;
  updateCategory?: Maybe<CategoryEntityResponse>;
  updateCompletedTask?: Maybe<CompletedTaskEntityResponse>;
  updateCookiesPage?: Maybe<CookiesPageEntityResponse>;
  updateCopyrightPage?: Maybe<CopyrightPageEntityResponse>;
  updateCourse?: Maybe<CourseEntityResponse>;
  updateCourseCategory?: Maybe<CourseCategoryEntityResponse>;
  updateCourseFeedback?: Maybe<CourseFeedbackEntityResponse>;
  updateCoursePage?: Maybe<CoursePageEntityResponse>;
  updateCourseType?: Maybe<CourseTypeEntityResponse>;
  updateDailyBubbleFinishedPage?: Maybe<DailyBubbleFinishedPageEntityResponse>;
  updateDailyBubblePage?: Maybe<DailyBubblePageEntityResponse>;
  updateEdwinPluginSsoV4Roles?: Maybe<EdwinPluginSsoV4RolesEntityResponse>;
  updateEdwinStrapiAuditLogsAuditLog?: Maybe<EdwinStrapiAuditLogsAuditLogEntityResponse>;
  updateEmailSent?: Maybe<EmailSentEntityResponse>;
  updateEmailTemplate?: Maybe<EmailTemplateEntityResponse>;
  updateEmotionWheel?: Maybe<EmotionWheelEntityResponse>;
  updateEmotionWheelPage?: Maybe<EmotionWheelPageEntityResponse>;
  updateFavorite?: Maybe<FavoriteEntityResponse>;
  updateFavouritePage?: Maybe<FavouritePageEntityResponse>;
  updateFileInfo: UploadFileEntityResponse;
  updateForgotPassword?: Maybe<ForgotPasswordEntityResponse>;
  updateGlobalFooter?: Maybe<GlobalFooterEntityResponse>;
  updateGlobalMenu?: Maybe<GlobalMenuEntityResponse>;
  updateGuest?: Maybe<GuestEntityResponse>;
  updateImportarDailyGame?: Maybe<ImportarDailyGameEntityResponse>;
  updateImportedUser?: Maybe<ImportedUserEntityResponse>;
  updateInsight?: Maybe<InsightEntityResponse>;
  updateInsightPage?: Maybe<InsightPageEntityResponse>;
  updateInteractionsGa?: Maybe<InteractionsGaEntityResponse>;
  updateInvitedUser?: Maybe<InvitedUserEntityResponse>;
  updateKnowledgeHubPage?: Maybe<KnowledgeHubPageEntityResponse>;
  updateLearn?: Maybe<LearnEntityResponse>;
  updateLearnItem?: Maybe<LearnItemEntityResponse>;
  updateLearnPage?: Maybe<LearnPageEntityResponse>;
  updateLike?: Maybe<LikeEntityResponse>;
  updateLoginPage?: Maybe<LoginPageEntityResponse>;
  updateLoginTracker?: Maybe<LoginTrackerEntityResponse>;
  updateManageUsersPage?: Maybe<ManageUsersPageEntityResponse>;
  updateMeasure?: Maybe<MeasureEntityResponse>;
  updateMeditation?: Maybe<MeditationEntityResponse>;
  updateMeditationDetailPage?: Maybe<MeditationDetailPageEntityResponse>;
  updateMeditationPage?: Maybe<MeditationPageEntityResponse>;
  updateMindfulExerciseType?: Maybe<MindfulExerciseTypeEntityResponse>;
  updateMindfulMinute?: Maybe<MindfulMinuteEntityResponse>;
  updateMindfulMinutePage?: Maybe<MindfulMinutePageEntityResponse>;
  updateMobileLogo?: Maybe<MobileLogoEntityResponse>;
  updateMobileSidebar?: Maybe<MobileSidebarEntityResponse>;
  updateNotFoundPage?: Maybe<NotFoundPageEntityResponse>;
  updateNotificationLog?: Maybe<NotificationLogEntityResponse>;
  updateNotificationsTemplate?: Maybe<NotificationsTemplateEntityResponse>;
  updateOnBoardingPage?: Maybe<OnBoardingPageEntityResponse>;
  updatePodcast?: Maybe<PodcastEntityResponse>;
  updatePodcastEmailTemplate?: Maybe<PodcastEmailTemplateEntityResponse>;
  updatePodcastInteraction?: Maybe<PodcastInteractionEntityResponse>;
  updatePodcastListeningTime?: Maybe<PodcastListeningTimeEntityResponse>;
  updatePodcastPage?: Maybe<PodcastPageEntityResponse>;
  updatePrivacyPolicyPage?: Maybe<PrivacyPolicyPageEntityResponse>;
  updateProfilePage?: Maybe<ProfilePageEntityResponse>;
  updateQuestion?: Maybe<QuestionEntityResponse>;
  updateQuote?: Maybe<QuoteEntityResponse>;
  updateQuotePage?: Maybe<QuotePageEntityResponse>;
  updateRegisterPage?: Maybe<RegisterPageEntityResponse>;
  updateResource?: Maybe<ResourceEntityResponse>;
  updateResourceType?: Maybe<ResourceTypeEntityResponse>;
  updateScale?: Maybe<ScaleEntityResponse>;
  updateSchool?: Maybe<SchoolEntityResponse>;
  updateSearchPage?: Maybe<SearchPageEntityResponse>;
  updateSetting?: Maybe<SettingEntityResponse>;
  updateStep1?: Maybe<Step1EntityResponse>;
  updateStep2?: Maybe<Step2EntityResponse>;
  updateStep3?: Maybe<Step3EntityResponse>;
  updateStep4?: Maybe<Step4EntityResponse>;
  updateStep5?: Maybe<Step5EntityResponse>;
  updateSubscription?: Maybe<SubscriptionEntityResponse>;
  updateSurvey?: Maybe<SurveyEntityResponse>;
  updateSurveyDashboardPage?: Maybe<SurveyDashboardPageEntityResponse>;
  updateSurveyMethodology?: Maybe<SurveyMethodologyEntityResponse>;
  updateSurveyUser?: Maybe<SurveyUserEntityResponse>;
  updateTermAndCondition?: Maybe<TermAndConditionEntityResponse>;
  updateTermsAndConditionsPage?: Maybe<TermsAndConditionsPageEntityResponse>;
  updateTheme?: Maybe<ThemeEntityResponse>;
  updateTopic?: Maybe<TopicEntityResponse>;
  updateTracking?: Maybe<TrackingEntityResponse>;
  updateUploadFile?: Maybe<UploadFileEntityResponse>;
  updateUploadFolder?: Maybe<UploadFolderEntityResponse>;
  updateUserEmotionWheelTrackingDisabled?: Maybe<UserEmotionWheelTrackingDisabledEntityResponse>;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  updateWellbeingAwarenessDaysCalendarPage?: Maybe<WellbeingAwarenessDaysCalendarPageEntityResponse>;
  updateWildcard?: Maybe<WildcardEntityResponse>;
  updateWildcardAdminPage?: Maybe<WildcardAdminPageEntityResponse>;
  updateWordPictureGame?: Maybe<WordPictureGameEntityResponse>;
  updateWordPictureGamePage?: Maybe<WordPictureGamePageEntityResponse>;
  updateWsPermission?: Maybe<WsPermissionEntityResponse>;
  upload: UploadFileEntityResponse;
};

export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};

export type MutationCreateAnswerArgs = {
  data: AnswerInput;
};

export type MutationCreateAuthorArgs = {
  data: AuthorInput;
};

export type MutationCreateCalendarArgs = {
  data: CalendarInput;
};

export type MutationCreateCategoryArgs = {
  data: CategoryInput;
};

export type MutationCreateCompletedTaskArgs = {
  data: CompletedTaskInput;
};

export type MutationCreateCourseArgs = {
  data: CourseInput;
};

export type MutationCreateCourseCategoryArgs = {
  data: CourseCategoryInput;
};

export type MutationCreateCourseFeedbackArgs = {
  data: CourseFeedbackInput;
};

export type MutationCreateCourseTypeArgs = {
  data: CourseTypeInput;
};

export type MutationCreateEdwinPluginSsoV4RolesArgs = {
  data: EdwinPluginSsoV4RolesInput;
};

export type MutationCreateEdwinStrapiAuditLogsAuditLogArgs = {
  data: EdwinStrapiAuditLogsAuditLogInput;
};

export type MutationCreateEmailSentArgs = {
  data: EmailSentInput;
};

export type MutationCreateEmotionWheelArgs = {
  data: EmotionWheelInput;
};

export type MutationCreateFavoriteArgs = {
  data: FavoriteInput;
};

export type MutationCreateGuestArgs = {
  data: GuestInput;
};

export type MutationCreateImportedUserArgs = {
  data: ImportedUserInput;
};

export type MutationCreateInsightArgs = {
  data: InsightInput;
};

export type MutationCreateInteractionsGaArgs = {
  data: InteractionsGaInput;
};

export type MutationCreateInvitedUserArgs = {
  data: InvitedUserInput;
};

export type MutationCreateLearnArgs = {
  data: LearnInput;
};

export type MutationCreateLearnItemArgs = {
  data: LearnItemInput;
};

export type MutationCreateLikeArgs = {
  data: LikeInput;
};

export type MutationCreateLoginTrackerArgs = {
  data: LoginTrackerInput;
};

export type MutationCreateMeasureArgs = {
  data: MeasureInput;
};

export type MutationCreateMeditationArgs = {
  data: MeditationInput;
};

export type MutationCreateMindfulExerciseTypeArgs = {
  data: MindfulExerciseTypeInput;
};

export type MutationCreateMindfulMinuteArgs = {
  data: MindfulMinuteInput;
};

export type MutationCreateNotificationLogArgs = {
  data: NotificationLogInput;
};

export type MutationCreatePodcastArgs = {
  data: PodcastInput;
};

export type MutationCreatePodcastInteractionArgs = {
  data: PodcastInteractionInput;
};

export type MutationCreatePodcastListeningTimeArgs = {
  data: PodcastListeningTimeInput;
};

export type MutationCreateQuestionArgs = {
  data: QuestionInput;
};

export type MutationCreateQuoteArgs = {
  data: QuoteInput;
};

export type MutationCreateResourceArgs = {
  data: ResourceInput;
};

export type MutationCreateResourceTypeArgs = {
  data: ResourceTypeInput;
};

export type MutationCreateScaleArgs = {
  data: ScaleInput;
};

export type MutationCreateSchoolArgs = {
  data: SchoolInput;
};

export type MutationCreateSettingArgs = {
  data: SettingInput;
};

export type MutationCreateSubscriptionArgs = {
  data: SubscriptionInput;
};

export type MutationCreateSurveyArgs = {
  data: SurveyInput;
};

export type MutationCreateSurveyUserArgs = {
  data: SurveyUserInput;
};

export type MutationCreateThemeArgs = {
  data: ThemeInput;
};

export type MutationCreateTopicArgs = {
  data: TopicInput;
};

export type MutationCreateTrackingArgs = {
  data: TrackingInput;
};

export type MutationCreateUploadFileArgs = {
  data: UploadFileInput;
};

export type MutationCreateUploadFolderArgs = {
  data: UploadFolderInput;
};

export type MutationCreateUserEmotionWheelTrackingDisabledArgs = {
  data: UserEmotionWheelTrackingDisabledInput;
};

export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};

export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
};

export type MutationCreateWildcardArgs = {
  data: WildcardInput;
};

export type MutationCreateWordPictureGameArgs = {
  data: WordPictureGameInput;
};

export type MutationCreateWsPermissionArgs = {
  data: WsPermissionInput;
};

export type MutationDeleteAnswerArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteAuthorArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteCalendarArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteCategoryArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteCompletedTaskArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteCourseArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteCourseCategoryArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteCourseFeedbackArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteCourseTypeArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteEdwinPluginSsoV4RolesArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteEdwinStrapiAuditLogsAuditLogArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteEmailSentArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteEmotionWheelArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteFavoriteArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteGuestArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteImportedUserArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteInsightArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteInteractionsGaArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteInvitedUserArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteLearnArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteLearnItemArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteLikeArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteLoginTrackerArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteMeasureArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteMeditationArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteMindfulExerciseTypeArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteMindfulMinuteArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteNotificationLogArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeletePodcastArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeletePodcastInteractionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeletePodcastListeningTimeArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteQuestionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteQuoteArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteResourceArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteResourceTypeArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteScaleArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteSchoolArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteSettingArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteSubscriptionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteSurveyArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteSurveyUserArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteThemeArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteTopicArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteTrackingArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteUploadFolderArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteUserEmotionWheelTrackingDisabledArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteWildcardArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteWordPictureGameArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteWsPermissionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String']['input'];
};

export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};

export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};

export type MutationMultipleUploadArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  files: Array<InputMaybe<Scalars['Upload']['input']>>;
  ref?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};

export type MutationRemoveFileArgs = {
  id: Scalars['ID']['input'];
};

export type MutationResetPasswordArgs = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};

export type MutationUpdateAboutPageArgs = {
  data: AboutPageInput;
};

export type MutationUpdateAdminOnboardingArgs = {
  data: AdminOnboardingInput;
};

export type MutationUpdateAnswerArgs = {
  data: AnswerInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateAppVersionSettingArgs = {
  data: AppVersionSettingInput;
};

export type MutationUpdateAuthorArgs = {
  data: AuthorInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateCalendarArgs = {
  data: CalendarInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateCategoryArgs = {
  data: CategoryInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateCompletedTaskArgs = {
  data: CompletedTaskInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateCookiesPageArgs = {
  data: CookiesPageInput;
};

export type MutationUpdateCopyrightPageArgs = {
  data: CopyrightPageInput;
};

export type MutationUpdateCourseArgs = {
  data: CourseInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateCourseCategoryArgs = {
  data: CourseCategoryInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateCourseFeedbackArgs = {
  data: CourseFeedbackInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateCoursePageArgs = {
  data: CoursePageInput;
};

export type MutationUpdateCourseTypeArgs = {
  data: CourseTypeInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateDailyBubbleFinishedPageArgs = {
  data: DailyBubbleFinishedPageInput;
};

export type MutationUpdateDailyBubblePageArgs = {
  data: DailyBubblePageInput;
};

export type MutationUpdateEdwinPluginSsoV4RolesArgs = {
  data: EdwinPluginSsoV4RolesInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateEdwinStrapiAuditLogsAuditLogArgs = {
  data: EdwinStrapiAuditLogsAuditLogInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateEmailSentArgs = {
  data: EmailSentInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateEmailTemplateArgs = {
  data: EmailTemplateInput;
};

export type MutationUpdateEmotionWheelArgs = {
  data: EmotionWheelInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateEmotionWheelPageArgs = {
  data: EmotionWheelPageInput;
};

export type MutationUpdateFavoriteArgs = {
  data: FavoriteInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateFavouritePageArgs = {
  data: FavouritePageInput;
};

export type MutationUpdateFileInfoArgs = {
  id: Scalars['ID']['input'];
  info?: InputMaybe<FileInfoInput>;
};

export type MutationUpdateForgotPasswordArgs = {
  data: ForgotPasswordInput;
};

export type MutationUpdateGlobalFooterArgs = {
  data: GlobalFooterInput;
};

export type MutationUpdateGlobalMenuArgs = {
  data: GlobalMenuInput;
};

export type MutationUpdateGuestArgs = {
  data: GuestInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateImportarDailyGameArgs = {
  data: ImportarDailyGameInput;
};

export type MutationUpdateImportedUserArgs = {
  data: ImportedUserInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateInsightArgs = {
  data: InsightInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateInsightPageArgs = {
  data: InsightPageInput;
};

export type MutationUpdateInteractionsGaArgs = {
  data: InteractionsGaInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateInvitedUserArgs = {
  data: InvitedUserInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateKnowledgeHubPageArgs = {
  data: KnowledgeHubPageInput;
};

export type MutationUpdateLearnArgs = {
  data: LearnInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateLearnItemArgs = {
  data: LearnItemInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateLearnPageArgs = {
  data: LearnPageInput;
};

export type MutationUpdateLikeArgs = {
  data: LikeInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateLoginPageArgs = {
  data: LoginPageInput;
};

export type MutationUpdateLoginTrackerArgs = {
  data: LoginTrackerInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateManageUsersPageArgs = {
  data: ManageUsersPageInput;
};

export type MutationUpdateMeasureArgs = {
  data: MeasureInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateMeditationArgs = {
  data: MeditationInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateMeditationDetailPageArgs = {
  data: MeditationDetailPageInput;
};

export type MutationUpdateMeditationPageArgs = {
  data: MeditationPageInput;
};

export type MutationUpdateMindfulExerciseTypeArgs = {
  data: MindfulExerciseTypeInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateMindfulMinuteArgs = {
  data: MindfulMinuteInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateMindfulMinutePageArgs = {
  data: MindfulMinutePageInput;
};

export type MutationUpdateMobileLogoArgs = {
  data: MobileLogoInput;
};

export type MutationUpdateMobileSidebarArgs = {
  data: MobileSidebarInput;
};

export type MutationUpdateNotFoundPageArgs = {
  data: NotFoundPageInput;
};

export type MutationUpdateNotificationLogArgs = {
  data: NotificationLogInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateNotificationsTemplateArgs = {
  data: NotificationsTemplateInput;
};

export type MutationUpdateOnBoardingPageArgs = {
  data: OnBoardingPageInput;
};

export type MutationUpdatePodcastArgs = {
  data: PodcastInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdatePodcastEmailTemplateArgs = {
  data: PodcastEmailTemplateInput;
};

export type MutationUpdatePodcastInteractionArgs = {
  data: PodcastInteractionInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdatePodcastListeningTimeArgs = {
  data: PodcastListeningTimeInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdatePodcastPageArgs = {
  data: PodcastPageInput;
};

export type MutationUpdatePrivacyPolicyPageArgs = {
  data: PrivacyPolicyPageInput;
};

export type MutationUpdateProfilePageArgs = {
  data: ProfilePageInput;
};

export type MutationUpdateQuestionArgs = {
  data: QuestionInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateQuoteArgs = {
  data: QuoteInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateQuotePageArgs = {
  data: QuotePageInput;
};

export type MutationUpdateRegisterPageArgs = {
  data: RegisterPageInput;
};

export type MutationUpdateResourceArgs = {
  data: ResourceInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateResourceTypeArgs = {
  data: ResourceTypeInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateScaleArgs = {
  data: ScaleInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateSchoolArgs = {
  data: SchoolInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateSearchPageArgs = {
  data: SearchPageInput;
};

export type MutationUpdateSettingArgs = {
  data: SettingInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateStep1Args = {
  data: Step1Input;
};

export type MutationUpdateStep2Args = {
  data: Step2Input;
};

export type MutationUpdateStep3Args = {
  data: Step3Input;
};

export type MutationUpdateStep4Args = {
  data: Step4Input;
};

export type MutationUpdateStep5Args = {
  data: Step5Input;
};

export type MutationUpdateSubscriptionArgs = {
  data: SubscriptionInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateSurveyArgs = {
  data: SurveyInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateSurveyDashboardPageArgs = {
  data: SurveyDashboardPageInput;
};

export type MutationUpdateSurveyMethodologyArgs = {
  data: SurveyMethodologyInput;
};

export type MutationUpdateSurveyUserArgs = {
  data: SurveyUserInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateTermAndConditionArgs = {
  data: TermAndConditionInput;
};

export type MutationUpdateTermsAndConditionsPageArgs = {
  data: TermsAndConditionsPageInput;
};

export type MutationUpdateThemeArgs = {
  data: ThemeInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateTopicArgs = {
  data: TopicInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateTrackingArgs = {
  data: TrackingInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateUploadFileArgs = {
  data: UploadFileInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateUploadFolderArgs = {
  data: UploadFolderInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateUserEmotionWheelTrackingDisabledArgs = {
  data: UserEmotionWheelTrackingDisabledInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateWellbeingAwarenessDaysCalendarPageArgs = {
  data: WellbeingAwarenessDaysCalendarPageInput;
};

export type MutationUpdateWildcardArgs = {
  data: WildcardInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateWildcardAdminPageArgs = {
  data: WildcardAdminPageInput;
};

export type MutationUpdateWordPictureGameArgs = {
  data: WordPictureGameInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateWordPictureGamePageArgs = {
  data: WordPictureGamePageInput;
};

export type MutationUpdateWsPermissionArgs = {
  data: WsPermissionInput;
  id: Scalars['ID']['input'];
};

export type MutationUploadArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
  info?: InputMaybe<FileInfoInput>;
  ref?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['ID']['input']>;
};

export type NotFoundPage = {
  __typename?: 'NotFoundPage';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  cta: Scalars['String']['output'];
  description: Scalars['String']['output'];
  image: UploadFileEntityResponse;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type NotFoundPageEntity = {
  __typename?: 'NotFoundPageEntity';
  attributes?: Maybe<NotFoundPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type NotFoundPageEntityResponse = {
  __typename?: 'NotFoundPageEntityResponse';
  data?: Maybe<NotFoundPageEntity>;
};

export type NotFoundPageInput = {
  cta?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationLog = {
  __typename?: 'NotificationLog';
  contentMetadata?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  notificationMetadata?: Maybe<Scalars['JSON']['output']>;
  response?: Maybe<Scalars['JSON']['output']>;
  sendedActionTimestamp?: Maybe<Scalars['String']['output']>;
  senderEmail?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Enum_Notificationlog_Status>;
  type?: Maybe<Enum_Notificationlog_Type>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userMetadata?: Maybe<Scalars['JSON']['output']>;
};

export type NotificationLogEntity = {
  __typename?: 'NotificationLogEntity';
  attributes?: Maybe<NotificationLog>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type NotificationLogEntityResponse = {
  __typename?: 'NotificationLogEntityResponse';
  data?: Maybe<NotificationLogEntity>;
};

export type NotificationLogEntityResponseCollection = {
  __typename?: 'NotificationLogEntityResponseCollection';
  data: Array<NotificationLogEntity>;
  meta: ResponseCollectionMeta;
};

export type NotificationLogFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<NotificationLogFiltersInput>>>;
  contentMetadata?: InputMaybe<JsonFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<NotificationLogFiltersInput>;
  notificationMetadata?: InputMaybe<JsonFilterInput>;
  or?: InputMaybe<Array<InputMaybe<NotificationLogFiltersInput>>>;
  response?: InputMaybe<JsonFilterInput>;
  sendedActionTimestamp?: InputMaybe<StringFilterInput>;
  senderEmail?: InputMaybe<StringFilterInput>;
  sentAt?: InputMaybe<DateTimeFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  userMetadata?: InputMaybe<JsonFilterInput>;
};

export type NotificationLogInput = {
  contentMetadata?: InputMaybe<Scalars['JSON']['input']>;
  notificationMetadata?: InputMaybe<Scalars['JSON']['input']>;
  response?: InputMaybe<Scalars['JSON']['input']>;
  sendedActionTimestamp?: InputMaybe<Scalars['String']['input']>;
  senderEmail?: InputMaybe<Scalars['String']['input']>;
  sentAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Enum_Notificationlog_Status>;
  type?: InputMaybe<Enum_Notificationlog_Type>;
  userMetadata?: InputMaybe<Scalars['JSON']['input']>;
};

export type NotificationsTemplate = {
  __typename?: 'NotificationsTemplate';
  courseReminderTemplates?: Maybe<Array<Maybe<ComponentDefaultContentTemplateNotificationTemplateList>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currentCourseReminderTemplate?: Maybe<Scalars['Int']['output']>;
  currentDailyBubbleReminderTemplate?: Maybe<Scalars['Int']['output']>;
  currentDailyInsightTemplate: Scalars['Int']['output'];
  currentEmotionalWheelTemplate: Scalars['Int']['output'];
  currentMindfulMinuteTemplate?: Maybe<Scalars['Int']['output']>;
  currentSurveyReminderTemplate?: Maybe<Scalars['Int']['output']>;
  dailyBubbleReminderTemplates?: Maybe<Array<Maybe<ComponentDefaultContentTemplateNotificationTemplateList>>>;
  dailyInsightTemplate?: Maybe<Array<Maybe<ComponentDefaultContentTemplateDailyInsightTemplates>>>;
  emotionalWheelTemplate?: Maybe<Array<Maybe<ComponentDefaultContentTemplateEmotionalWheelTemplates>>>;
  mindfulMinuteTemplate?: Maybe<Array<Maybe<ComponentDefaultContentTemplateMindfulMinuteTemplates>>>;
  podcastNotification?: Maybe<ComponentDefaultContentTemplatePodcastNotification>;
  reEngageNotification?: Maybe<ComponentDefaultContentTemplateNotificationTemplateList>;
  resourceNotification?: Maybe<ComponentDefaultContentTemplateResourceNotification>;
  surveyReminderTemplates?: Maybe<Array<Maybe<ComponentDefaultContentTemplateNotificationTemplateList>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type NotificationsTemplateCourseReminderTemplatesArgs = {
  filters?: InputMaybe<ComponentDefaultContentTemplateNotificationTemplateListFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NotificationsTemplateDailyBubbleReminderTemplatesArgs = {
  filters?: InputMaybe<ComponentDefaultContentTemplateNotificationTemplateListFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NotificationsTemplateDailyInsightTemplateArgs = {
  filters?: InputMaybe<ComponentDefaultContentTemplateDailyInsightTemplatesFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NotificationsTemplateEmotionalWheelTemplateArgs = {
  filters?: InputMaybe<ComponentDefaultContentTemplateEmotionalWheelTemplatesFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NotificationsTemplateMindfulMinuteTemplateArgs = {
  filters?: InputMaybe<ComponentDefaultContentTemplateMindfulMinuteTemplatesFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NotificationsTemplateSurveyReminderTemplatesArgs = {
  filters?: InputMaybe<ComponentDefaultContentTemplateNotificationTemplateListFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NotificationsTemplateEntity = {
  __typename?: 'NotificationsTemplateEntity';
  attributes?: Maybe<NotificationsTemplate>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type NotificationsTemplateEntityResponse = {
  __typename?: 'NotificationsTemplateEntityResponse';
  data?: Maybe<NotificationsTemplateEntity>;
};

export type NotificationsTemplateInput = {
  courseReminderTemplates?: InputMaybe<Array<InputMaybe<ComponentDefaultContentTemplateNotificationTemplateListInput>>>;
  currentCourseReminderTemplate?: InputMaybe<Scalars['Int']['input']>;
  currentDailyBubbleReminderTemplate?: InputMaybe<Scalars['Int']['input']>;
  currentDailyInsightTemplate?: InputMaybe<Scalars['Int']['input']>;
  currentEmotionalWheelTemplate?: InputMaybe<Scalars['Int']['input']>;
  currentMindfulMinuteTemplate?: InputMaybe<Scalars['Int']['input']>;
  currentSurveyReminderTemplate?: InputMaybe<Scalars['Int']['input']>;
  dailyBubbleReminderTemplates?: InputMaybe<
    Array<InputMaybe<ComponentDefaultContentTemplateNotificationTemplateListInput>>
  >;
  dailyInsightTemplate?: InputMaybe<Array<InputMaybe<ComponentDefaultContentTemplateDailyInsightTemplatesInput>>>;
  emotionalWheelTemplate?: InputMaybe<Array<InputMaybe<ComponentDefaultContentTemplateEmotionalWheelTemplatesInput>>>;
  mindfulMinuteTemplate?: InputMaybe<Array<InputMaybe<ComponentDefaultContentTemplateMindfulMinuteTemplatesInput>>>;
  podcastNotification?: InputMaybe<ComponentDefaultContentTemplatePodcastNotificationInput>;
  reEngageNotification?: InputMaybe<ComponentDefaultContentTemplateNotificationTemplateListInput>;
  resourceNotification?: InputMaybe<ComponentDefaultContentTemplateResourceNotificationInput>;
  surveyReminderTemplates?: InputMaybe<Array<InputMaybe<ComponentDefaultContentTemplateNotificationTemplateListInput>>>;
};

export type OnBoardingPage = {
  __typename?: 'OnBoardingPage';
  aboutYouTitle: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dailyBubbleTitle: Scalars['String']['output'];
  delvingDeeperTitle: Scalars['String']['output'];
  reachingYouTitle: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  yourFocusTitle: Scalars['String']['output'];
};

export type OnBoardingPageEntity = {
  __typename?: 'OnBoardingPageEntity';
  attributes?: Maybe<OnBoardingPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type OnBoardingPageEntityResponse = {
  __typename?: 'OnBoardingPageEntityResponse';
  data?: Maybe<OnBoardingPageEntity>;
};

export type OnBoardingPageInput = {
  aboutYouTitle?: InputMaybe<Scalars['String']['input']>;
  dailyBubbleTitle?: InputMaybe<Scalars['String']['input']>;
  delvingDeeperTitle?: InputMaybe<Scalars['String']['input']>;
  reachingYouTitle?: InputMaybe<Scalars['String']['input']>;
  yourFocusTitle?: InputMaybe<Scalars['String']['input']>;
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginationArg = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export type Podcast = {
  __typename?: 'Podcast';
  DefaultContentTemplate: Array<Maybe<PodcastDefaultContentTemplateDynamicZone>>;
  briefDescription: Scalars['String']['output'];
  cover: UploadFileEntityResponse;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  guests?: Maybe<GuestRelationResponseCollection>;
  listenings?: Maybe<PodcastListeningTimeRelationResponseCollection>;
  publicationDate: Scalars['Date']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  subHeader?: Maybe<Scalars['String']['output']>;
  themes?: Maybe<ThemeRelationResponseCollection>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PodcastGuestsArgs = {
  filters?: InputMaybe<GuestFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PodcastListeningsArgs = {
  filters?: InputMaybe<PodcastListeningTimeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PodcastThemesArgs = {
  filters?: InputMaybe<ThemeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PodcastDefaultContentTemplateDynamicZone =
  | ComponentCommonAudio
  | ComponentCommonAuthor
  | ComponentCommonAuthorDetailed
  | ComponentCommonBullet
  | ComponentCommonDivider
  | ComponentCommonDownloadableContentList
  | ComponentCommonEmbedded
  | ComponentCommonFaqComponent
  | ComponentCommonH3
  | ComponentCommonInPartnershipWith
  | ComponentCommonMedia
  | ComponentCommonQuote
  | ComponentCommonRelatedContent
  | ComponentCommonTags
  | ComponentCommonTextEditor
  | ComponentCommonTitle
  | Error;

export type PodcastEmailTemplate = {
  __typename?: 'PodcastEmailTemplate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  question?: Maybe<ComponentPodcastEmailTemplate>;
  suggestion?: Maybe<ComponentPodcastEmailTemplate>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PodcastEmailTemplateEntity = {
  __typename?: 'PodcastEmailTemplateEntity';
  attributes?: Maybe<PodcastEmailTemplate>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type PodcastEmailTemplateEntityResponse = {
  __typename?: 'PodcastEmailTemplateEntityResponse';
  data?: Maybe<PodcastEmailTemplateEntity>;
};

export type PodcastEmailTemplateInput = {
  question?: InputMaybe<ComponentPodcastEmailTemplateInput>;
  suggestion?: InputMaybe<ComponentPodcastEmailTemplateInput>;
};

export type PodcastEntity = {
  __typename?: 'PodcastEntity';
  attributes?: Maybe<Podcast>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type PodcastEntityResponse = {
  __typename?: 'PodcastEntityResponse';
  data?: Maybe<PodcastEntity>;
};

export type PodcastEntityResponseCollection = {
  __typename?: 'PodcastEntityResponseCollection';
  data: Array<PodcastEntity>;
  meta: ResponseCollectionMeta;
};

export type PodcastFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PodcastFiltersInput>>>;
  briefDescription?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  guests?: InputMaybe<GuestFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  listenings?: InputMaybe<PodcastListeningTimeFiltersInput>;
  not?: InputMaybe<PodcastFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PodcastFiltersInput>>>;
  publicationDate?: InputMaybe<DateFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  subHeader?: InputMaybe<StringFilterInput>;
  themes?: InputMaybe<ThemeFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PodcastInput = {
  DefaultContentTemplate?: InputMaybe<Array<Scalars['PodcastDefaultContentTemplateDynamicZoneInput']['input']>>;
  briefDescription?: InputMaybe<Scalars['String']['input']>;
  cover?: InputMaybe<Scalars['ID']['input']>;
  guests?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  listenings?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publicationDate?: InputMaybe<Scalars['Date']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subHeader?: InputMaybe<Scalars['String']['input']>;
  themes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PodcastInteraction = {
  __typename?: 'PodcastInteraction';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  guests?: Maybe<GuestRelationResponseCollection>;
  text: Scalars['String']['output'];
  type?: Maybe<Enum_Podcastinteraction_Type>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PodcastInteractionGuestsArgs = {
  filters?: InputMaybe<GuestFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PodcastInteractionEntity = {
  __typename?: 'PodcastInteractionEntity';
  attributes?: Maybe<PodcastInteraction>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type PodcastInteractionEntityResponse = {
  __typename?: 'PodcastInteractionEntityResponse';
  data?: Maybe<PodcastInteractionEntity>;
};

export type PodcastInteractionEntityResponseCollection = {
  __typename?: 'PodcastInteractionEntityResponseCollection';
  data: Array<PodcastInteractionEntity>;
  meta: ResponseCollectionMeta;
};

export type PodcastInteractionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PodcastInteractionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  guests?: InputMaybe<GuestFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<PodcastInteractionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PodcastInteractionFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type PodcastInteractionInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  guests?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  text?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Enum_Podcastinteraction_Type>;
};

export type PodcastInteractionRelationResponseCollection = {
  __typename?: 'PodcastInteractionRelationResponseCollection';
  data: Array<PodcastInteractionEntity>;
};

export type PodcastListeningTime = {
  __typename?: 'PodcastListeningTime';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  duration: Scalars['Long']['output'];
  listeningTime: Scalars['Long']['output'];
  podcast?: Maybe<PodcastEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<UsersPermissionsUserEntityResponse>;
};

export type PodcastListeningTimeEntity = {
  __typename?: 'PodcastListeningTimeEntity';
  attributes?: Maybe<PodcastListeningTime>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type PodcastListeningTimeEntityResponse = {
  __typename?: 'PodcastListeningTimeEntityResponse';
  data?: Maybe<PodcastListeningTimeEntity>;
};

export type PodcastListeningTimeEntityResponseCollection = {
  __typename?: 'PodcastListeningTimeEntityResponseCollection';
  data: Array<PodcastListeningTimeEntity>;
  meta: ResponseCollectionMeta;
};

export type PodcastListeningTimeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PodcastListeningTimeFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  duration?: InputMaybe<LongFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  listeningTime?: InputMaybe<LongFilterInput>;
  not?: InputMaybe<PodcastListeningTimeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PodcastListeningTimeFiltersInput>>>;
  podcast?: InputMaybe<PodcastFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type PodcastListeningTimeInput = {
  duration?: InputMaybe<Scalars['Long']['input']>;
  listeningTime?: InputMaybe<Scalars['Long']['input']>;
  podcast?: InputMaybe<Scalars['ID']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type PodcastListeningTimeRelationResponseCollection = {
  __typename?: 'PodcastListeningTimeRelationResponseCollection';
  data: Array<PodcastListeningTimeEntity>;
};

export type PodcastPage = {
  __typename?: 'PodcastPage';
  chooseAThemeTitle: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  getInTouchSection?: Maybe<ComponentPodcastGetInTouch>;
  intro?: Maybe<ComponentPodcastIntro>;
  latestTitle: Scalars['String']['output'];
  moreButotnTItle: Scalars['String']['output'];
  questionsSection?: Maybe<ComponentPodcastGetInTouch>;
  topics?: Maybe<TopicRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PodcastPageTopicsArgs = {
  filters?: InputMaybe<TopicFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PodcastPageEntity = {
  __typename?: 'PodcastPageEntity';
  attributes?: Maybe<PodcastPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type PodcastPageEntityResponse = {
  __typename?: 'PodcastPageEntityResponse';
  data?: Maybe<PodcastPageEntity>;
};

export type PodcastPageInput = {
  chooseAThemeTitle?: InputMaybe<Scalars['String']['input']>;
  getInTouchSection?: InputMaybe<ComponentPodcastGetInTouchInput>;
  intro?: InputMaybe<ComponentPodcastIntroInput>;
  latestTitle?: InputMaybe<Scalars['String']['input']>;
  moreButotnTItle?: InputMaybe<Scalars['String']['input']>;
  questionsSection?: InputMaybe<ComponentPodcastGetInTouchInput>;
  topics?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type PodcastRelationResponseCollection = {
  __typename?: 'PodcastRelationResponseCollection';
  data: Array<PodcastEntity>;
};

export type PrivacyPolicyPage = {
  __typename?: 'PrivacyPolicyPage';
  DefaultContentTemplate: Array<Maybe<PrivacyPolicyPageDefaultContentTemplateDynamicZone>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PrivacyPolicyPageDefaultContentTemplateDynamicZone =
  | ComponentCommonAuthor
  | ComponentCommonAuthorDetailed
  | ComponentCommonBullet
  | ComponentCommonDivider
  | ComponentCommonDownloadableContentList
  | ComponentCommonEmbedded
  | ComponentCommonFaqComponent
  | ComponentCommonH3
  | ComponentCommonMedia
  | ComponentCommonQuote
  | ComponentCommonTextEditor
  | ComponentCommonTitle
  | Error;

export type PrivacyPolicyPageEntity = {
  __typename?: 'PrivacyPolicyPageEntity';
  attributes?: Maybe<PrivacyPolicyPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type PrivacyPolicyPageEntityResponse = {
  __typename?: 'PrivacyPolicyPageEntityResponse';
  data?: Maybe<PrivacyPolicyPageEntity>;
};

export type PrivacyPolicyPageInput = {
  DefaultContentTemplate?: InputMaybe<
    Array<Scalars['PrivacyPolicyPageDefaultContentTemplateDynamicZoneInput']['input']>
  >;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ProfilePage = {
  __typename?: 'ProfilePage';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  emotionTrackingSection?: Maybe<ComponentProfileEmotionTrackingSection>;
  policyLinksSection?: Maybe<ComponentProfilePolicyLinksSection>;
  profileInfoSection: ComponentProfileProfileInfoSection;
  profileNotificationsSection: ComponentProfileProfileNotificationsSection;
  profilePasswordSection: ComponentProfileProfilePasswordSection;
  profileThemesSection: ComponentProfileProfileThemesSection;
  statsAndStreaks?: Maybe<ComponentProfilePageStatsAndStreaks>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  welcomeTitle: Scalars['String']['output'];
};

export type ProfilePageEntity = {
  __typename?: 'ProfilePageEntity';
  attributes?: Maybe<ProfilePage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ProfilePageEntityResponse = {
  __typename?: 'ProfilePageEntityResponse';
  data?: Maybe<ProfilePageEntity>;
};

export type ProfilePageInput = {
  emotionTrackingSection?: InputMaybe<ComponentProfileEmotionTrackingSectionInput>;
  policyLinksSection?: InputMaybe<ComponentProfilePolicyLinksSectionInput>;
  profileInfoSection?: InputMaybe<ComponentProfileProfileInfoSectionInput>;
  profileNotificationsSection?: InputMaybe<ComponentProfileProfileNotificationsSectionInput>;
  profilePasswordSection?: InputMaybe<ComponentProfileProfilePasswordSectionInput>;
  profileThemesSection?: InputMaybe<ComponentProfileProfileThemesSectionInput>;
  statsAndStreaks?: InputMaybe<ComponentProfilePageStatsAndStreaksInput>;
  welcomeTitle?: InputMaybe<Scalars['String']['input']>;
};

export enum PublicationState {
  Live = 'LIVE',
  Preview = 'PREVIEW',
}

export type Query = {
  __typename?: 'Query';
  aboutPage?: Maybe<AboutPageEntityResponse>;
  adminOnboarding?: Maybe<AdminOnboardingEntityResponse>;
  answer?: Maybe<AnswerEntityResponse>;
  answers?: Maybe<AnswerEntityResponseCollection>;
  appVersionSetting?: Maybe<AppVersionSettingEntityResponse>;
  author?: Maybe<AuthorEntityResponse>;
  authors?: Maybe<AuthorEntityResponseCollection>;
  calculateSurveyResponseChange?: Maybe<SurveyResponseChange>;
  calendar?: Maybe<CalendarEntityResponse>;
  calendars?: Maybe<CalendarEntityResponseCollection>;
  categories?: Maybe<CategoryEntityResponseCollection>;
  category?: Maybe<CategoryEntityResponse>;
  completedTask?: Maybe<CompletedTaskEntityResponse>;
  completedTasks?: Maybe<CompletedTaskEntityResponseCollection>;
  cookiesPage?: Maybe<CookiesPageEntityResponse>;
  copyrightPage?: Maybe<CopyrightPageEntityResponse>;
  course?: Maybe<CourseEntityResponse>;
  courseCategories?: Maybe<CourseCategoryEntityResponseCollection>;
  courseCategory?: Maybe<CourseCategoryEntityResponse>;
  courseFeedback?: Maybe<CourseFeedbackEntityResponse>;
  courseFeedbacks?: Maybe<CourseFeedbackEntityResponseCollection>;
  coursePage?: Maybe<CoursePageEntityResponse>;
  courseType?: Maybe<CourseTypeEntityResponse>;
  courseTypes?: Maybe<CourseTypeEntityResponseCollection>;
  courses?: Maybe<CourseEntityResponseCollection>;
  currentSurvey?: Maybe<CurrentSurveyResult>;
  dailyBubbleFinishedPage?: Maybe<DailyBubbleFinishedPageEntityResponse>;
  dailyBubblePage?: Maybe<DailyBubblePageEntityResponse>;
  edwinPluginSsoV4Roles?: Maybe<EdwinPluginSsoV4RolesEntityResponse>;
  edwinPluginSsoV4SsoRoles?: Maybe<EdwinPluginSsoV4RolesEntityResponseCollection>;
  edwinStrapiAuditLogsAuditLog?: Maybe<EdwinStrapiAuditLogsAuditLogEntityResponse>;
  edwinStrapiAuditLogsAuditLogs?: Maybe<EdwinStrapiAuditLogsAuditLogEntityResponseCollection>;
  emailSent?: Maybe<EmailSentEntityResponse>;
  emailSents?: Maybe<EmailSentEntityResponseCollection>;
  emailTemplate?: Maybe<EmailTemplateEntityResponse>;
  emotionTracker?: Maybe<Array<Maybe<EmotionTrackerResult>>>;
  emotionWheel?: Maybe<EmotionWheelEntityResponse>;
  emotionWheelPage?: Maybe<EmotionWheelPageEntityResponse>;
  emotionWheels?: Maybe<EmotionWheelEntityResponseCollection>;
  emotionsByMonth?: Maybe<EmotionsPerDay>;
  emotionsByMonthManager?: Maybe<Array<Maybe<EmotionsPerDayManager>>>;
  favorite?: Maybe<FavoriteEntityResponse>;
  favorites?: Maybe<FavoriteEntityResponseCollection>;
  favouritePage?: Maybe<FavouritePageEntityResponse>;
  fetchMySchools?: Maybe<Array<SchoolEntity>>;
  fetchUserStreak?: Maybe<Streak>;
  fetchWildcard?: Maybe<Array<WildcardEntity>>;
  forgotPassword?: Maybe<ForgotPasswordEntityResponse>;
  frequencyByMonth?: Maybe<Frequency>;
  frequencyByMonthManager?: Maybe<Array<Maybe<FrequencyBySchool>>>;
  getActiveUsers?: Maybe<InteractionsGaGetActiveUsersData>;
  getFeatureFrequency?: Maybe<Array<SchoolFeatureFrequency>>;
  getFeatureUsage?: Maybe<Array<SchoolFeatureUsage>>;
  getSchoolEngagement: SchoolEngagement;
  getSchoolMood?: Maybe<Array<SchoolMood>>;
  getUserTrackingData?: Maybe<UserTrackingDataResult>;
  globalFooter?: Maybe<GlobalFooterEntityResponse>;
  globalMenu?: Maybe<GlobalMenuEntityResponse>;
  guest?: Maybe<GuestEntityResponse>;
  guests?: Maybe<GuestEntityResponseCollection>;
  i18NLocale?: Maybe<I18NLocaleEntityResponse>;
  i18NLocales?: Maybe<I18NLocaleEntityResponseCollection>;
  importarDailyGame?: Maybe<ImportarDailyGameEntityResponse>;
  importedUser?: Maybe<ImportedUserEntityResponse>;
  importedUsers?: Maybe<ImportedUserEntityResponseCollection>;
  insight?: Maybe<InsightEntityResponse>;
  insightPage?: Maybe<InsightPageEntityResponse>;
  insights?: Maybe<InsightEntityResponseCollection>;
  interactionsGa?: Maybe<InteractionsGaEntityResponse>;
  interactionsGas?: Maybe<InteractionsGaEntityResponseCollection>;
  invitedUser?: Maybe<InvitedUserEntityResponse>;
  invitedUsers?: Maybe<InvitedUserEntityResponseCollection>;
  knowledgeHubPage?: Maybe<KnowledgeHubPageEntityResponse>;
  learn?: Maybe<LearnEntityResponse>;
  learnItem?: Maybe<LearnItemEntityResponse>;
  learnItems?: Maybe<LearnItemEntityResponseCollection>;
  learnPage?: Maybe<LearnPageEntityResponse>;
  learns?: Maybe<LearnEntityResponseCollection>;
  like?: Maybe<LikeEntityResponse>;
  likes?: Maybe<LikeEntityResponseCollection>;
  loginPage?: Maybe<LoginPageEntityResponse>;
  loginTracker?: Maybe<LoginTrackerEntityResponse>;
  loginTrackers?: Maybe<LoginTrackerEntityResponseCollection>;
  manageUsersPage?: Maybe<ManageUsersPageEntityResponse>;
  me?: Maybe<UsersPermissionsMe>;
  measure?: Maybe<MeasureEntityResponse>;
  measures?: Maybe<MeasureEntityResponseCollection>;
  meditation?: Maybe<MeditationEntityResponse>;
  meditationDetailPage?: Maybe<MeditationDetailPageEntityResponse>;
  meditationPage?: Maybe<MeditationPageEntityResponse>;
  meditations?: Maybe<MeditationEntityResponseCollection>;
  mindfulExerciseType?: Maybe<MindfulExerciseTypeEntityResponse>;
  mindfulExerciseTypes?: Maybe<MindfulExerciseTypeEntityResponseCollection>;
  mindfulMinute?: Maybe<MindfulMinuteEntityResponse>;
  mindfulMinutePage?: Maybe<MindfulMinutePageEntityResponse>;
  mindfulMinutes?: Maybe<MindfulMinuteEntityResponseCollection>;
  mobileLogo?: Maybe<MobileLogoEntityResponse>;
  mobileSidebar?: Maybe<MobileSidebarEntityResponse>;
  notFoundPage?: Maybe<NotFoundPageEntityResponse>;
  notificationLog?: Maybe<NotificationLogEntityResponse>;
  notificationLogs?: Maybe<NotificationLogEntityResponseCollection>;
  notificationsTemplate?: Maybe<NotificationsTemplateEntityResponse>;
  onBoardingPage?: Maybe<OnBoardingPageEntityResponse>;
  podcast?: Maybe<PodcastEntityResponse>;
  podcastEmailTemplate?: Maybe<PodcastEmailTemplateEntityResponse>;
  podcastInteraction?: Maybe<PodcastInteractionEntityResponse>;
  podcastInteractions?: Maybe<PodcastInteractionEntityResponseCollection>;
  podcastListeningTime?: Maybe<PodcastListeningTimeEntityResponse>;
  podcastListeningTimes?: Maybe<PodcastListeningTimeEntityResponseCollection>;
  podcastPage?: Maybe<PodcastPageEntityResponse>;
  podcasts?: Maybe<PodcastEntityResponseCollection>;
  privacyPolicyPage?: Maybe<PrivacyPolicyPageEntityResponse>;
  profilePage?: Maybe<ProfilePageEntityResponse>;
  question?: Maybe<QuestionEntityResponse>;
  questions?: Maybe<QuestionEntityResponseCollection>;
  quote?: Maybe<QuoteEntityResponse>;
  quotePage?: Maybe<QuotePageEntityResponse>;
  quotes?: Maybe<QuoteEntityResponseCollection>;
  registerPage?: Maybe<RegisterPageEntityResponse>;
  resource?: Maybe<ResourceEntityResponse>;
  resourceType?: Maybe<ResourceTypeEntityResponse>;
  resourceTypes?: Maybe<ResourceTypeEntityResponseCollection>;
  resources?: Maybe<ResourceEntityResponseCollection>;
  scale?: Maybe<ScaleEntityResponse>;
  scales?: Maybe<ScaleEntityResponseCollection>;
  school?: Maybe<SchoolEntityResponse>;
  schools?: Maybe<SchoolEntityResponseCollection>;
  searchPage?: Maybe<SearchPageEntityResponse>;
  setting?: Maybe<SettingEntityResponse>;
  settings?: Maybe<SettingEntityResponseCollection>;
  step1?: Maybe<Step1EntityResponse>;
  step2?: Maybe<Step2EntityResponse>;
  step3?: Maybe<Step3EntityResponse>;
  step4?: Maybe<Step4EntityResponse>;
  step5?: Maybe<Step5EntityResponse>;
  subscription?: Maybe<SubscriptionEntityResponse>;
  subscriptions?: Maybe<SubscriptionEntityResponseCollection>;
  survey?: Maybe<SurveyEntityResponse>;
  surveyDashboardPage?: Maybe<SurveyDashboardPageEntityResponse>;
  surveyMethodology?: Maybe<SurveyMethodologyEntityResponse>;
  surveyResults?: Maybe<SurveyResult>;
  surveyUser?: Maybe<SurveyUserEntityResponse>;
  surveyUsers?: Maybe<SurveyUserEntityResponseCollection>;
  surveys?: Maybe<SurveyEntityResponseCollection>;
  surveysByUser?: Maybe<Array<Maybe<SurveysByUserResponse>>>;
  surveysResponsesCategories?: Maybe<SurveyCategoryResponse>;
  surveysResponsesQuestions?: Maybe<SurveyQuestionsResponse>;
  termAndCondition?: Maybe<TermAndConditionEntityResponse>;
  termsAndConditionsPage?: Maybe<TermsAndConditionsPageEntityResponse>;
  theme?: Maybe<ThemeEntityResponse>;
  themes?: Maybe<ThemeEntityResponseCollection>;
  topFavoriteResources?: Maybe<Array<ResourceEntity>>;
  topic?: Maybe<TopicEntityResponse>;
  topics?: Maybe<TopicEntityResponseCollection>;
  tracking?: Maybe<TrackingEntityResponse>;
  trackings?: Maybe<TrackingEntityResponseCollection>;
  trendingResources: Array<ResourceEntity>;
  uploadFile?: Maybe<UploadFileEntityResponse>;
  uploadFiles?: Maybe<UploadFileEntityResponseCollection>;
  uploadFolder?: Maybe<UploadFolderEntityResponse>;
  uploadFolders?: Maybe<UploadFolderEntityResponseCollection>;
  userEmotionWheelTrackingDisabled?: Maybe<UserEmotionWheelTrackingDisabledEntityResponse>;
  userEmotionWheelTrackingDisableds?: Maybe<UserEmotionWheelTrackingDisabledEntityResponseCollection>;
  usersPermissionsRole?: Maybe<UsersPermissionsRoleEntityResponse>;
  usersPermissionsRoles?: Maybe<UsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsUser?: Maybe<UsersPermissionsUserEntityResponse>;
  usersPermissionsUsers?: Maybe<UsersPermissionsUserEntityResponseCollection>;
  wellbeingAwarenessDaysCalendarPage?: Maybe<WellbeingAwarenessDaysCalendarPageEntityResponse>;
  wellbeingAwarenessDaysResources: Array<ResourceEntity>;
  wildcard?: Maybe<WildcardEntityResponse>;
  wildcardAdminPage?: Maybe<WildcardAdminPageEntityResponse>;
  wildcards?: Maybe<WildcardEntityResponseCollection>;
  wordPictureGame?: Maybe<WordPictureGameEntityResponse>;
  wordPictureGamePage?: Maybe<WordPictureGamePageEntityResponse>;
  wordPictureGames?: Maybe<WordPictureGameEntityResponseCollection>;
  wsPermission?: Maybe<WsPermissionEntityResponse>;
  wsPermissions?: Maybe<WsPermissionEntityResponseCollection>;
};

export type QueryAnswerArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryAnswersArgs = {
  filters?: InputMaybe<AnswerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryAuthorArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryAuthorsArgs = {
  filters?: InputMaybe<AuthorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryCalculateSurveyResponseChangeArgs = {
  schoolsIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryCalendarArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryCalendarsArgs = {
  filters?: InputMaybe<CalendarFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryCategoriesArgs = {
  filters?: InputMaybe<CategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryCategoryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryCompletedTaskArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryCompletedTasksArgs = {
  filters?: InputMaybe<CompletedTaskFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryCourseArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryCourseCategoriesArgs = {
  filters?: InputMaybe<CourseCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryCourseCategoryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryCourseFeedbackArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryCourseFeedbacksArgs = {
  filters?: InputMaybe<CourseFeedbackFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryCourseTypeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryCourseTypesArgs = {
  filters?: InputMaybe<CourseTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryCoursesArgs = {
  filters?: InputMaybe<CourseFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryDailyBubbleFinishedPageArgs = {
  publicationState?: InputMaybe<PublicationState>;
};

export type QueryEdwinPluginSsoV4RolesArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryEdwinPluginSsoV4SsoRolesArgs = {
  filters?: InputMaybe<EdwinPluginSsoV4RolesFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryEdwinStrapiAuditLogsAuditLogArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryEdwinStrapiAuditLogsAuditLogsArgs = {
  filters?: InputMaybe<EdwinStrapiAuditLogsAuditLogFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryEmailSentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryEmailSentsArgs = {
  filters?: InputMaybe<EmailSentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryEmotionTrackerArgs = {
  endDay: Scalars['Date']['input'];
  startDay: Scalars['Date']['input'];
};

export type QueryEmotionWheelArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryEmotionWheelsArgs = {
  filters?: InputMaybe<EmotionWheelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryEmotionsByMonthArgs = {
  date: Scalars['Date']['input'];
};

export type QueryEmotionsByMonthManagerArgs = {
  date: Scalars['Date']['input'];
};

export type QueryFavoriteArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryFavoritesArgs = {
  filters?: InputMaybe<FavoriteFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryFetchMySchoolsArgs = {
  asRegularUser?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryFetchUserStreakArgs = {
  type: Scalars['String']['input'];
};

export type QueryGetActiveUsersArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  schoolsIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetFeatureFrequencyArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  schoolsIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetFeatureUsageArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  schoolsIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetSchoolEngagementArgs = {
  schoolsIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryGetSchoolMoodArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  schoolsIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGuestArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGuestsArgs = {
  filters?: InputMaybe<GuestFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryI18NLocaleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryI18NLocalesArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryImportedUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryImportedUsersArgs = {
  filters?: InputMaybe<ImportedUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryInsightArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryInsightsArgs = {
  filters?: InputMaybe<InsightFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryInteractionsGaArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryInteractionsGasArgs = {
  filters?: InputMaybe<InteractionsGaFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryInvitedUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryInvitedUsersArgs = {
  filters?: InputMaybe<InvitedUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryLearnArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryLearnItemArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryLearnItemsArgs = {
  filters?: InputMaybe<LearnItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryLearnPageArgs = {
  publicationState?: InputMaybe<PublicationState>;
};

export type QueryLearnsArgs = {
  filters?: InputMaybe<LearnFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryLikeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryLikesArgs = {
  filters?: InputMaybe<LikeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryLoginTrackerArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryLoginTrackersArgs = {
  filters?: InputMaybe<LoginTrackerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryMeasureArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryMeasuresArgs = {
  filters?: InputMaybe<MeasureFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryMeditationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryMeditationsArgs = {
  filters?: InputMaybe<MeditationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryMindfulExerciseTypeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryMindfulExerciseTypesArgs = {
  filters?: InputMaybe<MindfulExerciseTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryMindfulMinuteArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryMindfulMinutesArgs = {
  filters?: InputMaybe<MindfulMinuteFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryNotificationLogArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryNotificationLogsArgs = {
  filters?: InputMaybe<NotificationLogFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryPodcastArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryPodcastInteractionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryPodcastInteractionsArgs = {
  filters?: InputMaybe<PodcastInteractionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryPodcastListeningTimeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryPodcastListeningTimesArgs = {
  filters?: InputMaybe<PodcastListeningTimeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryPodcastsArgs = {
  filters?: InputMaybe<PodcastFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryQuestionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryQuestionsArgs = {
  filters?: InputMaybe<QuestionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryQuoteArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryQuotesArgs = {
  filters?: InputMaybe<QuoteFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryResourceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryResourceTypeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryResourceTypesArgs = {
  filters?: InputMaybe<ResourceTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryResourcesArgs = {
  filters?: InputMaybe<ResourceFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryScaleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryScalesArgs = {
  filters?: InputMaybe<ScaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QuerySchoolArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QuerySchoolsArgs = {
  filters?: InputMaybe<SchoolFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QuerySettingArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QuerySettingsArgs = {
  filters?: InputMaybe<SettingFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QuerySubscriptionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QuerySubscriptionsArgs = {
  filters?: InputMaybe<SubscriptionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QuerySurveyArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QuerySurveyUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QuerySurveyUsersArgs = {
  filters?: InputMaybe<SurveyUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QuerySurveysArgs = {
  filters?: InputMaybe<SurveyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QuerySurveysResponsesCategoriesArgs = {
  schoolIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  surveyId?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerySurveysResponsesQuestionsArgs = {
  schoolIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  surveyId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryTermAndConditionArgs = {
  publicationState?: InputMaybe<PublicationState>;
};

export type QueryThemeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryThemesArgs = {
  filters?: InputMaybe<ThemeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryTopFavoriteResourcesArgs = {
  limit: Scalars['Int']['input'];
};

export type QueryTopicArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryTopicsArgs = {
  filters?: InputMaybe<TopicFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryTrackingArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryTrackingsArgs = {
  filters?: InputMaybe<TrackingFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryTrendingResourcesArgs = {
  limit: Scalars['Int']['input'];
};

export type QueryUploadFileArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryUploadFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryUploadFolderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryUploadFoldersArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryUserEmotionWheelTrackingDisabledArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryUserEmotionWheelTrackingDisabledsArgs = {
  filters?: InputMaybe<UserEmotionWheelTrackingDisabledFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryUsersPermissionsRoleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryUsersPermissionsRolesArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryUsersPermissionsUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryUsersPermissionsUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryWellbeingAwarenessDaysResourcesArgs = {
  limit: Scalars['Int']['input'];
};

export type QueryWildcardArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryWildcardsArgs = {
  filters?: InputMaybe<WildcardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryWordPictureGameArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryWordPictureGamesArgs = {
  filters?: InputMaybe<WordPictureGameFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryWsPermissionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryWsPermissionsArgs = {
  filters?: InputMaybe<WsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Question = {
  __typename?: 'Question';
  answers?: Maybe<AnswerRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  measure?: Maybe<MeasureEntityResponse>;
  question: Scalars['String']['output'];
  scale?: Maybe<ScaleEntityResponse>;
  surveys?: Maybe<SurveyRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user_question_answereds?: Maybe<SurveyUserRelationResponseCollection>;
};

export type QuestionAnswersArgs = {
  filters?: InputMaybe<AnswerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QuestionSurveysArgs = {
  filters?: InputMaybe<SurveyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QuestionUser_Question_AnsweredsArgs = {
  filters?: InputMaybe<SurveyUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QuestionEntity = {
  __typename?: 'QuestionEntity';
  attributes?: Maybe<Question>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type QuestionEntityResponse = {
  __typename?: 'QuestionEntityResponse';
  data?: Maybe<QuestionEntity>;
};

export type QuestionEntityResponseCollection = {
  __typename?: 'QuestionEntityResponseCollection';
  data: Array<QuestionEntity>;
  meta: ResponseCollectionMeta;
};

export type QuestionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<QuestionFiltersInput>>>;
  answers?: InputMaybe<AnswerFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  date?: InputMaybe<DateFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  identifier?: InputMaybe<StringFilterInput>;
  measure?: InputMaybe<MeasureFiltersInput>;
  not?: InputMaybe<QuestionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<QuestionFiltersInput>>>;
  question?: InputMaybe<StringFilterInput>;
  scale?: InputMaybe<ScaleFiltersInput>;
  surveys?: InputMaybe<SurveyFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user_question_answereds?: InputMaybe<SurveyUserFiltersInput>;
};

export type QuestionInput = {
  answers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  date?: InputMaybe<Scalars['Date']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  measure?: InputMaybe<Scalars['ID']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  scale?: InputMaybe<Scalars['ID']['input']>;
  surveys?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  user_question_answereds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type QuestionRelationResponseCollection = {
  __typename?: 'QuestionRelationResponseCollection';
  data: Array<QuestionEntity>;
};

export type Quote = {
  __typename?: 'Quote';
  author?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  links?: Maybe<ComponentCommonLinkList>;
  occupation?: Maybe<Scalars['String']['output']>;
  quote?: Maybe<Scalars['String']['output']>;
  quoteWithLinks?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<TopicEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type QuoteEntity = {
  __typename?: 'QuoteEntity';
  attributes?: Maybe<Quote>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type QuoteEntityResponse = {
  __typename?: 'QuoteEntityResponse';
  data?: Maybe<QuoteEntity>;
};

export type QuoteEntityResponseCollection = {
  __typename?: 'QuoteEntityResponseCollection';
  data: Array<QuoteEntity>;
  meta: ResponseCollectionMeta;
};

export type QuoteFiltersInput = {
  _softDeletedAt?: InputMaybe<DateTimeFilterInput>;
  _softDeletedById?: InputMaybe<IntFilterInput>;
  _softDeletedByType?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<QuoteFiltersInput>>>;
  author?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  date?: InputMaybe<DateFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  links?: InputMaybe<ComponentCommonLinkListFiltersInput>;
  not?: InputMaybe<QuoteFiltersInput>;
  occupation?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<QuoteFiltersInput>>>;
  quote?: InputMaybe<StringFilterInput>;
  quoteWithLinks?: InputMaybe<StringFilterInput>;
  topic?: InputMaybe<TopicFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type QuoteInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  links?: InputMaybe<ComponentCommonLinkListInput>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  quote?: InputMaybe<Scalars['String']['input']>;
  quoteWithLinks?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['ID']['input']>;
};

export type QuotePage = {
  __typename?: 'QuotePage';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  cta: ComponentCommonButton;
  quoteOfTheDayTitle: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type QuotePageEntity = {
  __typename?: 'QuotePageEntity';
  attributes?: Maybe<QuotePage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type QuotePageEntityResponse = {
  __typename?: 'QuotePageEntityResponse';
  data?: Maybe<QuotePageEntity>;
};

export type QuotePageInput = {
  cta?: InputMaybe<ComponentCommonButtonInput>;
  quoteOfTheDayTitle?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterPage = {
  __typename?: 'RegisterPage';
  choosePassword: Scalars['String']['output'];
  createYourAccountCta: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  fieldErrors?: Maybe<ComponentRegisterRegisterFieldErrors>;
  image: UploadFileEntityResponse;
  logo: UploadFileEntityResponse;
  popUpMessages?: Maybe<ComponentRegisterToastMessagesRegister>;
  registerTitle: Scalars['String']['output'];
  repeatYourPassword: Scalars['String']['output'];
  schoolCode: Scalars['String']['output'];
  successRegisterPopUpMessage?: Maybe<Scalars['String']['output']>;
  successRegisterPopUpTitle?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  welcomeToTItle: Scalars['String']['output'];
  yourEmail: Scalars['String']['output'];
  yourFirstName: Scalars['String']['output'];
  yourLastName: Scalars['String']['output'];
};

export type RegisterPageEntity = {
  __typename?: 'RegisterPageEntity';
  attributes?: Maybe<RegisterPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type RegisterPageEntityResponse = {
  __typename?: 'RegisterPageEntityResponse';
  data?: Maybe<RegisterPageEntity>;
};

export type RegisterPageInput = {
  choosePassword?: InputMaybe<Scalars['String']['input']>;
  createYourAccountCta?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fieldErrors?: InputMaybe<ComponentRegisterRegisterFieldErrorsInput>;
  image?: InputMaybe<Scalars['ID']['input']>;
  logo?: InputMaybe<Scalars['ID']['input']>;
  popUpMessages?: InputMaybe<ComponentRegisterToastMessagesRegisterInput>;
  registerTitle?: InputMaybe<Scalars['String']['input']>;
  repeatYourPassword?: InputMaybe<Scalars['String']['input']>;
  schoolCode?: InputMaybe<Scalars['String']['input']>;
  successRegisterPopUpMessage?: InputMaybe<Scalars['String']['input']>;
  successRegisterPopUpTitle?: InputMaybe<Scalars['String']['input']>;
  welcomeToTItle?: InputMaybe<Scalars['String']['input']>;
  yourEmail?: InputMaybe<Scalars['String']['input']>;
  yourFirstName?: InputMaybe<Scalars['String']['input']>;
  yourLastName?: InputMaybe<Scalars['String']['input']>;
};

export type Resource = {
  __typename?: 'Resource';
  DefaultContentTemplate: Array<Maybe<ResourceDefaultContentTemplateDynamicZone>>;
  briefDescription: Scalars['String']['output'];
  cover: UploadFileEntityResponse;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  publicationDate: Scalars['Date']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  resourceType?: Maybe<ResourceTypeEntityResponse>;
  slug: Scalars['String']['output'];
  subHeader?: Maybe<Scalars['String']['output']>;
  themes?: Maybe<ThemeRelationResponseCollection>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ResourceThemesArgs = {
  filters?: InputMaybe<ThemeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ResourceDefaultContentTemplateDynamicZone =
  | ComponentCommonAuthor
  | ComponentCommonAuthorDetailed
  | ComponentCommonBullet
  | ComponentCommonDivider
  | ComponentCommonDownloadableContentList
  | ComponentCommonEmbedded
  | ComponentCommonFaqComponent
  | ComponentCommonH3
  | ComponentCommonMedia
  | ComponentCommonQuote
  | ComponentCommonRelatedContent
  | ComponentCommonTags
  | ComponentCommonTextEditor
  | ComponentCommonTitle
  | ComponentKnowledgeHubResourcesRelated
  | Error;

export type ResourceEntity = {
  __typename?: 'ResourceEntity';
  attributes?: Maybe<Resource>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ResourceEntityResponse = {
  __typename?: 'ResourceEntityResponse';
  data?: Maybe<ResourceEntity>;
};

export type ResourceEntityResponseCollection = {
  __typename?: 'ResourceEntityResponseCollection';
  data: Array<ResourceEntity>;
  meta: ResponseCollectionMeta;
};

export type ResourceFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ResourceFiltersInput>>>;
  briefDescription?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  duration?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<ResourceFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ResourceFiltersInput>>>;
  publicationDate?: InputMaybe<DateFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  resourceType?: InputMaybe<ResourceTypeFiltersInput>;
  slug?: InputMaybe<StringFilterInput>;
  subHeader?: InputMaybe<StringFilterInput>;
  themes?: InputMaybe<ThemeFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ResourceInput = {
  DefaultContentTemplate?: InputMaybe<Array<Scalars['ResourceDefaultContentTemplateDynamicZoneInput']['input']>>;
  briefDescription?: InputMaybe<Scalars['String']['input']>;
  cover?: InputMaybe<Scalars['ID']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  publicationDate?: InputMaybe<Scalars['Date']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  resourceType?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subHeader?: InputMaybe<Scalars['String']['input']>;
  themes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ResourceRelationResponseCollection = {
  __typename?: 'ResourceRelationResponseCollection';
  data: Array<ResourceEntity>;
};

export type ResourceType = {
  __typename?: 'ResourceType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ResourceTypeEntity = {
  __typename?: 'ResourceTypeEntity';
  attributes?: Maybe<ResourceType>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ResourceTypeEntityResponse = {
  __typename?: 'ResourceTypeEntityResponse';
  data?: Maybe<ResourceTypeEntity>;
};

export type ResourceTypeEntityResponseCollection = {
  __typename?: 'ResourceTypeEntityResponseCollection';
  data: Array<ResourceTypeEntity>;
  meta: ResponseCollectionMeta;
};

export type ResourceTypeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ResourceTypeFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<ResourceTypeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ResourceTypeFiltersInput>>>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ResourceTypeInput = {
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ResponseCollectionMeta = {
  __typename?: 'ResponseCollectionMeta';
  pagination: Pagination;
};

export type Scale = {
  __typename?: 'Scale';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<ComponentSurveyAnswers>>>;
  questions?: Maybe<QuestionRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ScaleOptionsArgs = {
  filters?: InputMaybe<ComponentSurveyAnswersFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ScaleQuestionsArgs = {
  filters?: InputMaybe<QuestionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ScaleEntity = {
  __typename?: 'ScaleEntity';
  attributes?: Maybe<Scale>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ScaleEntityResponse = {
  __typename?: 'ScaleEntityResponse';
  data?: Maybe<ScaleEntity>;
};

export type ScaleEntityResponseCollection = {
  __typename?: 'ScaleEntityResponseCollection';
  data: Array<ScaleEntity>;
  meta: ResponseCollectionMeta;
};

export type ScaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ScaleFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ScaleFiltersInput>;
  options?: InputMaybe<ComponentSurveyAnswersFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ScaleFiltersInput>>>;
  questions?: InputMaybe<QuestionFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ScaleInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<ComponentSurveyAnswersInput>>>;
  questions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type School = {
  __typename?: 'School';
  active: Scalars['Boolean']['output'];
  answers?: Maybe<AnswerRelationResponseCollection>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  domains?: Maybe<Array<Maybe<ComponentSchollDomains>>>;
  imported_users?: Maybe<ImportedUserRelationResponseCollection>;
  invactivationReason?: Maybe<Scalars['String']['output']>;
  invited_users?: Maybe<InvitedUserRelationResponseCollection>;
  location?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  schools?: Maybe<SchoolRelationResponseCollection>;
  subscription?: Maybe<SubscriptionEntityResponse>;
  surveys?: Maybe<SurveyRelationResponseCollection>;
  termDates?: Maybe<ComponentSchollTermDates>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  wildcards?: Maybe<WildcardRelationResponseCollection>;
  wondeRoles?: Maybe<Array<Maybe<ComponentSchollWondeRoles>>>;
};

export type SchoolAnswersArgs = {
  filters?: InputMaybe<AnswerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SchoolDomainsArgs = {
  filters?: InputMaybe<ComponentSchollDomainsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SchoolImported_UsersArgs = {
  filters?: InputMaybe<ImportedUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SchoolInvited_UsersArgs = {
  filters?: InputMaybe<InvitedUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SchoolSchoolsArgs = {
  filters?: InputMaybe<SchoolFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SchoolSurveysArgs = {
  filters?: InputMaybe<SurveyFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SchoolWildcardsArgs = {
  filters?: InputMaybe<WildcardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SchoolWondeRolesArgs = {
  filters?: InputMaybe<ComponentSchollWondeRolesFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SchoolEntity = {
  __typename?: 'SchoolEntity';
  attributes?: Maybe<School>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type SchoolEntityResponse = {
  __typename?: 'SchoolEntityResponse';
  data?: Maybe<SchoolEntity>;
};

export type SchoolEntityResponseCollection = {
  __typename?: 'SchoolEntityResponseCollection';
  data: Array<SchoolEntity>;
  meta: ResponseCollectionMeta;
};

export type SchoolFeatureFrequency = {
  __typename?: 'SchoolFeatureFrequency';
  date?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<Maybe<FeatureFrequency>>>;
  schoolId?: Maybe<Scalars['String']['output']>;
  schoolName?: Maybe<Scalars['String']['output']>;
};

export type SchoolFeatureUsage = {
  __typename?: 'SchoolFeatureUsage';
  features?: Maybe<Array<Maybe<FeatureUsage>>>;
  schoolId?: Maybe<Scalars['String']['output']>;
  schoolName?: Maybe<Scalars['String']['output']>;
};

export type SchoolFiltersInput = {
  active?: InputMaybe<BooleanFilterInput>;
  and?: InputMaybe<Array<InputMaybe<SchoolFiltersInput>>>;
  answers?: InputMaybe<AnswerFiltersInput>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  domains?: InputMaybe<ComponentSchollDomainsFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  imported_users?: InputMaybe<ImportedUserFiltersInput>;
  invactivationReason?: InputMaybe<StringFilterInput>;
  invited_users?: InputMaybe<InvitedUserFiltersInput>;
  location?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<SchoolFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SchoolFiltersInput>>>;
  schools?: InputMaybe<SchoolFiltersInput>;
  subscription?: InputMaybe<SubscriptionFiltersInput>;
  surveys?: InputMaybe<SurveyFiltersInput>;
  termDates?: InputMaybe<ComponentSchollTermDatesFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  wildcards?: InputMaybe<WildcardFiltersInput>;
  wondeApiToken?: InputMaybe<StringFilterInput>;
  wondeRoles?: InputMaybe<ComponentSchollWondeRolesFiltersInput>;
  wondeSchoolId?: InputMaybe<StringFilterInput>;
};

export type SchoolInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  answers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  code?: InputMaybe<Scalars['String']['input']>;
  domains?: InputMaybe<Array<InputMaybe<ComponentSchollDomainsInput>>>;
  imported_users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  invactivationReason?: InputMaybe<Scalars['String']['input']>;
  invited_users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  schools?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  subscription?: InputMaybe<Scalars['ID']['input']>;
  surveys?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  termDates?: InputMaybe<ComponentSchollTermDatesInput>;
  wildcards?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  wondeApiToken?: InputMaybe<Scalars['String']['input']>;
  wondeRoles?: InputMaybe<Array<InputMaybe<ComponentSchollWondeRolesInput>>>;
  wondeSchoolId?: InputMaybe<Scalars['String']['input']>;
};

export type SchoolMood = {
  __typename?: 'SchoolMood';
  data?: Maybe<Array<MoodData>>;
  emotions?: Maybe<Array<EmotionCount>>;
  schoolId?: Maybe<Scalars['String']['output']>;
  schoolName?: Maybe<Scalars['String']['output']>;
};

export type SchoolRelationResponseCollection = {
  __typename?: 'SchoolRelationResponseCollection';
  data: Array<SchoolEntity>;
};

export type SearchPage = {
  __typename?: 'SearchPage';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  moreBtn: Scalars['String']['output'];
  noRecordsFoundText: Scalars['String']['output'];
  searchBtn: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  yourResultsTitle: Scalars['String']['output'];
};

export type SearchPageEntity = {
  __typename?: 'SearchPageEntity';
  attributes?: Maybe<SearchPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type SearchPageEntityResponse = {
  __typename?: 'SearchPageEntityResponse';
  data?: Maybe<SearchPageEntity>;
};

export type SearchPageInput = {
  moreBtn?: InputMaybe<Scalars['String']['input']>;
  noRecordsFoundText?: InputMaybe<Scalars['String']['input']>;
  searchBtn?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  yourResultsTitle?: InputMaybe<Scalars['String']['input']>;
};

export type Setting = {
  __typename?: 'Setting';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  restApiKey?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userAuthKey?: Maybe<Scalars['String']['output']>;
};

export type SettingEntity = {
  __typename?: 'SettingEntity';
  attributes?: Maybe<Setting>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type SettingEntityResponse = {
  __typename?: 'SettingEntityResponse';
  data?: Maybe<SettingEntity>;
};

export type SettingEntityResponseCollection = {
  __typename?: 'SettingEntityResponseCollection';
  data: Array<SettingEntity>;
  meta: ResponseCollectionMeta;
};

export type SettingFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<SettingFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<SettingFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SettingFiltersInput>>>;
  restApiKey?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  userAuthKey?: InputMaybe<StringFilterInput>;
};

export type SettingInput = {
  restApiKey?: InputMaybe<Scalars['String']['input']>;
  userAuthKey?: InputMaybe<Scalars['String']['input']>;
};

export type Step1 = {
  __typename?: 'Step1';
  content: ComponentOnBoardingOnBoardingContainer;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Step1Entity = {
  __typename?: 'Step1Entity';
  attributes?: Maybe<Step1>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type Step1EntityResponse = {
  __typename?: 'Step1EntityResponse';
  data?: Maybe<Step1Entity>;
};

export type Step1Input = {
  content?: InputMaybe<ComponentOnBoardingOnBoardingContainerInput>;
};

export type Step2 = {
  __typename?: 'Step2';
  content: ComponentOnBoardingOnBoardingContainer;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Step2Entity = {
  __typename?: 'Step2Entity';
  attributes?: Maybe<Step2>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type Step2EntityResponse = {
  __typename?: 'Step2EntityResponse';
  data?: Maybe<Step2Entity>;
};

export type Step2Input = {
  content?: InputMaybe<ComponentOnBoardingOnBoardingContainerInput>;
};

export type Step3 = {
  __typename?: 'Step3';
  content?: Maybe<ComponentOnBoardingOnBoardingContainer>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Step3Entity = {
  __typename?: 'Step3Entity';
  attributes?: Maybe<Step3>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type Step3EntityResponse = {
  __typename?: 'Step3EntityResponse';
  data?: Maybe<Step3Entity>;
};

export type Step3Input = {
  content?: InputMaybe<ComponentOnBoardingOnBoardingContainerInput>;
};

export type Step4 = {
  __typename?: 'Step4';
  ageBracket?: Maybe<ComponentCommonFieldSelect>;
  content?: Maybe<ComponentOnBoardingOnBoardingContainer>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  gender?: Maybe<ComponentCommonFieldSelect>;
  location?: Maybe<ComponentCommonField>;
  role?: Maybe<ComponentCommonField>;
  roles?: Maybe<Array<Maybe<ComponentCommonRoles>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Step4RolesArgs = {
  filters?: InputMaybe<ComponentCommonRolesFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Step4Entity = {
  __typename?: 'Step4Entity';
  attributes?: Maybe<Step4>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type Step4EntityResponse = {
  __typename?: 'Step4EntityResponse';
  data?: Maybe<Step4Entity>;
};

export type Step4Input = {
  ageBracket?: InputMaybe<ComponentCommonFieldSelectInput>;
  content?: InputMaybe<ComponentOnBoardingOnBoardingContainerInput>;
  gender?: InputMaybe<ComponentCommonFieldSelectInput>;
  location?: InputMaybe<ComponentCommonFieldInput>;
  role?: InputMaybe<ComponentCommonFieldInput>;
  roles?: InputMaybe<Array<InputMaybe<ComponentCommonRolesInput>>>;
};

export type Step5 = {
  __typename?: 'Step5';
  content: ComponentOnBoardingOnBoardingContainer;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Step5Entity = {
  __typename?: 'Step5Entity';
  attributes?: Maybe<Step5>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type Step5EntityResponse = {
  __typename?: 'Step5EntityResponse';
  data?: Maybe<Step5Entity>;
};

export type Step5Input = {
  content?: InputMaybe<ComponentOnBoardingOnBoardingContainerInput>;
};

export type Streak = {
  __typename?: 'Streak';
  currentStreak?: Maybe<Scalars['Int']['output']>;
  lastDay?: Maybe<Scalars['Date']['output']>;
  maxStreak?: Maybe<Scalars['Int']['output']>;
  streak?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type StringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  containsi?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  eqi?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nei?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notContainsi?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dailyBubble: Scalars['Boolean']['output'];
  knowledgeHub?: Maybe<Scalars['Boolean']['output']>;
  learn: Scalars['Boolean']['output'];
  meditation?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  podcast: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SubscriptionEntity = {
  __typename?: 'SubscriptionEntity';
  attributes?: Maybe<Subscription>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type SubscriptionEntityResponse = {
  __typename?: 'SubscriptionEntityResponse';
  data?: Maybe<SubscriptionEntity>;
};

export type SubscriptionEntityResponseCollection = {
  __typename?: 'SubscriptionEntityResponseCollection';
  data: Array<SubscriptionEntity>;
  meta: ResponseCollectionMeta;
};

export type SubscriptionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<SubscriptionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  dailyBubble?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  knowledgeHub?: InputMaybe<BooleanFilterInput>;
  learn?: InputMaybe<BooleanFilterInput>;
  meditation?: InputMaybe<BooleanFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<SubscriptionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SubscriptionFiltersInput>>>;
  podcast?: InputMaybe<BooleanFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type SubscriptionInput = {
  dailyBubble?: InputMaybe<Scalars['Boolean']['input']>;
  knowledgeHub?: InputMaybe<Scalars['Boolean']['input']>;
  learn?: InputMaybe<Scalars['Boolean']['input']>;
  meditation?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  podcast?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Survey = {
  __typename?: 'Survey';
  answers?: Maybe<AnswerRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  questions?: Maybe<QuestionRelationResponseCollection>;
  schools?: Maybe<SchoolRelationResponseCollection>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SurveyAnswersArgs = {
  filters?: InputMaybe<AnswerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SurveyQuestionsArgs = {
  filters?: InputMaybe<QuestionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SurveySchoolsArgs = {
  filters?: InputMaybe<SchoolFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SurveyAnswer = {
  __typename?: 'SurveyAnswer';
  color?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type SurveyAnswerEntry = {
  __typename?: 'SurveyAnswerEntry';
  answer?: Maybe<SurveyAnswer>;
  key?: Maybe<Scalars['String']['output']>;
};

export type SurveyCaption = {
  __typename?: 'SurveyCaption';
  color?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type SurveyCategory = {
  __typename?: 'SurveyCategory';
  answers?: Maybe<Array<Maybe<SurveyAnswerEntry>>>;
  key?: Maybe<Scalars['String']['output']>;
  measure?: Maybe<Scalars['String']['output']>;
  questions?: Maybe<Scalars['Int']['output']>;
  responses?: Maybe<Scalars['Int']['output']>;
};

export type SurveyCategoryResponse = {
  __typename?: 'SurveyCategoryResponse';
  captions?: Maybe<Array<Maybe<SurveyCaption>>>;
  data?: Maybe<Array<Maybe<SurveyCategory>>>;
  schools?: Maybe<Array<Maybe<SurveySchool>>>;
};

export type SurveyDashboardPage = {
  __typename?: 'SurveyDashboardPage';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  downloadButton: ComponentSurveyDashboardDownloadButton;
  notFoundMessage: Scalars['String']['output'];
  schoolsFilter: ComponentSurveyDashboardSchoolsFilter;
  tableCategories: ComponentSurveyDashboardTableCategories;
  tableQuestion: ComponentSurveyDashboardTableQuestion;
  tableResponses: ComponentSurveyDashboardTableResponses;
  tabs: ComponentSurveyDashboardTabs;
  toggle: ComponentSurveyDashboardToggle;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SurveyDashboardPageEntity = {
  __typename?: 'SurveyDashboardPageEntity';
  attributes?: Maybe<SurveyDashboardPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type SurveyDashboardPageEntityResponse = {
  __typename?: 'SurveyDashboardPageEntityResponse';
  data?: Maybe<SurveyDashboardPageEntity>;
};

export type SurveyDashboardPageInput = {
  downloadButton?: InputMaybe<ComponentSurveyDashboardDownloadButtonInput>;
  notFoundMessage?: InputMaybe<Scalars['String']['input']>;
  schoolsFilter?: InputMaybe<ComponentSurveyDashboardSchoolsFilterInput>;
  tableCategories?: InputMaybe<ComponentSurveyDashboardTableCategoriesInput>;
  tableQuestion?: InputMaybe<ComponentSurveyDashboardTableQuestionInput>;
  tableResponses?: InputMaybe<ComponentSurveyDashboardTableResponsesInput>;
  tabs?: InputMaybe<ComponentSurveyDashboardTabsInput>;
  toggle?: InputMaybe<ComponentSurveyDashboardToggleInput>;
};

export type SurveyEntity = {
  __typename?: 'SurveyEntity';
  attributes?: Maybe<Survey>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type SurveyEntityResponse = {
  __typename?: 'SurveyEntityResponse';
  data?: Maybe<SurveyEntity>;
};

export type SurveyEntityResponseCollection = {
  __typename?: 'SurveyEntityResponseCollection';
  data: Array<SurveyEntity>;
  meta: ResponseCollectionMeta;
};

export type SurveyFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<SurveyFiltersInput>>>;
  answers?: InputMaybe<AnswerFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  endDate?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<SurveyFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SurveyFiltersInput>>>;
  questions?: InputMaybe<QuestionFiltersInput>;
  schools?: InputMaybe<SchoolFiltersInput>;
  startDate?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type SurveyInput = {
  answers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  schools?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SurveyMethodology = {
  __typename?: 'SurveyMethodology';
  DefaultContentTemplate: Array<Maybe<SurveyMethodologyDefaultContentTemplateDynamicZone>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  pageTitle: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SurveyMethodologyDefaultContentTemplateDynamicZone =
  | ComponentCommonAuthor
  | ComponentCommonAuthorDetailed
  | ComponentCommonBullet
  | ComponentCommonDivider
  | ComponentCommonDownloadableContentList
  | ComponentCommonEmbedded
  | ComponentCommonFaqComponent
  | ComponentCommonH3
  | ComponentCommonMedia
  | ComponentCommonQuote
  | ComponentCommonTextEditor
  | ComponentCommonTitle
  | Error;

export type SurveyMethodologyEntity = {
  __typename?: 'SurveyMethodologyEntity';
  attributes?: Maybe<SurveyMethodology>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type SurveyMethodologyEntityResponse = {
  __typename?: 'SurveyMethodologyEntityResponse';
  data?: Maybe<SurveyMethodologyEntity>;
};

export type SurveyMethodologyInput = {
  DefaultContentTemplate?: InputMaybe<
    Array<Scalars['SurveyMethodologyDefaultContentTemplateDynamicZoneInput']['input']>
  >;
  pageTitle?: InputMaybe<Scalars['String']['input']>;
};

export type SurveyQuestion = {
  __typename?: 'SurveyQuestion';
  answers?: Maybe<Array<Maybe<SurveyAnswerEntry>>>;
  date?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  measure?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  responses?: Maybe<Scalars['Int']['output']>;
  uniqueId?: Maybe<Scalars['String']['output']>;
};

export type SurveyQuestionsResponse = {
  __typename?: 'SurveyQuestionsResponse';
  captions?: Maybe<Array<Maybe<SurveyCaption>>>;
  data?: Maybe<Array<Maybe<SurveyQuestion>>>;
  schools?: Maybe<Array<Maybe<SurveySchool>>>;
};

export type SurveyRelationResponseCollection = {
  __typename?: 'SurveyRelationResponseCollection';
  data: Array<SurveyEntity>;
};

export type SurveyResponseChange = {
  __typename?: 'SurveyResponseChange';
  increase?: Maybe<Scalars['Boolean']['output']>;
  totalCurrentWeek?: Maybe<Scalars['Int']['output']>;
  totalPreviousWeek?: Maybe<Scalars['Int']['output']>;
};

export type SurveyResult = {
  __typename?: 'SurveyResult';
  measures?: Maybe<Array<Maybe<CustomMeasure>>>;
};

export type SurveySchool = {
  __typename?: 'SurveySchool';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SurveyUser = {
  __typename?: 'SurveyUser';
  answerDate?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  question?: Maybe<QuestionEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<UsersPermissionsUserEntityResponse>;
};

export type SurveyUserEntity = {
  __typename?: 'SurveyUserEntity';
  attributes?: Maybe<SurveyUser>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type SurveyUserEntityResponse = {
  __typename?: 'SurveyUserEntityResponse';
  data?: Maybe<SurveyUserEntity>;
};

export type SurveyUserEntityResponseCollection = {
  __typename?: 'SurveyUserEntityResponseCollection';
  data: Array<SurveyUserEntity>;
  meta: ResponseCollectionMeta;
};

export type SurveyUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<SurveyUserFiltersInput>>>;
  answerDate?: InputMaybe<DateFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<SurveyUserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SurveyUserFiltersInput>>>;
  question?: InputMaybe<QuestionFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type SurveyUserInput = {
  answerDate?: InputMaybe<Scalars['Date']['input']>;
  question?: InputMaybe<Scalars['ID']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type SurveyUserRelationResponseCollection = {
  __typename?: 'SurveyUserRelationResponseCollection';
  data: Array<SurveyUserEntity>;
};

export type SurveysByUserResponse = {
  __typename?: 'SurveysByUserResponse';
  endDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
};

export type TermAndCondition = {
  __typename?: 'TermAndCondition';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TermAndConditionEntity = {
  __typename?: 'TermAndConditionEntity';
  attributes?: Maybe<TermAndCondition>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type TermAndConditionEntityResponse = {
  __typename?: 'TermAndConditionEntityResponse';
  data?: Maybe<TermAndConditionEntity>;
};

export type TermAndConditionInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TermsAndConditionsPage = {
  __typename?: 'TermsAndConditionsPage';
  DefaultContentTemplate: Array<Maybe<TermsAndConditionsPageDefaultContentTemplateDynamicZone>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TermsAndConditionsPageDefaultContentTemplateDynamicZone =
  | ComponentCommonAuthor
  | ComponentCommonAuthorDetailed
  | ComponentCommonBullet
  | ComponentCommonDivider
  | ComponentCommonDownloadableContentList
  | ComponentCommonEmbedded
  | ComponentCommonFaqComponent
  | ComponentCommonH3
  | ComponentCommonMedia
  | ComponentCommonQuote
  | ComponentCommonTextEditor
  | ComponentCommonTitle
  | Error;

export type TermsAndConditionsPageEntity = {
  __typename?: 'TermsAndConditionsPageEntity';
  attributes?: Maybe<TermsAndConditionsPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type TermsAndConditionsPageEntityResponse = {
  __typename?: 'TermsAndConditionsPageEntityResponse';
  data?: Maybe<TermsAndConditionsPageEntity>;
};

export type TermsAndConditionsPageInput = {
  DefaultContentTemplate?: InputMaybe<
    Array<Scalars['TermsAndConditionsPageDefaultContentTemplateDynamicZoneInput']['input']>
  >;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Theme = {
  __typename?: 'Theme';
  courses?: Maybe<CourseRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  insights?: Maybe<InsightRelationResponseCollection>;
  meditations?: Maybe<MeditationRelationResponseCollection>;
  podcasts?: Maybe<PodcastRelationResponseCollection>;
  resources?: Maybe<ResourceRelationResponseCollection>;
  theme?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<TopicEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ThemeCoursesArgs = {
  filters?: InputMaybe<CourseFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ThemeInsightsArgs = {
  filters?: InputMaybe<InsightFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ThemeMeditationsArgs = {
  filters?: InputMaybe<MeditationFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ThemePodcastsArgs = {
  filters?: InputMaybe<PodcastFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ThemeResourcesArgs = {
  filters?: InputMaybe<ResourceFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ThemeEntity = {
  __typename?: 'ThemeEntity';
  attributes?: Maybe<Theme>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ThemeEntityResponse = {
  __typename?: 'ThemeEntityResponse';
  data?: Maybe<ThemeEntity>;
};

export type ThemeEntityResponseCollection = {
  __typename?: 'ThemeEntityResponseCollection';
  data: Array<ThemeEntity>;
  meta: ResponseCollectionMeta;
};

export type ThemeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ThemeFiltersInput>>>;
  courses?: InputMaybe<CourseFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  insights?: InputMaybe<InsightFiltersInput>;
  meditations?: InputMaybe<MeditationFiltersInput>;
  not?: InputMaybe<ThemeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ThemeFiltersInput>>>;
  podcasts?: InputMaybe<PodcastFiltersInput>;
  resources?: InputMaybe<ResourceFiltersInput>;
  theme?: InputMaybe<StringFilterInput>;
  topic?: InputMaybe<TopicFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ThemeInput = {
  courses?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  insights?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  meditations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  podcasts?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  resources?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  theme?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['ID']['input']>;
};

export type ThemeRelationResponseCollection = {
  __typename?: 'ThemeRelationResponseCollection';
  data: Array<ThemeEntity>;
};

export type Topic = {
  __typename?: 'Topic';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  themes?: Maybe<ThemeRelationResponseCollection>;
  topic?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};

export type TopicThemesArgs = {
  filters?: InputMaybe<ThemeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TopicUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TopicEntity = {
  __typename?: 'TopicEntity';
  attributes?: Maybe<Topic>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type TopicEntityResponse = {
  __typename?: 'TopicEntityResponse';
  data?: Maybe<TopicEntity>;
};

export type TopicEntityResponseCollection = {
  __typename?: 'TopicEntityResponseCollection';
  data: Array<TopicEntity>;
  meta: ResponseCollectionMeta;
};

export type TopicFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<TopicFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<TopicFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TopicFiltersInput>>>;
  themes?: InputMaybe<ThemeFiltersInput>;
  topic?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type TopicInput = {
  themes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  topic?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type TopicRelationResponseCollection = {
  __typename?: 'TopicRelationResponseCollection';
  data: Array<TopicEntity>;
};

export type Tracking = {
  __typename?: 'Tracking';
  action: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users_permissions_user?: Maybe<UsersPermissionsUserEntityResponse>;
};

export type TrackingEntity = {
  __typename?: 'TrackingEntity';
  attributes?: Maybe<Tracking>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type TrackingEntityResponse = {
  __typename?: 'TrackingEntityResponse';
  data?: Maybe<TrackingEntity>;
};

export type TrackingEntityResponseCollection = {
  __typename?: 'TrackingEntityResponseCollection';
  data: Array<TrackingEntity>;
  meta: ResponseCollectionMeta;
};

export type TrackingFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<TrackingFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  metadata?: InputMaybe<JsonFilterInput>;
  not?: InputMaybe<TrackingFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TrackingFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  timestamp?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users_permissions_user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type TrackingInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  users_permissions_user?: InputMaybe<Scalars['ID']['input']>;
};

export type TrackingRelationResponseCollection = {
  __typename?: 'TrackingRelationResponseCollection';
  data: Array<TrackingEntity>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  alternativeText?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  ext?: Maybe<Scalars['String']['output']>;
  formats?: Maybe<Scalars['JSON']['output']>;
  hash: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  provider_metadata?: Maybe<Scalars['JSON']['output']>;
  related?: Maybe<Array<Maybe<GenericMorph>>>;
  size: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type UploadFileEntity = {
  __typename?: 'UploadFileEntity';
  attributes?: Maybe<UploadFile>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UploadFileEntityResponse = {
  __typename?: 'UploadFileEntityResponse';
  data?: Maybe<UploadFileEntity>;
};

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  data: Array<UploadFileEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFileFiltersInput = {
  alternativeText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  ext?: InputMaybe<StringFilterInput>;
  folder?: InputMaybe<UploadFolderFiltersInput>;
  folderPath?: InputMaybe<StringFilterInput>;
  formats?: InputMaybe<JsonFilterInput>;
  hash?: InputMaybe<StringFilterInput>;
  height?: InputMaybe<IntFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  mime?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  previewUrl?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  provider_metadata?: InputMaybe<JsonFilterInput>;
  size?: InputMaybe<FloatFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  width?: InputMaybe<IntFilterInput>;
};

export type UploadFileInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  ext?: InputMaybe<Scalars['String']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  folderPath?: InputMaybe<Scalars['String']['input']>;
  formats?: InputMaybe<Scalars['JSON']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  previewUrl?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  provider_metadata?: InputMaybe<Scalars['JSON']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadFileRelationResponseCollection = {
  __typename?: 'UploadFileRelationResponseCollection';
  data: Array<UploadFileEntity>;
};

export type UploadFolder = {
  __typename?: 'UploadFolder';
  children?: Maybe<UploadFolderRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  files?: Maybe<UploadFileRelationResponseCollection>;
  name: Scalars['String']['output'];
  parent?: Maybe<UploadFolderEntityResponse>;
  path: Scalars['String']['output'];
  pathId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UploadFolderChildrenArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UploadFolderFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UploadFolderEntity = {
  __typename?: 'UploadFolderEntity';
  attributes?: Maybe<UploadFolder>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UploadFolderEntityResponse = {
  __typename?: 'UploadFolderEntityResponse';
  data?: Maybe<UploadFolderEntity>;
};

export type UploadFolderEntityResponseCollection = {
  __typename?: 'UploadFolderEntityResponseCollection';
  data: Array<UploadFolderEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFolderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  children?: InputMaybe<UploadFolderFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  files?: InputMaybe<UploadFileFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFolderFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  parent?: InputMaybe<UploadFolderFiltersInput>;
  path?: InputMaybe<StringFilterInput>;
  pathId?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UploadFolderInput = {
  children?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  pathId?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadFolderRelationResponseCollection = {
  __typename?: 'UploadFolderRelationResponseCollection';
  data: Array<UploadFolderEntity>;
};

export type UserEmotionWheelTrackingDisabled = {
  __typename?: 'UserEmotionWheelTrackingDisabled';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<UsersPermissionsUserEntityResponse>;
};

export type UserEmotionWheelTrackingDisabledEntity = {
  __typename?: 'UserEmotionWheelTrackingDisabledEntity';
  attributes?: Maybe<UserEmotionWheelTrackingDisabled>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UserEmotionWheelTrackingDisabledEntityResponse = {
  __typename?: 'UserEmotionWheelTrackingDisabledEntityResponse';
  data?: Maybe<UserEmotionWheelTrackingDisabledEntity>;
};

export type UserEmotionWheelTrackingDisabledEntityResponseCollection = {
  __typename?: 'UserEmotionWheelTrackingDisabledEntityResponseCollection';
  data: Array<UserEmotionWheelTrackingDisabledEntity>;
  meta: ResponseCollectionMeta;
};

export type UserEmotionWheelTrackingDisabledFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UserEmotionWheelTrackingDisabledFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  endDate?: InputMaybe<DateFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UserEmotionWheelTrackingDisabledFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UserEmotionWheelTrackingDisabledFiltersInput>>>;
  startDate?: InputMaybe<DateFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  user?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UserEmotionWheelTrackingDisabledInput = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type UserTrackingDataResult = {
  __typename?: 'UserTrackingDataResult';
  dailyStreak?: Maybe<Scalars['Int']['output']>;
  emotionsTracked?: Maybe<Scalars['Int']['output']>;
  streakRecord?: Maybe<Scalars['Int']['output']>;
};

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
  provider?: Scalars['String']['input'];
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']['output']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UsersPermissionsPermissionEntity = {
  __typename?: 'UsersPermissionsPermissionEntity';
  attributes?: Maybe<UsersPermissionsPermission>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection';
  data: Array<UsersPermissionsPermissionEntity>;
};

export type UsersPermissionsRegisterInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  permissions?: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};

export type UsersPermissionsRolePermissionsArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsRoleEntity = {
  __typename?: 'UsersPermissionsRoleEntity';
  attributes?: Maybe<UsersPermissionsRole>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsRoleEntityResponse = {
  __typename?: 'UsersPermissionsRoleEntityResponse';
  data?: Maybe<UsersPermissionsRoleEntity>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection';
  data: Array<UsersPermissionsRoleEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  permissions?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  ageBracket?: Maybe<Scalars['String']['output']>;
  answers?: Maybe<AnswerRelationResponseCollection>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmationEmailSent?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  course_feedbacks?: Maybe<CourseFeedbackRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  disableSwipeHint?: Maybe<Scalars['Boolean']['output']>;
  email: Scalars['String']['output'];
  forename?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  isEmotionWheelTrackingDisabled?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  onboardEmotionWheelCompleted: Scalars['Boolean']['output'];
  onboardHomeCompleted: Scalars['Boolean']['output'];
  onboardMindfulMinuteCompleted: Scalars['Boolean']['output'];
  onboardQuestionsCompleted: Scalars['Boolean']['output'];
  onboardingStartDate?: Maybe<Scalars['Date']['output']>;
  photo?: Maybe<UploadFileEntityResponse>;
  profile?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  registrationDevice?: Maybe<Enum_Userspermissionsuser_Registrationdevice>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  school?: Maybe<SchoolEntityResponse>;
  surname?: Maybe<Scalars['String']['output']>;
  survey_users?: Maybe<SurveyUserRelationResponseCollection>;
  topics?: Maybe<TopicRelationResponseCollection>;
  trackings?: Maybe<TrackingRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  username: Scalars['String']['output'];
  ws_permission?: Maybe<WsPermissionEntityResponse>;
};

export type UsersPermissionsUserAnswersArgs = {
  filters?: InputMaybe<AnswerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsUserCourse_FeedbacksArgs = {
  filters?: InputMaybe<CourseFeedbackFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsUserSurvey_UsersArgs = {
  filters?: InputMaybe<SurveyUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsUserTopicsArgs = {
  filters?: InputMaybe<TopicFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsUserTrackingsArgs = {
  filters?: InputMaybe<TrackingFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsUserEntity = {
  __typename?: 'UsersPermissionsUserEntity';
  attributes?: Maybe<UsersPermissionsUser>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse';
  data?: Maybe<UsersPermissionsUserEntity>;
};

export type UsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsUserFiltersInput = {
  ageBracket?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  answers?: InputMaybe<AnswerFiltersInput>;
  blocked?: InputMaybe<BooleanFilterInput>;
  confirmationEmailSent?: InputMaybe<BooleanFilterInput>;
  confirmationToken?: InputMaybe<StringFilterInput>;
  confirmed?: InputMaybe<BooleanFilterInput>;
  course_feedbacks?: InputMaybe<CourseFeedbackFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  disableSwipeHint?: InputMaybe<BooleanFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  forename?: InputMaybe<StringFilterInput>;
  gender?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isEmotionWheelTrackingDisabled?: InputMaybe<BooleanFilterInput>;
  location?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsUserFiltersInput>;
  onboardEmotionWheelCompleted?: InputMaybe<BooleanFilterInput>;
  onboardHomeCompleted?: InputMaybe<BooleanFilterInput>;
  onboardMindfulMinuteCompleted?: InputMaybe<BooleanFilterInput>;
  onboardQuestionsCompleted?: InputMaybe<BooleanFilterInput>;
  onboardingStartDate?: InputMaybe<DateFilterInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  password?: InputMaybe<StringFilterInput>;
  profile?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  registrationDevice?: InputMaybe<StringFilterInput>;
  resetPasswordToken?: InputMaybe<StringFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  school?: InputMaybe<SchoolFiltersInput>;
  schoolCode?: InputMaybe<StringFilterInput>;
  surname?: InputMaybe<StringFilterInput>;
  survey_users?: InputMaybe<SurveyUserFiltersInput>;
  topics?: InputMaybe<TopicFiltersInput>;
  trackings?: InputMaybe<TrackingFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  username?: InputMaybe<StringFilterInput>;
  ws_permission?: InputMaybe<WsPermissionFiltersInput>;
};

export type UsersPermissionsUserInput = {
  ageBracket?: InputMaybe<Scalars['String']['input']>;
  answers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationEmailSent?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationToken?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  course_feedbacks?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  disableSwipeHint?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  forename?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  isEmotionWheelTrackingDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  onboardEmotionWheelCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  onboardHomeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  onboardMindfulMinuteCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  onboardQuestionsCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  onboardingStartDate?: InputMaybe<Scalars['Date']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['ID']['input']>;
  profile?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  registrationDevice?: InputMaybe<Enum_Userspermissionsuser_Registrationdevice>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  school?: InputMaybe<Scalars['ID']['input']>;
  schoolCode?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  survey_users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  topics?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  trackings?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  username?: InputMaybe<Scalars['String']['input']>;
  ws_permission?: InputMaybe<Scalars['ID']['input']>;
};

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
};

export type WellbeingAwarenessDaysCalendarPage = {
  __typename?: 'WellbeingAwarenessDaysCalendarPage';
  DefaultContentTemplate: Array<Maybe<WellbeingAwarenessDaysCalendarPageDefaultContentTemplateDynamicZone>>;
  NoAwarenessDaysMonthText?: Maybe<Scalars['String']['output']>;
  calendarFeedbackMessage?: Maybe<ComponentCalendarCalendarFeedbackMessage>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  downloadButtonText?: Maybe<Scalars['String']['output']>;
  file?: Maybe<UploadFileEntityResponse>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type WellbeingAwarenessDaysCalendarPageDefaultContentTemplateDynamicZone =
  | ComponentCommonAuthor
  | ComponentCommonAuthorDetailed
  | ComponentCommonBullet
  | ComponentCommonDivider
  | ComponentCommonDownloadableContentList
  | ComponentCommonEmbedded
  | ComponentCommonFaqComponent
  | ComponentCommonH3
  | ComponentCommonMedia
  | ComponentCommonQuote
  | ComponentCommonTextEditor
  | ComponentCommonTitle
  | Error;

export type WellbeingAwarenessDaysCalendarPageEntity = {
  __typename?: 'WellbeingAwarenessDaysCalendarPageEntity';
  attributes?: Maybe<WellbeingAwarenessDaysCalendarPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type WellbeingAwarenessDaysCalendarPageEntityResponse = {
  __typename?: 'WellbeingAwarenessDaysCalendarPageEntityResponse';
  data?: Maybe<WellbeingAwarenessDaysCalendarPageEntity>;
};

export type WellbeingAwarenessDaysCalendarPageInput = {
  DefaultContentTemplate?: InputMaybe<
    Array<Scalars['WellbeingAwarenessDaysCalendarPageDefaultContentTemplateDynamicZoneInput']['input']>
  >;
  NoAwarenessDaysMonthText?: InputMaybe<Scalars['String']['input']>;
  calendarFeedbackMessage?: InputMaybe<ComponentCalendarCalendarFeedbackMessageInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  downloadButtonText?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Wildcard = {
  __typename?: 'Wildcard';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  cta?: Maybe<ComponentWildcardCta>;
  ctaText: Scalars['String']['output'];
  description: Scalars['String']['output'];
  endDate: Scalars['Date']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  internal: Scalars['Boolean']['output'];
  likes: Scalars['Long']['output'];
  schools?: Maybe<SchoolRelationResponseCollection>;
  startDate: Scalars['Date']['output'];
  status: Enum_Wildcard_Status;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type WildcardSchoolsArgs = {
  filters?: InputMaybe<SchoolFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type WildcardAdminPage = {
  __typename?: 'WildcardAdminPage';
  actions?: Maybe<ComponentWildcardAnnouncementActions>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deleteDialog?: Maybe<ComponentWildcardAnnouncementDeleteDialog>;
  form?: Maybe<ComponentWildcardAnnouncementForm>;
  listDescription?: Maybe<Scalars['String']['output']>;
  listTitle?: Maybe<Scalars['String']['output']>;
  preview?: Maybe<ComponentWildcardAnnouncementPreview>;
  subHeader?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type WildcardAdminPageEntity = {
  __typename?: 'WildcardAdminPageEntity';
  attributes?: Maybe<WildcardAdminPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type WildcardAdminPageEntityResponse = {
  __typename?: 'WildcardAdminPageEntityResponse';
  data?: Maybe<WildcardAdminPageEntity>;
};

export type WildcardAdminPageInput = {
  actions?: InputMaybe<ComponentWildcardAnnouncementActionsInput>;
  deleteDialog?: InputMaybe<ComponentWildcardAnnouncementDeleteDialogInput>;
  form?: InputMaybe<ComponentWildcardAnnouncementFormInput>;
  listDescription?: InputMaybe<Scalars['String']['input']>;
  listTitle?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<ComponentWildcardAnnouncementPreviewInput>;
  subHeader?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type WildcardEntity = {
  __typename?: 'WildcardEntity';
  attributes?: Maybe<Wildcard>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type WildcardEntityResponse = {
  __typename?: 'WildcardEntityResponse';
  data?: Maybe<WildcardEntity>;
};

export type WildcardEntityResponseCollection = {
  __typename?: 'WildcardEntityResponseCollection';
  data: Array<WildcardEntity>;
  meta: ResponseCollectionMeta;
};

export type WildcardFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<WildcardFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  cta?: InputMaybe<ComponentWildcardCtaFiltersInput>;
  ctaText?: InputMaybe<StringFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  endDate?: InputMaybe<DateFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  internal?: InputMaybe<BooleanFilterInput>;
  likes?: InputMaybe<LongFilterInput>;
  not?: InputMaybe<WildcardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<WildcardFiltersInput>>>;
  schools?: InputMaybe<SchoolFiltersInput>;
  startDate?: InputMaybe<DateFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type WildcardInput = {
  cta?: InputMaybe<ComponentWildcardCtaInput>;
  ctaText?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  likes?: InputMaybe<Scalars['Long']['input']>;
  schools?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Enum_Wildcard_Status>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type WildcardRelationResponseCollection = {
  __typename?: 'WildcardRelationResponseCollection';
  data: Array<WildcardEntity>;
};

export type WordPictureGame = {
  __typename?: 'WordPictureGame';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  day: Scalars['Date']['output'];
  duration: Scalars['String']['output'];
  picture: UploadFileEntityResponse;
  tip: UploadFileEntityResponse;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  word: Scalars['String']['output'];
};

export type WordPictureGameEntity = {
  __typename?: 'WordPictureGameEntity';
  attributes?: Maybe<WordPictureGame>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type WordPictureGameEntityResponse = {
  __typename?: 'WordPictureGameEntityResponse';
  data?: Maybe<WordPictureGameEntity>;
};

export type WordPictureGameEntityResponseCollection = {
  __typename?: 'WordPictureGameEntityResponseCollection';
  data: Array<WordPictureGameEntity>;
  meta: ResponseCollectionMeta;
};

export type WordPictureGameFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<WordPictureGameFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  day?: InputMaybe<DateFilterInput>;
  duration?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<WordPictureGameFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<WordPictureGameFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  word?: InputMaybe<StringFilterInput>;
};

export type WordPictureGameInput = {
  day?: InputMaybe<Scalars['Date']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['ID']['input']>;
  tip?: InputMaybe<Scalars['ID']['input']>;
  word?: InputMaybe<Scalars['String']['input']>;
};

export type WordPictureGamePage = {
  __typename?: 'WordPictureGamePage';
  canYouIdentifyTItle: Scalars['String']['output'];
  continueCta?: Maybe<ComponentCommonButton>;
  correct: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  gameTypeTitle: Scalars['String']['output'];
  maybeNextTime: Scalars['String']['output'];
  ordinaryMagicTitle: Scalars['String']['output'];
  showMeTheAnswerCtaLabel: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  whatIsItTitle: Scalars['String']['output'];
};

export type WordPictureGamePageEntity = {
  __typename?: 'WordPictureGamePageEntity';
  attributes?: Maybe<WordPictureGamePage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type WordPictureGamePageEntityResponse = {
  __typename?: 'WordPictureGamePageEntityResponse';
  data?: Maybe<WordPictureGamePageEntity>;
};

export type WordPictureGamePageInput = {
  canYouIdentifyTItle?: InputMaybe<Scalars['String']['input']>;
  continueCta?: InputMaybe<ComponentCommonButtonInput>;
  correct?: InputMaybe<Scalars['String']['input']>;
  gameTypeTitle?: InputMaybe<Scalars['String']['input']>;
  maybeNextTime?: InputMaybe<Scalars['String']['input']>;
  ordinaryMagicTitle?: InputMaybe<Scalars['String']['input']>;
  showMeTheAnswerCtaLabel?: InputMaybe<Scalars['String']['input']>;
  whatIsItTitle?: InputMaybe<Scalars['String']['input']>;
};

export type WsPermission = {
  __typename?: 'WsPermission';
  adminManagement?: Maybe<Scalars['Boolean']['output']>;
  announcements?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  isAdmin: Scalars['Boolean']['output'];
  isMAT?: Maybe<Scalars['Boolean']['output']>;
  isSuperAdmin?: Maybe<Scalars['Boolean']['output']>;
  knowledgeHub?: Maybe<Scalars['Boolean']['output']>;
  meditation?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  reportingDashboard?: Maybe<Scalars['Boolean']['output']>;
  surveyDashboard?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userManagement?: Maybe<Scalars['Boolean']['output']>;
};

export type WsPermissionEntity = {
  __typename?: 'WsPermissionEntity';
  attributes?: Maybe<WsPermission>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type WsPermissionEntityResponse = {
  __typename?: 'WsPermissionEntityResponse';
  data?: Maybe<WsPermissionEntity>;
};

export type WsPermissionEntityResponseCollection = {
  __typename?: 'WsPermissionEntityResponseCollection';
  data: Array<WsPermissionEntity>;
  meta: ResponseCollectionMeta;
};

export type WsPermissionFiltersInput = {
  adminManagement?: InputMaybe<BooleanFilterInput>;
  and?: InputMaybe<Array<InputMaybe<WsPermissionFiltersInput>>>;
  announcements?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isAdmin?: InputMaybe<BooleanFilterInput>;
  isMAT?: InputMaybe<BooleanFilterInput>;
  isSuperAdmin?: InputMaybe<BooleanFilterInput>;
  knowledgeHub?: InputMaybe<BooleanFilterInput>;
  meditation?: InputMaybe<BooleanFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<WsPermissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<WsPermissionFiltersInput>>>;
  reportingDashboard?: InputMaybe<BooleanFilterInput>;
  surveyDashboard?: InputMaybe<BooleanFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  userManagement?: InputMaybe<BooleanFilterInput>;
};

export type WsPermissionInput = {
  adminManagement?: InputMaybe<Scalars['Boolean']['input']>;
  announcements?: InputMaybe<Scalars['Boolean']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isMAT?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  knowledgeHub?: InputMaybe<Scalars['Boolean']['input']>;
  meditation?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reportingDashboard?: InputMaybe<Scalars['Boolean']['input']>;
  surveyDashboard?: InputMaybe<Scalars['Boolean']['input']>;
  userManagement?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SchoolEngagement = {
  __typename?: 'schoolEngagement';
  differenceInHoursMinutesAndSeconds?: Maybe<Scalars['String']['output']>;
  differenceInSeconds?: Maybe<Scalars['Float']['output']>;
  increased?: Maybe<Scalars['Boolean']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
};

type DefaultContentTemplateFragment_ComponentCommonAuthor_Fragment = {
  __typename: 'ComponentCommonAuthor';
  publicationDate: any;
  author?: {
    __typename?: 'AuthorEntityResponse';
    data?: {
      __typename?: 'AuthorEntity';
      attributes?: { __typename?: 'Author'; name: string; role?: string | null } | null;
    } | null;
  } | null;
};

type DefaultContentTemplateFragment_ComponentCommonAuthorDetailed_Fragment = {
  __typename: 'ComponentCommonAuthorDetailed';
};

type DefaultContentTemplateFragment_ComponentCommonButton_Fragment = { __typename: 'ComponentCommonButton' };

type DefaultContentTemplateFragment_ComponentCommonDivider_Fragment = {
  __typename: 'ComponentCommonDivider';
  id: string;
};

type DefaultContentTemplateFragment_ComponentCommonDownloadableContentList_Fragment = {
  __typename: 'ComponentCommonDownloadableContentList';
};

type DefaultContentTemplateFragment_ComponentCommonEmbedded_Fragment = {
  __typename: 'ComponentCommonEmbedded';
  link: string;
  provider: Enum_Componentcommonembedded_Provider;
};

type DefaultContentTemplateFragment_ComponentCommonH3_Fragment = { __typename: 'ComponentCommonH3'; text: string };

type DefaultContentTemplateFragment_ComponentCommonMedia_Fragment = {
  __typename: 'ComponentCommonMedia';
  media: {
    __typename?: 'UploadFileEntityResponse';
    data?: {
      __typename?: 'UploadFileEntity';
      attributes?: { __typename?: 'UploadFile'; url: string; alternativeText?: string | null } | null;
    } | null;
  };
};

type DefaultContentTemplateFragment_ComponentCommonTextEditor_Fragment = {
  __typename: 'ComponentCommonTextEditor';
  markdownText?: string | null;
};

type DefaultContentTemplateFragment_ComponentCommonTheme_Fragment = { __typename: 'ComponentCommonTheme' };

type DefaultContentTemplateFragment_ComponentCommonTitle_Fragment = {
  __typename: 'ComponentCommonTitle';
  title: string;
};

type DefaultContentTemplateFragment_ComponentCommonTranscript_Fragment = { __typename: 'ComponentCommonTranscript' };

type DefaultContentTemplateFragment_Error_Fragment = { __typename: 'Error' };

export type DefaultContentTemplateFragmentFragment =
  | DefaultContentTemplateFragment_ComponentCommonAuthor_Fragment
  | DefaultContentTemplateFragment_ComponentCommonAuthorDetailed_Fragment
  | DefaultContentTemplateFragment_ComponentCommonButton_Fragment
  | DefaultContentTemplateFragment_ComponentCommonDivider_Fragment
  | DefaultContentTemplateFragment_ComponentCommonDownloadableContentList_Fragment
  | DefaultContentTemplateFragment_ComponentCommonEmbedded_Fragment
  | DefaultContentTemplateFragment_ComponentCommonH3_Fragment
  | DefaultContentTemplateFragment_ComponentCommonMedia_Fragment
  | DefaultContentTemplateFragment_ComponentCommonTextEditor_Fragment
  | DefaultContentTemplateFragment_ComponentCommonTheme_Fragment
  | DefaultContentTemplateFragment_ComponentCommonTitle_Fragment
  | DefaultContentTemplateFragment_ComponentCommonTranscript_Fragment
  | DefaultContentTemplateFragment_Error_Fragment;

export type ImageFragmentFragment = {
  __typename?: 'UploadFileEntity';
  attributes?: { __typename?: 'UploadFile'; url: string; alternativeText?: string | null; mime: string } | null;
};

export type LearnFragmentFragment = {
  __typename?: 'Learn';
  completed?: boolean | null;
  completedAt?: any | null;
  users_permissions_user?: {
    __typename?: 'UsersPermissionsUserEntityResponse';
    data?: { __typename?: 'UsersPermissionsUserEntity'; id?: string | null } | null;
  } | null;
  course?: {
    __typename?: 'CourseEntityResponse';
    data?: {
      __typename?: 'CourseEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'Course';
        title: string;
        slug?: string | null;
        description: string;
        thumbnail: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        };
        course_category?: {
          __typename?: 'CourseCategoryEntityResponse';
          data?: {
            __typename?: 'CourseCategoryEntity';
            attributes?: { __typename?: 'CourseCategory'; name: string; description?: string | null } | null;
          } | null;
        } | null;
        type?: {
          __typename?: 'CourseTypeEntityResponse';
          data?: {
            __typename?: 'CourseTypeEntity';
            attributes?: { __typename?: 'CourseType'; name: string } | null;
          } | null;
        } | null;
        modules?: Array<{
          __typename?: 'ComponentLearnCourseModule';
          id: string;
          title: string;
          lessons?: Array<{ __typename?: 'ComponentLearnCourseLesson'; id: string; title: string } | null> | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
  learn_items?: {
    __typename?: 'LearnItemRelationResponseCollection';
    data: Array<{
      __typename?: 'LearnItemEntity';
      attributes?: { __typename?: 'LearnItem'; idModule: string; idLesson: string } | null;
    }>;
  } | null;
};

export type PodcastBaseFragmentFragment = {
  __typename?: 'Podcast';
  title: string;
  slug: string;
  publicationDate: any;
  subHeader?: string | null;
  briefDescription: string;
  guests?: {
    __typename?: 'GuestRelationResponseCollection';
    data: Array<{ __typename?: 'GuestEntity'; attributes?: { __typename?: 'Guest'; name?: string | null } | null }>;
  } | null;
  listenings?: {
    __typename?: 'PodcastListeningTimeRelationResponseCollection';
    data: Array<{
      __typename?: 'PodcastListeningTimeEntity';
      id?: string | null;
      attributes?: { __typename?: 'PodcastListeningTime'; listeningTime: any; duration: any } | null;
    }>;
  } | null;
  themes?: {
    __typename?: 'ThemeRelationResponseCollection';
    data: Array<{
      __typename?: 'ThemeEntity';
      attributes?: {
        __typename?: 'Theme';
        theme?: string | null;
        topic?: {
          __typename?: 'TopicEntityResponse';
          data?: {
            __typename?: 'TopicEntity';
            attributes?: { __typename?: 'Topic'; topic?: string | null } | null;
          } | null;
        } | null;
      } | null;
    }>;
  } | null;
  cover: {
    __typename?: 'UploadFileEntityResponse';
    data?: {
      __typename?: 'UploadFileEntity';
      attributes?: { __typename?: 'UploadFile'; url: string; alternativeText?: string | null; mime: string } | null;
    } | null;
  };
  DefaultContentTemplate: Array<
    | { __typename: 'ComponentCommonAudio' }
    | { __typename: 'ComponentCommonAuthor' }
    | {
        __typename: 'ComponentCommonAuthorDetailed';
        authors?: {
          __typename?: 'AuthorRelationResponseCollection';
          data: Array<{
            __typename?: 'AuthorEntity';
            attributes?: {
              __typename?: 'Author';
              name: string;
              role?: string | null;
              bio?: string | null;
              avatar: {
                __typename?: 'UploadFileEntityResponse';
                data?: {
                  __typename?: 'UploadFileEntity';
                  attributes?: {
                    __typename?: 'UploadFile';
                    url: string;
                    alternativeText?: string | null;
                    mime: string;
                  } | null;
                } | null;
              };
            } | null;
          }>;
        } | null;
      }
    | { __typename: 'ComponentCommonBullet' }
    | { __typename: 'ComponentCommonDivider' }
    | { __typename: 'ComponentCommonDownloadableContentList' }
    | { __typename: 'ComponentCommonEmbedded' }
    | { __typename: 'ComponentCommonFaqComponent' }
    | { __typename: 'ComponentCommonH3' }
    | { __typename: 'ComponentCommonInPartnershipWith' }
    | { __typename: 'ComponentCommonMedia' }
    | { __typename: 'ComponentCommonQuote' }
    | { __typename: 'ComponentCommonRelatedContent' }
    | { __typename: 'ComponentCommonTags' }
    | { __typename: 'ComponentCommonTextEditor' }
    | { __typename: 'ComponentCommonTitle' }
    | { __typename: 'Error' }
    | null
  >;
};

export type ResourceBaseFragmentFragment = {
  __typename?: 'Resource';
  createdAt?: any | null;
  publishedAt?: any | null;
  title: string;
  slug: string;
  duration?: string | null;
  briefDescription: string;
  resourceType?: {
    __typename?: 'ResourceTypeEntityResponse';
    data?: {
      __typename?: 'ResourceTypeEntity';
      attributes?: { __typename?: 'ResourceType'; type: string } | null;
    } | null;
  } | null;
  themes?: {
    __typename?: 'ThemeRelationResponseCollection';
    data: Array<{
      __typename?: 'ThemeEntity';
      attributes?: {
        __typename?: 'Theme';
        theme?: string | null;
        topic?: {
          __typename?: 'TopicEntityResponse';
          data?: {
            __typename?: 'TopicEntity';
            attributes?: { __typename?: 'Topic'; topic?: string | null } | null;
          } | null;
        } | null;
      } | null;
    }>;
  } | null;
  cover: {
    __typename?: 'UploadFileEntityResponse';
    data?: {
      __typename?: 'UploadFileEntity';
      attributes?: { __typename?: 'UploadFile'; url: string; alternativeText?: string | null; mime: string } | null;
    } | null;
  };
  DefaultContentTemplate: Array<
    | { __typename: 'ComponentCommonAuthor' }
    | {
        __typename: 'ComponentCommonAuthorDetailed';
        authors?: {
          __typename?: 'AuthorRelationResponseCollection';
          data: Array<{
            __typename?: 'AuthorEntity';
            attributes?: {
              __typename?: 'Author';
              name: string;
              role?: string | null;
              bio?: string | null;
              avatar: {
                __typename?: 'UploadFileEntityResponse';
                data?: {
                  __typename?: 'UploadFileEntity';
                  attributes?: {
                    __typename?: 'UploadFile';
                    url: string;
                    alternativeText?: string | null;
                    mime: string;
                  } | null;
                } | null;
              };
            } | null;
          }>;
        } | null;
      }
    | { __typename: 'ComponentCommonBullet' }
    | { __typename: 'ComponentCommonDivider' }
    | { __typename: 'ComponentCommonDownloadableContentList' }
    | { __typename: 'ComponentCommonEmbedded' }
    | { __typename: 'ComponentCommonFaqComponent' }
    | { __typename: 'ComponentCommonH3' }
    | { __typename: 'ComponentCommonMedia' }
    | { __typename: 'ComponentCommonQuote' }
    | { __typename: 'ComponentCommonRelatedContent' }
    | { __typename: 'ComponentCommonTags' }
    | { __typename: 'ComponentCommonTextEditor' }
    | { __typename: 'ComponentCommonTitle' }
    | { __typename: 'ComponentKnowledgeHubResourcesRelated' }
    | { __typename: 'Error' }
    | null
  >;
};

export type SeoFragmentFragment = {
  __typename?: 'ComponentSharedSeo';
  metaTitle: string;
  metaDescription: string;
  keywords?: string | null;
  metaRobots?: string | null;
  structuredData?: any | null;
  metaViewport?: string | null;
  canonicalURL?: string | null;
  metaImage?: {
    __typename?: 'UploadFileEntityResponse';
    data?: {
      __typename?: 'UploadFileEntity';
      attributes?: { __typename?: 'UploadFile'; url: string; alternativeText?: string | null; mime: string } | null;
    } | null;
  } | null;
  metaSocial?: Array<{
    __typename?: 'ComponentSharedMetaSocial';
    socialNetwork: Enum_Componentsharedmetasocial_Socialnetwork;
    title: string;
    description: string;
    image?: {
      __typename?: 'UploadFileEntityResponse';
      data?: {
        __typename?: 'UploadFileEntity';
        attributes?: { __typename?: 'UploadFile'; url: string; alternativeText?: string | null; mime: string } | null;
      } | null;
    } | null;
  } | null> | null;
};

export type TopicsBaseFragmentFragment = {
  __typename?: 'Topic';
  topic?: string | null;
  themes?: {
    __typename?: 'ThemeRelationResponseCollection';
    data: Array<{ __typename?: 'ThemeEntity'; attributes?: { __typename?: 'Theme'; theme?: string | null } | null }>;
  } | null;
};

export type CreateLoginTrackerMutationVariables = Exact<{
  input: LoginTrackerInput;
}>;

export type CreateLoginTrackerMutation = {
  __typename?: 'Mutation';
  createLoginTracker?: {
    __typename?: 'LoginTrackerEntityResponse';
    data?: {
      __typename?: 'LoginTrackerEntity';
      attributes?: { __typename?: 'LoginTracker'; streakCounter?: number | null; day?: any | null } | null;
    } | null;
  } | null;
};

export type LoginMutationVariables = Exact<{
  input: UsersPermissionsLoginInput;
}>;

export type LoginMutation = {
  __typename?: 'Mutation';
  login: {
    __typename?: 'UsersPermissionsLoginPayload';
    jwt?: string | null;
    user: { __typename?: 'UsersPermissionsMe'; id: string; email?: string | null };
  };
};

export type RegisterMutationVariables = Exact<{
  input: UsersPermissionsRegisterInput;
}>;

export type RegisterMutation = {
  __typename?: 'Mutation';
  register: { __typename?: 'UsersPermissionsLoginPayload'; user: { __typename?: 'UsersPermissionsMe'; id: string } };
};

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;

export type ForgotPasswordMutation = {
  __typename?: 'Mutation';
  forgotPassword?: { __typename?: 'UsersPermissionsPasswordPayload'; ok: boolean } | null;
};

export type ResetPasswordMutationVariables = Exact<{
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;

export type ResetPasswordMutation = {
  __typename?: 'Mutation';
  resetPassword?: { __typename?: 'UsersPermissionsLoginPayload'; jwt?: string | null } | null;
};

export type CompletedTaskMutationVariables = Exact<{
  data: CompletedTaskInput;
}>;

export type CompletedTaskMutation = {
  __typename?: 'Mutation';
  createCompletedTask?: {
    __typename?: 'CompletedTaskEntityResponse';
    data?: {
      __typename?: 'CompletedTaskEntity';
      attributes?: { __typename?: 'CompletedTask'; createdAt?: any | null } | null;
    } | null;
  } | null;
};

export type AddFavoriteMutationVariables = Exact<{
  data: FavoriteInput;
}>;

export type AddFavoriteMutation = {
  __typename?: 'Mutation';
  createFavorite?: {
    __typename?: 'FavoriteEntityResponse';
    data?: {
      __typename?: 'FavoriteEntity';
      attributes?: { __typename?: 'Favorite'; createdAt?: any | null } | null;
    } | null;
  } | null;
};

export type DeleteFavoriteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteFavoriteMutation = {
  __typename?: 'Mutation';
  deleteFavorite?: {
    __typename?: 'FavoriteEntityResponse';
    data?: {
      __typename?: 'FavoriteEntity';
      attributes?: { __typename?: 'Favorite'; createdAt?: any | null } | null;
    } | null;
  } | null;
};

export type CompleteLessonMutationVariables = Exact<{
  idLesson: Scalars['String']['input'];
  idModule: Scalars['String']['input'];
  idLearn: Scalars['ID']['input'];
}>;

export type CompleteLessonMutation = {
  __typename?: 'Mutation';
  createLearnItem?: {
    __typename?: 'LearnItemEntityResponse';
    data?: {
      __typename?: 'LearnItemEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'LearnItem';
        learn?: {
          __typename?: 'LearnEntityResponse';
          data?: {
            __typename?: 'LearnEntity';
            attributes?: {
              __typename?: 'Learn';
              completed?: boolean | null;
              completedAt?: any | null;
              users_permissions_user?: {
                __typename?: 'UsersPermissionsUserEntityResponse';
                data?: { __typename?: 'UsersPermissionsUserEntity'; id?: string | null } | null;
              } | null;
              course?: {
                __typename?: 'CourseEntityResponse';
                data?: {
                  __typename?: 'CourseEntity';
                  id?: string | null;
                  attributes?: {
                    __typename?: 'Course';
                    title: string;
                    slug?: string | null;
                    description: string;
                    thumbnail: {
                      __typename?: 'UploadFileEntityResponse';
                      data?: {
                        __typename?: 'UploadFileEntity';
                        attributes?: {
                          __typename?: 'UploadFile';
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        } | null;
                      } | null;
                    };
                    course_category?: {
                      __typename?: 'CourseCategoryEntityResponse';
                      data?: {
                        __typename?: 'CourseCategoryEntity';
                        attributes?: {
                          __typename?: 'CourseCategory';
                          name: string;
                          description?: string | null;
                        } | null;
                      } | null;
                    } | null;
                    type?: {
                      __typename?: 'CourseTypeEntityResponse';
                      data?: {
                        __typename?: 'CourseTypeEntity';
                        attributes?: { __typename?: 'CourseType'; name: string } | null;
                      } | null;
                    } | null;
                    modules?: Array<{
                      __typename?: 'ComponentLearnCourseModule';
                      id: string;
                      title: string;
                      lessons?: Array<{
                        __typename?: 'ComponentLearnCourseLesson';
                        id: string;
                        title: string;
                      } | null> | null;
                    } | null> | null;
                  } | null;
                } | null;
              } | null;
              learn_items?: {
                __typename?: 'LearnItemRelationResponseCollection';
                data: Array<{
                  __typename?: 'LearnItemEntity';
                  attributes?: { __typename?: 'LearnItem'; idModule: string; idLesson: string } | null;
                }>;
              } | null;
            } | null;
          } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CreateLearnMutationVariables = Exact<{
  idUser: Scalars['ID']['input'];
  idCourse: Scalars['ID']['input'];
}>;

export type CreateLearnMutation = {
  __typename?: 'Mutation';
  createLearn?: {
    __typename?: 'LearnEntityResponse';
    data?: {
      __typename?: 'LearnEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'Learn';
        completed?: boolean | null;
        completedAt?: any | null;
        users_permissions_user?: {
          __typename?: 'UsersPermissionsUserEntityResponse';
          data?: { __typename?: 'UsersPermissionsUserEntity'; id?: string | null } | null;
        } | null;
        course?: {
          __typename?: 'CourseEntityResponse';
          data?: {
            __typename?: 'CourseEntity';
            id?: string | null;
            attributes?: {
              __typename?: 'Course';
              title: string;
              slug?: string | null;
              description: string;
              thumbnail: {
                __typename?: 'UploadFileEntityResponse';
                data?: {
                  __typename?: 'UploadFileEntity';
                  attributes?: {
                    __typename?: 'UploadFile';
                    url: string;
                    alternativeText?: string | null;
                    mime: string;
                  } | null;
                } | null;
              };
              course_category?: {
                __typename?: 'CourseCategoryEntityResponse';
                data?: {
                  __typename?: 'CourseCategoryEntity';
                  attributes?: { __typename?: 'CourseCategory'; name: string; description?: string | null } | null;
                } | null;
              } | null;
              type?: {
                __typename?: 'CourseTypeEntityResponse';
                data?: {
                  __typename?: 'CourseTypeEntity';
                  attributes?: { __typename?: 'CourseType'; name: string } | null;
                } | null;
              } | null;
              modules?: Array<{
                __typename?: 'ComponentLearnCourseModule';
                id: string;
                title: string;
                lessons?: Array<{ __typename?: 'ComponentLearnCourseLesson'; id: string; title: string } | null> | null;
              } | null> | null;
            } | null;
          } | null;
        } | null;
        learn_items?: {
          __typename?: 'LearnItemRelationResponseCollection';
          data: Array<{
            __typename?: 'LearnItemEntity';
            attributes?: { __typename?: 'LearnItem'; idModule: string; idLesson: string } | null;
          }>;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CompleteLearnMutationVariables = Exact<{
  idLearn: Scalars['ID']['input'];
}>;

export type CompleteLearnMutation = {
  __typename?: 'Mutation';
  updateLearn?: {
    __typename?: 'LearnEntityResponse';
    data?: {
      __typename?: 'LearnEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'Learn';
        completed?: boolean | null;
        completedAt?: any | null;
        users_permissions_user?: {
          __typename?: 'UsersPermissionsUserEntityResponse';
          data?: { __typename?: 'UsersPermissionsUserEntity'; id?: string | null } | null;
        } | null;
        course?: {
          __typename?: 'CourseEntityResponse';
          data?: {
            __typename?: 'CourseEntity';
            id?: string | null;
            attributes?: {
              __typename?: 'Course';
              title: string;
              slug?: string | null;
              description: string;
              thumbnail: {
                __typename?: 'UploadFileEntityResponse';
                data?: {
                  __typename?: 'UploadFileEntity';
                  attributes?: {
                    __typename?: 'UploadFile';
                    url: string;
                    alternativeText?: string | null;
                    mime: string;
                  } | null;
                } | null;
              };
              course_category?: {
                __typename?: 'CourseCategoryEntityResponse';
                data?: {
                  __typename?: 'CourseCategoryEntity';
                  attributes?: { __typename?: 'CourseCategory'; name: string; description?: string | null } | null;
                } | null;
              } | null;
              type?: {
                __typename?: 'CourseTypeEntityResponse';
                data?: {
                  __typename?: 'CourseTypeEntity';
                  attributes?: { __typename?: 'CourseType'; name: string } | null;
                } | null;
              } | null;
              modules?: Array<{
                __typename?: 'ComponentLearnCourseModule';
                id: string;
                title: string;
                lessons?: Array<{ __typename?: 'ComponentLearnCourseLesson'; id: string; title: string } | null> | null;
              } | null> | null;
            } | null;
          } | null;
        } | null;
        learn_items?: {
          __typename?: 'LearnItemRelationResponseCollection';
          data: Array<{
            __typename?: 'LearnItemEntity';
            attributes?: { __typename?: 'LearnItem'; idModule: string; idLesson: string } | null;
          }>;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CreateCourseFeedbackMutationVariables = Exact<{
  data: CourseFeedbackInput;
}>;

export type CreateCourseFeedbackMutation = {
  __typename?: 'Mutation';
  createCourseFeedback?: {
    __typename?: 'CourseFeedbackEntityResponse';
    data?: { __typename?: 'CourseFeedbackEntity'; id?: string | null } | null;
  } | null;
};

export type UpdateSchollTermDatesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: SchoolInput;
}>;

export type UpdateSchollTermDatesMutation = {
  __typename?: 'Mutation';
  updateSchool?: {
    __typename?: 'SchoolEntityResponse';
    data?: { __typename?: 'SchoolEntity'; id?: string | null } | null;
  } | null;
};

export type UpdateUsersPermissionsUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UsersPermissionsUserInput;
}>;

export type UpdateUsersPermissionsUserMutation = {
  __typename?: 'Mutation';
  updateUsersPermissionsUser: {
    __typename?: 'UsersPermissionsUserEntityResponse';
    data?: {
      __typename?: 'UsersPermissionsUserEntity';
      attributes?: { __typename?: 'UsersPermissionsUser'; updatedAt?: any | null } | null;
    } | null;
  };
};

export type UpdateUserOnboardingWeeklyQuestionsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UsersPermissionsUserInput;
}>;

export type UpdateUserOnboardingWeeklyQuestionsMutation = {
  __typename?: 'Mutation';
  updateUsersPermissionsUser: {
    __typename?: 'UsersPermissionsUserEntityResponse';
    data?: {
      __typename?: 'UsersPermissionsUserEntity';
      attributes?: { __typename?: 'UsersPermissionsUser'; username: string; onboardQuestionsCompleted: boolean } | null;
    } | null;
  };
};

export type UpdateUserTrackingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UsersPermissionsUserInput;
}>;

export type UpdateUserTrackingMutation = {
  __typename?: 'Mutation';
  updateUsersPermissionsUser: {
    __typename?: 'UsersPermissionsUserEntityResponse';
    data?: {
      __typename?: 'UsersPermissionsUserEntity';
      attributes?: {
        __typename?: 'UsersPermissionsUser';
        username: string;
        isEmotionWheelTrackingDisabled?: boolean | null;
      } | null;
    } | null;
  };
};

export type CreatePodcastInteractionMutationVariables = Exact<{
  input: PodcastInteractionInput;
}>;

export type CreatePodcastInteractionMutation = {
  __typename?: 'Mutation';
  createPodcastInteraction?: {
    __typename?: 'PodcastInteractionEntityResponse';
    data?: {
      __typename?: 'PodcastInteractionEntity';
      attributes?: { __typename?: 'PodcastInteraction'; createdAt?: any | null } | null;
    } | null;
  } | null;
};

export type CreatePodcastListeningTimeMutationVariables = Exact<{
  input: PodcastListeningTimeInput;
}>;

export type CreatePodcastListeningTimeMutation = {
  __typename?: 'Mutation';
  createPodcastListeningTime?: {
    __typename?: 'PodcastListeningTimeEntityResponse';
    data?: {
      __typename?: 'PodcastListeningTimeEntity';
      id?: string | null;
      attributes?: { __typename?: 'PodcastListeningTime'; listeningTime: any; duration: any } | null;
    } | null;
  } | null;
};

export type UpdatePodcastListeningTimeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: PodcastListeningTimeInput;
}>;

export type UpdatePodcastListeningTimeMutation = {
  __typename?: 'Mutation';
  updatePodcastListeningTime?: {
    __typename?: 'PodcastListeningTimeEntityResponse';
    data?: {
      __typename?: 'PodcastListeningTimeEntity';
      attributes?: { __typename?: 'PodcastListeningTime'; createdAt?: any | null } | null;
    } | null;
  } | null;
};

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UsersPermissionsUserInput;
}>;

export type UpdateUserMutation = {
  __typename?: 'Mutation';
  updateUsersPermissionsUser: {
    __typename?: 'UsersPermissionsUserEntityResponse';
    data?: {
      __typename?: 'UsersPermissionsUserEntity';
      attributes?: { __typename?: 'UsersPermissionsUser'; username: string } | null;
    } | null;
  };
};

export type ChangePasswordMutationVariables = Exact<{
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
}>;

export type ChangePasswordMutation = {
  __typename?: 'Mutation';
  changePassword?: { __typename: 'UsersPermissionsLoginPayload' } | null;
};

export type InsertWildcardMutationVariables = Exact<{
  data: WildcardInput;
}>;

export type InsertWildcardMutation = {
  __typename?: 'Mutation';
  createWildcard?: {
    __typename?: 'WildcardEntityResponse';
    data?: {
      __typename?: 'WildcardEntity';
      attributes?: {
        __typename?: 'Wildcard';
        title?: string | null;
        startDate: any;
        endDate: any;
        description: string;
        status: Enum_Wildcard_Status;
      } | null;
    } | null;
  } | null;
};

export type UpdateWildcardMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: WildcardInput;
}>;

export type UpdateWildcardMutation = {
  __typename?: 'Mutation';
  updateWildcard?: {
    __typename?: 'WildcardEntityResponse';
    data?: {
      __typename?: 'WildcardEntity';
      attributes?: {
        __typename?: 'Wildcard';
        title?: string | null;
        startDate: any;
        endDate: any;
        description: string;
        status: Enum_Wildcard_Status;
      } | null;
    } | null;
  } | null;
};

export type PublishWildcardMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type PublishWildcardMutation = {
  __typename?: 'Mutation';
  updateWildcard?: {
    __typename?: 'WildcardEntityResponse';
    data?: {
      __typename?: 'WildcardEntity';
      attributes?: { __typename?: 'Wildcard'; status: Enum_Wildcard_Status } | null;
    } | null;
  } | null;
};

export type UnpublishWildcardMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type UnpublishWildcardMutation = {
  __typename?: 'Mutation';
  updateWildcard?: {
    __typename?: 'WildcardEntityResponse';
    data?: {
      __typename?: 'WildcardEntity';
      attributes?: { __typename?: 'Wildcard'; status: Enum_Wildcard_Status } | null;
    } | null;
  } | null;
};

export type DeleteWildcardMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteWildcardMutation = {
  __typename?: 'Mutation';
  updateWildcard?: {
    __typename?: 'WildcardEntityResponse';
    data?: {
      __typename?: 'WildcardEntity';
      attributes?: { __typename?: 'Wildcard'; status: Enum_Wildcard_Status } | null;
    } | null;
  } | null;
};

export type AboutPageQueryVariables = Exact<{ [key: string]: never }>;

export type AboutPageQuery = {
  __typename?: 'Query';
  aboutPage?: {
    __typename?: 'AboutPageEntityResponse';
    data?: {
      __typename?: 'AboutPageEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'AboutPage';
        pageTitle: string;
        DefaultContentTemplate: Array<
          | {
              __typename: 'ComponentCommonAuthor';
              publicationDate: any;
              author?: {
                __typename?: 'AuthorEntityResponse';
                data?: {
                  __typename?: 'AuthorEntity';
                  attributes?: { __typename?: 'Author'; name: string } | null;
                } | null;
              } | null;
            }
          | {
              __typename: 'ComponentCommonAuthorDetailed';
              authors?: {
                __typename?: 'AuthorRelationResponseCollection';
                data: Array<{
                  __typename?: 'AuthorEntity';
                  attributes?: {
                    __typename?: 'Author';
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: 'UploadFileEntityResponse';
                      data?: {
                        __typename?: 'UploadFileEntity';
                        attributes?: {
                          __typename?: 'UploadFile';
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        } | null;
                      } | null;
                    };
                  } | null;
                }>;
              } | null;
            }
          | {
              __typename: 'ComponentCommonBullet';
              item: Array<{ __typename?: 'ComponentCommonList'; text: string } | null>;
            }
          | { __typename: 'ComponentCommonDivider'; id: string }
          | {
              __typename: 'ComponentCommonDownloadableContentList';
              list?: Array<{
                __typename?: 'ComponentCommonDownloadableContent';
                id: string;
                title: string;
                description?: string | null;
                content: {
                  __typename?: 'UploadFileEntityResponse';
                  data?: {
                    __typename?: 'UploadFileEntity';
                    attributes?: { __typename?: 'UploadFile'; url: string } | null;
                  } | null;
                };
              } | null> | null;
            }
          | { __typename: 'ComponentCommonEmbedded'; link: string; provider: Enum_Componentcommonembedded_Provider }
          | {
              __typename: 'ComponentCommonFaqComponent';
              faq?: Array<{ __typename?: 'ComponentCommonFaq'; title: string; description: string } | null> | null;
            }
          | { __typename: 'ComponentCommonH3'; text: string }
          | {
              __typename: 'ComponentCommonMedia';
              media: {
                __typename?: 'UploadFileEntityResponse';
                data?: {
                  __typename?: 'UploadFileEntity';
                  attributes?: { __typename?: 'UploadFile'; url: string; alternativeText?: string | null } | null;
                } | null;
              };
            }
          | { __typename: 'ComponentCommonQuote'; quote: string }
          | { __typename: 'ComponentCommonTextEditor'; markdownText?: string | null }
          | { __typename: 'ComponentCommonTitle'; title: string }
          | { __typename: 'Error' }
          | null
        >;
      } | null;
    } | null;
  } | null;
};

export type FetchUserTrackingQueryVariables = Exact<{ [key: string]: never }>;

export type FetchUserTrackingQuery = {
  __typename?: 'Query';
  getUserTrackingData?: {
    __typename?: 'UserTrackingDataResult';
    dailyStreak?: number | null;
    streakRecord?: number | null;
    emotionsTracked?: number | null;
  } | null;
};

export type FetchLoginTrackerQueryVariables = Exact<{
  startDay: Scalars['Date']['input'];
  endDay: Scalars['Date']['input'];
  userId: Scalars['ID']['input'];
}>;

export type FetchLoginTrackerQuery = {
  __typename?: 'Query';
  loginTrackers?: {
    __typename?: 'LoginTrackerEntityResponseCollection';
    data: Array<{
      __typename?: 'LoginTrackerEntity';
      attributes?: { __typename?: 'LoginTracker'; streakCounter?: number | null; day?: any | null } | null;
    }>;
  } | null;
};

export type CookiesPageQueryVariables = Exact<{ [key: string]: never }>;

export type CookiesPageQuery = {
  __typename?: 'Query';
  cookiesPage?: {
    __typename?: 'CookiesPageEntityResponse';
    data?: {
      __typename?: 'CookiesPageEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'CookiesPage';
        title: string;
        DefaultContentTemplate: Array<
          | {
              __typename: 'ComponentCommonAuthor';
              publicationDate: any;
              author?: {
                __typename?: 'AuthorEntityResponse';
                data?: {
                  __typename?: 'AuthorEntity';
                  attributes?: { __typename?: 'Author'; name: string } | null;
                } | null;
              } | null;
            }
          | {
              __typename: 'ComponentCommonAuthorDetailed';
              authors?: {
                __typename?: 'AuthorRelationResponseCollection';
                data: Array<{
                  __typename?: 'AuthorEntity';
                  attributes?: {
                    __typename?: 'Author';
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: 'UploadFileEntityResponse';
                      data?: {
                        __typename?: 'UploadFileEntity';
                        attributes?: {
                          __typename?: 'UploadFile';
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        } | null;
                      } | null;
                    };
                  } | null;
                }>;
              } | null;
            }
          | {
              __typename: 'ComponentCommonBullet';
              item: Array<{ __typename?: 'ComponentCommonList'; text: string } | null>;
            }
          | { __typename: 'ComponentCommonDivider'; id: string }
          | {
              __typename: 'ComponentCommonDownloadableContentList';
              list?: Array<{
                __typename?: 'ComponentCommonDownloadableContent';
                id: string;
                title: string;
                description?: string | null;
                content: {
                  __typename?: 'UploadFileEntityResponse';
                  data?: {
                    __typename?: 'UploadFileEntity';
                    attributes?: { __typename?: 'UploadFile'; url: string } | null;
                  } | null;
                };
              } | null> | null;
            }
          | { __typename: 'ComponentCommonEmbedded'; link: string; provider: Enum_Componentcommonembedded_Provider }
          | {
              __typename: 'ComponentCommonFaqComponent';
              faq?: Array<{ __typename?: 'ComponentCommonFaq'; title: string; description: string } | null> | null;
            }
          | { __typename: 'ComponentCommonH3'; text: string }
          | {
              __typename: 'ComponentCommonMedia';
              media: {
                __typename?: 'UploadFileEntityResponse';
                data?: {
                  __typename?: 'UploadFileEntity';
                  attributes?: { __typename?: 'UploadFile'; url: string; alternativeText?: string | null } | null;
                } | null;
              };
            }
          | { __typename: 'ComponentCommonQuote'; quote: string }
          | { __typename: 'ComponentCommonTextEditor'; markdownText?: string | null }
          | { __typename: 'ComponentCommonTitle'; title: string }
          | { __typename: 'Error' }
          | null
        >;
      } | null;
    } | null;
  } | null;
};

export type CopyrightPageQueryVariables = Exact<{ [key: string]: never }>;

export type CopyrightPageQuery = {
  __typename?: 'Query';
  copyrightPage?: {
    __typename?: 'CopyrightPageEntityResponse';
    data?: {
      __typename?: 'CopyrightPageEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'CopyrightPage';
        title: string;
        DefaultContentTemplate: Array<
          | {
              __typename: 'ComponentCommonAuthor';
              publicationDate: any;
              author?: {
                __typename?: 'AuthorEntityResponse';
                data?: {
                  __typename?: 'AuthorEntity';
                  attributes?: { __typename?: 'Author'; name: string } | null;
                } | null;
              } | null;
            }
          | {
              __typename: 'ComponentCommonAuthorDetailed';
              authors?: {
                __typename?: 'AuthorRelationResponseCollection';
                data: Array<{
                  __typename?: 'AuthorEntity';
                  attributes?: {
                    __typename?: 'Author';
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: 'UploadFileEntityResponse';
                      data?: {
                        __typename?: 'UploadFileEntity';
                        attributes?: {
                          __typename?: 'UploadFile';
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        } | null;
                      } | null;
                    };
                  } | null;
                }>;
              } | null;
            }
          | {
              __typename: 'ComponentCommonBullet';
              item: Array<{ __typename?: 'ComponentCommonList'; text: string } | null>;
            }
          | { __typename: 'ComponentCommonDivider'; id: string }
          | {
              __typename: 'ComponentCommonDownloadableContentList';
              list?: Array<{
                __typename?: 'ComponentCommonDownloadableContent';
                id: string;
                title: string;
                description?: string | null;
                content: {
                  __typename?: 'UploadFileEntityResponse';
                  data?: {
                    __typename?: 'UploadFileEntity';
                    attributes?: { __typename?: 'UploadFile'; url: string } | null;
                  } | null;
                };
              } | null> | null;
            }
          | { __typename: 'ComponentCommonEmbedded'; link: string; provider: Enum_Componentcommonembedded_Provider }
          | {
              __typename: 'ComponentCommonFaqComponent';
              faq?: Array<{ __typename?: 'ComponentCommonFaq'; title: string; description: string } | null> | null;
            }
          | { __typename: 'ComponentCommonH3'; text: string }
          | {
              __typename: 'ComponentCommonMedia';
              media: {
                __typename?: 'UploadFileEntityResponse';
                data?: {
                  __typename?: 'UploadFileEntity';
                  attributes?: { __typename?: 'UploadFile'; url: string; alternativeText?: string | null } | null;
                } | null;
              };
            }
          | { __typename: 'ComponentCommonQuote'; quote: string }
          | { __typename: 'ComponentCommonTextEditor'; markdownText?: string | null }
          | { __typename: 'ComponentCommonTitle'; title: string }
          | { __typename: 'Error' }
          | null
        >;
      } | null;
    } | null;
  } | null;
};

export type DailyTaskHasBeenCompletedQueryVariables = Exact<{
  day: Scalars['Date']['input'];
  type: Scalars['String']['input'];
  relationID: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
}>;

export type DailyTaskHasBeenCompletedQuery = {
  __typename?: 'Query';
  completedTasks?: {
    __typename?: 'CompletedTaskEntityResponseCollection';
    data: Array<{
      __typename?: 'CompletedTaskEntity';
      attributes?: { __typename?: 'CompletedTask'; metadata: any } | null;
    }>;
  } | null;
};

export type DailyTrakingEmotionQueryVariables = Exact<{
  startDay: Scalars['Date']['input'];
  endDay: Scalars['Date']['input'];
}>;

export type DailyTrakingEmotionQuery = {
  __typename?: 'Query';
  emotionTracker?: Array<{
    __typename?: 'EmotionTrackerResult';
    emotion?: string | null;
    day?: string | null;
    isDisabledTracking?: boolean | null;
  } | null> | null;
};

export type GetUserTrackingDataQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserTrackingDataQuery = {
  __typename?: 'Query';
  getUserTrackingData?: {
    __typename?: 'UserTrackingDataResult';
    dailyStreak?: number | null;
    streakRecord?: number | null;
    emotionsTracked?: number | null;
  } | null;
};

export type FetchUserStreakQueryVariables = Exact<{
  type: Scalars['String']['input'];
}>;

export type FetchUserStreakQuery = {
  __typename?: 'Query';
  fetchUserStreak?: { __typename?: 'Streak'; total?: number | null; streak?: number | null } | null;
};

export type DailyBubbleFinishedQueryVariables = Exact<{ [key: string]: never }>;

export type DailyBubbleFinishedQuery = {
  __typename?: 'Query';
  dailyBubbleFinishedPage?: {
    __typename?: 'DailyBubbleFinishedPageEntityResponse';
    data?: {
      __typename?: 'DailyBubbleFinishedPageEntity';
      attributes?: {
        __typename?: 'DailyBubbleFinishedPage';
        continueYourWeelbeingJourneyTitle: string;
        resourcesTitle: string;
        resourceDescription: string;
        toolkitsTitle: string;
        toolkitsDescription: string;
        messageSection: {
          __typename?: 'ComponentCommonMessageSection';
          youAreDoneTitle: string;
          comeBackTitle: string;
        };
      } | null;
    } | null;
  } | null;
};

export type HomePageQueryVariables = Exact<{ [key: string]: never }>;

export type HomePageQuery = {
  __typename?: 'Query';
  dailyBubblePage?: {
    __typename?: 'DailyBubblePageEntityResponse';
    data?: {
      __typename?: 'DailyBubblePageEntity';
      attributes?: {
        __typename?: 'DailyBubblePage';
        headerSection: { __typename?: 'ComponentDailyBubblePageHeaderSection'; message: string };
        sections: {
          __typename?: 'ComponentHomeSections';
          yourDailyBubbleTitle: string;
          trendingThisWeekTitle: string;
          yourWeeklyquestionTitle: string;
          yourWeeklyQuestionDescription?: string | null;
          yourWeeklyQuestionOnboardingTitle?: string | null;
          latestPodcastTitle: string;
          learnTitle: string;
          wildcardTitle?: string | null;
        };
        dailySection: {
          __typename?: 'ComponentHomeDailySection';
          insightTitle: string;
          insightDescription: string;
          insightBtnLabel: string;
          mindfulMinuteTitle: string;
          mindfulMinuteDescription: string;
          mindfulMinuteBtnLabel: string;
          emotionWheelTItle: string;
          emotionWheelDescription: string;
          emotionWheelBtnLabel: string;
          dailyQuoteTitle: string;
          prefixInsightCard?: string | null;
          titleInsightCard?: string | null;
          prefixMindfulMinuteCard?: string | null;
          titleMindfulMinuteCard?: string | null;
        };
        onboardingQuestions?: {
          __typename?: 'ComponentDailyBubblePageOnboardingQuestions';
          title: string;
          description: string;
          btnLabel: string;
        } | null;
        finishingCard?: {
          __typename?: 'ComponentDailyBubblePageFinishingCard';
          finishingCardEmotionWheel?: {
            __typename?: 'ComponentAdminOnboradingFinishingCardEmotionWheel';
            trackAgain?: string | null;
            yourCalendar?: string | null;
            title?: string | null;
            emotions?: string | null;
            yourStreak?: string | null;
            days?: string | null;
            youHaveTracked?: string | null;
          } | null;
          finishingCardInsight?: {
            __typename?: 'ComponentDailyBubblePageFinishingCardInsight';
            title?: string | null;
            insights?: string | null;
            yourStreak?: string | null;
            days?: string | null;
            readAgain?: string | null;
            youHaveRead?: string | null;
          } | null;
          finishingCardMindfulMinute?: {
            __typename?: 'ComponentDailyBubblePageFinishingCardMindfulMinute';
            title?: string | null;
            minutes?: string | null;
            yourStreak?: string | null;
            days?: string | null;
            startAgain?: string | null;
            relatedContent?: string | null;
            youHaveWatched?: string | null;
          } | null;
          finishingCardSurvey?: {
            __typename?: 'ComponentDailyBubblePageFinishingCardSurvey';
            title?: string | null;
            youHaveAnswered?: string | null;
            questions?: string | null;
            learnMore?: string | null;
            hideThisCard?: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type DailyInsightQueryVariables = Exact<{
  date?: InputMaybe<DateFilterInput>;
}>;

export type DailyInsightQuery = {
  __typename?: 'Query';
  insights?: {
    __typename?: 'InsightEntityResponseCollection';
    data: Array<{
      __typename?: 'InsightEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'Insight';
        title?: string | null;
        type?: string | null;
        subHeader?: string | null;
        duration: string;
        day: any;
        cover?: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        } | null;
        themes?: {
          __typename?: 'ThemeRelationResponseCollection';
          data: Array<{
            __typename?: 'ThemeEntity';
            attributes?: {
              __typename?: 'Theme';
              theme?: string | null;
              topic?: {
                __typename?: 'TopicEntityResponse';
                data?: {
                  __typename?: 'TopicEntity';
                  attributes?: { __typename?: 'Topic'; topic?: string | null } | null;
                } | null;
              } | null;
            } | null;
          }>;
        } | null;
        resource?: {
          __typename?: 'ResourceEntityResponse';
          data?: {
            __typename?: 'ResourceEntity';
            attributes?: { __typename?: 'Resource'; slug: string } | null;
          } | null;
        } | null;
        DefaultContentTemplate?: Array<
          | {
              __typename: 'ComponentCommonAuthor';
              publicationDate: any;
              author?: {
                __typename?: 'AuthorEntityResponse';
                data?: {
                  __typename?: 'AuthorEntity';
                  attributes?: { __typename?: 'Author'; name: string; role?: string | null } | null;
                } | null;
              } | null;
            }
          | {
              __typename: 'ComponentCommonAuthorDetailed';
              authors?: {
                __typename?: 'AuthorRelationResponseCollection';
                data: Array<{
                  __typename?: 'AuthorEntity';
                  attributes?: {
                    __typename?: 'Author';
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: 'UploadFileEntityResponse';
                      data?: {
                        __typename?: 'UploadFileEntity';
                        attributes?: {
                          __typename?: 'UploadFile';
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        } | null;
                      } | null;
                    };
                  } | null;
                }>;
              } | null;
            }
          | { __typename: 'ComponentCommonButton'; text: string; link: string }
          | { __typename: 'ComponentCommonDivider'; id: string }
          | {
              __typename: 'ComponentCommonDownloadableContentList';
              list?: Array<{
                __typename?: 'ComponentCommonDownloadableContent';
                title: string;
                description?: string | null;
                content: {
                  __typename?: 'UploadFileEntityResponse';
                  data?: {
                    __typename?: 'UploadFileEntity';
                    attributes?: { __typename?: 'UploadFile'; url: string } | null;
                  } | null;
                };
              } | null> | null;
            }
          | { __typename: 'ComponentCommonEmbedded'; link: string; provider: Enum_Componentcommonembedded_Provider }
          | { __typename: 'ComponentCommonH3'; text: string }
          | {
              __typename: 'ComponentCommonMedia';
              media: {
                __typename?: 'UploadFileEntityResponse';
                data?: {
                  __typename?: 'UploadFileEntity';
                  attributes?: { __typename?: 'UploadFile'; url: string; alternativeText?: string | null } | null;
                } | null;
              };
            }
          | { __typename: 'ComponentCommonTextEditor'; markdownText?: string | null }
          | { __typename: 'ComponentCommonTheme'; theme?: string | null }
          | { __typename: 'ComponentCommonTitle'; title: string }
          | { __typename: 'ComponentCommonTranscript'; id: string }
          | { __typename: 'Error' }
          | null
        > | null;
      } | null;
    }>;
  } | null;
};

export type InsightPageQueryVariables = Exact<{ [key: string]: never }>;

export type InsightPageQuery = {
  __typename?: 'Query';
  insightPage?: {
    __typename?: 'InsightPageEntityResponse';
    data?: {
      __typename?: 'InsightPageEntity';
      attributes?: {
        __typename?: 'InsightPage';
        relatedContentViewAllLabel?: string | null;
        relatedContentTitle?: string | null;
      } | null;
    } | null;
  } | null;
};

export type EmotionWHeelQueryVariables = Exact<{ [key: string]: never }>;

export type EmotionWHeelQuery = {
  __typename?: 'Query';
  emotionWheels?: {
    __typename?: 'EmotionWheelEntityResponseCollection';
    data: Array<{
      __typename?: 'EmotionWheelEntity';
      attributes?: {
        __typename?: 'EmotionWheel';
        emotion: string;
        description: string;
        typeSection: {
          __typename?: 'ComponentEmotionWheelTypeSection';
          type?: string | null;
          mainGradientFrom: string;
          mainGradientTo: string;
          secondaryGradientFrom: string;
          secondaryGradientTo: string;
        };
        L2?: Array<{
          __typename?: 'ComponentEmotionWheelLevels';
          emotion: string;
          description: string;
          advice?: string | null;
          L3?: Array<{ __typename?: 'ComponentEmotionWheelLevel'; emotion: string; description: string } | null> | null;
          finalState?: {
            __typename?: 'ComponentEmotionWheelFinalState';
            redirectToCurrentInsight?: boolean | null;
            redirectToCurrentMindfulMinute?: boolean | null;
            redirectToCalendar?: boolean | null;
            podcast?: {
              __typename?: 'PodcastEntityResponse';
              data?: {
                __typename?: 'PodcastEntity';
                attributes?: { __typename?: 'Podcast'; slug: string } | null;
              } | null;
            } | null;
            mindfulExercise?: {
              __typename?: 'MeditationEntityResponse';
              data?: {
                __typename?: 'MeditationEntity';
                attributes?: { __typename?: 'Meditation'; slug?: string | null } | null;
              } | null;
            } | null;
            course?: {
              __typename?: 'CourseEntityResponse';
              data?: {
                __typename?: 'CourseEntity';
                attributes?: { __typename?: 'Course'; slug?: string | null } | null;
              } | null;
            } | null;
            resource?: {
              __typename?: 'ResourceEntityResponse';
              data?: {
                __typename?: 'ResourceEntity';
                attributes?: { __typename?: 'Resource'; slug: string } | null;
              } | null;
            } | null;
          } | null;
        } | null> | null;
        overallMoodIcon?: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: { __typename?: 'UploadFile'; url: string } | null;
          } | null;
        } | null;
      } | null;
    }>;
  } | null;
};

export type EmotionWHeelPageQueryVariables = Exact<{ [key: string]: never }>;

export type EmotionWHeelPageQuery = {
  __typename?: 'Query';
  emotionWheelPage?: {
    __typename?: 'EmotionWheelPageEntityResponse';
    data?: {
      __typename?: 'EmotionWheelPageEntity';
      attributes?: {
        __typename?: 'EmotionWheelPage';
        relatedContentTitle?: string | null;
        howAreYouFeelingTitle: string;
        youAreTitle: string;
        howAreYouTitle: string;
        changeMyAnswerCta: string;
        wellDoneTitle: string;
        goToYourMoodTracker?: string | null;
        resetTheWheel?: string | null;
        calendarTitle?: string | null;
        bottomText?: string | null;
        messages?: {
          __typename?: 'ComponentEmotionWheelMessages';
          initial?: string | null;
          L1?: string | null;
          L2?: string | null;
          initialTitle?: string | null;
          L1Title?: string | null;
          L2Title?: string | null;
          privacyStatement?: string | null;
        } | null;
        onboarding?: {
          __typename?: 'ComponentEmotionWheelOnboarding';
          steps?: Array<{
            __typename?: 'ComponentCommonSteps';
            title: string;
            description: string;
            textBtn: string;
            image: {
              __typename?: 'UploadFileEntityResponse';
              data?: {
                __typename?: 'UploadFileEntity';
                attributes?: {
                  __typename?: 'UploadFile';
                  url: string;
                  alternativeText?: string | null;
                  mime: string;
                } | null;
              } | null;
            };
          } | null> | null;
        } | null;
        EmotionNotFound?: {
          __typename?: 'ComponentCommonRawTextWithLinks';
          text?: string | null;
          finalState?: {
            __typename?: 'ComponentEmotionWheelFinalState';
            redirectToCurrentInsight?: boolean | null;
            redirectToCurrentMindfulMinute?: boolean | null;
            redirectToCalendar?: boolean | null;
            podcast?: {
              __typename?: 'PodcastEntityResponse';
              data?: {
                __typename?: 'PodcastEntity';
                attributes?: { __typename?: 'Podcast'; slug: string } | null;
              } | null;
            } | null;
            mindfulExercise?: {
              __typename?: 'MeditationEntityResponse';
              data?: {
                __typename?: 'MeditationEntity';
                attributes?: { __typename?: 'Meditation'; slug?: string | null } | null;
              } | null;
            } | null;
            course?: {
              __typename?: 'CourseEntityResponse';
              data?: {
                __typename?: 'CourseEntity';
                attributes?: { __typename?: 'Course'; slug?: string | null } | null;
              } | null;
            } | null;
            resource?: {
              __typename?: 'ResourceEntityResponse';
              data?: {
                __typename?: 'ResourceEntity';
                attributes?: { __typename?: 'Resource'; slug: string } | null;
              } | null;
            } | null;
          } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type WordPictureGamePageQueryVariables = Exact<{ [key: string]: never }>;

export type WordPictureGamePageQuery = {
  __typename?: 'Query';
  wordPictureGamePage?: {
    __typename?: 'WordPictureGamePageEntityResponse';
    data?: {
      __typename?: 'WordPictureGamePageEntity';
      attributes?: {
        __typename?: 'WordPictureGamePage';
        canYouIdentifyTItle: string;
        maybeNextTime: string;
        correct: string;
        showMeTheAnswerCtaLabel: string;
        ordinaryMagicTitle: string;
        gameTypeTitle: string;
        whatIsItTitle: string;
        continueCta?: { __typename?: 'ComponentCommonButton'; text: string; link: string } | null;
      } | null;
    } | null;
  } | null;
};

export type DailyGameQueryVariables = Exact<{
  date?: InputMaybe<DateFilterInput>;
}>;

export type DailyGameQuery = {
  __typename?: 'Query';
  wordPictureGames?: {
    __typename?: 'WordPictureGameEntityResponseCollection';
    data: Array<{
      __typename?: 'WordPictureGameEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'WordPictureGame';
        word: string;
        duration: string;
        day: any;
        picture: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: { __typename?: 'UploadFile'; url: string; alternativeText?: string | null } | null;
          } | null;
        };
        tip: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: { __typename?: 'UploadFile'; url: string; alternativeText?: string | null } | null;
          } | null;
        };
      } | null;
    }>;
  } | null;
};

export type CurrentMindfulMinuteQueryVariables = Exact<{
  date?: InputMaybe<DateFilterInput>;
}>;

export type CurrentMindfulMinuteQuery = {
  __typename?: 'Query';
  mindfulMinutes?: {
    __typename?: 'MindfulMinuteEntityResponseCollection';
    data: Array<{
      __typename?: 'MindfulMinuteEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'MindfulMinute';
        date: any;
        type: Enum_Mindfulminute_Type;
        calmBreathing?: {
          __typename?: 'ComponentMindfulMinuteCalmBreathing';
          title: string;
          prompt: string;
          spokenGuidance?: {
            __typename?: 'UploadFileEntityResponse';
            data?: {
              __typename?: 'UploadFileEntity';
              attributes?: { __typename?: 'UploadFile'; name: string; url: string } | null;
            } | null;
          } | null;
        } | null;
        prompt?: {
          __typename?: 'ComponentMindfulMinuteQuote';
          title: string;
          prompt: string;
          durationInSeconds?: any | null;
        } | null;
        video?: {
          __typename?: 'ComponentMindfulMinuteVideo';
          videoTitle: string;
          video: {
            __typename?: 'UploadFileEntityResponse';
            data?: {
              __typename?: 'UploadFileEntity';
              attributes?: {
                __typename?: 'UploadFile';
                name: string;
                url: string;
                height?: number | null;
                width?: number | null;
              } | null;
            } | null;
          };
        } | null;
      } | null;
    }>;
  } | null;
};

export type MindfulMinutePageQueryVariables = Exact<{ [key: string]: never }>;

export type MindfulMinutePageQuery = {
  __typename?: 'Query';
  mindfulMinutePage?: {
    __typename?: 'MindfulMinutePageEntityResponse';
    data?: {
      __typename?: 'MindfulMinutePageEntity';
      attributes?: {
        __typename?: 'MindfulMinutePage';
        relatedContentViewAllLabel?: string | null;
        relatedContentTitle?: string | null;
        CalmBreathingPage?: {
          __typename?: 'ComponentMindfulMinuteCalmBreathingPage';
          thankYouTitle: string;
          backDailyBubbleButton: string;
          playButtonLabel?: string | null;
          pauseButtonLabel?: string | null;
          stopButtonLabel?: string | null;
          minutes: Array<{ __typename?: 'ComponentCommonMinutes'; id: string; minute?: number | null } | null>;
        } | null;
        QuotePage?: {
          __typename?: 'ComponentMindfulMinuteQuotePage';
          backDailyBubbleButton: string;
          startExerciseButton: string;
          thankYouTitle?: string | null;
          playButtonLabel?: string | null;
          pauseButtonLabel?: string | null;
          stopButtonLabel?: string | null;
          restartButtonLabel?: string | null;
        } | null;
        VideoPage?: {
          __typename?: 'ComponentMindfulMinuteVideoPage';
          backDailyBubbleButton: string;
          thankYouTitle: string;
        } | null;
        relatedContent?: {
          __typename?: 'TopicEntityResponse';
          data?: {
            __typename?: 'TopicEntity';
            attributes?: { __typename?: 'Topic'; topic?: string | null } | null;
          } | null;
        } | null;
        onboarding?: {
          __typename?: 'ComponentEmotionWheelOnboarding';
          steps?: Array<{
            __typename?: 'ComponentCommonSteps';
            title: string;
            description: string;
            textBtn: string;
            image: {
              __typename?: 'UploadFileEntityResponse';
              data?: {
                __typename?: 'UploadFileEntity';
                attributes?: {
                  __typename?: 'UploadFile';
                  url: string;
                  alternativeText?: string | null;
                  mime: string;
                } | null;
              } | null;
            };
          } | null> | null;
        } | null;
        mindfulExerciseRelatedContent?: {
          __typename?: 'MeditationRelationResponseCollection';
          data: Array<{
            __typename?: 'MeditationEntity';
            id?: string | null;
            attributes?: {
              __typename?: 'Meditation';
              title: string;
              subHeader: string;
              slug?: string | null;
              duration: string;
              briefDescription: string;
              type: Enum_Meditation_Type;
              mindful_exercise_type?: {
                __typename?: 'MindfulExerciseTypeEntityResponse';
                data?: {
                  __typename?: 'MindfulExerciseTypeEntity';
                  attributes?: { __typename?: 'MindfulExerciseType'; name: string } | null;
                } | null;
              } | null;
            } | null;
          }>;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type QuotePageQueryVariables = Exact<{ [key: string]: never }>;

export type QuotePageQuery = {
  __typename?: 'Query';
  quotePage?: {
    __typename?: 'QuotePageEntityResponse';
    data?: {
      __typename?: 'QuotePageEntity';
      attributes?: {
        __typename?: 'QuotePage';
        quoteOfTheDayTitle: string;
        cta: { __typename?: 'ComponentCommonButton'; text: string; link: string };
      } | null;
    } | null;
  } | null;
};

export type QuoteQueryVariables = Exact<{
  date?: InputMaybe<DateFilterInput>;
}>;

export type QuoteQuery = {
  __typename?: 'Query';
  quotes?: {
    __typename?: 'QuoteEntityResponseCollection';
    data: Array<{
      __typename?: 'QuoteEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'Quote';
        quote?: string | null;
        author?: string | null;
        date?: any | null;
        occupation?: string | null;
        quoteWithLinks?: string | null;
        topic?: {
          __typename?: 'TopicEntityResponse';
          data?: {
            __typename?: 'TopicEntity';
            attributes?: { __typename?: 'Topic'; topic?: string | null } | null;
          } | null;
        } | null;
        links?: {
          __typename?: 'ComponentCommonLinkList';
          redirectToCurrentInsight?: boolean | null;
          redirectToCurrentMindfulMinute?: boolean | null;
          redirectToCalendar?: boolean | null;
          redirectToEmotionWheel?: boolean | null;
          podcast?: {
            __typename?: 'PodcastEntityResponse';
            data?: {
              __typename?: 'PodcastEntity';
              attributes?: { __typename?: 'Podcast'; slug: string } | null;
            } | null;
          } | null;
          mindfulExercise?: {
            __typename?: 'MeditationEntityResponse';
            data?: {
              __typename?: 'MeditationEntity';
              attributes?: { __typename?: 'Meditation'; slug?: string | null } | null;
            } | null;
          } | null;
          course?: {
            __typename?: 'CourseEntityResponse';
            data?: {
              __typename?: 'CourseEntity';
              attributes?: { __typename?: 'Course'; slug?: string | null } | null;
            } | null;
          } | null;
          resource?: {
            __typename?: 'ResourceEntityResponse';
            data?: {
              __typename?: 'ResourceEntity';
              attributes?: { __typename?: 'Resource'; slug: string } | null;
            } | null;
          } | null;
        } | null;
      } | null;
    }>;
  } | null;
};

export type FetchManageStaffPageQueryVariables = Exact<{ [key: string]: never }>;

export type FetchManageStaffPageQuery = {
  __typename?: 'Query';
  manageUsersPage?: {
    __typename?: 'ManageUsersPageEntityResponse';
    data?: {
      __typename?: 'ManageUsersPageEntity';
      attributes?: {
        __typename?: 'ManageUsersPage';
        title?: string | null;
        description?: string | null;
        staffListTitle?: string | null;
        staffEmptyState?: {
          __typename?: 'ComponentReportingToolsUsersEmptyState';
          title?: string | null;
          description?: string | null;
        } | null;
        staffStatus?: {
          __typename?: 'ComponentReportingToolsStaffStatus';
          pendingInviteMessage?: string | null;
          invitedPendingSignUpMessage?: string | null;
          registeredPendingOnboardingMessage?: string | null;
          registeredOnboardedMessage?: string | null;
          invitedPendingSignUpColor?: string | null;
          registeredPendingOnboardingColor?: string | null;
          registeredOnboardedColor?: string | null;
          pendingInviteColor?: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type SchoolChidrenQueryVariables = Exact<{
  asRegularUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type SchoolChidrenQuery = {
  __typename?: 'Query';
  fetchMySchools?: Array<{
    __typename?: 'SchoolEntity';
    id?: string | null;
    attributes?: {
      __typename?: 'School';
      name: string;
      code?: string | null;
      schools?: {
        __typename?: 'SchoolRelationResponseCollection';
        data: Array<{
          __typename?: 'SchoolEntity';
          id?: string | null;
          attributes?: { __typename?: 'School'; name: string; code?: string | null } | null;
        }>;
      } | null;
    } | null;
  }> | null;
};

export type FetchPodcastsByIdsQueryVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type FetchPodcastsByIdsQuery = {
  __typename?: 'Query';
  podcasts?: {
    __typename?: 'PodcastEntityResponseCollection';
    data: Array<{
      __typename?: 'PodcastEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'Podcast';
        title: string;
        slug: string;
        publicationDate: any;
        subHeader?: string | null;
        briefDescription: string;
        guests?: {
          __typename?: 'GuestRelationResponseCollection';
          data: Array<{
            __typename?: 'GuestEntity';
            attributes?: { __typename?: 'Guest'; name?: string | null } | null;
          }>;
        } | null;
        listenings?: {
          __typename?: 'PodcastListeningTimeRelationResponseCollection';
          data: Array<{
            __typename?: 'PodcastListeningTimeEntity';
            id?: string | null;
            attributes?: { __typename?: 'PodcastListeningTime'; listeningTime: any; duration: any } | null;
          }>;
        } | null;
        themes?: {
          __typename?: 'ThemeRelationResponseCollection';
          data: Array<{
            __typename?: 'ThemeEntity';
            attributes?: {
              __typename?: 'Theme';
              theme?: string | null;
              topic?: {
                __typename?: 'TopicEntityResponse';
                data?: {
                  __typename?: 'TopicEntity';
                  attributes?: { __typename?: 'Topic'; topic?: string | null } | null;
                } | null;
              } | null;
            } | null;
          }>;
        } | null;
        cover: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        };
        DefaultContentTemplate: Array<
          | { __typename: 'ComponentCommonAudio' }
          | { __typename: 'ComponentCommonAuthor' }
          | {
              __typename: 'ComponentCommonAuthorDetailed';
              authors?: {
                __typename?: 'AuthorRelationResponseCollection';
                data: Array<{
                  __typename?: 'AuthorEntity';
                  attributes?: {
                    __typename?: 'Author';
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: 'UploadFileEntityResponse';
                      data?: {
                        __typename?: 'UploadFileEntity';
                        attributes?: {
                          __typename?: 'UploadFile';
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        } | null;
                      } | null;
                    };
                  } | null;
                }>;
              } | null;
            }
          | { __typename: 'ComponentCommonBullet' }
          | { __typename: 'ComponentCommonDivider' }
          | { __typename: 'ComponentCommonDownloadableContentList' }
          | { __typename: 'ComponentCommonEmbedded' }
          | { __typename: 'ComponentCommonFaqComponent' }
          | { __typename: 'ComponentCommonH3' }
          | { __typename: 'ComponentCommonInPartnershipWith' }
          | { __typename: 'ComponentCommonMedia' }
          | { __typename: 'ComponentCommonQuote' }
          | { __typename: 'ComponentCommonRelatedContent' }
          | { __typename: 'ComponentCommonTags' }
          | { __typename: 'ComponentCommonTextEditor' }
          | { __typename: 'ComponentCommonTitle' }
          | { __typename: 'Error' }
          | null
        >;
      } | null;
    }>;
  } | null;
};

export type FetchResourcesByIdsQueryVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;

export type FetchResourcesByIdsQuery = {
  __typename?: 'Query';
  resources?: {
    __typename?: 'ResourceEntityResponseCollection';
    data: Array<{
      __typename?: 'ResourceEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'Resource';
        createdAt?: any | null;
        publishedAt?: any | null;
        title: string;
        slug: string;
        duration?: string | null;
        briefDescription: string;
        resourceType?: {
          __typename?: 'ResourceTypeEntityResponse';
          data?: {
            __typename?: 'ResourceTypeEntity';
            attributes?: { __typename?: 'ResourceType'; type: string } | null;
          } | null;
        } | null;
        themes?: {
          __typename?: 'ThemeRelationResponseCollection';
          data: Array<{
            __typename?: 'ThemeEntity';
            attributes?: {
              __typename?: 'Theme';
              theme?: string | null;
              topic?: {
                __typename?: 'TopicEntityResponse';
                data?: {
                  __typename?: 'TopicEntity';
                  attributes?: { __typename?: 'Topic'; topic?: string | null } | null;
                } | null;
              } | null;
            } | null;
          }>;
        } | null;
        cover: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        };
        DefaultContentTemplate: Array<
          | { __typename: 'ComponentCommonAuthor' }
          | {
              __typename: 'ComponentCommonAuthorDetailed';
              authors?: {
                __typename?: 'AuthorRelationResponseCollection';
                data: Array<{
                  __typename?: 'AuthorEntity';
                  attributes?: {
                    __typename?: 'Author';
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: 'UploadFileEntityResponse';
                      data?: {
                        __typename?: 'UploadFileEntity';
                        attributes?: {
                          __typename?: 'UploadFile';
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        } | null;
                      } | null;
                    };
                  } | null;
                }>;
              } | null;
            }
          | { __typename: 'ComponentCommonBullet' }
          | { __typename: 'ComponentCommonDivider' }
          | { __typename: 'ComponentCommonDownloadableContentList' }
          | { __typename: 'ComponentCommonEmbedded' }
          | { __typename: 'ComponentCommonFaqComponent' }
          | { __typename: 'ComponentCommonH3' }
          | { __typename: 'ComponentCommonMedia' }
          | { __typename: 'ComponentCommonQuote' }
          | { __typename: 'ComponentCommonRelatedContent' }
          | { __typename: 'ComponentCommonTags' }
          | { __typename: 'ComponentCommonTextEditor' }
          | { __typename: 'ComponentCommonTitle' }
          | { __typename: 'ComponentKnowledgeHubResourcesRelated' }
          | { __typename: 'Error' }
          | null
        >;
      } | null;
    }>;
  } | null;
};

export type FavoritesPageableByUserIdQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
  size: Scalars['Int']['input'];
}>;

export type FavoritesPageableByUserIdQuery = {
  __typename?: 'Query';
  favorites?: {
    __typename?: 'FavoriteEntityResponseCollection';
    data: Array<{
      __typename?: 'FavoriteEntity';
      attributes?: { __typename?: 'Favorite'; relationId: any; type: Enum_Favorite_Type; metadata?: any | null } | null;
    }>;
    meta: { __typename?: 'ResponseCollectionMeta'; pagination: { __typename?: 'Pagination'; total: number } };
  } | null;
};

export type ExistByRelationIdQueryVariables = Exact<{
  relationId: Scalars['Long']['input'];
  userId: Scalars['ID']['input'];
}>;

export type ExistByRelationIdQuery = {
  __typename?: 'Query';
  favorites?: {
    __typename?: 'FavoriteEntityResponseCollection';
    data: Array<{
      __typename?: 'FavoriteEntity';
      attributes?: { __typename?: 'Favorite'; createdAt?: any | null } | null;
    }>;
  } | null;
};

export type FindByRelationIdQueryVariables = Exact<{
  relationId: Scalars['Long']['input'];
  userId: Scalars['ID']['input'];
}>;

export type FindByRelationIdQuery = {
  __typename?: 'Query';
  favorites?: {
    __typename?: 'FavoriteEntityResponseCollection';
    data: Array<{ __typename?: 'FavoriteEntity'; id?: string | null }>;
  } | null;
};

export type FavouritePageQueryVariables = Exact<{ [key: string]: never }>;

export type FavouritePageQuery = {
  __typename?: 'Query';
  favouritePage?: {
    __typename?: 'FavouritePageEntityResponse';
    data?: {
      __typename?: 'FavouritePageEntity';
      attributes?: {
        __typename?: 'FavouritePage';
        title: string;
        yourFavouriteTitle: string;
        podcastTitle: string;
        noPodcastsFoundMsg: string;
        resourcesTitle: string;
        noResourcesFoundMsg: string;
        removeFavourtieBtn: string;
        addFavourite: string;
        courseTitle?: string | null;
        noCoursesFoundMsg?: string | null;
        createdAt?: any | null;
        updatedAt?: any | null;
      } | null;
    } | null;
  } | null;
};

export type QueryFooterQueryVariables = Exact<{ [key: string]: never }>;

export type QueryFooterQuery = {
  __typename?: 'Query';
  globalFooter?: {
    __typename?: 'GlobalFooterEntityResponse';
    data?: {
      __typename?: 'GlobalFooterEntity';
      attributes?: {
        __typename?: 'GlobalFooter';
        linkedinUrl?: string | null;
        facebookUrl?: string | null;
        twitterUrl?: string | null;
        instagramUrl?: string | null;
        copyright?: string | null;
        links?: Array<{
          __typename?: 'ComponentCommonLink';
          text: string;
          url?: string | null;
          file?: {
            __typename?: 'UploadFileEntityResponse';
            data?: {
              __typename?: 'UploadFileEntity';
              attributes?: {
                __typename?: 'UploadFile';
                url: string;
                alternativeText?: string | null;
                mime: string;
              } | null;
            } | null;
          } | null;
        } | null> | null;
        stillHumanlogo: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        };
        edwinGroupLogo: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        };
      } | null;
    } | null;
  } | null;
};

export type UsersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type UsersQuery = {
  __typename?: 'Query';
  usersPermissionsUser?: {
    __typename?: 'UsersPermissionsUserEntityResponse';
    data?: {
      __typename?: 'UsersPermissionsUserEntity';
      attributes?: {
        __typename?: 'UsersPermissionsUser';
        topics?: {
          __typename?: 'TopicRelationResponseCollection';
          data: Array<{
            __typename?: 'TopicEntity';
            attributes?: { __typename?: 'Topic'; topic?: string | null } | null;
          }>;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type QueryMenuQueryVariables = Exact<{ [key: string]: never }>;

export type QueryMenuQuery = {
  __typename?: 'Query';
  globalMenu?: {
    __typename?: 'GlobalMenuEntityResponse';
    data?: {
      __typename?: 'GlobalMenuEntity';
      attributes?: {
        __typename?: 'GlobalMenu';
        logo: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        };
        links?: Array<{ __typename?: 'ComponentCommonLink'; text: string; url?: string | null } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type NotFoundPageQueryVariables = Exact<{ [key: string]: never }>;

export type NotFoundPageQuery = {
  __typename?: 'Query';
  notFoundPage?: {
    __typename?: 'NotFoundPageEntityResponse';
    data?: {
      __typename?: 'NotFoundPageEntity';
      attributes?: {
        __typename?: 'NotFoundPage';
        title: string;
        description: string;
        cta: string;
        image: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        };
      } | null;
    } | null;
  } | null;
};

export type QueryTermsAndConditionsQueryVariables = Exact<{ [key: string]: never }>;

export type QueryTermsAndConditionsQuery = {
  __typename?: 'Query';
  termAndCondition?: {
    __typename?: 'TermAndConditionEntityResponse';
    data?: {
      __typename?: 'TermAndConditionEntity';
      attributes?: { __typename?: 'TermAndCondition'; title: string; content?: string | null } | null;
    } | null;
  } | null;
};

export type KnowledgeHubPageQueryVariables = Exact<{ [key: string]: never }>;

export type KnowledgeHubPageQuery = {
  __typename?: 'Query';
  knowledgeHubPage?: {
    __typename?: 'KnowledgeHubPageEntityResponse';
    data?: {
      __typename?: 'KnowledgeHubPageEntity';
      attributes?: {
        __typename?: 'KnowledgeHubPage';
        highlightOfTheWeekTitle: string;
        highlightTopicLabel?: string | null;
        latestTitle: string;
        moreButotnTItle: string;
        chooseAThemeTitle: string;
        topics?: {
          __typename?: 'TopicRelationResponseCollection';
          data: Array<{
            __typename?: 'TopicEntity';
            attributes?: {
              __typename?: 'Topic';
              topic?: string | null;
              themes?: {
                __typename?: 'ThemeRelationResponseCollection';
                data: Array<{
                  __typename?: 'ThemeEntity';
                  attributes?: { __typename?: 'Theme'; theme?: string | null } | null;
                }>;
              } | null;
            } | null;
          }>;
        } | null;
        welcomePageMessage?: {
          __typename?: 'ComponentCommonWelcomePageMessage';
          title: string;
          description: string;
        } | null;
        highlights?: {
          __typename?: 'ResourceRelationResponseCollection';
          data: Array<{
            __typename?: 'ResourceEntity';
            attributes?: {
              __typename?: 'Resource';
              createdAt?: any | null;
              publishedAt?: any | null;
              title: string;
              slug: string;
              duration?: string | null;
              briefDescription: string;
              resourceType?: {
                __typename?: 'ResourceTypeEntityResponse';
                data?: {
                  __typename?: 'ResourceTypeEntity';
                  attributes?: { __typename?: 'ResourceType'; type: string } | null;
                } | null;
              } | null;
              themes?: {
                __typename?: 'ThemeRelationResponseCollection';
                data: Array<{
                  __typename?: 'ThemeEntity';
                  attributes?: {
                    __typename?: 'Theme';
                    theme?: string | null;
                    topic?: {
                      __typename?: 'TopicEntityResponse';
                      data?: {
                        __typename?: 'TopicEntity';
                        attributes?: { __typename?: 'Topic'; topic?: string | null } | null;
                      } | null;
                    } | null;
                  } | null;
                }>;
              } | null;
              cover: {
                __typename?: 'UploadFileEntityResponse';
                data?: {
                  __typename?: 'UploadFileEntity';
                  attributes?: {
                    __typename?: 'UploadFile';
                    url: string;
                    alternativeText?: string | null;
                    mime: string;
                  } | null;
                } | null;
              };
              DefaultContentTemplate: Array<
                | { __typename: 'ComponentCommonAuthor' }
                | {
                    __typename: 'ComponentCommonAuthorDetailed';
                    authors?: {
                      __typename?: 'AuthorRelationResponseCollection';
                      data: Array<{
                        __typename?: 'AuthorEntity';
                        attributes?: {
                          __typename?: 'Author';
                          name: string;
                          role?: string | null;
                          bio?: string | null;
                          avatar: {
                            __typename?: 'UploadFileEntityResponse';
                            data?: {
                              __typename?: 'UploadFileEntity';
                              attributes?: {
                                __typename?: 'UploadFile';
                                url: string;
                                alternativeText?: string | null;
                                mime: string;
                              } | null;
                            } | null;
                          };
                        } | null;
                      }>;
                    } | null;
                  }
                | { __typename: 'ComponentCommonBullet' }
                | { __typename: 'ComponentCommonDivider' }
                | { __typename: 'ComponentCommonDownloadableContentList' }
                | { __typename: 'ComponentCommonEmbedded' }
                | { __typename: 'ComponentCommonFaqComponent' }
                | { __typename: 'ComponentCommonH3' }
                | { __typename: 'ComponentCommonMedia' }
                | { __typename: 'ComponentCommonQuote' }
                | { __typename: 'ComponentCommonRelatedContent' }
                | { __typename: 'ComponentCommonTags' }
                | { __typename: 'ComponentCommonTextEditor' }
                | { __typename: 'ComponentCommonTitle' }
                | { __typename: 'ComponentKnowledgeHubResourcesRelated' }
                | { __typename: 'Error' }
                | null
              >;
            } | null;
          }>;
        } | null;
        searchSection?: {
          __typename?: 'ComponentCommonSearchSection';
          title: string;
          searchInput: string;
          whatKindTitle: string;
          chooseATopicTitle: string;
          chooseCollectionTitle: string;
          topics?: {
            __typename?: 'TopicRelationResponseCollection';
            data: Array<{
              __typename?: 'TopicEntity';
              attributes?: { __typename?: 'Topic'; topic?: string | null } | null;
            }>;
          } | null;
          themes?: {
            __typename?: 'ThemeRelationResponseCollection';
            data: Array<{
              __typename?: 'ThemeEntity';
              attributes?: { __typename?: 'Theme'; theme?: string | null } | null;
            }>;
          } | null;
          types?: Array<{ __typename?: 'ComponentCommonTypes'; type: string } | null> | null;
        } | null;
        contentTemplateLabels?: {
          __typename?: 'ComponentCommonContentTemplateLabels';
          downloadableContentLabel?: string | null;
        } | null;
        highlightSections?: {
          __typename?: 'ComponentKnowledgeHubHighlightSections';
          trendingThisWeekSection?: {
            __typename?: 'ComponentKnowledgeHubTrendingThisWeekSection';
            title: string;
          } | null;
          wellbeingAwarenessDaysSection?: {
            __typename?: 'ComponentKnowledgeHubWellbeingAwarenessDaysSection';
            title: string;
            linkLabel?: string | null;
          } | null;
          allTimePopularFavouritesSection?: {
            __typename?: 'ComponentKnowledgeHubAllTimePopularFavouritesSection';
            title: string;
          } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type LatestResourcesByTopicQueryVariables = Exact<{
  topic?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  excludeId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type LatestResourcesByTopicQuery = {
  __typename?: 'Query';
  resources?: {
    __typename?: 'ResourceEntityResponseCollection';
    data: Array<{
      __typename?: 'ResourceEntity';
      attributes?: {
        __typename?: 'Resource';
        createdAt?: any | null;
        publishedAt?: any | null;
        title: string;
        slug: string;
        duration?: string | null;
        briefDescription: string;
        resourceType?: {
          __typename?: 'ResourceTypeEntityResponse';
          data?: {
            __typename?: 'ResourceTypeEntity';
            attributes?: { __typename?: 'ResourceType'; type: string } | null;
          } | null;
        } | null;
        themes?: {
          __typename?: 'ThemeRelationResponseCollection';
          data: Array<{
            __typename?: 'ThemeEntity';
            attributes?: {
              __typename?: 'Theme';
              theme?: string | null;
              topic?: {
                __typename?: 'TopicEntityResponse';
                data?: {
                  __typename?: 'TopicEntity';
                  attributes?: { __typename?: 'Topic'; topic?: string | null } | null;
                } | null;
              } | null;
            } | null;
          }>;
        } | null;
        cover: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        };
        DefaultContentTemplate: Array<
          | { __typename: 'ComponentCommonAuthor' }
          | {
              __typename: 'ComponentCommonAuthorDetailed';
              authors?: {
                __typename?: 'AuthorRelationResponseCollection';
                data: Array<{
                  __typename?: 'AuthorEntity';
                  attributes?: {
                    __typename?: 'Author';
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: 'UploadFileEntityResponse';
                      data?: {
                        __typename?: 'UploadFileEntity';
                        attributes?: {
                          __typename?: 'UploadFile';
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        } | null;
                      } | null;
                    };
                  } | null;
                }>;
              } | null;
            }
          | { __typename: 'ComponentCommonBullet' }
          | { __typename: 'ComponentCommonDivider' }
          | { __typename: 'ComponentCommonDownloadableContentList' }
          | { __typename: 'ComponentCommonEmbedded' }
          | { __typename: 'ComponentCommonFaqComponent' }
          | { __typename: 'ComponentCommonH3' }
          | { __typename: 'ComponentCommonMedia' }
          | { __typename: 'ComponentCommonQuote' }
          | { __typename: 'ComponentCommonRelatedContent' }
          | { __typename: 'ComponentCommonTags' }
          | { __typename: 'ComponentCommonTextEditor' }
          | { __typename: 'ComponentCommonTitle' }
          | { __typename: 'ComponentKnowledgeHubResourcesRelated' }
          | { __typename: 'Error' }
          | null
        >;
      } | null;
    }>;
  } | null;
};

export type LatestResourcesByThemeQueryVariables = Exact<{
  theme: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;

export type LatestResourcesByThemeQuery = {
  __typename?: 'Query';
  resources?: {
    __typename?: 'ResourceEntityResponseCollection';
    data: Array<{
      __typename?: 'ResourceEntity';
      attributes?: {
        __typename?: 'Resource';
        createdAt?: any | null;
        publishedAt?: any | null;
        title: string;
        slug: string;
        duration?: string | null;
        briefDescription: string;
        resourceType?: {
          __typename?: 'ResourceTypeEntityResponse';
          data?: {
            __typename?: 'ResourceTypeEntity';
            attributes?: { __typename?: 'ResourceType'; type: string } | null;
          } | null;
        } | null;
        themes?: {
          __typename?: 'ThemeRelationResponseCollection';
          data: Array<{
            __typename?: 'ThemeEntity';
            attributes?: {
              __typename?: 'Theme';
              theme?: string | null;
              topic?: {
                __typename?: 'TopicEntityResponse';
                data?: {
                  __typename?: 'TopicEntity';
                  attributes?: { __typename?: 'Topic'; topic?: string | null } | null;
                } | null;
              } | null;
            } | null;
          }>;
        } | null;
        cover: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        };
        DefaultContentTemplate: Array<
          | { __typename: 'ComponentCommonAuthor' }
          | {
              __typename: 'ComponentCommonAuthorDetailed';
              authors?: {
                __typename?: 'AuthorRelationResponseCollection';
                data: Array<{
                  __typename?: 'AuthorEntity';
                  attributes?: {
                    __typename?: 'Author';
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: 'UploadFileEntityResponse';
                      data?: {
                        __typename?: 'UploadFileEntity';
                        attributes?: {
                          __typename?: 'UploadFile';
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        } | null;
                      } | null;
                    };
                  } | null;
                }>;
              } | null;
            }
          | { __typename: 'ComponentCommonBullet' }
          | { __typename: 'ComponentCommonDivider' }
          | { __typename: 'ComponentCommonDownloadableContentList' }
          | { __typename: 'ComponentCommonEmbedded' }
          | { __typename: 'ComponentCommonFaqComponent' }
          | { __typename: 'ComponentCommonH3' }
          | { __typename: 'ComponentCommonMedia' }
          | { __typename: 'ComponentCommonQuote' }
          | { __typename: 'ComponentCommonRelatedContent' }
          | { __typename: 'ComponentCommonTags' }
          | { __typename: 'ComponentCommonTextEditor' }
          | { __typename: 'ComponentCommonTitle' }
          | { __typename: 'ComponentKnowledgeHubResourcesRelated' }
          | { __typename: 'Error' }
          | null
        >;
      } | null;
    }>;
    meta: {
      __typename?: 'ResponseCollectionMeta';
      pagination: { __typename?: 'Pagination'; total: number; pageCount: number; page: number; pageSize: number };
    };
  } | null;
};

export type LatestResourcesByTypeQueryVariables = Exact<{
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;

export type LatestResourcesByTypeQuery = {
  __typename?: 'Query';
  resources?: {
    __typename?: 'ResourceEntityResponseCollection';
    data: Array<{
      __typename?: 'ResourceEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'Resource';
        createdAt?: any | null;
        publishedAt?: any | null;
        title: string;
        slug: string;
        duration?: string | null;
        briefDescription: string;
        resourceType?: {
          __typename?: 'ResourceTypeEntityResponse';
          data?: {
            __typename?: 'ResourceTypeEntity';
            attributes?: { __typename?: 'ResourceType'; type: string } | null;
          } | null;
        } | null;
        themes?: {
          __typename?: 'ThemeRelationResponseCollection';
          data: Array<{
            __typename?: 'ThemeEntity';
            attributes?: {
              __typename?: 'Theme';
              theme?: string | null;
              topic?: {
                __typename?: 'TopicEntityResponse';
                data?: {
                  __typename?: 'TopicEntity';
                  attributes?: { __typename?: 'Topic'; topic?: string | null } | null;
                } | null;
              } | null;
            } | null;
          }>;
        } | null;
        cover: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        };
        DefaultContentTemplate: Array<
          | { __typename: 'ComponentCommonAuthor' }
          | {
              __typename: 'ComponentCommonAuthorDetailed';
              authors?: {
                __typename?: 'AuthorRelationResponseCollection';
                data: Array<{
                  __typename?: 'AuthorEntity';
                  attributes?: {
                    __typename?: 'Author';
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: 'UploadFileEntityResponse';
                      data?: {
                        __typename?: 'UploadFileEntity';
                        attributes?: {
                          __typename?: 'UploadFile';
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        } | null;
                      } | null;
                    };
                  } | null;
                }>;
              } | null;
            }
          | { __typename: 'ComponentCommonBullet' }
          | { __typename: 'ComponentCommonDivider' }
          | { __typename: 'ComponentCommonDownloadableContentList' }
          | { __typename: 'ComponentCommonEmbedded' }
          | { __typename: 'ComponentCommonFaqComponent' }
          | { __typename: 'ComponentCommonH3' }
          | { __typename: 'ComponentCommonMedia' }
          | { __typename: 'ComponentCommonQuote' }
          | { __typename: 'ComponentCommonRelatedContent' }
          | { __typename: 'ComponentCommonTags' }
          | { __typename: 'ComponentCommonTextEditor' }
          | { __typename: 'ComponentCommonTitle' }
          | { __typename: 'ComponentKnowledgeHubResourcesRelated' }
          | { __typename: 'Error' }
          | null
        >;
      } | null;
    }>;
    meta: {
      __typename?: 'ResponseCollectionMeta';
      pagination: { __typename?: 'Pagination'; total: number; pageCount: number; page: number; pageSize: number };
    };
  } | null;
};

export type FetchMainLatestResourcesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type FetchMainLatestResourcesQuery = {
  __typename?: 'Query';
  resources?: {
    __typename?: 'ResourceEntityResponseCollection';
    data: Array<{
      __typename?: 'ResourceEntity';
      attributes?: {
        __typename?: 'Resource';
        createdAt?: any | null;
        publishedAt?: any | null;
        title: string;
        slug: string;
        duration?: string | null;
        briefDescription: string;
        resourceType?: {
          __typename?: 'ResourceTypeEntityResponse';
          data?: {
            __typename?: 'ResourceTypeEntity';
            attributes?: { __typename?: 'ResourceType'; type: string } | null;
          } | null;
        } | null;
        themes?: {
          __typename?: 'ThemeRelationResponseCollection';
          data: Array<{
            __typename?: 'ThemeEntity';
            attributes?: {
              __typename?: 'Theme';
              theme?: string | null;
              topic?: {
                __typename?: 'TopicEntityResponse';
                data?: {
                  __typename?: 'TopicEntity';
                  attributes?: { __typename?: 'Topic'; topic?: string | null } | null;
                } | null;
              } | null;
            } | null;
          }>;
        } | null;
        cover: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        };
        DefaultContentTemplate: Array<
          | { __typename: 'ComponentCommonAuthor' }
          | {
              __typename: 'ComponentCommonAuthorDetailed';
              authors?: {
                __typename?: 'AuthorRelationResponseCollection';
                data: Array<{
                  __typename?: 'AuthorEntity';
                  attributes?: {
                    __typename?: 'Author';
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: 'UploadFileEntityResponse';
                      data?: {
                        __typename?: 'UploadFileEntity';
                        attributes?: {
                          __typename?: 'UploadFile';
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        } | null;
                      } | null;
                    };
                  } | null;
                }>;
              } | null;
            }
          | { __typename: 'ComponentCommonBullet' }
          | { __typename: 'ComponentCommonDivider' }
          | { __typename: 'ComponentCommonDownloadableContentList' }
          | { __typename: 'ComponentCommonEmbedded' }
          | { __typename: 'ComponentCommonFaqComponent' }
          | { __typename: 'ComponentCommonH3' }
          | { __typename: 'ComponentCommonMedia' }
          | { __typename: 'ComponentCommonQuote' }
          | { __typename: 'ComponentCommonRelatedContent' }
          | { __typename: 'ComponentCommonTags' }
          | { __typename: 'ComponentCommonTextEditor' }
          | { __typename: 'ComponentCommonTitle' }
          | { __typename: 'ComponentKnowledgeHubResourcesRelated' }
          | { __typename: 'Error' }
          | null
        >;
      } | null;
    }>;
  } | null;
};

export type FetchTrendingResourcesQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
}>;

export type FetchTrendingResourcesQuery = {
  __typename?: 'Query';
  trendingResources: Array<{
    __typename?: 'ResourceEntity';
    attributes?: {
      __typename?: 'Resource';
      createdAt?: any | null;
      publishedAt?: any | null;
      title: string;
      slug: string;
      duration?: string | null;
      briefDescription: string;
      resourceType?: {
        __typename?: 'ResourceTypeEntityResponse';
        data?: {
          __typename?: 'ResourceTypeEntity';
          attributes?: { __typename?: 'ResourceType'; type: string } | null;
        } | null;
      } | null;
      themes?: {
        __typename?: 'ThemeRelationResponseCollection';
        data: Array<{
          __typename?: 'ThemeEntity';
          attributes?: {
            __typename?: 'Theme';
            theme?: string | null;
            topic?: {
              __typename?: 'TopicEntityResponse';
              data?: {
                __typename?: 'TopicEntity';
                attributes?: { __typename?: 'Topic'; topic?: string | null } | null;
              } | null;
            } | null;
          } | null;
        }>;
      } | null;
      cover: {
        __typename?: 'UploadFileEntityResponse';
        data?: {
          __typename?: 'UploadFileEntity';
          attributes?: { __typename?: 'UploadFile'; url: string; alternativeText?: string | null; mime: string } | null;
        } | null;
      };
    } | null;
  }>;
};

export type FetchWellbeingAwarenessDaysResourcesQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
}>;

export type FetchWellbeingAwarenessDaysResourcesQuery = {
  __typename?: 'Query';
  wellbeingAwarenessDaysResources: Array<{
    __typename?: 'ResourceEntity';
    attributes?: {
      __typename?: 'Resource';
      createdAt?: any | null;
      publishedAt?: any | null;
      title: string;
      slug: string;
      duration?: string | null;
      briefDescription: string;
      resourceType?: {
        __typename?: 'ResourceTypeEntityResponse';
        data?: {
          __typename?: 'ResourceTypeEntity';
          attributes?: { __typename?: 'ResourceType'; type: string } | null;
        } | null;
      } | null;
      themes?: {
        __typename?: 'ThemeRelationResponseCollection';
        data: Array<{
          __typename?: 'ThemeEntity';
          attributes?: {
            __typename?: 'Theme';
            theme?: string | null;
            topic?: {
              __typename?: 'TopicEntityResponse';
              data?: {
                __typename?: 'TopicEntity';
                attributes?: { __typename?: 'Topic'; topic?: string | null } | null;
              } | null;
            } | null;
          } | null;
        }>;
      } | null;
      cover: {
        __typename?: 'UploadFileEntityResponse';
        data?: {
          __typename?: 'UploadFileEntity';
          attributes?: { __typename?: 'UploadFile'; url: string; alternativeText?: string | null; mime: string } | null;
        } | null;
      };
    } | null;
  }>;
};

export type FetchTopFavoriteResourcesQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
}>;

export type FetchTopFavoriteResourcesQuery = {
  __typename?: 'Query';
  topFavoriteResources?: Array<{
    __typename?: 'ResourceEntity';
    attributes?: {
      __typename?: 'Resource';
      createdAt?: any | null;
      publishedAt?: any | null;
      title: string;
      slug: string;
      duration?: string | null;
      briefDescription: string;
      resourceType?: {
        __typename?: 'ResourceTypeEntityResponse';
        data?: {
          __typename?: 'ResourceTypeEntity';
          attributes?: { __typename?: 'ResourceType'; type: string } | null;
        } | null;
      } | null;
      themes?: {
        __typename?: 'ThemeRelationResponseCollection';
        data: Array<{
          __typename?: 'ThemeEntity';
          attributes?: {
            __typename?: 'Theme';
            theme?: string | null;
            topic?: {
              __typename?: 'TopicEntityResponse';
              data?: {
                __typename?: 'TopicEntity';
                attributes?: { __typename?: 'Topic'; topic?: string | null } | null;
              } | null;
            } | null;
          } | null;
        }>;
      } | null;
      cover: {
        __typename?: 'UploadFileEntityResponse';
        data?: {
          __typename?: 'UploadFileEntity';
          attributes?: { __typename?: 'UploadFile'; url: string; alternativeText?: string | null; mime: string } | null;
        } | null;
      };
    } | null;
  }> | null;
};

export type ResourceQueryVariables = Exact<{
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type ResourceQuery = {
  __typename?: 'Query';
  resources?: {
    __typename?: 'ResourceEntityResponseCollection';
    data: Array<{
      __typename?: 'ResourceEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'Resource';
        title: string;
        slug: string;
        duration?: string | null;
        briefDescription: string;
        subHeader?: string | null;
        resourceType?: {
          __typename?: 'ResourceTypeEntityResponse';
          data?: {
            __typename?: 'ResourceTypeEntity';
            attributes?: { __typename?: 'ResourceType'; type: string } | null;
          } | null;
        } | null;
        cover: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        };
        themes?: {
          __typename?: 'ThemeRelationResponseCollection';
          data: Array<{
            __typename?: 'ThemeEntity';
            id?: string | null;
            attributes?: {
              __typename?: 'Theme';
              theme?: string | null;
              topic?: {
                __typename?: 'TopicEntityResponse';
                data?: {
                  __typename?: 'TopicEntity';
                  id?: string | null;
                  attributes?: { __typename?: 'Topic'; topic?: string | null } | null;
                } | null;
              } | null;
            } | null;
          }>;
        } | null;
        DefaultContentTemplate: Array<
          | { __typename: 'ComponentCommonAuthor' }
          | {
              __typename: 'ComponentCommonAuthorDetailed';
              authors?: {
                __typename?: 'AuthorRelationResponseCollection';
                data: Array<{
                  __typename?: 'AuthorEntity';
                  attributes?: {
                    __typename?: 'Author';
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: 'UploadFileEntityResponse';
                      data?: {
                        __typename?: 'UploadFileEntity';
                        attributes?: {
                          __typename?: 'UploadFile';
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        } | null;
                      } | null;
                    };
                  } | null;
                }>;
              } | null;
            }
          | {
              __typename: 'ComponentCommonBullet';
              item: Array<{ __typename?: 'ComponentCommonList'; text: string } | null>;
            }
          | { __typename: 'ComponentCommonDivider'; id: string }
          | {
              __typename: 'ComponentCommonDownloadableContentList';
              list?: Array<{
                __typename?: 'ComponentCommonDownloadableContent';
                title: string;
                description?: string | null;
                content: {
                  __typename?: 'UploadFileEntityResponse';
                  data?: {
                    __typename?: 'UploadFileEntity';
                    attributes?: { __typename?: 'UploadFile'; url: string } | null;
                  } | null;
                };
              } | null> | null;
            }
          | { __typename: 'ComponentCommonEmbedded'; link: string; provider: Enum_Componentcommonembedded_Provider }
          | {
              __typename: 'ComponentCommonFaqComponent';
              faq?: Array<{ __typename?: 'ComponentCommonFaq'; title: string; description: string } | null> | null;
            }
          | { __typename: 'ComponentCommonH3'; text: string }
          | {
              __typename: 'ComponentCommonMedia';
              media: {
                __typename?: 'UploadFileEntityResponse';
                data?: {
                  __typename?: 'UploadFileEntity';
                  attributes?: { __typename?: 'UploadFile'; url: string; alternativeText?: string | null } | null;
                } | null;
              };
            }
          | { __typename: 'ComponentCommonQuote'; quote: string }
          | { __typename: 'ComponentCommonRelatedContent'; id: string }
          | { __typename: 'ComponentCommonTags'; id: string }
          | { __typename: 'ComponentCommonTextEditor'; markdownText?: string | null }
          | { __typename: 'ComponentCommonTitle'; title: string }
          | {
              __typename: 'ComponentKnowledgeHubResourcesRelated';
              resources?: {
                __typename?: 'ResourceRelationResponseCollection';
                data: Array<{
                  __typename?: 'ResourceEntity';
                  attributes?: {
                    __typename?: 'Resource';
                    createdAt?: any | null;
                    publishedAt?: any | null;
                    title: string;
                    slug: string;
                    duration?: string | null;
                    briefDescription: string;
                    resourceType?: {
                      __typename?: 'ResourceTypeEntityResponse';
                      data?: {
                        __typename?: 'ResourceTypeEntity';
                        attributes?: { __typename?: 'ResourceType'; type: string } | null;
                      } | null;
                    } | null;
                    themes?: {
                      __typename?: 'ThemeRelationResponseCollection';
                      data: Array<{
                        __typename?: 'ThemeEntity';
                        attributes?: {
                          __typename?: 'Theme';
                          theme?: string | null;
                          topic?: {
                            __typename?: 'TopicEntityResponse';
                            data?: {
                              __typename?: 'TopicEntity';
                              attributes?: { __typename?: 'Topic'; topic?: string | null } | null;
                            } | null;
                          } | null;
                        } | null;
                      }>;
                    } | null;
                    cover: {
                      __typename?: 'UploadFileEntityResponse';
                      data?: {
                        __typename?: 'UploadFileEntity';
                        attributes?: {
                          __typename?: 'UploadFile';
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        } | null;
                      } | null;
                    };
                    DefaultContentTemplate: Array<
                      | { __typename: 'ComponentCommonAuthor' }
                      | {
                          __typename: 'ComponentCommonAuthorDetailed';
                          authors?: {
                            __typename?: 'AuthorRelationResponseCollection';
                            data: Array<{
                              __typename?: 'AuthorEntity';
                              attributes?: {
                                __typename?: 'Author';
                                name: string;
                                role?: string | null;
                                bio?: string | null;
                                avatar: {
                                  __typename?: 'UploadFileEntityResponse';
                                  data?: {
                                    __typename?: 'UploadFileEntity';
                                    attributes?: {
                                      __typename?: 'UploadFile';
                                      url: string;
                                      alternativeText?: string | null;
                                      mime: string;
                                    } | null;
                                  } | null;
                                };
                              } | null;
                            }>;
                          } | null;
                        }
                      | { __typename: 'ComponentCommonBullet' }
                      | { __typename: 'ComponentCommonDivider' }
                      | { __typename: 'ComponentCommonDownloadableContentList' }
                      | { __typename: 'ComponentCommonEmbedded' }
                      | { __typename: 'ComponentCommonFaqComponent' }
                      | { __typename: 'ComponentCommonH3' }
                      | { __typename: 'ComponentCommonMedia' }
                      | { __typename: 'ComponentCommonQuote' }
                      | { __typename: 'ComponentCommonRelatedContent' }
                      | { __typename: 'ComponentCommonTags' }
                      | { __typename: 'ComponentCommonTextEditor' }
                      | { __typename: 'ComponentCommonTitle' }
                      | { __typename: 'ComponentKnowledgeHubResourcesRelated' }
                      | { __typename: 'Error' }
                      | null
                    >;
                  } | null;
                }>;
              } | null;
              exercises?: {
                __typename?: 'MeditationRelationResponseCollection';
                data: Array<{
                  __typename?: 'MeditationEntity';
                  attributes?: {
                    __typename?: 'Meditation';
                    title: string;
                    slug?: string | null;
                    duration: string;
                    briefDescription: string;
                    mindful_exercise_type?: {
                      __typename?: 'MindfulExerciseTypeEntityResponse';
                      data?: {
                        __typename?: 'MindfulExerciseTypeEntity';
                        attributes?: { __typename?: 'MindfulExerciseType'; name: string } | null;
                      } | null;
                    } | null;
                  } | null;
                }>;
              } | null;
              podcasts?: {
                __typename?: 'PodcastRelationResponseCollection';
                data: Array<{
                  __typename?: 'PodcastEntity';
                  attributes?: {
                    __typename?: 'Podcast';
                    title: string;
                    slug: string;
                    publicationDate: any;
                    subHeader?: string | null;
                    briefDescription: string;
                    guests?: {
                      __typename?: 'GuestRelationResponseCollection';
                      data: Array<{
                        __typename?: 'GuestEntity';
                        id?: string | null;
                        attributes?: { __typename?: 'Guest'; name?: string | null } | null;
                      }>;
                    } | null;
                    themes?: {
                      __typename?: 'ThemeRelationResponseCollection';
                      data: Array<{
                        __typename?: 'ThemeEntity';
                        id?: string | null;
                        attributes?: {
                          __typename?: 'Theme';
                          theme?: string | null;
                          topic?: {
                            __typename?: 'TopicEntityResponse';
                            data?: {
                              __typename?: 'TopicEntity';
                              id?: string | null;
                              attributes?: { __typename?: 'Topic'; topic?: string | null } | null;
                            } | null;
                          } | null;
                        } | null;
                      }>;
                    } | null;
                    cover: {
                      __typename?: 'UploadFileEntityResponse';
                      data?: {
                        __typename?: 'UploadFileEntity';
                        id?: string | null;
                        attributes?: {
                          __typename?: 'UploadFile';
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        } | null;
                      } | null;
                    };
                  } | null;
                }>;
              } | null;
            }
          | { __typename: 'Error' }
          | null
        >;
      } | null;
    }>;
  } | null;
};

export type FetchLatestResourcesPageableQueryVariables = Exact<{
  kinds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
}>;

export type FetchLatestResourcesPageableQuery = {
  __typename?: 'Query';
  resources?: {
    __typename?: 'ResourceEntityResponseCollection';
    data: Array<{
      __typename?: 'ResourceEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'Resource';
        createdAt?: any | null;
        publishedAt?: any | null;
        title: string;
        slug: string;
        duration?: string | null;
        briefDescription: string;
        resourceType?: {
          __typename?: 'ResourceTypeEntityResponse';
          data?: {
            __typename?: 'ResourceTypeEntity';
            attributes?: { __typename?: 'ResourceType'; type: string } | null;
          } | null;
        } | null;
        themes?: {
          __typename?: 'ThemeRelationResponseCollection';
          data: Array<{
            __typename?: 'ThemeEntity';
            attributes?: {
              __typename?: 'Theme';
              theme?: string | null;
              topic?: {
                __typename?: 'TopicEntityResponse';
                data?: {
                  __typename?: 'TopicEntity';
                  attributes?: { __typename?: 'Topic'; topic?: string | null } | null;
                } | null;
              } | null;
            } | null;
          }>;
        } | null;
        cover: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        };
        DefaultContentTemplate: Array<
          | { __typename: 'ComponentCommonAuthor' }
          | {
              __typename: 'ComponentCommonAuthorDetailed';
              authors?: {
                __typename?: 'AuthorRelationResponseCollection';
                data: Array<{
                  __typename?: 'AuthorEntity';
                  attributes?: {
                    __typename?: 'Author';
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: 'UploadFileEntityResponse';
                      data?: {
                        __typename?: 'UploadFileEntity';
                        attributes?: {
                          __typename?: 'UploadFile';
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        } | null;
                      } | null;
                    };
                  } | null;
                }>;
              } | null;
            }
          | { __typename: 'ComponentCommonBullet' }
          | { __typename: 'ComponentCommonDivider' }
          | { __typename: 'ComponentCommonDownloadableContentList' }
          | { __typename: 'ComponentCommonEmbedded' }
          | { __typename: 'ComponentCommonFaqComponent' }
          | { __typename: 'ComponentCommonH3' }
          | { __typename: 'ComponentCommonMedia' }
          | { __typename: 'ComponentCommonQuote' }
          | { __typename: 'ComponentCommonRelatedContent' }
          | { __typename: 'ComponentCommonTags' }
          | { __typename: 'ComponentCommonTextEditor' }
          | { __typename: 'ComponentCommonTitle' }
          | { __typename: 'ComponentKnowledgeHubResourcesRelated' }
          | { __typename: 'Error' }
          | null
        >;
      } | null;
    }>;
    meta: {
      __typename?: 'ResponseCollectionMeta';
      pagination: { __typename?: 'Pagination'; page: number; pageCount: number; total: number };
    };
  } | null;
};

export type FetchLatestResourcesQueryVariables = Exact<{
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type FetchLatestResourcesQuery = {
  __typename?: 'Query';
  resources?: {
    __typename?: 'ResourceEntityResponseCollection';
    data: Array<{
      __typename?: 'ResourceEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'Resource';
        createdAt?: any | null;
        publishedAt?: any | null;
        title: string;
        slug: string;
        duration?: string | null;
        briefDescription: string;
        resourceType?: {
          __typename?: 'ResourceTypeEntityResponse';
          data?: {
            __typename?: 'ResourceTypeEntity';
            attributes?: { __typename?: 'ResourceType'; type: string } | null;
          } | null;
        } | null;
        themes?: {
          __typename?: 'ThemeRelationResponseCollection';
          data: Array<{
            __typename?: 'ThemeEntity';
            attributes?: {
              __typename?: 'Theme';
              theme?: string | null;
              topic?: {
                __typename?: 'TopicEntityResponse';
                data?: {
                  __typename?: 'TopicEntity';
                  attributes?: { __typename?: 'Topic'; topic?: string | null } | null;
                } | null;
              } | null;
            } | null;
          }>;
        } | null;
        cover: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        };
        DefaultContentTemplate: Array<
          | { __typename: 'ComponentCommonAuthor' }
          | {
              __typename: 'ComponentCommonAuthorDetailed';
              authors?: {
                __typename?: 'AuthorRelationResponseCollection';
                data: Array<{
                  __typename?: 'AuthorEntity';
                  attributes?: {
                    __typename?: 'Author';
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: 'UploadFileEntityResponse';
                      data?: {
                        __typename?: 'UploadFileEntity';
                        attributes?: {
                          __typename?: 'UploadFile';
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        } | null;
                      } | null;
                    };
                  } | null;
                }>;
              } | null;
            }
          | { __typename: 'ComponentCommonBullet' }
          | { __typename: 'ComponentCommonDivider' }
          | { __typename: 'ComponentCommonDownloadableContentList' }
          | { __typename: 'ComponentCommonEmbedded' }
          | { __typename: 'ComponentCommonFaqComponent' }
          | { __typename: 'ComponentCommonH3' }
          | { __typename: 'ComponentCommonMedia' }
          | { __typename: 'ComponentCommonQuote' }
          | { __typename: 'ComponentCommonRelatedContent' }
          | { __typename: 'ComponentCommonTags' }
          | { __typename: 'ComponentCommonTextEditor' }
          | { __typename: 'ComponentCommonTitle' }
          | { __typename: 'ComponentKnowledgeHubResourcesRelated' }
          | { __typename: 'Error' }
          | null
        >;
      } | null;
    }>;
  } | null;
};

export type HighlightsQueryVariables = Exact<{ [key: string]: never }>;

export type HighlightsQuery = {
  __typename?: 'Query';
  knowledgeHubPage?: {
    __typename?: 'KnowledgeHubPageEntityResponse';
    data?: {
      __typename?: 'KnowledgeHubPageEntity';
      attributes?: {
        __typename?: 'KnowledgeHubPage';
        highlights?: {
          __typename?: 'ResourceRelationResponseCollection';
          data: Array<{
            __typename?: 'ResourceEntity';
            attributes?: {
              __typename?: 'Resource';
              createdAt?: any | null;
              publishedAt?: any | null;
              title: string;
              slug: string;
              duration?: string | null;
              briefDescription: string;
              resourceType?: {
                __typename?: 'ResourceTypeEntityResponse';
                data?: {
                  __typename?: 'ResourceTypeEntity';
                  attributes?: { __typename?: 'ResourceType'; type: string } | null;
                } | null;
              } | null;
              themes?: {
                __typename?: 'ThemeRelationResponseCollection';
                data: Array<{
                  __typename?: 'ThemeEntity';
                  attributes?: {
                    __typename?: 'Theme';
                    theme?: string | null;
                    topic?: {
                      __typename?: 'TopicEntityResponse';
                      data?: {
                        __typename?: 'TopicEntity';
                        attributes?: { __typename?: 'Topic'; topic?: string | null } | null;
                      } | null;
                    } | null;
                  } | null;
                }>;
              } | null;
              cover: {
                __typename?: 'UploadFileEntityResponse';
                data?: {
                  __typename?: 'UploadFileEntity';
                  attributes?: {
                    __typename?: 'UploadFile';
                    url: string;
                    alternativeText?: string | null;
                    mime: string;
                  } | null;
                } | null;
              };
              DefaultContentTemplate: Array<
                | { __typename: 'ComponentCommonAuthor' }
                | {
                    __typename: 'ComponentCommonAuthorDetailed';
                    authors?: {
                      __typename?: 'AuthorRelationResponseCollection';
                      data: Array<{
                        __typename?: 'AuthorEntity';
                        attributes?: {
                          __typename?: 'Author';
                          name: string;
                          role?: string | null;
                          bio?: string | null;
                          avatar: {
                            __typename?: 'UploadFileEntityResponse';
                            data?: {
                              __typename?: 'UploadFileEntity';
                              attributes?: {
                                __typename?: 'UploadFile';
                                url: string;
                                alternativeText?: string | null;
                                mime: string;
                              } | null;
                            } | null;
                          };
                        } | null;
                      }>;
                    } | null;
                  }
                | { __typename: 'ComponentCommonBullet' }
                | { __typename: 'ComponentCommonDivider' }
                | { __typename: 'ComponentCommonDownloadableContentList' }
                | { __typename: 'ComponentCommonEmbedded' }
                | { __typename: 'ComponentCommonFaqComponent' }
                | { __typename: 'ComponentCommonH3' }
                | { __typename: 'ComponentCommonMedia' }
                | { __typename: 'ComponentCommonQuote' }
                | { __typename: 'ComponentCommonRelatedContent' }
                | { __typename: 'ComponentCommonTags' }
                | { __typename: 'ComponentCommonTextEditor' }
                | { __typename: 'ComponentCommonTitle' }
                | { __typename: 'ComponentKnowledgeHubResourcesRelated' }
                | { __typename: 'Error' }
                | null
              >;
            } | null;
          }>;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CourseQueryVariables = Exact<{
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type CourseQuery = {
  __typename?: 'Query';
  courses?: {
    __typename?: 'CourseEntityResponseCollection';
    data: Array<{
      __typename?: 'CourseEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'Course';
        title: string;
        slug?: string | null;
        description: string;
        duration?: string | null;
        textContent?: { __typename?: 'ComponentCommonTextEditor'; markdownText?: string | null } | null;
        course_category?: {
          __typename?: 'CourseCategoryEntityResponse';
          data?: {
            __typename?: 'CourseCategoryEntity';
            attributes?: { __typename?: 'CourseCategory'; name: string; description?: string | null } | null;
          } | null;
        } | null;
        courseCompletedSection?: {
          __typename?: 'ComponentLearnCourseCompletedSection';
          title: string;
          message: string;
        } | null;
        thumbnail: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        };
        hero: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        };
        modules?: Array<{
          __typename?: 'ComponentLearnCourseModule';
          id: string;
          title: string;
          description: string;
          lessons?: Array<{
            __typename?: 'ComponentLearnCourseLesson';
            id: string;
            title: string;
            description: string;
            duration?: string | null;
            textContent?: { __typename?: 'ComponentCommonTextEditor'; markdownText?: string | null } | null;
            thumbnail: {
              __typename?: 'UploadFileEntityResponse';
              data?: {
                __typename?: 'UploadFileEntity';
                attributes?: {
                  __typename?: 'UploadFile';
                  url: string;
                  alternativeText?: string | null;
                  mime: string;
                } | null;
              } | null;
            };
            authors?: {
              __typename?: 'AuthorRelationResponseCollection';
              data: Array<{
                __typename?: 'AuthorEntity';
                attributes?: {
                  __typename?: 'Author';
                  name: string;
                  role?: string | null;
                  bio?: string | null;
                  avatar: {
                    __typename?: 'UploadFileEntityResponse';
                    data?: {
                      __typename?: 'UploadFileEntity';
                      attributes?: {
                        __typename?: 'UploadFile';
                        url: string;
                        alternativeText?: string | null;
                        mime: string;
                      } | null;
                    } | null;
                  };
                } | null;
              }>;
            } | null;
          } | null> | null;
        } | null> | null;
        type?: {
          __typename?: 'CourseTypeEntityResponse';
          data?: {
            __typename?: 'CourseTypeEntity';
            attributes?: { __typename?: 'CourseType'; name: string } | null;
          } | null;
        } | null;
      } | null;
    }>;
  } | null;
};

export type CourseLessonQueryVariables = Exact<{
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type CourseLessonQuery = {
  __typename?: 'Query';
  courses?: {
    __typename?: 'CourseEntityResponseCollection';
    data: Array<{
      __typename?: 'CourseEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'Course';
        title: string;
        slug?: string | null;
        duration?: string | null;
        description: string;
        feedbackQuestions?: Array<{ __typename?: 'ComponentLearnQuestions'; question: string } | null> | null;
        textContent?: { __typename?: 'ComponentCommonTextEditor'; markdownText?: string | null } | null;
        course_category?: {
          __typename?: 'CourseCategoryEntityResponse';
          data?: {
            __typename?: 'CourseCategoryEntity';
            attributes?: { __typename?: 'CourseCategory'; name: string; description?: string | null } | null;
          } | null;
        } | null;
        thumbnail: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        };
        hero: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        };
        modules?: Array<{
          __typename?: 'ComponentLearnCourseModule';
          id: string;
          title: string;
          description: string;
          lessons?: Array<{
            __typename?: 'ComponentLearnCourseLesson';
            id: string;
            duration?: string | null;
            title: string;
            description: string;
            textContent?: { __typename?: 'ComponentCommonTextEditor'; markdownText?: string | null } | null;
            objectivesSection?: {
              __typename?: 'ComponentCommonObjectivesSection';
              id: string;
              title: string;
              objectives?: Array<{ __typename?: 'ComponentCommonObjectives'; description: string } | null> | null;
            } | null;
            thumbnail: {
              __typename?: 'UploadFileEntityResponse';
              data?: {
                __typename?: 'UploadFileEntity';
                attributes?: {
                  __typename?: 'UploadFile';
                  url: string;
                  alternativeText?: string | null;
                  mime: string;
                } | null;
              } | null;
            };
            highlightContent?: {
              __typename?: 'ComponentLearnHighlightContent';
              audio?: {
                __typename?: 'ComponentCommonAudio';
                transcription?: string | null;
                audio: {
                  __typename?: 'UploadFileEntityResponse';
                  data?: {
                    __typename?: 'UploadFileEntity';
                    attributes?: { __typename?: 'UploadFile'; url: string } | null;
                  } | null;
                };
              } | null;
              embedded?: {
                __typename?: 'ComponentCommonEmbedded';
                link: string;
                provider: Enum_Componentcommonembedded_Provider;
              } | null;
              image?: {
                __typename?: 'ComponentCommonMedia';
                media: {
                  __typename?: 'UploadFileEntityResponse';
                  data?: {
                    __typename?: 'UploadFileEntity';
                    attributes?: {
                      __typename?: 'UploadFile';
                      url: string;
                      alternativeText?: string | null;
                      mime: string;
                    } | null;
                  } | null;
                };
              } | null;
            } | null;
            downloadableContent?: Array<{
              __typename?: 'ComponentCommonDownloadableContent';
              title: string;
              description?: string | null;
              content: {
                __typename?: 'UploadFileEntityResponse';
                data?: {
                  __typename?: 'UploadFileEntity';
                  attributes?: { __typename?: 'UploadFile'; url: string } | null;
                } | null;
              };
            } | null> | null;
            faq?: Array<{ __typename?: 'ComponentCommonFaq'; title: string; description: string } | null> | null;
            authors?: {
              __typename?: 'AuthorRelationResponseCollection';
              data: Array<{
                __typename?: 'AuthorEntity';
                attributes?: {
                  __typename?: 'Author';
                  name: string;
                  role?: string | null;
                  bio?: string | null;
                  avatar: {
                    __typename?: 'UploadFileEntityResponse';
                    data?: {
                      __typename?: 'UploadFileEntity';
                      attributes?: {
                        __typename?: 'UploadFile';
                        url: string;
                        alternativeText?: string | null;
                        mime: string;
                      } | null;
                    } | null;
                  };
                } | null;
              }>;
            } | null;
          } | null> | null;
        } | null> | null;
        type?: {
          __typename?: 'CourseTypeEntityResponse';
          data?: {
            __typename?: 'CourseTypeEntity';
            attributes?: { __typename?: 'CourseType'; name: string } | null;
          } | null;
        } | null;
      } | null;
    }>;
  } | null;
};

export type FetchLatestCoursesQueryVariables = Exact<{
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type FetchLatestCoursesQuery = {
  __typename?: 'Query';
  courses?: {
    __typename?: 'CourseEntityResponseCollection';
    data: Array<{
      __typename?: 'CourseEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'Course';
        title: string;
        slug?: string | null;
        description: string;
        thumbnail: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        };
        modules?: Array<{
          __typename?: 'ComponentLearnCourseModule';
          id: string;
          lessons?: Array<{
            __typename?: 'ComponentLearnCourseLesson';
            id: string;
            authors?: {
              __typename?: 'AuthorRelationResponseCollection';
              data: Array<{
                __typename?: 'AuthorEntity';
                attributes?: {
                  __typename?: 'Author';
                  name: string;
                  role?: string | null;
                  bio?: string | null;
                  avatar: {
                    __typename?: 'UploadFileEntityResponse';
                    data?: {
                      __typename?: 'UploadFileEntity';
                      attributes?: {
                        __typename?: 'UploadFile';
                        url: string;
                        alternativeText?: string | null;
                        mime: string;
                      } | null;
                    } | null;
                  };
                } | null;
              }>;
            } | null;
          } | null> | null;
        } | null> | null;
        type?: {
          __typename?: 'CourseTypeEntityResponse';
          data?: {
            __typename?: 'CourseTypeEntity';
            attributes?: { __typename?: 'CourseType'; name: string } | null;
          } | null;
        } | null;
      } | null;
    }>;
  } | null;
};

export type FetchCoursesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type FetchCoursesQuery = {
  __typename?: 'Query';
  courses?: {
    __typename?: 'CourseEntityResponseCollection';
    data: Array<{
      __typename?: 'CourseEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'Course';
        title: string;
        slug?: string | null;
        duration?: string | null;
        description: string;
        thumbnail: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        };
        type?: {
          __typename?: 'CourseTypeEntityResponse';
          data?: {
            __typename?: 'CourseTypeEntity';
            attributes?: { __typename?: 'CourseType'; name: string } | null;
          } | null;
        } | null;
        course_category?: {
          __typename?: 'CourseCategoryEntityResponse';
          data?: {
            __typename?: 'CourseCategoryEntity';
            attributes?: { __typename?: 'CourseCategory'; name: string; description?: string | null } | null;
          } | null;
        } | null;
        modules?: Array<{
          __typename?: 'ComponentLearnCourseModule';
          id: string;
          lessons?: Array<{
            __typename?: 'ComponentLearnCourseLesson';
            id: string;
            authors?: {
              __typename?: 'AuthorRelationResponseCollection';
              data: Array<{
                __typename?: 'AuthorEntity';
                attributes?: {
                  __typename?: 'Author';
                  name: string;
                  role?: string | null;
                  bio?: string | null;
                  avatar: {
                    __typename?: 'UploadFileEntityResponse';
                    data?: {
                      __typename?: 'UploadFileEntity';
                      attributes?: {
                        __typename?: 'UploadFile';
                        url: string;
                        alternativeText?: string | null;
                        mime: string;
                      } | null;
                    } | null;
                  };
                } | null;
              }>;
            } | null;
          } | null> | null;
        } | null> | null;
      } | null;
    }>;
  } | null;
};

export type FetchCoursesPageableQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
}>;

export type FetchCoursesPageableQuery = {
  __typename?: 'Query';
  courses?: {
    __typename?: 'CourseEntityResponseCollection';
    data: Array<{
      __typename?: 'CourseEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'Course';
        title: string;
        slug?: string | null;
        description: string;
        duration?: string | null;
        thumbnail: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        };
        type?: {
          __typename?: 'CourseTypeEntityResponse';
          data?: {
            __typename?: 'CourseTypeEntity';
            attributes?: { __typename?: 'CourseType'; name: string } | null;
          } | null;
        } | null;
        course_category?: {
          __typename?: 'CourseCategoryEntityResponse';
          data?: {
            __typename?: 'CourseCategoryEntity';
            attributes?: { __typename?: 'CourseCategory'; name: string; description?: string | null } | null;
          } | null;
        } | null;
        modules?: Array<{
          __typename?: 'ComponentLearnCourseModule';
          id: string;
          lessons?: Array<{
            __typename?: 'ComponentLearnCourseLesson';
            id: string;
            authors?: {
              __typename?: 'AuthorRelationResponseCollection';
              data: Array<{
                __typename?: 'AuthorEntity';
                attributes?: {
                  __typename?: 'Author';
                  name: string;
                  role?: string | null;
                  bio?: string | null;
                  avatar: {
                    __typename?: 'UploadFileEntityResponse';
                    data?: {
                      __typename?: 'UploadFileEntity';
                      attributes?: {
                        __typename?: 'UploadFile';
                        url: string;
                        alternativeText?: string | null;
                        mime: string;
                      } | null;
                    } | null;
                  };
                } | null;
              }>;
            } | null;
          } | null> | null;
        } | null> | null;
      } | null;
    }>;
    meta: {
      __typename?: 'ResponseCollectionMeta';
      pagination: { __typename?: 'Pagination'; page: number; pageCount: number; total: number };
    };
  } | null;
};

export type FetchLearnQueryVariables = Exact<{
  idUser: Scalars['ID']['input'];
  completed?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type FetchLearnQuery = {
  __typename?: 'Query';
  learn?: {
    __typename?: 'LearnEntityResponseCollection';
    data: Array<{
      __typename?: 'LearnEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'Learn';
        completed?: boolean | null;
        completedAt?: any | null;
        users_permissions_user?: {
          __typename?: 'UsersPermissionsUserEntityResponse';
          data?: { __typename?: 'UsersPermissionsUserEntity'; id?: string | null } | null;
        } | null;
        course?: {
          __typename?: 'CourseEntityResponse';
          data?: {
            __typename?: 'CourseEntity';
            id?: string | null;
            attributes?: {
              __typename?: 'Course';
              title: string;
              slug?: string | null;
              description: string;
              thumbnail: {
                __typename?: 'UploadFileEntityResponse';
                data?: {
                  __typename?: 'UploadFileEntity';
                  attributes?: {
                    __typename?: 'UploadFile';
                    url: string;
                    alternativeText?: string | null;
                    mime: string;
                  } | null;
                } | null;
              };
              course_category?: {
                __typename?: 'CourseCategoryEntityResponse';
                data?: {
                  __typename?: 'CourseCategoryEntity';
                  attributes?: { __typename?: 'CourseCategory'; name: string; description?: string | null } | null;
                } | null;
              } | null;
              type?: {
                __typename?: 'CourseTypeEntityResponse';
                data?: {
                  __typename?: 'CourseTypeEntity';
                  attributes?: { __typename?: 'CourseType'; name: string } | null;
                } | null;
              } | null;
              modules?: Array<{
                __typename?: 'ComponentLearnCourseModule';
                id: string;
                title: string;
                lessons?: Array<{ __typename?: 'ComponentLearnCourseLesson'; id: string; title: string } | null> | null;
              } | null> | null;
            } | null;
          } | null;
        } | null;
        learn_items?: {
          __typename?: 'LearnItemRelationResponseCollection';
          data: Array<{
            __typename?: 'LearnItemEntity';
            attributes?: { __typename?: 'LearnItem'; idModule: string; idLesson: string } | null;
          }>;
        } | null;
      } | null;
    }>;
  } | null;
};

export type FetchCourseLearnQueryVariables = Exact<{
  idUser: Scalars['ID']['input'];
  courseSlug: Scalars['String']['input'];
}>;

export type FetchCourseLearnQuery = {
  __typename?: 'Query';
  learn?: {
    __typename?: 'LearnEntityResponseCollection';
    data: Array<{
      __typename?: 'LearnEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'Learn';
        completed?: boolean | null;
        completedAt?: any | null;
        users_permissions_user?: {
          __typename?: 'UsersPermissionsUserEntityResponse';
          data?: { __typename?: 'UsersPermissionsUserEntity'; id?: string | null } | null;
        } | null;
        course?: {
          __typename?: 'CourseEntityResponse';
          data?: {
            __typename?: 'CourseEntity';
            id?: string | null;
            attributes?: {
              __typename?: 'Course';
              title: string;
              slug?: string | null;
              description: string;
              thumbnail: {
                __typename?: 'UploadFileEntityResponse';
                data?: {
                  __typename?: 'UploadFileEntity';
                  attributes?: {
                    __typename?: 'UploadFile';
                    url: string;
                    alternativeText?: string | null;
                    mime: string;
                  } | null;
                } | null;
              };
              course_category?: {
                __typename?: 'CourseCategoryEntityResponse';
                data?: {
                  __typename?: 'CourseCategoryEntity';
                  attributes?: { __typename?: 'CourseCategory'; name: string; description?: string | null } | null;
                } | null;
              } | null;
              type?: {
                __typename?: 'CourseTypeEntityResponse';
                data?: {
                  __typename?: 'CourseTypeEntity';
                  attributes?: { __typename?: 'CourseType'; name: string } | null;
                } | null;
              } | null;
              modules?: Array<{
                __typename?: 'ComponentLearnCourseModule';
                id: string;
                title: string;
                lessons?: Array<{ __typename?: 'ComponentLearnCourseLesson'; id: string; title: string } | null> | null;
              } | null> | null;
            } | null;
          } | null;
        } | null;
        learn_items?: {
          __typename?: 'LearnItemRelationResponseCollection';
          data: Array<{
            __typename?: 'LearnItemEntity';
            attributes?: { __typename?: 'LearnItem'; idModule: string; idLesson: string } | null;
          }>;
        } | null;
      } | null;
    }>;
  } | null;
};

export type CoursePageQueryVariables = Exact<{ [key: string]: never }>;

export type CoursePageQuery = {
  __typename?: 'Query';
  coursePage?: {
    __typename?: 'CoursePageEntityResponse';
    data?: {
      __typename?: 'CoursePageEntity';
      attributes?: {
        __typename?: 'CoursePage';
        lesson?: {
          __typename?: 'ComponentCoursePageLesson';
          beginButtonLabel?: string | null;
          watchAgainButtonlabel?: string | null;
          lockedButtonlabel?: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type LearnPageQueryVariables = Exact<{ [key: string]: never }>;

export type LearnPageQuery = {
  __typename?: 'Query';
  learnPage?: {
    __typename?: 'LearnPageEntityResponse';
    data?: {
      __typename?: 'LearnPageEntity';
      attributes?: {
        __typename?: 'LearnPage';
        emptyInProgressCoursesMessage?: string | null;
        emptyCompletedCoursesMessage?: string | null;
        welcomePageMessage?: {
          __typename?: 'ComponentCommonWelcomePageMessage';
          title: string;
          description: string;
        } | null;
        searchSection?: {
          __typename?: 'ComponentCommonSearchSection';
          title: string;
          searchInput: string;
          whatKindTitle: string;
          chooseATopicTitle: string;
          chooseCollectionTitle: string;
          topics?: {
            __typename?: 'TopicRelationResponseCollection';
            data: Array<{
              __typename?: 'TopicEntity';
              attributes?: { __typename?: 'Topic'; topic?: string | null } | null;
            }>;
          } | null;
          themes?: {
            __typename?: 'ThemeRelationResponseCollection';
            data: Array<{
              __typename?: 'ThemeEntity';
              attributes?: { __typename?: 'Theme'; theme?: string | null } | null;
            }>;
          } | null;
          types?: Array<{ __typename?: 'ComponentCommonTypes'; type: string } | null> | null;
        } | null;
        markLessonAsCompleteButton?: {
          __typename?: 'ComponentLearnMarkAsCompleteButton';
          markAsCompleteLabel?: string | null;
          completedLabel?: string | null;
        } | null;
        markCourseAsCompleted?: {
          __typename?: 'ComponentLearnMarkAsCompleteButton';
          markAsCompleteLabel?: string | null;
          completedLabel?: string | null;
        } | null;
        contentTemplateLabels?: {
          __typename?: 'ComponentCommonContentTemplateLabels';
          downloadableContentLabel?: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CourseFeedbackPageQueryVariables = Exact<{ [key: string]: never }>;

export type CourseFeedbackPageQuery = {
  __typename?: 'Query';
  learnPage?: {
    __typename?: 'LearnPageEntityResponse';
    data?: {
      __typename?: 'LearnPageEntity';
      attributes?: {
        __typename?: 'LearnPage';
        markCourseAsCompleted?: {
          __typename?: 'ComponentLearnMarkAsCompleteButton';
          completedLabel?: string | null;
        } | null;
        feedbackSection?: {
          __typename?: 'ComponentLearnFeebackSection';
          title: string;
          description: string;
          submitYourFeedback?: string | null;
          enterYourFeedback: string;
          sendFeedback: string;
        } | null;
        modalLeavePage?: {
          __typename?: 'ComponentLearnModalLeavePage';
          title: string;
          description?: string | null;
          confirmButton: string;
          cancelButton: string;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type ForgotPasswordPageQueryVariables = Exact<{ [key: string]: never }>;

export type ForgotPasswordPageQuery = {
  __typename?: 'Query';
  forgotPassword?: {
    __typename?: 'ForgotPasswordEntityResponse';
    data?: {
      __typename?: 'ForgotPasswordEntity';
      attributes?: {
        __typename?: 'ForgotPassword';
        forgotPasswordTItle: string;
        letUsKnowDescription: string;
        yourEmail: string;
        sendMeCta: string;
        backToLoginCta: string;
        chooseANewPasswordTitle: string;
        passwordsShouldBeDescription: string;
        yourNewPassword: string;
        repeatYourPassword: string;
        resetMyPasswordCta: string;
        logo: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        };
        feedback?: {
          __typename?: 'ComponentRegisterFeedbackFeedback';
          emailSent?: {
            __typename?: 'ComponentCommonEmailSent';
            title?: string | null;
            description?: string | null;
          } | null;
          passwordResetSuccess?: {
            __typename?: 'ComponentCommonEmailSent';
            title?: string | null;
            description?: string | null;
          } | null;
          passwordResetError?: {
            __typename?: 'ComponentCommonEmailSent';
            title?: string | null;
            description?: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type LoginPageQueryVariables = Exact<{ [key: string]: never }>;

export type LoginPageQuery = {
  __typename?: 'Query';
  loginPage?: {
    __typename?: 'LoginPageEntityResponse';
    data?: {
      __typename?: 'LoginPageEntity';
      attributes?: {
        __typename?: 'LoginPage';
        loginTitle: string;
        yourEmailTitle: string;
        yourPasswordTitle: string;
        rememberMeTitle: string;
        loginCta: string;
        forgotYourPasswordCta: string;
        confirmEmailTitle: string;
        pleaseLoginTItle: string;
        logo: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        };
        fieldErrors?: {
          __typename?: 'ComponentLoginLoginFieldErrors';
          identifierRequired?: string | null;
          passwordRequired?: string | null;
        } | null;
        popUpMessages?: {
          __typename?: 'ComponentLoginToastMessagesLogin';
          success?: { __typename?: 'ComponentCommonToast'; title?: string | null; message?: string | null } | null;
          error?: { __typename?: 'ComponentCommonToast'; title?: string | null; message?: string | null } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type RegisterPageQueryVariables = Exact<{ [key: string]: never }>;

export type RegisterPageQuery = {
  __typename?: 'Query';
  registerPage?: {
    __typename?: 'RegisterPageEntityResponse';
    data?: {
      __typename?: 'RegisterPageEntity';
      attributes?: {
        __typename?: 'RegisterPage';
        registerTitle: string;
        description: string;
        yourEmail: string;
        schoolCode: string;
        yourFirstName: string;
        yourLastName: string;
        choosePassword: string;
        repeatYourPassword: string;
        createYourAccountCta: string;
        welcomeToTItle: string;
        successRegisterPopUpTitle?: string | null;
        successRegisterPopUpMessage?: string | null;
        logo: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        };
        image: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        };
        fieldErrors?: {
          __typename?: 'ComponentRegisterRegisterFieldErrors';
          surnameRequired?: string | null;
          forenameRequired?: string | null;
          emailRequired?: string | null;
          schoolCodeRequired?: string | null;
          passwordRequired?: string | null;
          termsAndConditionsRequired?: string | null;
          confirmPasswordRequired?: string | null;
          confirmPasswordDidNotMatch?: string | null;
        } | null;
        popUpMessages?: {
          __typename?: 'ComponentRegisterToastMessagesRegister';
          success?: { __typename?: 'ComponentCommonToast'; title?: string | null; message?: string | null } | null;
          error?: { __typename?: 'ComponentCommonToast'; title?: string | null; message?: string | null } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type MeditationDetailPageQueryVariables = Exact<{ [key: string]: never }>;

export type MeditationDetailPageQuery = {
  __typename?: 'Query';
  meditationDetailPage?: {
    __typename?: 'MeditationDetailPageEntityResponse';
    data?: {
      __typename?: 'MeditationDetailPageEntity';
      attributes?: {
        __typename?: 'MeditationDetailPage';
        startBtn?: string | null;
        pauseBtn: string;
        stopBtn: string;
        youMayAlsoLikeTitle: string;
        moreBtn: string;
        goToTheMeditationBtn: string;
        thankYou?: string | null;
      } | null;
    } | null;
  } | null;
};

export type MeditationPageQueryVariables = Exact<{ [key: string]: never }>;

export type MeditationPageQuery = {
  __typename?: 'Query';
  meditationPage?: {
    __typename?: 'MeditationPageEntityResponse';
    data?: {
      __typename?: 'MeditationPageEntity';
      attributes?: {
        __typename?: 'MeditationPage';
        moreBtn: string;
        goToTheMeditationBtn: string;
        sectionLabel?: string | null;
        header: {
          __typename?: 'ComponentMeditationHeader';
          title: string;
          description: string;
          image: {
            __typename?: 'UploadFileEntityResponse';
            data?: {
              __typename?: 'UploadFileEntity';
              attributes?: {
                __typename?: 'UploadFile';
                url: string;
                alternativeText?: string | null;
                mime: string;
              } | null;
            } | null;
          };
        };
      } | null;
    } | null;
  } | null;
};

export type MeditationsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
}>;

export type MeditationsQuery = {
  __typename?: 'Query';
  meditations?: {
    __typename?: 'MeditationEntityResponseCollection';
    data: Array<{
      __typename?: 'MeditationEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'Meditation';
        title: string;
        subHeader: string;
        slug?: string | null;
        duration: string;
        briefDescription: string;
        type: Enum_Meditation_Type;
        mindful_exercise_type?: {
          __typename?: 'MindfulExerciseTypeEntityResponse';
          data?: {
            __typename?: 'MindfulExerciseTypeEntity';
            attributes?: { __typename?: 'MindfulExerciseType'; name: string } | null;
          } | null;
        } | null;
      } | null;
    }>;
    meta: {
      __typename?: 'ResponseCollectionMeta';
      pagination: { __typename?: 'Pagination'; total: number; pageCount: number; page: number };
    };
  } | null;
};

export type MeditationQueryVariables = Exact<{
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type MeditationQuery = {
  __typename?: 'Query';
  meditations?: {
    __typename?: 'MeditationEntityResponseCollection';
    data: Array<{
      __typename?: 'MeditationEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'Meditation';
        title: string;
        subHeader: string;
        slug?: string | null;
        briefDescription: string;
        type: Enum_Meditation_Type;
        presentedBy: string;
        mindful_exercise_type?: {
          __typename?: 'MindfulExerciseTypeEntityResponse';
          data?: {
            __typename?: 'MindfulExerciseTypeEntity';
            attributes?: { __typename?: 'MindfulExerciseType'; name: string } | null;
          } | null;
        } | null;
        themes?: {
          __typename?: 'ThemeRelationResponseCollection';
          data: Array<{
            __typename?: 'ThemeEntity';
            attributes?: {
              __typename?: 'Theme';
              theme?: string | null;
              topic?: {
                __typename?: 'TopicEntityResponse';
                data?: {
                  __typename?: 'TopicEntity';
                  attributes?: { __typename?: 'Topic'; topic?: string | null } | null;
                } | null;
              } | null;
            } | null;
          }>;
        } | null;
        audio?: {
          __typename?: 'ComponentCommonAudio';
          transcription?: string | null;
          audio: {
            __typename?: 'UploadFileEntityResponse';
            data?: {
              __typename?: 'UploadFileEntity';
              attributes?: { __typename?: 'UploadFile'; url: string } | null;
            } | null;
          };
        } | null;
        video?: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: { __typename?: 'UploadFile'; url: string } | null;
          } | null;
        } | null;
        relatedContent?: {
          __typename?: 'MeditationRelationResponseCollection';
          data: Array<{
            __typename?: 'MeditationEntity';
            attributes?: {
              __typename?: 'Meditation';
              title: string;
              duration: string;
              slug?: string | null;
              briefDescription: string;
              type: Enum_Meditation_Type;
              mindful_exercise_type?: {
                __typename?: 'MindfulExerciseTypeEntityResponse';
                data?: {
                  __typename?: 'MindfulExerciseTypeEntity';
                  attributes?: { __typename?: 'MindfulExerciseType'; name: string } | null;
                } | null;
              } | null;
            } | null;
          }>;
        } | null;
      } | null;
    }>;
  } | null;
};

export type AdminOnboardingQueryVariables = Exact<{ [key: string]: never }>;

export type AdminOnboardingQuery = {
  __typename?: 'Query';
  adminOnboarding?: {
    __typename?: 'AdminOnboardingEntityResponse';
    data?: {
      __typename?: 'AdminOnboardingEntity';
      attributes?: {
        __typename?: 'AdminOnboarding';
        step1: {
          __typename?: 'ComponentAdminOnboradingStep1';
          title: string;
          description: string;
          buttonTxt: string;
          image: {
            __typename?: 'UploadFileEntityResponse';
            data?: {
              __typename?: 'UploadFileEntity';
              attributes?: { __typename?: 'UploadFile'; url: string; alternativeText?: string | null } | null;
            } | null;
          };
        };
        step2: {
          __typename?: 'ComponentAdminOnboradingStep2';
          title: string;
          subTitle: string;
          autumTermTitle: string;
          springTerm: string;
          summerTerm: string;
          btnText: string;
        };
        schoolManagement: {
          __typename?: 'ComponentAdminOnboradingSchoolManagement';
          welcomeTitle: string;
          welcomeDescription: string;
          yourAccessCode: string;
          btnCopyCodeTxt: string;
          shareCodeTitle: string;
          sendEmailSubTitle: string;
          btnShareCodeTxt: string;
          downloadQrCode: string;
          downloadQrCodeDescription: string;
          btnDownloadPdf: string;
          copyPasteTitle: string;
          copyTxtSubTItle: string;
          btnCopyMessagTxt: string;
          template: string;
          toastStaffInvitedTitle?: string | null;
          toastStaffInvitedDescription?: string | null;
          toastStaffImportedTitle?: string | null;
          toastStaffImportedDescription?: string | null;
          toastErrorDownloadingPDFTitle?: string | null;
          toastPDFDownloadedTitle?: string | null;
          toastPDFDownloadedDescription?: string | null;
          tooltipCopiedMessage?: string | null;
          btnInviteStaffTxt?: string | null;
          btnImportStaffWondeTxt?: string | null;
          orText?: string | null;
          invitationUsingFile?: {
            __typename?: 'ComponentAdminOnboradingInvitationUsingFile';
            uploadSpreadsheetBtn?: string | null;
            seePreviewBtn?: string | null;
            warningMsgDialog?: string | null;
            dialogTitle?: string | null;
            uploadFileBtn?: string | null;
            sendInvitationBtn?: string | null;
            closeBtn?: string | null;
            button?: string | null;
          } | null;
          invitationPreview?: {
            __typename?: 'ComponentAdminOnboradingInvitationPreview';
            dialogTitle?: string | null;
            closeBtn?: string | null;
            sendInvitationBtn?: string | null;
            userPreviewSurnameLabel?: string | null;
            userPreviewForenameLabel?: string | null;
            userPreviewEmailLabel?: string | null;
            userPreviewNoStaffLabel?: string | null;
          } | null;
          tabs?: {
            __typename?: 'ComponentAdminOnboradingTabs';
            adminManagementTabName?: string | null;
            surveyDashboardTabName?: string | null;
            reportingDashboardTabName?: string | null;
            announcementsTabName?: string | null;
            manageStaffTabName?: string | null;
          } | null;
        };
        dashboard?: {
          __typename?: 'ComponentAdminOnboradingDashboard';
          title?: string | null;
          allSchools?: string | null;
          header?: {
            __typename?: 'ComponentAdminOnboradingHeader';
            overallMood?: string | null;
            engagementPastWeek?: string | null;
            surveysResponse?: string | null;
            totalUsers?: string | null;
          } | null;
          chartsTitles?: {
            __typename?: 'ComponentAdminOnboradingChartsTitles';
            schoolMood?: string | null;
            mostUsedFeatures?: string | null;
            featureUsage?: string | null;
            dailyUsers?: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type OnBoardingPageQueryVariables = Exact<{ [key: string]: never }>;

export type OnBoardingPageQuery = {
  __typename?: 'Query';
  onBoardingPage?: {
    __typename?: 'OnBoardingPageEntityResponse';
    data?: {
      __typename?: 'OnBoardingPageEntity';
      attributes?: {
        __typename?: 'OnBoardingPage';
        dailyBubbleTitle: string;
        delvingDeeperTitle: string;
        aboutYouTitle: string;
        reachingYouTitle: string;
      } | null;
    } | null;
  } | null;
};

export type OnBoardingStep1QueryVariables = Exact<{ [key: string]: never }>;

export type OnBoardingStep1Query = {
  __typename?: 'Query';
  step1?: {
    __typename?: 'Step1EntityResponse';
    data?: {
      __typename?: 'Step1Entity';
      attributes?: {
        __typename?: 'Step1';
        content: {
          __typename?: 'ComponentOnBoardingOnBoardingContainer';
          title: string;
          description?: string | null;
          image?: {
            __typename?: 'UploadFileEntityResponse';
            data?: {
              __typename?: 'UploadFileEntity';
              attributes?: { __typename?: 'UploadFile'; url: string; alternativeText?: string | null } | null;
            } | null;
          } | null;
          button?: { __typename?: 'ComponentCommonButton'; text: string; link: string } | null;
        };
      } | null;
    } | null;
  } | null;
};

export type OnBoardingStep2QueryVariables = Exact<{ [key: string]: never }>;

export type OnBoardingStep2Query = {
  __typename?: 'Query';
  step2?: {
    __typename?: 'Step2EntityResponse';
    data?: {
      __typename?: 'Step2Entity';
      attributes?: {
        __typename?: 'Step2';
        content: {
          __typename?: 'ComponentOnBoardingOnBoardingContainer';
          title: string;
          description?: string | null;
          image?: {
            __typename?: 'UploadFileEntityResponse';
            data?: {
              __typename?: 'UploadFileEntity';
              attributes?: { __typename?: 'UploadFile'; url: string; alternativeText?: string | null } | null;
            } | null;
          } | null;
          button?: { __typename?: 'ComponentCommonButton'; text: string; link: string } | null;
        };
      } | null;
    } | null;
  } | null;
};

export type OnBoardingStep3QueryVariables = Exact<{ [key: string]: never }>;

export type OnBoardingStep3Query = {
  __typename?: 'Query';
  step3?: {
    __typename?: 'Step3EntityResponse';
    data?: {
      __typename?: 'Step3Entity';
      attributes?: {
        __typename?: 'Step3';
        content?: {
          __typename?: 'ComponentOnBoardingOnBoardingContainer';
          title: string;
          description?: string | null;
          image?: {
            __typename?: 'UploadFileEntityResponse';
            data?: {
              __typename?: 'UploadFileEntity';
              attributes?: { __typename?: 'UploadFile'; url: string; alternativeText?: string | null } | null;
            } | null;
          } | null;
          button?: { __typename?: 'ComponentCommonButton'; text: string; link: string } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type UpdateUserProfileMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  profile?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  ageBracket?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateUserProfileMutation = {
  __typename?: 'Mutation';
  updateUsersPermissionsUser: {
    __typename?: 'UsersPermissionsUserEntityResponse';
    data?: {
      __typename?: 'UsersPermissionsUserEntity';
      attributes?: { __typename?: 'UsersPermissionsUser'; updatedAt?: any | null } | null;
    } | null;
  };
};

export type OnBoardingStep4QueryVariables = Exact<{ [key: string]: never }>;

export type OnBoardingStep4Query = {
  __typename?: 'Query';
  step4?: {
    __typename?: 'Step4EntityResponse';
    data?: {
      __typename?: 'Step4Entity';
      attributes?: {
        __typename?: 'Step4';
        content?: {
          __typename?: 'ComponentOnBoardingOnBoardingContainer';
          title: string;
          description?: string | null;
          image?: {
            __typename?: 'UploadFileEntityResponse';
            data?: {
              __typename?: 'UploadFileEntity';
              attributes?: { __typename?: 'UploadFile'; url: string; alternativeText?: string | null } | null;
            } | null;
          } | null;
          button?: { __typename?: 'ComponentCommonButton'; text: string; link: string } | null;
        } | null;
        roles?: Array<{ __typename?: 'ComponentCommonRoles'; role?: string | null } | null> | null;
        ageBracket?: {
          __typename?: 'ComponentCommonFieldSelect';
          label: string;
          placeholder: string;
          options?: Array<{ __typename?: 'ComponentCommonText'; option: string } | null> | null;
        } | null;
        role?: { __typename?: 'ComponentCommonField'; label: string; placeholder: string } | null;
        gender?: {
          __typename?: 'ComponentCommonFieldSelect';
          label: string;
          placeholder: string;
          options?: Array<{ __typename?: 'ComponentCommonText'; option: string } | null> | null;
        } | null;
        location?: { __typename?: 'ComponentCommonField'; label: string; placeholder: string } | null;
      } | null;
    } | null;
  } | null;
};

export type UpdateUserTopicsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  topics?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;

export type UpdateUserTopicsMutation = {
  __typename?: 'Mutation';
  updateUsersPermissionsUser: {
    __typename?: 'UsersPermissionsUserEntityResponse';
    data?: {
      __typename?: 'UsersPermissionsUserEntity';
      attributes?: { __typename?: 'UsersPermissionsUser'; updatedAt?: any | null } | null;
    } | null;
  };
};

export type OnBoardingStep5QueryVariables = Exact<{ [key: string]: never }>;

export type OnBoardingStep5Query = {
  __typename?: 'Query';
  step5?: {
    __typename?: 'Step5EntityResponse';
    data?: {
      __typename?: 'Step5Entity';
      attributes?: {
        __typename?: 'Step5';
        content: {
          __typename?: 'ComponentOnBoardingOnBoardingContainer';
          title: string;
          description?: string | null;
          image?: {
            __typename?: 'UploadFileEntityResponse';
            data?: {
              __typename?: 'UploadFileEntity';
              attributes?: { __typename?: 'UploadFile'; url: string; alternativeText?: string | null } | null;
            } | null;
          } | null;
          button?: { __typename?: 'ComponentCommonButton'; text: string; link: string } | null;
        };
      } | null;
    } | null;
  } | null;
};

export type PodcastQueryVariables = Exact<{
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  userId: Scalars['ID']['input'];
}>;

export type PodcastQuery = {
  __typename?: 'Query';
  podcasts?: {
    __typename?: 'PodcastEntityResponseCollection';
    data: Array<{
      __typename?: 'PodcastEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'Podcast';
        title: string;
        slug: string;
        briefDescription: string;
        subHeader?: string | null;
        cover: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        };
        listenings?: {
          __typename?: 'PodcastListeningTimeRelationResponseCollection';
          data: Array<{
            __typename?: 'PodcastListeningTimeEntity';
            id?: string | null;
            attributes?: { __typename?: 'PodcastListeningTime'; listeningTime: any; duration: any } | null;
          }>;
        } | null;
        themes?: {
          __typename?: 'ThemeRelationResponseCollection';
          data: Array<{
            __typename?: 'ThemeEntity';
            attributes?: {
              __typename?: 'Theme';
              theme?: string | null;
              topic?: {
                __typename?: 'TopicEntityResponse';
                data?: {
                  __typename?: 'TopicEntity';
                  attributes?: { __typename?: 'Topic'; topic?: string | null } | null;
                } | null;
              } | null;
            } | null;
          }>;
        } | null;
        DefaultContentTemplate: Array<
          | {
              __typename: 'ComponentCommonAudio';
              transcription?: string | null;
              audio: {
                __typename?: 'UploadFileEntityResponse';
                data?: {
                  __typename?: 'UploadFileEntity';
                  attributes?: { __typename?: 'UploadFile'; url: string } | null;
                } | null;
              };
            }
          | { __typename: 'ComponentCommonAuthor' }
          | {
              __typename: 'ComponentCommonAuthorDetailed';
              authors?: {
                __typename?: 'AuthorRelationResponseCollection';
                data: Array<{
                  __typename?: 'AuthorEntity';
                  attributes?: {
                    __typename?: 'Author';
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: 'UploadFileEntityResponse';
                      data?: {
                        __typename?: 'UploadFileEntity';
                        attributes?: {
                          __typename?: 'UploadFile';
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        } | null;
                      } | null;
                    };
                  } | null;
                }>;
              } | null;
            }
          | {
              __typename: 'ComponentCommonBullet';
              item: Array<{ __typename?: 'ComponentCommonList'; text: string } | null>;
            }
          | { __typename: 'ComponentCommonDivider'; id: string }
          | {
              __typename: 'ComponentCommonDownloadableContentList';
              list?: Array<{
                __typename?: 'ComponentCommonDownloadableContent';
                title: string;
                description?: string | null;
                content: {
                  __typename?: 'UploadFileEntityResponse';
                  data?: {
                    __typename?: 'UploadFileEntity';
                    attributes?: { __typename?: 'UploadFile'; url: string } | null;
                  } | null;
                };
              } | null> | null;
            }
          | { __typename: 'ComponentCommonEmbedded'; link: string; provider: Enum_Componentcommonembedded_Provider }
          | {
              __typename: 'ComponentCommonFaqComponent';
              faq?: Array<{ __typename?: 'ComponentCommonFaq'; title: string; description: string } | null> | null;
            }
          | { __typename: 'ComponentCommonH3'; text: string }
          | { __typename: 'ComponentCommonInPartnershipWith'; partnership: string }
          | {
              __typename: 'ComponentCommonMedia';
              media: {
                __typename?: 'UploadFileEntityResponse';
                data?: {
                  __typename?: 'UploadFileEntity';
                  attributes?: { __typename?: 'UploadFile'; url: string; alternativeText?: string | null } | null;
                } | null;
              };
            }
          | { __typename: 'ComponentCommonQuote'; quote: string }
          | { __typename: 'ComponentCommonRelatedContent'; id: string }
          | { __typename: 'ComponentCommonTags'; id: string }
          | { __typename: 'ComponentCommonTextEditor'; markdownText?: string | null }
          | { __typename: 'ComponentCommonTitle'; title: string }
          | { __typename: 'Error' }
          | null
        >;
      } | null;
    }>;
  } | null;
};

export type PodcastPageQueryVariables = Exact<{ [key: string]: never }>;

export type PodcastPageQuery = {
  __typename?: 'Query';
  podcastPage?: {
    __typename?: 'PodcastPageEntityResponse';
    data?: {
      __typename?: 'PodcastPageEntity';
      attributes?: {
        __typename?: 'PodcastPage';
        latestTitle: string;
        moreButotnTItle: string;
        chooseAThemeTitle: string;
        intro?: {
          __typename?: 'ComponentPodcastIntro';
          title: string;
          description: string;
          thumbnail: {
            __typename?: 'UploadFileEntityResponse';
            data?: {
              __typename?: 'UploadFileEntity';
              attributes?: {
                __typename?: 'UploadFile';
                url: string;
                alternativeText?: string | null;
                mime: string;
              } | null;
            } | null;
          };
        } | null;
        topics?: {
          __typename?: 'TopicRelationResponseCollection';
          data: Array<{
            __typename?: 'TopicEntity';
            attributes?: {
              __typename?: 'Topic';
              topic?: string | null;
              themes?: {
                __typename?: 'ThemeRelationResponseCollection';
                data: Array<{
                  __typename?: 'ThemeEntity';
                  attributes?: { __typename?: 'Theme'; theme?: string | null } | null;
                }>;
              } | null;
            } | null;
          }>;
        } | null;
        getInTouchSection?: {
          __typename?: 'ComponentPodcastGetInTouch';
          boxText: string;
          buttonText: string;
          titleModal: string;
          descriptionModal: string;
          emailPlaceholder: string;
          submitText: string;
          yourTextPlaceholder: string;
          thanksTitle: string;
          thanksDescription: string;
        } | null;
        questionsSection?: {
          __typename?: 'ComponentPodcastGetInTouch';
          boxText: string;
          buttonText: string;
          titleModal: string;
          descriptionModal: string;
          emailPlaceholder: string;
          submitText: string;
          yourTextPlaceholder: string;
          thanksTitle: string;
          thanksDescription: string;
          guests?: {
            __typename?: 'GuestRelationResponseCollection';
            data: Array<{
              __typename?: 'GuestEntity';
              id?: string | null;
              attributes?: { __typename?: 'Guest'; name?: string | null } | null;
            }>;
          } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type FetchPodcastsPageableQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type FetchPodcastsPageableQuery = {
  __typename?: 'Query';
  podcasts?: {
    __typename?: 'PodcastEntityResponseCollection';
    data: Array<{
      __typename?: 'PodcastEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'Podcast';
        title: string;
        slug: string;
        publicationDate: any;
        subHeader?: string | null;
        briefDescription: string;
        guests?: {
          __typename?: 'GuestRelationResponseCollection';
          data: Array<{
            __typename?: 'GuestEntity';
            attributes?: { __typename?: 'Guest'; name?: string | null } | null;
          }>;
        } | null;
        listenings?: {
          __typename?: 'PodcastListeningTimeRelationResponseCollection';
          data: Array<{
            __typename?: 'PodcastListeningTimeEntity';
            id?: string | null;
            attributes?: { __typename?: 'PodcastListeningTime'; listeningTime: any; duration: any } | null;
          }>;
        } | null;
        themes?: {
          __typename?: 'ThemeRelationResponseCollection';
          data: Array<{
            __typename?: 'ThemeEntity';
            attributes?: {
              __typename?: 'Theme';
              theme?: string | null;
              topic?: {
                __typename?: 'TopicEntityResponse';
                data?: {
                  __typename?: 'TopicEntity';
                  attributes?: { __typename?: 'Topic'; topic?: string | null } | null;
                } | null;
              } | null;
            } | null;
          }>;
        } | null;
        cover: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        };
        DefaultContentTemplate: Array<
          | { __typename: 'ComponentCommonAudio' }
          | { __typename: 'ComponentCommonAuthor' }
          | {
              __typename: 'ComponentCommonAuthorDetailed';
              authors?: {
                __typename?: 'AuthorRelationResponseCollection';
                data: Array<{
                  __typename?: 'AuthorEntity';
                  attributes?: {
                    __typename?: 'Author';
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: 'UploadFileEntityResponse';
                      data?: {
                        __typename?: 'UploadFileEntity';
                        attributes?: {
                          __typename?: 'UploadFile';
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        } | null;
                      } | null;
                    };
                  } | null;
                }>;
              } | null;
            }
          | { __typename: 'ComponentCommonBullet' }
          | { __typename: 'ComponentCommonDivider' }
          | { __typename: 'ComponentCommonDownloadableContentList' }
          | { __typename: 'ComponentCommonEmbedded' }
          | { __typename: 'ComponentCommonFaqComponent' }
          | { __typename: 'ComponentCommonH3' }
          | { __typename: 'ComponentCommonInPartnershipWith' }
          | { __typename: 'ComponentCommonMedia' }
          | { __typename: 'ComponentCommonQuote' }
          | { __typename: 'ComponentCommonRelatedContent' }
          | { __typename: 'ComponentCommonTags' }
          | { __typename: 'ComponentCommonTextEditor' }
          | { __typename: 'ComponentCommonTitle' }
          | { __typename: 'Error' }
          | null
        >;
      } | null;
    }>;
    meta: {
      __typename?: 'ResponseCollectionMeta';
      pagination: { __typename?: 'Pagination'; page: number; pageCount: number; total: number };
    };
  } | null;
};

export type LatestPodcastsByThemeQueryVariables = Exact<{
  theme: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type LatestPodcastsByThemeQuery = {
  __typename?: 'Query';
  podcasts?: {
    __typename?: 'PodcastEntityResponseCollection';
    data: Array<{
      __typename?: 'PodcastEntity';
      attributes?: {
        __typename?: 'Podcast';
        title: string;
        slug: string;
        publicationDate: any;
        subHeader?: string | null;
        briefDescription: string;
        guests?: {
          __typename?: 'GuestRelationResponseCollection';
          data: Array<{
            __typename?: 'GuestEntity';
            attributes?: { __typename?: 'Guest'; name?: string | null } | null;
          }>;
        } | null;
        listenings?: {
          __typename?: 'PodcastListeningTimeRelationResponseCollection';
          data: Array<{
            __typename?: 'PodcastListeningTimeEntity';
            id?: string | null;
            attributes?: { __typename?: 'PodcastListeningTime'; listeningTime: any; duration: any } | null;
          }>;
        } | null;
        themes?: {
          __typename?: 'ThemeRelationResponseCollection';
          data: Array<{
            __typename?: 'ThemeEntity';
            attributes?: {
              __typename?: 'Theme';
              theme?: string | null;
              topic?: {
                __typename?: 'TopicEntityResponse';
                data?: {
                  __typename?: 'TopicEntity';
                  attributes?: { __typename?: 'Topic'; topic?: string | null } | null;
                } | null;
              } | null;
            } | null;
          }>;
        } | null;
        cover: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        };
        DefaultContentTemplate: Array<
          | { __typename: 'ComponentCommonAudio' }
          | { __typename: 'ComponentCommonAuthor' }
          | {
              __typename: 'ComponentCommonAuthorDetailed';
              authors?: {
                __typename?: 'AuthorRelationResponseCollection';
                data: Array<{
                  __typename?: 'AuthorEntity';
                  attributes?: {
                    __typename?: 'Author';
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: 'UploadFileEntityResponse';
                      data?: {
                        __typename?: 'UploadFileEntity';
                        attributes?: {
                          __typename?: 'UploadFile';
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        } | null;
                      } | null;
                    };
                  } | null;
                }>;
              } | null;
            }
          | { __typename: 'ComponentCommonBullet' }
          | { __typename: 'ComponentCommonDivider' }
          | { __typename: 'ComponentCommonDownloadableContentList' }
          | { __typename: 'ComponentCommonEmbedded' }
          | { __typename: 'ComponentCommonFaqComponent' }
          | { __typename: 'ComponentCommonH3' }
          | { __typename: 'ComponentCommonInPartnershipWith' }
          | { __typename: 'ComponentCommonMedia' }
          | { __typename: 'ComponentCommonQuote' }
          | { __typename: 'ComponentCommonRelatedContent' }
          | { __typename: 'ComponentCommonTags' }
          | { __typename: 'ComponentCommonTextEditor' }
          | { __typename: 'ComponentCommonTitle' }
          | { __typename: 'Error' }
          | null
        >;
      } | null;
    }>;
    meta: { __typename?: 'ResponseCollectionMeta'; pagination: { __typename?: 'Pagination'; total: number } };
  } | null;
};

export type FetchLatestPodcastsQueryVariables = Exact<{
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type FetchLatestPodcastsQuery = {
  __typename?: 'Query';
  podcasts?: {
    __typename?: 'PodcastEntityResponseCollection';
    data: Array<{
      __typename?: 'PodcastEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'Podcast';
        title: string;
        slug: string;
        publicationDate: any;
        subHeader?: string | null;
        briefDescription: string;
        guests?: {
          __typename?: 'GuestRelationResponseCollection';
          data: Array<{
            __typename?: 'GuestEntity';
            attributes?: { __typename?: 'Guest'; name?: string | null } | null;
          }>;
        } | null;
        listenings?: {
          __typename?: 'PodcastListeningTimeRelationResponseCollection';
          data: Array<{
            __typename?: 'PodcastListeningTimeEntity';
            id?: string | null;
            attributes?: { __typename?: 'PodcastListeningTime'; listeningTime: any; duration: any } | null;
          }>;
        } | null;
        themes?: {
          __typename?: 'ThemeRelationResponseCollection';
          data: Array<{
            __typename?: 'ThemeEntity';
            attributes?: {
              __typename?: 'Theme';
              theme?: string | null;
              topic?: {
                __typename?: 'TopicEntityResponse';
                data?: {
                  __typename?: 'TopicEntity';
                  attributes?: { __typename?: 'Topic'; topic?: string | null } | null;
                } | null;
              } | null;
            } | null;
          }>;
        } | null;
        cover: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        };
        DefaultContentTemplate: Array<
          | { __typename: 'ComponentCommonAudio' }
          | { __typename: 'ComponentCommonAuthor' }
          | {
              __typename: 'ComponentCommonAuthorDetailed';
              authors?: {
                __typename?: 'AuthorRelationResponseCollection';
                data: Array<{
                  __typename?: 'AuthorEntity';
                  attributes?: {
                    __typename?: 'Author';
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: 'UploadFileEntityResponse';
                      data?: {
                        __typename?: 'UploadFileEntity';
                        attributes?: {
                          __typename?: 'UploadFile';
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        } | null;
                      } | null;
                    };
                  } | null;
                }>;
              } | null;
            }
          | { __typename: 'ComponentCommonBullet' }
          | { __typename: 'ComponentCommonDivider' }
          | { __typename: 'ComponentCommonDownloadableContentList' }
          | { __typename: 'ComponentCommonEmbedded' }
          | { __typename: 'ComponentCommonFaqComponent' }
          | { __typename: 'ComponentCommonH3' }
          | { __typename: 'ComponentCommonInPartnershipWith' }
          | { __typename: 'ComponentCommonMedia' }
          | { __typename: 'ComponentCommonQuote' }
          | { __typename: 'ComponentCommonRelatedContent' }
          | { __typename: 'ComponentCommonTags' }
          | { __typename: 'ComponentCommonTextEditor' }
          | { __typename: 'ComponentCommonTitle' }
          | { __typename: 'Error' }
          | null
        >;
      } | null;
    }>;
  } | null;
};

export type FindPodcastListeningTimeQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  podcastId: Scalars['ID']['input'];
}>;

export type FindPodcastListeningTimeQuery = {
  __typename?: 'Query';
  podcastListeningTimes?: {
    __typename?: 'PodcastListeningTimeEntityResponseCollection';
    data: Array<{
      __typename?: 'PodcastListeningTimeEntity';
      id?: string | null;
      attributes?: { __typename?: 'PodcastListeningTime'; listeningTime: any; duration: any } | null;
    }>;
  } | null;
};

export type PrivacyPolicyPageQueryVariables = Exact<{ [key: string]: never }>;

export type PrivacyPolicyPageQuery = {
  __typename?: 'Query';
  privacyPolicyPage?: {
    __typename?: 'PrivacyPolicyPageEntityResponse';
    data?: {
      __typename?: 'PrivacyPolicyPageEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'PrivacyPolicyPage';
        title: string;
        DefaultContentTemplate: Array<
          | {
              __typename: 'ComponentCommonAuthor';
              publicationDate: any;
              author?: {
                __typename?: 'AuthorEntityResponse';
                data?: {
                  __typename?: 'AuthorEntity';
                  attributes?: { __typename?: 'Author'; name: string } | null;
                } | null;
              } | null;
            }
          | {
              __typename: 'ComponentCommonAuthorDetailed';
              authors?: {
                __typename?: 'AuthorRelationResponseCollection';
                data: Array<{
                  __typename?: 'AuthorEntity';
                  attributes?: {
                    __typename?: 'Author';
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: 'UploadFileEntityResponse';
                      data?: {
                        __typename?: 'UploadFileEntity';
                        attributes?: {
                          __typename?: 'UploadFile';
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        } | null;
                      } | null;
                    };
                  } | null;
                }>;
              } | null;
            }
          | {
              __typename: 'ComponentCommonBullet';
              item: Array<{ __typename?: 'ComponentCommonList'; text: string } | null>;
            }
          | { __typename: 'ComponentCommonDivider'; id: string }
          | {
              __typename: 'ComponentCommonDownloadableContentList';
              list?: Array<{
                __typename?: 'ComponentCommonDownloadableContent';
                id: string;
                title: string;
                description?: string | null;
                content: {
                  __typename?: 'UploadFileEntityResponse';
                  data?: {
                    __typename?: 'UploadFileEntity';
                    attributes?: { __typename?: 'UploadFile'; url: string } | null;
                  } | null;
                };
              } | null> | null;
            }
          | { __typename: 'ComponentCommonEmbedded'; link: string; provider: Enum_Componentcommonembedded_Provider }
          | {
              __typename: 'ComponentCommonFaqComponent';
              faq?: Array<{ __typename?: 'ComponentCommonFaq'; title: string; description: string } | null> | null;
            }
          | { __typename: 'ComponentCommonH3'; text: string }
          | {
              __typename: 'ComponentCommonMedia';
              media: {
                __typename?: 'UploadFileEntityResponse';
                data?: {
                  __typename?: 'UploadFileEntity';
                  attributes?: { __typename?: 'UploadFile'; url: string; alternativeText?: string | null } | null;
                } | null;
              };
            }
          | { __typename: 'ComponentCommonQuote'; quote: string }
          | { __typename: 'ComponentCommonTextEditor'; markdownText?: string | null }
          | { __typename: 'ComponentCommonTitle'; title: string }
          | { __typename: 'Error' }
          | null
        >;
      } | null;
    } | null;
  } | null;
};

export type FindUsersPermissionsUserByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type FindUsersPermissionsUserByIdQuery = {
  __typename?: 'Query';
  usersPermissionsUser?: {
    __typename?: 'UsersPermissionsUserEntityResponse';
    data?: {
      __typename?: 'UsersPermissionsUserEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'UsersPermissionsUser';
        username: string;
        email: string;
        provider?: string | null;
        confirmed?: boolean | null;
        blocked?: boolean | null;
        onboardHomeCompleted: boolean;
        location?: string | null;
        forename?: string | null;
        surname?: string | null;
        confirmationEmailSent?: boolean | null;
        ageBracket?: string | null;
        gender?: string | null;
        onboardQuestionsCompleted: boolean;
        isEmotionWheelTrackingDisabled?: boolean | null;
        onboardMindfulMinuteCompleted: boolean;
        onboardEmotionWheelCompleted: boolean;
        profile?: string | null;
        createdAt?: any | null;
        school?: {
          __typename?: 'SchoolEntityResponse';
          data?: {
            __typename?: 'SchoolEntity';
            id?: string | null;
            attributes?: {
              __typename?: 'School';
              name: string;
              subscription?: {
                __typename?: 'SubscriptionEntityResponse';
                data?: {
                  __typename?: 'SubscriptionEntity';
                  attributes?: {
                    __typename?: 'Subscription';
                    name: string;
                    dailyBubble: boolean;
                    knowledgeHub?: boolean | null;
                    podcast: boolean;
                    learn: boolean;
                    meditation?: boolean | null;
                  } | null;
                } | null;
              } | null;
            } | null;
          } | null;
        } | null;
        ws_permission?: {
          __typename?: 'WsPermissionEntityResponse';
          data?: {
            __typename?: 'WsPermissionEntity';
            attributes?: {
              __typename?: 'WsPermission';
              name: string;
              isAdmin: boolean;
              isMAT?: boolean | null;
              adminManagement?: boolean | null;
              reportingDashboard?: boolean | null;
              surveyDashboard?: boolean | null;
              userManagement?: boolean | null;
              meditation?: boolean | null;
              knowledgeHub?: boolean | null;
              announcements?: boolean | null;
            } | null;
          } | null;
        } | null;
        photo?: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: { __typename?: 'UploadFile'; url: string; alternativeText?: string | null } | null;
          } | null;
        } | null;
        topics?: {
          __typename?: 'TopicRelationResponseCollection';
          data: Array<{
            __typename?: 'TopicEntity';
            id?: string | null;
            attributes?: { __typename?: 'Topic'; topic?: string | null } | null;
          }>;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type ProfilePageQueryVariables = Exact<{ [key: string]: never }>;

export type ProfilePageQuery = {
  __typename?: 'Query';
  profilePage?: {
    __typename?: 'ProfilePageEntityResponse';
    data?: {
      __typename?: 'ProfilePageEntity';
      attributes?: {
        __typename?: 'ProfilePage';
        welcomeTitle: string;
        profileInfoSection: {
          __typename?: 'ComponentProfileProfileInfoSection';
          memberSinceTitle: string;
          youLocationTitle: string;
          editYourInfoCta: string;
          saveYourChangesCta: string;
          surnamePlaceholder: string;
          forenamePlaceholder: string;
        };
        profilePasswordSection: {
          __typename?: 'ComponentProfileProfilePasswordSection';
          yourPasswordTitle: string;
          yourCurrentPasswordField: string;
          yourNewPasswordField: string;
          confirmYourPasswordField: string;
          confirmYourChangesCta: string;
        };
        profileNotificationsSection: {
          __typename?: 'ComponentProfileProfileNotificationsSection';
          yourNotificationsTitle: string;
          confirmYourChangesCta: string;
        };
        profileThemesSection: {
          __typename?: 'ComponentProfileProfileThemesSection';
          yourFocusTitle: string;
          whichAreasTitle: string;
          confirmYouChangesCta: string;
        };
        emotionTrackingSection?: {
          __typename?: 'ComponentProfileEmotionTrackingSection';
          title: string;
          btnStopTrackingLabel: string;
          btnStartTrackingLabel: string;
          notRecordedLabel: string;
          notRecordedDescription?: string | null;
          notRecordedIcon: {
            __typename?: 'UploadFileEntityResponse';
            data?: {
              __typename?: 'UploadFileEntity';
              attributes?: {
                __typename?: 'UploadFile';
                url: string;
                alternativeText?: string | null;
                mime: string;
              } | null;
            } | null;
          };
          notTrackingIcon: {
            __typename?: 'UploadFileEntityResponse';
            data?: {
              __typename?: 'UploadFileEntity';
              attributes?: {
                __typename?: 'UploadFile';
                url: string;
                alternativeText?: string | null;
                mime: string;
              } | null;
            } | null;
          };
        } | null;
        statsAndStreaks?: {
          __typename?: 'ComponentProfilePageStatsAndStreaks';
          finishingCardStreak?: {
            __typename?: 'ComponentProfilePageFinishingCardStreak';
            days?: string | null;
            title?: string | null;
          } | null;
          finishingCardMaxStreak?: {
            __typename?: 'ComponentProfilePageFinishingCardMaxStreak';
            days?: string | null;
            title?: string | null;
          } | null;
          finishingCardEmotionWheel?: {
            __typename?: 'ComponentProfilePageFinishingCardEmotions';
            emotions?: string | null;
          } | null;
          finishingCardInsight?: {
            __typename?: 'ComponentProfilePageFinishingCardInsights';
            insights?: string | null;
          } | null;
          finishingCardMindfulMinute?: {
            __typename?: 'ComponentProfilePageFinishingCardMindfulMinutes';
            minutes?: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type GetActiveUsersQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  schoolsIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  period?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetActiveUsersQuery = {
  __typename?: 'Query';
  getActiveUsers?: {
    __typename?: 'InteractionsGAGetActiveUsersData';
    totalUsers?: number | null;
    totalActiveUsers?: number | null;
    data?: Array<{
      __typename?: 'InteractionsGAGetActiveUsers';
      countUniqueUsers?: number | null;
      schoolId?: string | null;
      schoolName?: string | null;
      date?: string | null;
    } | null> | null;
  } | null;
};

export type MostUsedFeaturesQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  schoolsIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type MostUsedFeaturesQuery = {
  __typename?: 'Query';
  getFeatureUsage?: Array<{
    __typename?: 'SchoolFeatureUsage';
    schoolId?: string | null;
    schoolName?: string | null;
    features?: Array<{
      __typename?: 'FeatureUsage';
      feature?: string | null;
      pageViewsCount?: number | null;
    } | null> | null;
  }> | null;
};

export type FeatureFrequencyQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  schoolsIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  period?: InputMaybe<Scalars['String']['input']>;
}>;

export type FeatureFrequencyQuery = {
  __typename?: 'Query';
  getFeatureFrequency?: Array<{
    __typename?: 'SchoolFeatureFrequency';
    schoolId?: string | null;
    schoolName?: string | null;
    date?: string | null;
    features?: Array<{
      __typename?: 'FeatureFrequency';
      feature?: string | null;
      averageUseInSeconds?: number | null;
    } | null> | null;
  }> | null;
};

export type SchoolMoodQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  schoolsIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type SchoolMoodQuery = {
  __typename?: 'Query';
  getSchoolMood?: Array<{
    __typename?: 'SchoolMood';
    schoolId?: string | null;
    schoolName?: string | null;
    emotions?: Array<{
      __typename?: 'EmotionCount';
      emotion?: string | null;
      count?: number | null;
      type?: string | null;
      overallMoodIcon?: string | null;
    }> | null;
    data?: Array<{
      __typename?: 'MoodData';
      schoolId?: string | null;
      schoolName?: string | null;
      emotion?: string | null;
      type?: string | null;
      idUser?: string | null;
    }> | null;
  }> | null;
};

export type SchoolEngagementQueryVariables = Exact<{
  schoolsIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type SchoolEngagementQuery = {
  __typename?: 'Query';
  getSchoolEngagement: {
    __typename?: 'schoolEngagement';
    differenceInSeconds?: number | null;
    differenceInHoursMinutesAndSeconds?: string | null;
    increased?: boolean | null;
    percentage?: number | null;
  };
};

export type GetSurveyChangeQueryVariables = Exact<{
  schoolsIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type GetSurveyChangeQuery = {
  __typename?: 'Query';
  calculateSurveyResponseChange?: {
    __typename?: 'SurveyResponseChange';
    totalCurrentWeek?: number | null;
    totalPreviousWeek?: number | null;
    increase?: boolean | null;
  } | null;
};

export type FetchSearchPageQueryVariables = Exact<{ [key: string]: never }>;

export type FetchSearchPageQuery = {
  __typename?: 'Query';
  searchPage?: {
    __typename?: 'SearchPageEntityResponse';
    data?: {
      __typename?: 'SearchPageEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'SearchPage';
        title: string;
        searchBtn: string;
        yourResultsTitle: string;
        noRecordsFoundText: string;
        moreBtn: string;
      } | null;
    } | null;
  } | null;
};

export type FetchSearchCoursesPageableQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;

export type FetchSearchCoursesPageableQuery = {
  __typename?: 'Query';
  courses?: {
    __typename?: 'CourseEntityResponseCollection';
    data: Array<{
      __typename?: 'CourseEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'Course';
        title: string;
        slug?: string | null;
        description: string;
        duration?: string | null;
        thumbnail: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        };
        type?: {
          __typename?: 'CourseTypeEntityResponse';
          data?: {
            __typename?: 'CourseTypeEntity';
            attributes?: { __typename?: 'CourseType'; name: string } | null;
          } | null;
        } | null;
        course_category?: {
          __typename?: 'CourseCategoryEntityResponse';
          data?: {
            __typename?: 'CourseCategoryEntity';
            attributes?: { __typename?: 'CourseCategory'; name: string; description?: string | null } | null;
          } | null;
        } | null;
        modules?: Array<{
          __typename?: 'ComponentLearnCourseModule';
          id: string;
          lessons?: Array<{
            __typename?: 'ComponentLearnCourseLesson';
            id: string;
            authors?: {
              __typename?: 'AuthorRelationResponseCollection';
              data: Array<{
                __typename?: 'AuthorEntity';
                attributes?: {
                  __typename?: 'Author';
                  name: string;
                  role?: string | null;
                  bio?: string | null;
                  avatar: {
                    __typename?: 'UploadFileEntityResponse';
                    data?: {
                      __typename?: 'UploadFileEntity';
                      attributes?: {
                        __typename?: 'UploadFile';
                        url: string;
                        alternativeText?: string | null;
                        mime: string;
                      } | null;
                    } | null;
                  };
                } | null;
              }>;
            } | null;
          } | null> | null;
        } | null> | null;
      } | null;
    }>;
    meta: {
      __typename?: 'ResponseCollectionMeta';
      pagination: { __typename?: 'Pagination'; page: number; pageCount: number; total: number };
    };
  } | null;
};

export type FetchSearchLatestResourcesWithoutMetaPageableQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;

export type FetchSearchLatestResourcesWithoutMetaPageableQuery = {
  __typename?: 'Query';
  resources?: {
    __typename?: 'ResourceEntityResponseCollection';
    data: Array<{
      __typename?: 'ResourceEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'Resource';
        createdAt?: any | null;
        publishedAt?: any | null;
        title: string;
        slug: string;
        duration?: string | null;
        briefDescription: string;
        resourceType?: {
          __typename?: 'ResourceTypeEntityResponse';
          data?: {
            __typename?: 'ResourceTypeEntity';
            attributes?: { __typename?: 'ResourceType'; type: string } | null;
          } | null;
        } | null;
        themes?: {
          __typename?: 'ThemeRelationResponseCollection';
          data: Array<{
            __typename?: 'ThemeEntity';
            attributes?: {
              __typename?: 'Theme';
              theme?: string | null;
              topic?: {
                __typename?: 'TopicEntityResponse';
                data?: {
                  __typename?: 'TopicEntity';
                  attributes?: { __typename?: 'Topic'; topic?: string | null } | null;
                } | null;
              } | null;
            } | null;
          }>;
        } | null;
        cover: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        };
        DefaultContentTemplate: Array<
          | { __typename: 'ComponentCommonAuthor' }
          | {
              __typename: 'ComponentCommonAuthorDetailed';
              authors?: {
                __typename?: 'AuthorRelationResponseCollection';
                data: Array<{
                  __typename?: 'AuthorEntity';
                  attributes?: {
                    __typename?: 'Author';
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: 'UploadFileEntityResponse';
                      data?: {
                        __typename?: 'UploadFileEntity';
                        attributes?: {
                          __typename?: 'UploadFile';
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        } | null;
                      } | null;
                    };
                  } | null;
                }>;
              } | null;
            }
          | { __typename: 'ComponentCommonBullet' }
          | { __typename: 'ComponentCommonDivider' }
          | { __typename: 'ComponentCommonDownloadableContentList' }
          | { __typename: 'ComponentCommonEmbedded' }
          | { __typename: 'ComponentCommonFaqComponent' }
          | { __typename: 'ComponentCommonH3' }
          | { __typename: 'ComponentCommonMedia' }
          | { __typename: 'ComponentCommonQuote' }
          | { __typename: 'ComponentCommonRelatedContent' }
          | { __typename: 'ComponentCommonTags' }
          | { __typename: 'ComponentCommonTextEditor' }
          | { __typename: 'ComponentCommonTitle' }
          | { __typename: 'ComponentKnowledgeHubResourcesRelated' }
          | { __typename: 'Error' }
          | null
        >;
      } | null;
    }>;
    meta: {
      __typename?: 'ResponseCollectionMeta';
      pagination: { __typename?: 'Pagination'; page: number; pageCount: number; total: number };
    };
  } | null;
};

export type FetchSearchPodcastsPageableQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type FetchSearchPodcastsPageableQuery = {
  __typename?: 'Query';
  podcasts?: {
    __typename?: 'PodcastEntityResponseCollection';
    data: Array<{
      __typename?: 'PodcastEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'Podcast';
        title: string;
        slug: string;
        publicationDate: any;
        subHeader?: string | null;
        briefDescription: string;
        guests?: {
          __typename?: 'GuestRelationResponseCollection';
          data: Array<{
            __typename?: 'GuestEntity';
            attributes?: { __typename?: 'Guest'; name?: string | null } | null;
          }>;
        } | null;
        listenings?: {
          __typename?: 'PodcastListeningTimeRelationResponseCollection';
          data: Array<{
            __typename?: 'PodcastListeningTimeEntity';
            id?: string | null;
            attributes?: { __typename?: 'PodcastListeningTime'; listeningTime: any; duration: any } | null;
          }>;
        } | null;
        themes?: {
          __typename?: 'ThemeRelationResponseCollection';
          data: Array<{
            __typename?: 'ThemeEntity';
            attributes?: {
              __typename?: 'Theme';
              theme?: string | null;
              topic?: {
                __typename?: 'TopicEntityResponse';
                data?: {
                  __typename?: 'TopicEntity';
                  attributes?: { __typename?: 'Topic'; topic?: string | null } | null;
                } | null;
              } | null;
            } | null;
          }>;
        } | null;
        cover: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        };
        DefaultContentTemplate: Array<
          | { __typename: 'ComponentCommonAudio' }
          | { __typename: 'ComponentCommonAuthor' }
          | {
              __typename: 'ComponentCommonAuthorDetailed';
              authors?: {
                __typename?: 'AuthorRelationResponseCollection';
                data: Array<{
                  __typename?: 'AuthorEntity';
                  attributes?: {
                    __typename?: 'Author';
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: 'UploadFileEntityResponse';
                      data?: {
                        __typename?: 'UploadFileEntity';
                        attributes?: {
                          __typename?: 'UploadFile';
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        } | null;
                      } | null;
                    };
                  } | null;
                }>;
              } | null;
            }
          | { __typename: 'ComponentCommonBullet' }
          | { __typename: 'ComponentCommonDivider' }
          | { __typename: 'ComponentCommonDownloadableContentList' }
          | { __typename: 'ComponentCommonEmbedded' }
          | { __typename: 'ComponentCommonFaqComponent' }
          | { __typename: 'ComponentCommonH3' }
          | { __typename: 'ComponentCommonInPartnershipWith' }
          | { __typename: 'ComponentCommonMedia' }
          | { __typename: 'ComponentCommonQuote' }
          | { __typename: 'ComponentCommonRelatedContent' }
          | { __typename: 'ComponentCommonTags' }
          | { __typename: 'ComponentCommonTextEditor' }
          | { __typename: 'ComponentCommonTitle' }
          | { __typename: 'Error' }
          | null
        >;
      } | null;
    }>;
    meta: {
      __typename?: 'ResponseCollectionMeta';
      pagination: { __typename?: 'Pagination'; page: number; pageCount: number; total: number };
    };
  } | null;
};

export type FetchSearchCoursesPredictPageableQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;

export type FetchSearchCoursesPredictPageableQuery = {
  __typename?: 'Query';
  courses?: {
    __typename?: 'CourseEntityResponseCollection';
    data: Array<{
      __typename?: 'CourseEntity';
      id?: string | null;
      attributes?: { __typename?: 'Course'; title: string; slug?: string | null; description: string } | null;
    }>;
  } | null;
};

export type FetchSearchLatestResourcesPageableQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
}>;

export type FetchSearchLatestResourcesPageableQuery = {
  __typename?: 'Query';
  resources?: {
    __typename?: 'ResourceEntityResponseCollection';
    data: Array<{
      __typename?: 'ResourceEntity';
      id?: string | null;
      attributes?: { __typename?: 'Resource'; title: string; briefDescription: string } | null;
    }>;
    meta: {
      __typename?: 'ResponseCollectionMeta';
      pagination: { __typename?: 'Pagination'; page: number; pageCount: number; total: number };
    };
  } | null;
};

export type FetchSearchPodcastsWihoutMetaPageableQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;

export type FetchSearchPodcastsWihoutMetaPageableQuery = {
  __typename?: 'Query';
  podcasts?: {
    __typename?: 'PodcastEntityResponseCollection';
    data: Array<{
      __typename?: 'PodcastEntity';
      id?: string | null;
      attributes?: { __typename?: 'Podcast'; title: string; briefDescription: string } | null;
    }>;
  } | null;
};

export type SurveyMethodologyPageQueryVariables = Exact<{ [key: string]: never }>;

export type SurveyMethodologyPageQuery = {
  __typename?: 'Query';
  surveyMethodology?: {
    __typename?: 'SurveyMethodologyEntityResponse';
    data?: {
      __typename?: 'SurveyMethodologyEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'SurveyMethodology';
        pageTitle: string;
        DefaultContentTemplate: Array<
          | {
              __typename: 'ComponentCommonAuthor';
              publicationDate: any;
              author?: {
                __typename?: 'AuthorEntityResponse';
                data?: {
                  __typename?: 'AuthorEntity';
                  attributes?: { __typename?: 'Author'; name: string } | null;
                } | null;
              } | null;
            }
          | {
              __typename: 'ComponentCommonAuthorDetailed';
              authors?: {
                __typename?: 'AuthorRelationResponseCollection';
                data: Array<{
                  __typename?: 'AuthorEntity';
                  attributes?: {
                    __typename?: 'Author';
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: 'UploadFileEntityResponse';
                      data?: {
                        __typename?: 'UploadFileEntity';
                        attributes?: {
                          __typename?: 'UploadFile';
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        } | null;
                      } | null;
                    };
                  } | null;
                }>;
              } | null;
            }
          | {
              __typename: 'ComponentCommonBullet';
              item: Array<{ __typename?: 'ComponentCommonList'; text: string } | null>;
            }
          | { __typename: 'ComponentCommonDivider'; id: string }
          | {
              __typename: 'ComponentCommonDownloadableContentList';
              list?: Array<{
                __typename?: 'ComponentCommonDownloadableContent';
                id: string;
                title: string;
                description?: string | null;
                content: {
                  __typename?: 'UploadFileEntityResponse';
                  data?: {
                    __typename?: 'UploadFileEntity';
                    attributes?: { __typename?: 'UploadFile'; url: string } | null;
                  } | null;
                };
              } | null> | null;
            }
          | { __typename: 'ComponentCommonEmbedded'; link: string; provider: Enum_Componentcommonembedded_Provider }
          | {
              __typename: 'ComponentCommonFaqComponent';
              faq?: Array<{ __typename?: 'ComponentCommonFaq'; title: string; description: string } | null> | null;
            }
          | { __typename: 'ComponentCommonH3'; text: string }
          | {
              __typename: 'ComponentCommonMedia';
              media: {
                __typename?: 'UploadFileEntityResponse';
                data?: {
                  __typename?: 'UploadFileEntity';
                  attributes?: { __typename?: 'UploadFile'; url: string; alternativeText?: string | null } | null;
                } | null;
              };
            }
          | { __typename: 'ComponentCommonQuote'; quote: string }
          | { __typename: 'ComponentCommonTextEditor'; markdownText?: string | null }
          | { __typename: 'ComponentCommonTitle'; title: string }
          | { __typename: 'Error' }
          | null
        >;
      } | null;
    } | null;
  } | null;
};

export type SurveysResponsesQuestionsQueryVariables = Exact<{
  surveyId?: InputMaybe<Scalars['Int']['input']>;
  schoolIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
}>;

export type SurveysResponsesQuestionsQuery = {
  __typename?: 'Query';
  surveysResponsesQuestions?: {
    __typename?: 'SurveyQuestionsResponse';
    captions?: Array<{
      __typename?: 'SurveyCaption';
      key?: string | null;
      label?: string | null;
      color?: string | null;
    } | null> | null;
    schools?: Array<{ __typename?: 'SurveySchool'; id?: number | null; name?: string | null } | null> | null;
    data?: Array<{
      __typename?: 'SurveyQuestion';
      uniqueId?: string | null;
      question?: string | null;
      date?: string | null;
      measure?: string | null;
      responses?: number | null;
      answers?: Array<{
        __typename?: 'SurveyAnswerEntry';
        key?: string | null;
        answer?: {
          __typename?: 'SurveyAnswer';
          color?: string | null;
          label?: string | null;
          value?: number | null;
          percentage?: number | null;
        } | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type SurveysResponsesCategoriesQueryVariables = Exact<{
  surveyId?: InputMaybe<Scalars['Int']['input']>;
  schoolIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
}>;

export type SurveysResponsesCategoriesQuery = {
  __typename?: 'Query';
  surveysResponsesCategories?: {
    __typename?: 'SurveyCategoryResponse';
    captions?: Array<{
      __typename?: 'SurveyCaption';
      key?: string | null;
      label?: string | null;
      color?: string | null;
    } | null> | null;
    schools?: Array<{ __typename?: 'SurveySchool'; id?: number | null; name?: string | null } | null> | null;
    data?: Array<{
      __typename?: 'SurveyCategory';
      key?: string | null;
      responses?: number | null;
      questions?: number | null;
      measure?: string | null;
      answers?: Array<{
        __typename?: 'SurveyAnswerEntry';
        key?: string | null;
        answer?: {
          __typename?: 'SurveyAnswer';
          color?: string | null;
          label?: string | null;
          value?: number | null;
          percentage?: number | null;
        } | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type ListAllSurveysQueryVariables = Exact<{ [key: string]: never }>;

export type ListAllSurveysQuery = {
  __typename?: 'Query';
  surveysByUser?: Array<{
    __typename?: 'SurveysByUserResponse';
    id?: number | null;
    name?: string | null;
    startDate?: string | null;
    endDate?: string | null;
  } | null> | null;
};

export type SurveyDashboardPageQueryVariables = Exact<{ [key: string]: never }>;

export type SurveyDashboardPageQuery = {
  __typename?: 'Query';
  surveyDashboardPage?: {
    __typename?: 'SurveyDashboardPageEntityResponse';
    data?: {
      __typename?: 'SurveyDashboardPageEntity';
      attributes?: {
        __typename?: 'SurveyDashboardPage';
        notFoundMessage: string;
        schoolsFilter: {
          __typename?: 'ComponentSurveyDashboardSchoolsFilter';
          allSchools: string;
          schoolsSelected: string;
        };
        tabs: { __typename?: 'ComponentSurveyDashboardTabs'; surveyResponses: string; responseTable: string };
        tableQuestion: {
          __typename?: 'ComponentSurveyDashboardTableQuestion';
          day: string;
          date: string;
          questions: string;
          responses: string;
          answers: string;
        };
        tableCategories: {
          __typename?: 'ComponentSurveyDashboardTableCategories';
          questionCategory: string;
          responses: string;
          questions: string;
          answers: string;
        };
        tableResponses: {
          __typename?: 'ComponentSurveyDashboardTableResponses';
          category: string;
          date: string;
          question: string;
          total: string;
        };
        toggle: { __typename?: 'ComponentSurveyDashboardToggle'; questions: string; categories: string };
        downloadButton: { __typename?: 'ComponentSurveyDashboardDownloadButton'; text: string };
      } | null;
    } | null;
  } | null;
};

export type GetSurveyUsersDashboardQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
}>;

export type GetSurveyUsersDashboardQuery = {
  __typename?: 'Query';
  surveyUsers?: {
    __typename?: 'SurveyUserEntityResponseCollection';
    meta: { __typename?: 'ResponseCollectionMeta'; pagination: { __typename?: 'Pagination'; total: number } };
  } | null;
};

export type TermsAndConditionsPageQueryVariables = Exact<{ [key: string]: never }>;

export type TermsAndConditionsPageQuery = {
  __typename?: 'Query';
  termsAndConditionsPage?: {
    __typename?: 'TermsAndConditionsPageEntityResponse';
    data?: {
      __typename?: 'TermsAndConditionsPageEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'TermsAndConditionsPage';
        title: string;
        DefaultContentTemplate: Array<
          | {
              __typename: 'ComponentCommonAuthor';
              publicationDate: any;
              author?: {
                __typename?: 'AuthorEntityResponse';
                data?: {
                  __typename?: 'AuthorEntity';
                  attributes?: { __typename?: 'Author'; name: string } | null;
                } | null;
              } | null;
            }
          | {
              __typename: 'ComponentCommonAuthorDetailed';
              authors?: {
                __typename?: 'AuthorRelationResponseCollection';
                data: Array<{
                  __typename?: 'AuthorEntity';
                  attributes?: {
                    __typename?: 'Author';
                    name: string;
                    role?: string | null;
                    bio?: string | null;
                    avatar: {
                      __typename?: 'UploadFileEntityResponse';
                      data?: {
                        __typename?: 'UploadFileEntity';
                        attributes?: {
                          __typename?: 'UploadFile';
                          url: string;
                          alternativeText?: string | null;
                          mime: string;
                        } | null;
                      } | null;
                    };
                  } | null;
                }>;
              } | null;
            }
          | {
              __typename: 'ComponentCommonBullet';
              item: Array<{ __typename?: 'ComponentCommonList'; text: string } | null>;
            }
          | { __typename: 'ComponentCommonDivider'; id: string }
          | {
              __typename: 'ComponentCommonDownloadableContentList';
              list?: Array<{
                __typename?: 'ComponentCommonDownloadableContent';
                id: string;
                title: string;
                description?: string | null;
                content: {
                  __typename?: 'UploadFileEntityResponse';
                  data?: {
                    __typename?: 'UploadFileEntity';
                    attributes?: { __typename?: 'UploadFile'; url: string } | null;
                  } | null;
                };
              } | null> | null;
            }
          | { __typename: 'ComponentCommonEmbedded'; link: string; provider: Enum_Componentcommonembedded_Provider }
          | {
              __typename: 'ComponentCommonFaqComponent';
              faq?: Array<{ __typename?: 'ComponentCommonFaq'; title: string; description: string } | null> | null;
            }
          | { __typename: 'ComponentCommonH3'; text: string }
          | {
              __typename: 'ComponentCommonMedia';
              media: {
                __typename?: 'UploadFileEntityResponse';
                data?: {
                  __typename?: 'UploadFileEntity';
                  attributes?: { __typename?: 'UploadFile'; url: string; alternativeText?: string | null } | null;
                } | null;
              };
            }
          | { __typename: 'ComponentCommonQuote'; quote: string }
          | { __typename: 'ComponentCommonTextEditor'; markdownText?: string | null }
          | { __typename: 'ComponentCommonTitle'; title: string }
          | { __typename: 'Error' }
          | null
        >;
      } | null;
    } | null;
  } | null;
};

export type CurrentQuestionsQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentQuestionsQuery = {
  __typename?: 'Query';
  currentSurvey?: {
    __typename?: 'CurrentSurveyResult';
    survey?: { __typename?: 'SurveyEntity'; id?: string | null } | null;
    questions?: Array<{
      __typename?: 'QuestionEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'Question';
        question: string;
        scale?: {
          __typename?: 'ScaleEntityResponse';
          data?: {
            __typename?: 'ScaleEntity';
            attributes?: {
              __typename?: 'Scale';
              options?: Array<{
                __typename?: 'ComponentSurveyAnswers';
                scale?: number | null;
                option?: string | null;
              } | null> | null;
            } | null;
          } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type SubmitAnswerMutationVariables = Exact<{
  data: AnswerInput;
}>;

export type SubmitAnswerMutation = {
  __typename?: 'Mutation';
  createAnswer?: {
    __typename?: 'AnswerEntityResponse';
    data?: {
      __typename?: 'AnswerEntity';
      attributes?: { __typename?: 'Answer'; createdAt?: any | null } | null;
    } | null;
  } | null;
};

export type SubmitSurveyUserMutationVariables = Exact<{
  data: SurveyUserInput;
}>;

export type SubmitSurveyUserMutation = {
  __typename?: 'Mutation';
  createSurveyUser?: {
    __typename?: 'SurveyUserEntityResponse';
    data?: {
      __typename?: 'SurveyUserEntity';
      attributes?: { __typename?: 'SurveyUser'; createdAt?: any | null } | null;
    } | null;
  } | null;
};

export type WellbeingAwarenessDaysCalendarPageQueryVariables = Exact<{ [key: string]: never }>;

export type WellbeingAwarenessDaysCalendarPageQuery = {
  __typename?: 'Query';
  wellbeingAwarenessDaysCalendarPage?: {
    __typename?: 'WellbeingAwarenessDaysCalendarPageEntityResponse';
    data?: {
      __typename?: 'WellbeingAwarenessDaysCalendarPageEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'WellbeingAwarenessDaysCalendarPage';
        title: string;
        description?: string | null;
        downloadButtonText?: string | null;
        NoAwarenessDaysMonthText?: string | null;
        file?: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: { __typename?: 'UploadFile'; url: string } | null;
          } | null;
        } | null;
        calendarFeedbackMessage?: {
          __typename?: 'ComponentCalendarCalendarFeedbackMessage';
          calendarPermissionDenied?: string | null;
          calendarNotFound?: string | null;
          eventAlreadyExists?: string | null;
          eventAddedSuccessGoogle?: string | null;
          eventAddedSuccessApple?: string | null;
          eventAddedSuccessGeneric?: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CalendarByYearQueryVariables = Exact<{
  year: Scalars['Int']['input'];
}>;

export type CalendarByYearQuery = {
  __typename?: 'Query';
  calendars?: {
    __typename?: 'CalendarEntityResponseCollection';
    data: Array<{
      __typename?: 'CalendarEntity';
      attributes?: {
        __typename?: 'Calendar';
        year?: number | null;
        eventDays?: Array<{
          __typename?: 'ComponentCommonDays';
          startDate: any;
          name: string;
          wholeMonth?: boolean | null;
          endDate?: any | null;
          related_resource?: {
            __typename?: 'ResourceEntityResponse';
            data?: {
              __typename?: 'ResourceEntity';
              attributes?: { __typename?: 'Resource'; slug: string } | null;
            } | null;
          } | null;
          related_podcast?: {
            __typename?: 'PodcastEntityResponse';
            data?: {
              __typename?: 'PodcastEntity';
              attributes?: { __typename?: 'Podcast'; slug: string } | null;
            } | null;
          } | null;
        } | null> | null;
      } | null;
    }>;
  } | null;
};

export type GetWildcardAdminPageQueryVariables = Exact<{ [key: string]: never }>;

export type GetWildcardAdminPageQuery = {
  __typename?: 'Query';
  wildcardAdminPage?: {
    __typename?: 'WildcardAdminPageEntityResponse';
    data?: {
      __typename?: 'WildcardAdminPageEntity';
      attributes?: {
        __typename?: 'WildcardAdminPage';
        title: string;
        subHeader?: string | null;
        listTitle?: string | null;
        listDescription?: string | null;
        form?: {
          __typename?: 'ComponentWildcardAnnouncementForm';
          schoolsTitle?: string | null;
          schoolsDescription?: string | null;
          datesTitle?: string | null;
          datesDescription?: string | null;
          logoTitle?: string | null;
          logoDescription?: string | null;
          logoSelected?: string | null;
          logoUploadPrompt?: string | null;
          logoUploadBtn?: string | null;
          descriptionTitle?: string | null;
          descriptionSubtitle?: string | null;
          descriptionPlaceholder?: string | null;
          charactersLabel?: string | null;
          savingBtn?: string | null;
          updateBtn?: string | null;
          createBtn?: string | null;
          createSuccess?: string | null;
          createSuccessDescription?: string | null;
          createError?: string | null;
          updateSuccess?: string | null;
          updateSuccessDescription?: string | null;
          updateError?: string | null;
          logoRequired?: string | null;
          logoRequiredDescription?: string | null;
          defaultSchoolTitle?: string | null;
          validations?: {
            __typename?: 'ComponentWildcardValidation';
            startDateFuture?: string | null;
            endDateValid?: string | null;
            descriptionRequired?: string | null;
            descriptionMaxLength?: string | null;
            schoolRequired?: string | null;
            logoRequired?: string | null;
            logoSize?: string | null;
            logoDimensions?: string | null;
            endDateAfterStart?: string | null;
            dateRangeLimit?: string | null;
          } | null;
        } | null;
        actions?: {
          __typename?: 'ComponentWildcardAnnouncementActions';
          unpublishBtn?: string | null;
          publishBtn?: string | null;
          editBtn?: string | null;
          duplicateBtn?: string | null;
          deleteBtn?: string | null;
        } | null;
        deleteDialog?: {
          __typename?: 'ComponentWildcardAnnouncementDeleteDialog';
          title?: string | null;
          description?: string | null;
          confirmBtn?: string | null;
          cancelBtn?: string | null;
        } | null;
        preview?: {
          __typename?: 'ComponentWildcardAnnouncementPreview';
          like?: string | null;
          liveLabel?: string | null;
          scheduledLabel?: string | null;
          liveFromLabel?: string | null;
          untilLabel?: string | null;
          totalLikesLabel?: string | null;
          publishSuccess?: string | null;
          publishSuccessDescription?: string | null;
          publishError?: string | null;
          publishErrorDescription?: string | null;
          unpublishSuccess?: string | null;
          unpublishSuccessDescription?: string | null;
          unpublishError?: string | null;
          unpublishErrorDescription?: string | null;
          deleteSuccess?: string | null;
          deleteSuccessDescription?: string | null;
          deleteError?: string | null;
          deleteErrorDescription?: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type FetchMySchoolsQueryVariables = Exact<{
  asRegularUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type FetchMySchoolsQuery = {
  __typename?: 'Query';
  fetchMySchools?: Array<{
    __typename?: 'SchoolEntity';
    id?: string | null;
    attributes?: { __typename?: 'School'; name: string; code?: string | null } | null;
  }> | null;
};

export type ListWildCardsQueryVariables = Exact<{ [key: string]: never }>;

export type ListWildCardsQuery = {
  __typename?: 'Query';
  fetchWildcard?: Array<{
    __typename?: 'WildcardEntity';
    id?: string | null;
    attributes?: {
      __typename?: 'Wildcard';
      title?: string | null;
      startDate: any;
      endDate: any;
      description: string;
      status: Enum_Wildcard_Status;
      likes: any;
      ctaText: string;
      internal: boolean;
      image?: {
        __typename?: 'UploadFileEntityResponse';
        data?: {
          __typename?: 'UploadFileEntity';
          id?: string | null;
          attributes?: { __typename?: 'UploadFile'; url: string } | null;
        } | null;
      } | null;
      schools?: {
        __typename?: 'SchoolRelationResponseCollection';
        data: Array<{
          __typename?: 'SchoolEntity';
          id?: string | null;
          attributes?: { __typename?: 'School'; name: string } | null;
        }>;
      } | null;
      cta?: {
        __typename?: 'ComponentWildcardCta';
        redirectToCurrentInsight?: boolean | null;
        redirectToCurrentMindfulMinute?: boolean | null;
        redirectToCalendar?: boolean | null;
        redirectToEmotionWheel?: boolean | null;
        podcast?: {
          __typename?: 'PodcastEntityResponse';
          data?: { __typename?: 'PodcastEntity'; attributes?: { __typename?: 'Podcast'; slug: string } | null } | null;
        } | null;
        mindfulExercise?: {
          __typename?: 'MeditationEntityResponse';
          data?: {
            __typename?: 'MeditationEntity';
            attributes?: { __typename?: 'Meditation'; slug?: string | null } | null;
          } | null;
        } | null;
        course?: {
          __typename?: 'CourseEntityResponse';
          data?: {
            __typename?: 'CourseEntity';
            attributes?: { __typename?: 'Course'; slug?: string | null } | null;
          } | null;
        } | null;
        resource?: {
          __typename?: 'ResourceEntityResponse';
          data?: {
            __typename?: 'ResourceEntity';
            attributes?: { __typename?: 'Resource'; slug: string } | null;
          } | null;
        } | null;
      } | null;
    } | null;
  }> | null;
};

export type FetchWildcardsQueryVariables = Exact<{
  today: Scalars['Date']['input'];
}>;

export type FetchWildcardsQuery = {
  __typename?: 'Query';
  wildcards?: {
    __typename?: 'WildcardEntityResponseCollection';
    data: Array<{
      __typename?: 'WildcardEntity';
      id?: string | null;
      attributes?: {
        __typename?: 'Wildcard';
        startDate: any;
        endDate: any;
        description: string;
        likes: any;
        title?: string | null;
        ctaText: string;
        internal: boolean;
        cta?: {
          __typename?: 'ComponentWildcardCta';
          redirectToCurrentInsight?: boolean | null;
          redirectToCurrentMindfulMinute?: boolean | null;
          redirectToCalendar?: boolean | null;
          redirectToEmotionWheel?: boolean | null;
          podcast?: {
            __typename?: 'PodcastEntityResponse';
            data?: {
              __typename?: 'PodcastEntity';
              attributes?: { __typename?: 'Podcast'; slug: string } | null;
            } | null;
          } | null;
          mindfulExercise?: {
            __typename?: 'MeditationEntityResponse';
            data?: {
              __typename?: 'MeditationEntity';
              attributes?: { __typename?: 'Meditation'; slug?: string | null } | null;
            } | null;
          } | null;
          course?: {
            __typename?: 'CourseEntityResponse';
            data?: {
              __typename?: 'CourseEntity';
              attributes?: { __typename?: 'Course'; slug?: string | null } | null;
            } | null;
          } | null;
          resource?: {
            __typename?: 'ResourceEntityResponse';
            data?: {
              __typename?: 'ResourceEntity';
              attributes?: { __typename?: 'Resource'; slug: string } | null;
            } | null;
          } | null;
        } | null;
        image?: {
          __typename?: 'UploadFileEntityResponse';
          data?: {
            __typename?: 'UploadFileEntity';
            attributes?: {
              __typename?: 'UploadFile';
              url: string;
              alternativeText?: string | null;
              mime: string;
            } | null;
          } | null;
        } | null;
      } | null;
    }>;
  } | null;
};

export const DefaultContentTemplateFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DefaultContentTemplateFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'InsightDefaultContentTemplateDynamicZone' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ComponentCommonH3' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'text' } }],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ComponentCommonMedia' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'media' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'data' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'attributes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ComponentCommonTitle' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ComponentCommonAuthor' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'author' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'data' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'attributes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'publicationDate' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ComponentCommonDivider' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ComponentCommonEmbedded' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'link' } },
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ComponentCommonTextEditor' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'markdownText' } }],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ComponentCommonEmbedded' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'link' } },
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DefaultContentTemplateFragmentFragment, unknown>;
export const LearnFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LearnFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Learn' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users_permissions_user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'course' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'thumbnail' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'course_category' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'modules' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lessons' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'learn_items' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '999' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'idModule' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'idLesson' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LearnFragmentFragment, unknown>;
export const ImageFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImageFragmentFragment, unknown>;
export const PodcastBaseFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PodcastBaseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Podcast' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicationDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guests' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listenings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'listeningTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'subHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'themes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'theme' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'topic' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'topic' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cover' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DefaultContentTemplate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ComponentCommonAuthorDetailed' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'authors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'data' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'avatar' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: { kind: 'Name', value: 'ImageFragment' },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PodcastBaseFragmentFragment, unknown>;
export const ResourceBaseFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResourceBaseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resource' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resourceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'themes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'theme' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'topic' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'topic' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cover' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DefaultContentTemplate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ComponentCommonAuthorDetailed' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'authors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'data' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'avatar' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: { kind: 'Name', value: 'ImageFragment' },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResourceBaseFragmentFragment, unknown>;
export const SeoFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SeoFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ComponentSharedSeo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'metaTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metaImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metaSocial' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'socialNetwork' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'data' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'keywords' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaRobots' } },
          { kind: 'Field', name: { kind: 'Name', value: 'structuredData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaViewport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canonicalURL' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SeoFragmentFragment, unknown>;
export const TopicsBaseFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TopicsBaseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Topic' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'themes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'theme' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TopicsBaseFragmentFragment, unknown>;
export const CreateLoginTrackerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createLoginTracker' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'LoginTrackerInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createLoginTracker' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'streakCounter' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'day' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateLoginTrackerMutation, CreateLoginTrackerMutationVariables>;
export const LoginDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'login' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersPermissionsLoginInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'login' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'jwt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const RegisterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'register' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersPermissionsRegisterInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'register' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RegisterMutation, RegisterMutationVariables>;
export const ForgotPasswordDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'forgotPassword' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'forgotPassword' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'ok' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const ResetPasswordDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'resetPassword' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'passwordConfirmation' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resetPassword' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'password' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'passwordConfirmation' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'passwordConfirmation' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'code' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'jwt' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const CompletedTaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'completedTask' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CompletedTaskInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCompletedTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompletedTaskMutation, CompletedTaskMutationVariables>;
export const AddFavoriteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'addFavorite' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'FavoriteInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createFavorite' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddFavoriteMutation, AddFavoriteMutationVariables>;
export const DeleteFavoriteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteFavorite' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteFavorite' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteFavoriteMutation, DeleteFavoriteMutationVariables>;
export const CompleteLessonDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'completeLesson' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'idLesson' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'idModule' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'idLearn' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createLearnItem' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'idModule' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'idModule' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'idLesson' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'idLesson' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'learn' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'idLearn' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'learn' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'LearnFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LearnFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Learn' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users_permissions_user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'course' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'thumbnail' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'course_category' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'modules' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lessons' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'learn_items' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '999' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'idModule' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'idLesson' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompleteLessonMutation, CompleteLessonMutationVariables>;
export const CreateLearnDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createLearn' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'idUser' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'idCourse' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createLearn' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'users_permissions_user' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'idUser' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'course' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'idCourse' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LearnFragment' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LearnFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Learn' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users_permissions_user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'course' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'thumbnail' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'course_category' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'modules' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lessons' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'learn_items' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '999' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'idModule' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'idLesson' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateLearnMutation, CreateLearnMutationVariables>;
export const CompleteLearnDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'completeLearn' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'idLearn' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateLearn' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'idLearn' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'completed' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LearnFragment' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LearnFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Learn' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users_permissions_user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'course' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'thumbnail' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'course_category' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'modules' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lessons' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'learn_items' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '999' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'idModule' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'idLesson' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompleteLearnMutation, CompleteLearnMutationVariables>;
export const CreateCourseFeedbackDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createCourseFeedback' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CourseFeedbackInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCourseFeedback' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCourseFeedbackMutation, CreateCourseFeedbackMutationVariables>;
export const UpdateSchollTermDatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateSchollTermDates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SchoolInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSchool' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateSchollTermDatesMutation, UpdateSchollTermDatesMutationVariables>;
export const UpdateUsersPermissionsUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateUsersPermissionsUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersPermissionsUserInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUsersPermissionsUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUsersPermissionsUserMutation, UpdateUsersPermissionsUserMutationVariables>;
export const UpdateUserOnboardingWeeklyQuestionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateUserOnboardingWeeklyQuestions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersPermissionsUserInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUsersPermissionsUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'onboardQuestionsCompleted' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateUserOnboardingWeeklyQuestionsMutation,
  UpdateUserOnboardingWeeklyQuestionsMutationVariables
>;
export const UpdateUserTrackingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateUserTracking' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersPermissionsUserInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUsersPermissionsUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isEmotionWheelTrackingDisabled' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserTrackingMutation, UpdateUserTrackingMutationVariables>;
export const CreatePodcastInteractionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createPodcastInteraction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PodcastInteractionInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPodcastInteraction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreatePodcastInteractionMutation, CreatePodcastInteractionMutationVariables>;
export const CreatePodcastListeningTimeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createPodcastListeningTime' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PodcastListeningTimeInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPodcastListeningTime' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'listeningTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreatePodcastListeningTimeMutation, CreatePodcastListeningTimeMutationVariables>;
export const UpdatePodcastListeningTimeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updatePodcastListeningTime' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PodcastListeningTimeInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePodcastListeningTime' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePodcastListeningTimeMutation, UpdatePodcastListeningTimeMutationVariables>;
export const UpdateUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UsersPermissionsUserInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUsersPermissionsUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'username' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const ChangePasswordDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'changePassword' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'currentPassword' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'passwordConfirmation' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changePassword' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'currentPassword' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'currentPassword' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'password' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'passwordConfirmation' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'passwordConfirmation' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: '__typename' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const InsertWildcardDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InsertWildcard' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'WildcardInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createWildcard' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InsertWildcardMutation, InsertWildcardMutationVariables>;
export const UpdateWildcardDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateWildcard' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'WildcardInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateWildcard' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateWildcardMutation, UpdateWildcardMutationVariables>;
export const PublishWildcardDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PublishWildcard' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateWildcard' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status' },
                      value: { kind: 'EnumValue', value: 'PUBLISHED' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'status' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PublishWildcardMutation, PublishWildcardMutationVariables>;
export const UnpublishWildcardDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UnpublishWildcard' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateWildcard' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status' },
                      value: { kind: 'EnumValue', value: 'DRAFT' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'status' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UnpublishWildcardMutation, UnpublishWildcardMutationVariables>;
export const DeleteWildcardDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteWildcard' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateWildcard' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status' },
                      value: { kind: 'EnumValue', value: 'DELETED' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'status' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteWildcardMutation, DeleteWildcardMutationVariables>;
export const AboutPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'aboutPage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'aboutPage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'pageTitle' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'DefaultContentTemplate' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonH3' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'text' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonMedia' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'media' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'alternativeText' },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonTitle' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonAuthor' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'author' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'publicationDate' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonAuthorDetailed' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'authors' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'avatar' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'data' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageFragment' },
                                                                      },
                                                                    ],
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonDivider' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonEmbedded' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'link' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonTextEditor' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'markdownText' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonEmbedded' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'link' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonBullet' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'item' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'text' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonQuote' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'quote' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonFaqComponent' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'faq' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonDownloadableContentList' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'list' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'content' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'data' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'attributes' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AboutPageQuery, AboutPageQueryVariables>;
export const FetchUserTrackingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchUserTracking' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUserTrackingData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'dailyStreak' } },
                { kind: 'Field', name: { kind: 'Name', value: 'streakRecord' } },
                { kind: 'Field', name: { kind: 'Name', value: 'emotionsTracked' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchUserTrackingQuery, FetchUserTrackingQueryVariables>;
export const FetchLoginTrackerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchLoginTracker' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startDay' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endDay' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loginTrackers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'day' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'gte' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'startDay' } },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'lte' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'endDay' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'streakCounter' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'day' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchLoginTrackerQuery, FetchLoginTrackerQueryVariables>;
export const CookiesPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'cookiesPage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cookiesPage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'DefaultContentTemplate' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonH3' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'text' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonMedia' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'media' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'alternativeText' },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonTitle' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonAuthor' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'author' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'publicationDate' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonAuthorDetailed' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'authors' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'avatar' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'data' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageFragment' },
                                                                      },
                                                                    ],
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonDivider' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonEmbedded' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'link' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonTextEditor' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'markdownText' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonEmbedded' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'link' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonBullet' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'item' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'text' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonQuote' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'quote' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonFaqComponent' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'faq' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonDownloadableContentList' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'list' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'content' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'data' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'attributes' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CookiesPageQuery, CookiesPageQueryVariables>;
export const CopyrightPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'copyrightPage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'copyrightPage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'DefaultContentTemplate' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonH3' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'text' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonMedia' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'media' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'alternativeText' },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonTitle' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonAuthor' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'author' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'publicationDate' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonAuthorDetailed' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'authors' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'avatar' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'data' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageFragment' },
                                                                      },
                                                                    ],
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonDivider' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonEmbedded' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'link' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonTextEditor' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'markdownText' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonEmbedded' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'link' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonBullet' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'item' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'text' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonQuote' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'quote' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonFaqComponent' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'faq' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonDownloadableContentList' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'list' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'content' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'data' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'attributes' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CopyrightPageQuery, CopyrightPageQueryVariables>;
export const DailyTaskHasBeenCompletedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'dailyTaskHasBeenCompleted' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'day' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'relationID' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completedTasks' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'day' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'day' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'done' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'BooleanValue', value: true },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'relationID' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'relationID' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'metadata' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DailyTaskHasBeenCompletedQuery, DailyTaskHasBeenCompletedQueryVariables>;
export const DailyTrakingEmotionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'dailyTrakingEmotion' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startDay' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endDay' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emotionTracker' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startDay' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startDay' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endDay' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'endDay' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'emotion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'day' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDisabledTracking' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DailyTrakingEmotionQuery, DailyTrakingEmotionQueryVariables>;
export const GetUserTrackingDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUserTrackingData' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUserTrackingData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'dailyStreak' } },
                { kind: 'Field', name: { kind: 'Name', value: 'streakRecord' } },
                { kind: 'Field', name: { kind: 'Name', value: 'emotionsTracked' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserTrackingDataQuery, GetUserTrackingDataQueryVariables>;
export const FetchUserStreakDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchUserStreak' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchUserStreak' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'type' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'streak' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchUserStreakQuery, FetchUserStreakQueryVariables>;
export const DailyBubbleFinishedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DailyBubbleFinished' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dailyBubbleFinishedPage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'messageSection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'youAreDoneTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'comeBackTitle' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'continueYourWeelbeingJourneyTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'resourcesTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'resourceDescription' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'toolkitsTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'toolkitsDescription' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DailyBubbleFinishedQuery, DailyBubbleFinishedQueryVariables>;
export const HomePageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'HomePage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dailyBubblePage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'headerSection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sections' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'yourDailyBubbleTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'trendingThisWeekTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'yourWeeklyquestionTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'yourWeeklyQuestionDescription' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'yourWeeklyQuestionOnboardingTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'latestPodcastTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'learnTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'wildcardTitle' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'dailySection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'insightTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'insightDescription' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'insightBtnLabel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'mindfulMinuteTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'mindfulMinuteDescription' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'mindfulMinuteBtnLabel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'emotionWheelTItle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'emotionWheelDescription' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'emotionWheelBtnLabel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'dailyQuoteTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'prefixInsightCard' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'titleInsightCard' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'prefixMindfulMinuteCard' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'titleMindfulMinuteCard' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'onboardingQuestions' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'btnLabel' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'finishingCard' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'finishingCardEmotionWheel' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'trackAgain' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'yourCalendar' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'emotions' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'yourStreak' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'days' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'youHaveTracked' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'finishingCardInsight' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'insights' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'yourStreak' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'days' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'readAgain' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'youHaveRead' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'finishingCardMindfulMinute' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'minutes' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'yourStreak' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'days' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'startAgain' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'relatedContent' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'youHaveWatched' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'finishingCardSurvey' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'youHaveAnswered' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'questions' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'learnMore' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'hideThisCard' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HomePageQuery, HomePageQueryVariables>;
export const DailyInsightDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'dailyInsight' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'date' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insights' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'day' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'date' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'subHeader' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cover' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'themes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'theme' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'topic' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'data' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'attributes' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'topic' },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'day' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resource' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'DefaultContentTemplate' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonH3' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'text' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonTheme' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'theme' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonMedia' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'media' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'alternativeText' },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonTitle' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonButton' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'link' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonAuthor' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'author' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'publicationDate' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonAuthorDetailed' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'authors' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'avatar' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'data' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageFragment' },
                                                                      },
                                                                    ],
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonDivider' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonEmbedded' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'link' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonTranscript' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonTextEditor' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'markdownText' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonDownloadableContentList' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'list' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'content' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'data' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'attributes' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DailyInsightQuery, DailyInsightQueryVariables>;
export const InsightPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'insightPage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insightPage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'relatedContentViewAllLabel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'relatedContentTitle' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InsightPageQuery, InsightPageQueryVariables>;
export const EmotionWHeelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'emotionWHeel' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emotionWheels' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'typeSection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'mainGradientFrom' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'mainGradientTo' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'secondaryGradientFrom' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'secondaryGradientTo' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'emotion' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'L2' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'emotion' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'L3' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'emotion' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'advice' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'finalState' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'podcast' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'mindfulExercise' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'course' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'resource' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'redirectToCurrentInsight' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'redirectToCurrentMindfulMinute' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'redirectToCalendar' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'overallMoodIcon' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EmotionWHeelQuery, EmotionWHeelQueryVariables>;
export const EmotionWHeelPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'emotionWHeelPage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emotionWheelPage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'relatedContentTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'howAreYouFeelingTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'youAreTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'howAreYouTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'changeMyAnswerCta' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'wellDoneTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'goToYourMoodTracker' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'resetTheWheel' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'messages' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'initial' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'L1' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'L2' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'initialTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'L1Title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'L2Title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'privacyStatement' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'onboarding' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'steps' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'textBtn' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: { kind: 'Name', value: 'ImageFragment' },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'calendarTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'bottomText' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'EmotionNotFound' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'finalState' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'podcast' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'mindfulExercise' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'course' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'resource' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'redirectToCurrentInsight' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'redirectToCurrentMindfulMinute' },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'redirectToCalendar' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EmotionWHeelPageQuery, EmotionWHeelPageQueryVariables>;
export const WordPictureGamePageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'wordPictureGamePage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wordPictureGamePage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'canYouIdentifyTItle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maybeNextTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'correct' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'continueCta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'link' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'showMeTheAnswerCtaLabel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ordinaryMagicTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'gameTypeTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'whatIsItTitle' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WordPictureGamePageQuery, WordPictureGamePageQueryVariables>;
export const DailyGameDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'dailyGame' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'date' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wordPictureGames' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'day' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'date' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'word' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'day' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'picture' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tip' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DailyGameQuery, DailyGameQueryVariables>;
export const CurrentMindfulMinuteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'currentMindfulMinute' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'date' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mindfulMinutes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'date' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'date' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'calmBreathing' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'prompt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'spokenGuidance' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'data' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'attributes' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'prompt' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'prompt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'durationInSeconds' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'video' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'videoTitle' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'video' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'data' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'attributes' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CurrentMindfulMinuteQuery, CurrentMindfulMinuteQueryVariables>;
export const MindfulMinutePageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'mindfulMinutePage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mindfulMinutePage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'CalmBreathingPage' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'thankYouTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'backDailyBubbleButton' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'minutes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'minute' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'playButtonLabel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pauseButtonLabel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'stopButtonLabel' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'QuotePage' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'backDailyBubbleButton' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'startExerciseButton' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'thankYouTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'playButtonLabel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pauseButtonLabel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'stopButtonLabel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'restartButtonLabel' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'VideoPage' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'backDailyBubbleButton' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'thankYouTitle' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'relatedContentViewAllLabel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'relatedContentTitle' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'relatedContent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'topic' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'onboarding' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'steps' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'textBtn' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'image' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: { kind: 'Name', value: 'ImageFragment' },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mindfulExerciseRelatedContent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'subHeader' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'mindful_exercise_type' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'data' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'attributes' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'name' },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MindfulMinutePageQuery, MindfulMinutePageQueryVariables>;
export const QuotePageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'quotePage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'quotePage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'quoteOfTheDayTitle' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'link' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QuotePageQuery, QuotePageQueryVariables>;
export const QuoteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'quote' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'date' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateFilterInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'quotes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'date' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'date' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'quote' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'author' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'topic' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'topic' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'occupation' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'quoteWithLinks' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'links' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'podcast' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'data' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'attributes' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'mindfulExercise' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'data' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'attributes' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'course' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'data' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'attributes' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'resource' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'data' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'attributes' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'redirectToCurrentInsight' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'redirectToCurrentMindfulMinute' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'redirectToCalendar' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'redirectToEmotionWheel' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QuoteQuery, QuoteQueryVariables>;
export const FetchManageStaffPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FetchManageStaffPage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'manageUsersPage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'staffListTitle' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'staffEmptyState' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'staffStatus' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'pendingInviteMessage' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'invitedPendingSignUpMessage' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'registeredPendingOnboardingMessage' },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'registeredOnboardedMessage' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'invitedPendingSignUpColor' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'registeredPendingOnboardingColor' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'registeredOnboardedColor' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pendingInviteColor' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchManageStaffPageQuery, FetchManageStaffPageQueryVariables>;
export const SchoolChidrenDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'schoolChidren' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'asRegularUser' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchMySchools' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'asRegularUser' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'asRegularUser' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'schools' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'data' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SchoolChidrenQuery, SchoolChidrenQueryVariables>;
export const FetchPodcastsByIdsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchPodcastsByIds' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'podcasts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'StringValue', value: 'createdAt:desc', block: false },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'in' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PodcastBaseFragment' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PodcastBaseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Podcast' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicationDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guests' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listenings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'listeningTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'subHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'themes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'theme' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'topic' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'topic' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cover' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DefaultContentTemplate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ComponentCommonAuthorDetailed' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'authors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'data' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'avatar' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: { kind: 'Name', value: 'ImageFragment' },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchPodcastsByIdsQuery, FetchPodcastsByIdsQueryVariables>;
export const FetchResourcesByIdsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchResourcesByIds' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resources' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'StringValue', value: 'createdAt:desc', block: false },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'in' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResourceBaseFragment' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResourceBaseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resource' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resourceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'themes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'theme' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'topic' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'topic' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cover' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DefaultContentTemplate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ComponentCommonAuthorDetailed' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'authors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'data' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'avatar' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: { kind: 'Name', value: 'ImageFragment' },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchResourcesByIdsQuery, FetchResourcesByIdsQueryVariables>;
export const FavoritesPageableByUserIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'favoritesPageableByUserId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'size' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'favorites' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'pageSize' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'size' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'StringValue', value: 'createdAt:desc', block: false },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'relationId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'meta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pagination' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FavoritesPageableByUserIdQuery, FavoritesPageableByUserIdQueryVariables>;
export const ExistByRelationIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'existByRelationId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'relationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Long' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'favorites' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'relationId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'relationId' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExistByRelationIdQuery, ExistByRelationIdQueryVariables>;
export const FindByRelationIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'findByRelationId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'relationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Long' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'favorites' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'relationId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'relationId' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FindByRelationIdQuery, FindByRelationIdQueryVariables>;
export const FavouritePageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'favouritePage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'favouritePage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'yourFavouriteTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'podcastTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'noPodcastsFoundMsg' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'resourcesTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'noResourcesFoundMsg' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'removeFavourtieBtn' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'addFavourite' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'courseTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'noCoursesFoundMsg' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FavouritePageQuery, FavouritePageQueryVariables>;
export const QueryFooterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'QueryFooter' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'globalFooter' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'links' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'file' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'data' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'ImageFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stillHumanlogo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edwinGroupLogo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'linkedinUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'facebookUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'twitterUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'instagramUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'copyright' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QueryFooterQuery, QueryFooterQueryVariables>;
export const UsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'users' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'usersPermissionsUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'topics' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'topic' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UsersQuery, UsersQueryVariables>;
export const QueryMenuDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'QueryMenu' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'globalMenu' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'logo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'links' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QueryMenuQuery, QueryMenuQueryVariables>;
export const NotFoundPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'notFoundPage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notFoundPage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cta' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NotFoundPageQuery, NotFoundPageQueryVariables>;
export const QueryTermsAndConditionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'QueryTermsAndConditions' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termAndCondition' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QueryTermsAndConditionsQuery, QueryTermsAndConditionsQueryVariables>;
export const KnowledgeHubPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'knowledgeHubPage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'knowledgeHubPage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'topics' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'TopicsBaseFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'highlightOfTheWeekTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'highlightTopicLabel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'latestTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'moreButotnTItle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'chooseAThemeTitle' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'welcomePageMessage' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'highlights' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'ResourceBaseFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'searchSection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'searchInput' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'whatKindTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'chooseATopicTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'chooseCollectionTitle' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'topics' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'data' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'attributes' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'themes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'data' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'attributes' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'theme' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'types' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'contentTemplateLabels' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'downloadableContentLabel' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'highlightSections' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'trendingThisWeekSection' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'wellbeingAwarenessDaysSection' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'linkLabel' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'allTimePopularFavouritesSection' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TopicsBaseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Topic' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'themes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'theme' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResourceBaseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resource' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resourceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'themes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'theme' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'topic' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'topic' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cover' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DefaultContentTemplate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ComponentCommonAuthorDetailed' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'authors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'data' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'avatar' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: { kind: 'Name', value: 'ImageFragment' },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<KnowledgeHubPageQuery, KnowledgeHubPageQueryVariables>;
export const LatestResourcesByTopicDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'latestResourcesByTopic' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'topic' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'excludeId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resources' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'themes' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'topic' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'topic' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'eq' },
                                        value: { kind: 'Variable', name: { kind: 'Name', value: 'topic' } },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'not' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'excludeId' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'StringValue', value: 'publicationDate:desc', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResourceBaseFragment' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResourceBaseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resource' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resourceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'themes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'theme' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'topic' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'topic' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cover' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DefaultContentTemplate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ComponentCommonAuthorDetailed' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'authors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'data' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'avatar' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: { kind: 'Name', value: 'ImageFragment' },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LatestResourcesByTopicQuery, LatestResourcesByTopicQueryVariables>;
export const LatestResourcesByThemeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'latestResourcesByTheme' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'theme' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resources' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'themes' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'theme' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'theme' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'pageSize' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'page' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'StringValue', value: 'publicationDate:desc', block: false },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'publicationState' },
                value: { kind: 'EnumValue', value: 'LIVE' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResourceBaseFragment' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'meta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pagination' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pageCount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResourceBaseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resource' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resourceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'themes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'theme' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'topic' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'topic' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cover' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DefaultContentTemplate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ComponentCommonAuthorDetailed' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'authors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'data' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'avatar' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: { kind: 'Name', value: 'ImageFragment' },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LatestResourcesByThemeQuery, LatestResourcesByThemeQueryVariables>;
export const LatestResourcesByTypeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'latestResourcesByType' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'types' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resources' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'resourceType' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'type' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'in' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'types' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'pageSize' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'page' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'StringValue', value: 'publicationDate:desc', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResourceBaseFragment' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'meta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pagination' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pageCount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pageSize' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResourceBaseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resource' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resourceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'themes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'theme' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'topic' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'topic' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cover' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DefaultContentTemplate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ComponentCommonAuthorDetailed' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'authors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'data' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'avatar' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: { kind: 'Name', value: 'ImageFragment' },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LatestResourcesByTypeQuery, LatestResourcesByTypeQueryVariables>;
export const FetchMainLatestResourcesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchMainLatestResources' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resources' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'pageSize' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'StringValue', value: 'publicationDate:desc', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResourceBaseFragment' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResourceBaseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resource' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resourceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'themes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'theme' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'topic' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'topic' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cover' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DefaultContentTemplate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ComponentCommonAuthorDetailed' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'authors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'data' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'avatar' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: { kind: 'Name', value: 'ImageFragment' },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchMainLatestResourcesQuery, FetchMainLatestResourcesQueryVariables>;
export const FetchTrendingResourcesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchTrendingResources' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'trendingResources' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resourceType' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'data' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'themes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'data' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'theme' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'topic' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cover' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'data' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchTrendingResourcesQuery, FetchTrendingResourcesQueryVariables>;
export const FetchWellbeingAwarenessDaysResourcesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchWellbeingAwarenessDaysResources' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wellbeingAwarenessDaysResources' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resourceType' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'data' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'themes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'data' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'theme' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'topic' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cover' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'data' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchWellbeingAwarenessDaysResourcesQuery,
  FetchWellbeingAwarenessDaysResourcesQueryVariables
>;
export const FetchTopFavoriteResourcesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchTopFavoriteResources' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'topFavoriteResources' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resourceType' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'data' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'themes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'data' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'theme' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'topic' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cover' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'data' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchTopFavoriteResourcesQuery, FetchTopFavoriteResourcesQueryVariables>;
export const ResourceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'resource' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resources' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '1' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'StringValue', value: 'publicationDate:desc', block: false },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'in' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resourceType' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'subHeader' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cover' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'themes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'theme' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'topic' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'data' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'attributes' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'topic' },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'DefaultContentTemplate' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonH3' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'text' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonMedia' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'media' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'alternativeText' },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonTitle' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonAuthorDetailed' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'authors' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'avatar' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'data' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageFragment' },
                                                                      },
                                                                    ],
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentKnowledgeHubResourcesRelated' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'resources' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'ResourceBaseFragment' },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'exercises' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'briefDescription' },
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'mindful_exercise_type' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'data' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'attributes' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            {
                                                                              kind: 'Field',
                                                                              name: { kind: 'Name', value: 'name' },
                                                                            },
                                                                          ],
                                                                        },
                                                                      },
                                                                    ],
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'podcasts' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'publicationDate' },
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'guests' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'data' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'id' },
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'attributes' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            {
                                                                              kind: 'Field',
                                                                              name: { kind: 'Name', value: 'name' },
                                                                            },
                                                                          ],
                                                                        },
                                                                      },
                                                                    ],
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'subHeader' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'briefDescription' },
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'themes' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'data' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'id' },
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'attributes' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            {
                                                                              kind: 'Field',
                                                                              name: { kind: 'Name', value: 'theme' },
                                                                            },
                                                                            {
                                                                              kind: 'Field',
                                                                              name: { kind: 'Name', value: 'topic' },
                                                                              selectionSet: {
                                                                                kind: 'SelectionSet',
                                                                                selections: [
                                                                                  {
                                                                                    kind: 'Field',
                                                                                    name: {
                                                                                      kind: 'Name',
                                                                                      value: 'data',
                                                                                    },
                                                                                    selectionSet: {
                                                                                      kind: 'SelectionSet',
                                                                                      selections: [
                                                                                        {
                                                                                          kind: 'Field',
                                                                                          name: {
                                                                                            kind: 'Name',
                                                                                            value: 'id',
                                                                                          },
                                                                                        },
                                                                                        {
                                                                                          kind: 'Field',
                                                                                          name: {
                                                                                            kind: 'Name',
                                                                                            value: 'attributes',
                                                                                          },
                                                                                          selectionSet: {
                                                                                            kind: 'SelectionSet',
                                                                                            selections: [
                                                                                              {
                                                                                                kind: 'Field',
                                                                                                name: {
                                                                                                  kind: 'Name',
                                                                                                  value: 'topic',
                                                                                                },
                                                                                              },
                                                                                            ],
                                                                                          },
                                                                                        },
                                                                                      ],
                                                                                    },
                                                                                  },
                                                                                ],
                                                                              },
                                                                            },
                                                                          ],
                                                                        },
                                                                      },
                                                                    ],
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'cover' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'data' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'id' },
                                                                      },
                                                                      {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageFragment' },
                                                                      },
                                                                    ],
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonDivider' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonEmbedded' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'link' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonTextEditor' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'markdownText' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonEmbedded' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'link' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonBullet' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'item' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'text' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonQuote' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'quote' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonFaqComponent' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'faq' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonTags' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonRelatedContent' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonDownloadableContentList' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'list' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'content' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'data' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'attributes' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResourceBaseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resource' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resourceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'themes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'theme' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'topic' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'topic' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cover' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DefaultContentTemplate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ComponentCommonAuthorDetailed' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'authors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'data' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'avatar' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: { kind: 'Name', value: 'ImageFragment' },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResourceQuery, ResourceQueryVariables>;
export const FetchLatestResourcesPageableDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchLatestResourcesPageable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'kinds' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'theme' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'topic' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resources' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'pageSize' },
                      value: { kind: 'IntValue', value: '8' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'page' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'StringValue', value: 'publicationDate:desc', block: false },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'containsi' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'resourceType' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'type' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'in' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'kinds' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'themes' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'theme' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'theme' } },
                                },
                              ],
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'topic' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'topic' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'eq' },
                                        value: { kind: 'Variable', name: { kind: 'Name', value: 'topic' } },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResourceBaseFragment' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'meta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pagination' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pageCount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResourceBaseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resource' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resourceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'themes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'theme' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'topic' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'topic' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cover' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DefaultContentTemplate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ComponentCommonAuthorDetailed' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'authors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'data' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'avatar' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: { kind: 'Name', value: 'ImageFragment' },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchLatestResourcesPageableQuery, FetchLatestResourcesPageableQueryVariables>;
export const FetchLatestResourcesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchLatestResources' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resources' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '2' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'StringValue', value: 'publicationDate:desc', block: false },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'notIn' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResourceBaseFragment' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResourceBaseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resource' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resourceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'themes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'theme' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'topic' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'topic' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cover' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DefaultContentTemplate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ComponentCommonAuthorDetailed' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'authors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'data' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'avatar' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: { kind: 'Name', value: 'ImageFragment' },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchLatestResourcesQuery, FetchLatestResourcesQueryVariables>;
export const HighlightsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'highlights' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'knowledgeHubPage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'highlights' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'ResourceBaseFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResourceBaseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resource' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resourceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'themes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'theme' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'topic' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'topic' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cover' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DefaultContentTemplate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ComponentCommonAuthorDetailed' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'authors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'data' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'avatar' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: { kind: 'Name', value: 'ImageFragment' },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HighlightsQuery, HighlightsQueryVariables>;
export const CourseDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'course' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'courses' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '1' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'in' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'publicationState' },
                value: { kind: 'EnumValue', value: 'LIVE' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'textContent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'markdownText' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'course_category' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'courseCompletedSection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'thumbnail' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hero' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'modules' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lessons' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'textContent' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'markdownText' } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'thumbnail' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: { kind: 'Name', value: 'ImageFragment' },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'authors' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'avatar' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'data' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageFragment' },
                                                                      },
                                                                    ],
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CourseQuery, CourseQueryVariables>;
export const CourseLessonDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'courseLesson' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'courses' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '1' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'in' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'publicationState' },
                value: { kind: 'EnumValue', value: 'LIVE' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'feedbackQuestions' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'question' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'textContent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'markdownText' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'course_category' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'thumbnail' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hero' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'modules' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lessons' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'textContent' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'markdownText' } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'objectivesSection' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'objectives' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'thumbnail' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: { kind: 'Name', value: 'ImageFragment' },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'highlightContent' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'audio' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'audio' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'data' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'attributes' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'url' },
                                                                      },
                                                                    ],
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'transcription' } },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'embedded' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'link' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'image' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'media' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'data' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'attributes' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'url' },
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: {
                                                                          kind: 'Name',
                                                                          value: 'alternativeText',
                                                                        },
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'mime' },
                                                                      },
                                                                    ],
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'downloadableContent' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'content' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'data' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'attributes' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'faq' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'authors' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'avatar' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'data' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageFragment' },
                                                                      },
                                                                    ],
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CourseLessonQuery, CourseLessonQueryVariables>;
export const FetchLatestCoursesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchLatestCourses' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'courses' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '2' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'notIn' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'publicationState' },
                value: { kind: 'EnumValue', value: 'LIVE' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'thumbnail' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'modules' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lessons' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'authors' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'avatar' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'data' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageFragment' },
                                                                      },
                                                                    ],
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchLatestCoursesQuery, FetchLatestCoursesQueryVariables>;
export const FetchCoursesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchCourses' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'publishedAt' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          defaultValue: { kind: 'StringValue', value: 'publishedAt:asc', block: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'courses' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'publicationState' },
                value: { kind: 'EnumValue', value: 'LIVE' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'publishedAt' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'thumbnail' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'course_category' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'modules' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lessons' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'authors' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'avatar' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'data' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageFragment' },
                                                                      },
                                                                    ],
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchCoursesQuery, FetchCoursesQueryVariables>;
export const FetchCoursesPageableDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchCoursesPageable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'theme' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'topic' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'courses' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'pageSize' },
                      value: { kind: 'IntValue', value: '8' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'page' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'containsi' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'themes' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'theme' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'theme' } },
                                },
                              ],
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'topic' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'topic' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'eq' },
                                        value: { kind: 'Variable', name: { kind: 'Name', value: 'topic' } },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'publicationState' },
                value: { kind: 'EnumValue', value: 'LIVE' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'thumbnail' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'course_category' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'modules' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lessons' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'authors' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'avatar' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'data' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageFragment' },
                                                                      },
                                                                    ],
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'meta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pagination' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pageCount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchCoursesPageableQuery, FetchCoursesPageableQueryVariables>;
export const FetchLearnDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchLearn' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'idUser' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'completed' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'learn' },
            name: { kind: 'Name', value: 'learns' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'users_permissions_user' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'idUser' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'completed' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'completed' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LearnFragment' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LearnFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Learn' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users_permissions_user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'course' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'thumbnail' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'course_category' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'modules' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lessons' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'learn_items' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '999' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'idModule' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'idLesson' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchLearnQuery, FetchLearnQueryVariables>;
export const FetchCourseLearnDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchCourseLearn' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'idUser' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'courseSlug' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'learn' },
            name: { kind: 'Name', value: 'learns' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'users_permissions_user' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'idUser' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'course' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'slug' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'courseSlug' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LearnFragment' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LearnFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Learn' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users_permissions_user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'course' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'thumbnail' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'course_category' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'modules' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lessons' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'learn_items' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '999' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'idModule' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'idLesson' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchCourseLearnQuery, FetchCourseLearnQueryVariables>;
export const CoursePageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CoursePage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'coursePage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lesson' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'beginButtonLabel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'watchAgainButtonlabel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lockedButtonlabel' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CoursePageQuery, CoursePageQueryVariables>;
export const LearnPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LearnPage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'learnPage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'welcomePageMessage' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'searchSection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'searchInput' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'whatKindTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'chooseATopicTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'chooseCollectionTitle' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'topics' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'data' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'attributes' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'themes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'data' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'attributes' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'theme' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'types' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'emptyInProgressCoursesMessage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'emptyCompletedCoursesMessage' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'markLessonAsCompleteButton' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'markAsCompleteLabel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedLabel' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'markCourseAsCompleted' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'markAsCompleteLabel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedLabel' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'contentTemplateLabels' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'downloadableContentLabel' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LearnPageQuery, LearnPageQueryVariables>;
export const CourseFeedbackPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'courseFeedbackPage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'learnPage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'markCourseAsCompleted' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'completedLabel' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'feedbackSection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'submitYourFeedback' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'enterYourFeedback' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'sendFeedback' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'modalLeavePage' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'confirmButton' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'cancelButton' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CourseFeedbackPageQuery, CourseFeedbackPageQueryVariables>;
export const ForgotPasswordPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'forgotPasswordPage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'forgotPassword' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'logo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'forgotPasswordTItle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'letUsKnowDescription' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'yourEmail' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sendMeCta' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'backToLoginCta' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'chooseANewPasswordTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'passwordsShouldBeDescription' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'yourNewPassword' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'repeatYourPassword' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'resetMyPasswordCta' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'feedback' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'emailSent' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'passwordResetSuccess' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'passwordResetError' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ForgotPasswordPageQuery, ForgotPasswordPageQueryVariables>;
export const LoginPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'loginPage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loginPage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'logo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'loginTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'yourEmailTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'yourPasswordTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'rememberMeTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'loginCta' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'forgotYourPasswordCta' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'confirmEmailTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pleaseLoginTItle' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fieldErrors' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'identifierRequired' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'passwordRequired' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'popUpMessages' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'success' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'error' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LoginPageQuery, LoginPageQueryVariables>;
export const RegisterPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'registerPage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registerPage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'registerTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'yourEmail' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'schoolCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'yourFirstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'yourLastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'choosePassword' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'repeatYourPassword' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createYourAccountCta' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'welcomeToTItle' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'logo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'successRegisterPopUpTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'successRegisterPopUpMessage' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fieldErrors' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'surnameRequired' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'forenameRequired' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'emailRequired' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'schoolCodeRequired' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'passwordRequired' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'termsAndConditionsRequired' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'confirmPasswordRequired' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'confirmPasswordDidNotMatch' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'popUpMessages' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'success' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'error' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RegisterPageQuery, RegisterPageQueryVariables>;
export const MeditationDetailPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'meditationDetailPage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'meditationDetailPage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'startBtn' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pauseBtn' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stopBtn' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'youMayAlsoLikeTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'moreBtn' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'goToTheMeditationBtn' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'thankYou' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeditationDetailPageQuery, MeditationDetailPageQueryVariables>;
export const MeditationPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'meditationPage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'meditationPage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'header' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'data' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'ImageFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'moreBtn' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'goToTheMeditationBtn' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sectionLabel' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeditationPageQuery, MeditationPageQueryVariables>;
export const MeditationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'meditations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'meditations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'page' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'pageSize' },
                      value: { kind: 'IntValue', value: '5' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'StringValue', value: 'publicationDate:desc', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'subHeader' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mindful_exercise_type' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'meta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pagination' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pageCount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeditationsQuery, MeditationsQueryVariables>;
export const MeditationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'meditation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'meditations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '1' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'StringValue', value: 'publicationDate:desc', block: false },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'in' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'subHeader' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'presentedBy' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mindful_exercise_type' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'themes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'theme' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'topic' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'data' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'attributes' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'topic' },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'audio' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'transcription' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'audio' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'data' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'attributes' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'video' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'relatedContent' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'mindful_exercise_type' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'data' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'attributes' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'name' },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeditationQuery, MeditationQueryVariables>;
export const AdminOnboardingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AdminOnboarding' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminOnboarding' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'step1' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'buttonTxt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'data' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'attributes' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'step2' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'subTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'autumTermTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'springTerm' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'summerTerm' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'btnText' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'schoolManagement' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'welcomeTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'welcomeDescription' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'yourAccessCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'btnCopyCodeTxt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'shareCodeTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'sendEmailSubTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'btnShareCodeTxt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'downloadQrCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'downloadQrCodeDescription' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'btnDownloadPdf' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'copyPasteTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'copyTxtSubTItle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'btnCopyMessagTxt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'template' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'toastStaffInvitedTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'toastStaffInvitedDescription' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'toastStaffImportedTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'toastStaffImportedDescription' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'toastErrorDownloadingPDFTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'toastPDFDownloadedTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'toastPDFDownloadedDescription' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'tooltipCopiedMessage' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'btnInviteStaffTxt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'btnImportStaffWondeTxt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'orText' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'invitationUsingFile' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'uploadSpreadsheetBtn' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'seePreviewBtn' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'warningMsgDialog' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'dialogTitle' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'uploadFileBtn' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'sendInvitationBtn' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'closeBtn' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'button' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'invitationPreview' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'dialogTitle' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'closeBtn' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'sendInvitationBtn' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'userPreviewSurnameLabel' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'userPreviewForenameLabel' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'userPreviewEmailLabel' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'userPreviewNoStaffLabel' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'tabs' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'adminManagementTabName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'surveyDashboardTabName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'reportingDashboardTabName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'announcementsTabName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'manageStaffTabName' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'dashboard' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'allSchools' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'header' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'overallMood' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'engagementPastWeek' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'surveysResponse' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'totalUsers' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'chartsTitles' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'schoolMood' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'mostUsedFeatures' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'featureUsage' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'dailyUsers' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminOnboardingQuery, AdminOnboardingQueryVariables>;
export const OnBoardingPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'onBoardingPage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'onBoardingPage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'dailyBubbleTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'delvingDeeperTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'aboutYouTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'reachingYouTitle' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OnBoardingPageQuery, OnBoardingPageQueryVariables>;
export const OnBoardingStep1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'onBoardingStep1' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'step1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'content' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'data' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'attributes' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'button' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'link' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OnBoardingStep1Query, OnBoardingStep1QueryVariables>;
export const OnBoardingStep2Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'onBoardingStep2' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'step2' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'content' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'data' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'attributes' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'button' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'link' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OnBoardingStep2Query, OnBoardingStep2QueryVariables>;
export const OnBoardingStep3Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'onBoardingStep3' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'step3' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'content' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'data' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'attributes' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'button' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'link' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OnBoardingStep3Query, OnBoardingStep3QueryVariables>;
export const UpdateUserProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateUserProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'gender' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'location' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ageBracket' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUsersPermissionsUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'profile' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'profile' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'gender' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'gender' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'location' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'location' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ageBracket' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'ageBracket' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const OnBoardingStep4Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'onBoardingStep4' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'step4' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'content' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'data' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'attributes' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'button' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'link' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'roles' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'role' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ageBracket' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'options' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'option' } }],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'role' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'gender' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'options' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'option' } }],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'location' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'placeholder' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OnBoardingStep4Query, OnBoardingStep4QueryVariables>;
export const UpdateUserTopicsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateUserTopics' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'topics' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUsersPermissionsUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'topics' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'topics' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserTopicsMutation, UpdateUserTopicsMutationVariables>;
export const OnBoardingStep5Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'onBoardingStep5' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'step5' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'content' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'data' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'attributes' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'button' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'link' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OnBoardingStep5Query, OnBoardingStep5QueryVariables>;
export const PodcastDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'podcast' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'podcasts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '1' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'StringValue', value: 'publicationDate:desc', block: false },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'in' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'subHeader' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cover' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'listenings' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'filters' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'user' },
                                        value: {
                                          kind: 'ObjectValue',
                                          fields: [
                                            {
                                              kind: 'ObjectField',
                                              name: { kind: 'Name', value: 'id' },
                                              value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                  {
                                                    kind: 'ObjectField',
                                                    name: { kind: 'Name', value: 'eq' },
                                                    value: {
                                                      kind: 'Variable',
                                                      name: { kind: 'Name', value: 'userId' },
                                                    },
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'listeningTime' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'themes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'theme' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'topic' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'data' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'attributes' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'topic' },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'DefaultContentTemplate' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonH3' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'text' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonMedia' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'media' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'alternativeText' },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonTitle' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonAuthorDetailed' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'authors' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'avatar' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'data' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageFragment' },
                                                                      },
                                                                    ],
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonDivider' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonEmbedded' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'link' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonTextEditor' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'markdownText' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonEmbedded' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'link' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonBullet' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'item' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'text' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonQuote' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'quote' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonFaqComponent' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'faq' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonTags' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonRelatedContent' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonDownloadableContentList' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'list' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'content' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'data' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'attributes' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonAudio' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'transcription' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'audio' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonInPartnershipWith' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'partnership' } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PodcastQuery, PodcastQueryVariables>;
export const PodcastPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PodcastPage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'podcastPage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'intro' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'thumbnail' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'data' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'ImageFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'topics' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'TopicsBaseFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'latestTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'moreButotnTItle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'chooseAThemeTitle' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'getInTouchSection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'boxText' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'buttonText' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'titleModal' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'descriptionModal' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'emailPlaceholder' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'submitText' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'yourTextPlaceholder' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'thanksTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'thanksDescription' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'questionsSection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'boxText' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'buttonText' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'titleModal' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'descriptionModal' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'emailPlaceholder' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'submitText' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'yourTextPlaceholder' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'thanksTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'thanksDescription' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'guests' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'data' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'attributes' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TopicsBaseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Topic' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'themes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'theme' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PodcastPageQuery, PodcastPageQueryVariables>;
export const FetchPodcastsPageableDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchPodcastsPageable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'podcasts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'page' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'pageSize' },
                      value: { kind: 'IntValue', value: '5' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'StringValue', value: 'publicationDate:desc', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PodcastBaseFragment' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'meta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pagination' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pageCount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PodcastBaseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Podcast' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicationDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guests' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listenings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'listeningTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'subHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'themes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'theme' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'topic' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'topic' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cover' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DefaultContentTemplate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ComponentCommonAuthorDetailed' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'authors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'data' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'avatar' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: { kind: 'Name', value: 'ImageFragment' },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchPodcastsPageableQuery, FetchPodcastsPageableQueryVariables>;
export const LatestPodcastsByThemeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'latestPodcastsByTheme' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'theme' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'podcasts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'themes' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'theme' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'theme' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'StringValue', value: 'publicationDate:desc', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PodcastBaseFragment' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'meta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pagination' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PodcastBaseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Podcast' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicationDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guests' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listenings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'listeningTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'subHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'themes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'theme' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'topic' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'topic' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cover' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DefaultContentTemplate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ComponentCommonAuthorDetailed' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'authors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'data' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'avatar' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: { kind: 'Name', value: 'ImageFragment' },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LatestPodcastsByThemeQuery, LatestPodcastsByThemeQueryVariables>;
export const FetchLatestPodcastsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchLatestPodcasts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'podcasts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '2' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'StringValue', value: 'publicationDate:desc', block: false },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'slug' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'notIn' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PodcastBaseFragment' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PodcastBaseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Podcast' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicationDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guests' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listenings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'listeningTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'subHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'themes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'theme' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'topic' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'topic' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cover' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DefaultContentTemplate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ComponentCommonAuthorDetailed' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'authors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'data' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'avatar' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: { kind: 'Name', value: 'ImageFragment' },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchLatestPodcastsQuery, FetchLatestPodcastsQueryVariables>;
export const FindPodcastListeningTimeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'findPodcastListeningTime' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'podcastId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'podcastListeningTimes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'podcast' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'podcastId' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'listeningTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FindPodcastListeningTimeQuery, FindPodcastListeningTimeQueryVariables>;
export const PrivacyPolicyPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'privacyPolicyPage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'privacyPolicyPage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'DefaultContentTemplate' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonH3' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'text' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonMedia' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'media' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'alternativeText' },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonTitle' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonAuthor' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'author' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'publicationDate' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonAuthorDetailed' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'authors' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'avatar' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'data' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageFragment' },
                                                                      },
                                                                    ],
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonDivider' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonEmbedded' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'link' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonTextEditor' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'markdownText' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonEmbedded' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'link' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonBullet' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'item' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'text' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonQuote' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'quote' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonFaqComponent' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'faq' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonDownloadableContentList' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'list' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'content' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'data' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'attributes' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PrivacyPolicyPageQuery, PrivacyPolicyPageQueryVariables>;
export const FindUsersPermissionsUserByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'findUsersPermissionsUserById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'usersPermissionsUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'confirmed' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'blocked' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'onboardHomeCompleted' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'forename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'surname' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'confirmationEmailSent' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ageBracket' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'onboardQuestionsCompleted' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isEmotionWheelTrackingDisabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'onboardMindfulMinuteCompleted' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'onboardEmotionWheelCompleted' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'profile' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'school' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'subscription' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'data' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'attributes' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'name' },
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'dailyBubble' },
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'knowledgeHub' },
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'podcast' },
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'learn' },
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'meditation' },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ws_permission' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'isAdmin' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'isMAT' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'adminManagement' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'reportingDashboard' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'surveyDashboard' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'userManagement' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'meditation' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'knowledgeHub' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'announcements' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'school' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'subscription' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'data' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'attributes' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'name' },
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'dailyBubble' },
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'knowledgeHub' },
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'podcast' },
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'learn' },
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'meditation' },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'photo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'topics' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'topic' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FindUsersPermissionsUserByIdQuery, FindUsersPermissionsUserByIdQueryVariables>;
export const ProfilePageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'profilePage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profilePage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'welcomeTitle' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'profileInfoSection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'memberSinceTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'youLocationTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'editYourInfoCta' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'saveYourChangesCta' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'surnamePlaceholder' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'forenamePlaceholder' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'profilePasswordSection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'yourPasswordTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'yourCurrentPasswordField' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'yourNewPasswordField' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'confirmYourPasswordField' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'confirmYourChangesCta' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'profileNotificationsSection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'yourNotificationsTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'confirmYourChangesCta' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'profileThemesSection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'yourFocusTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'whichAreasTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'confirmYouChangesCta' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'emotionTrackingSection' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'btnStopTrackingLabel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'btnStartTrackingLabel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'notRecordedLabel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'notRecordedDescription' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'notRecordedIcon' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'data' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'ImageFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'notTrackingIcon' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'data' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'ImageFragment' },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'statsAndStreaks' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'finishingCardStreak' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'days' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'finishingCardMaxStreak' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'days' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'finishingCardEmotionWheel' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'emotions' } }],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'finishingCardInsight' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'insights' } }],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'finishingCardMindfulMinute' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'minutes' } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProfilePageQuery, ProfilePageQueryVariables>;
export const GetActiveUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getActiveUsers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'schoolsIds' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'period' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getActiveUsers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'period' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'period' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'schoolsIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'schoolsIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalUsers' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalActiveUsers' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'countUniqueUsers' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'schoolId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'schoolName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetActiveUsersQuery, GetActiveUsersQueryVariables>;
export const MostUsedFeaturesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MostUsedFeatures' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'schoolsIds' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getFeatureUsage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'schoolsIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'schoolsIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'schoolId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'schoolName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'features' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'feature' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pageViewsCount' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MostUsedFeaturesQuery, MostUsedFeaturesQueryVariables>;
export const FeatureFrequencyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FeatureFrequency' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'schoolsIds' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'period' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getFeatureFrequency' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'schoolsIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'schoolsIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'period' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'period' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'schoolId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'schoolName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'features' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'feature' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'averageUseInSeconds' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FeatureFrequencyQuery, FeatureFrequencyQueryVariables>;
export const SchoolMoodDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SchoolMood' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'schoolsIds' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSchoolMood' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'schoolsIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'schoolsIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'schoolId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'schoolName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'emotions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'emotion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'overallMoodIcon' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'schoolId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'schoolName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'emotion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'idUser' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SchoolMoodQuery, SchoolMoodQueryVariables>;
export const SchoolEngagementDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SchoolEngagement' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'schoolsIds' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSchoolEngagement' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'schoolsIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'schoolsIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'differenceInSeconds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'differenceInHoursMinutesAndSeconds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'increased' } },
                { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SchoolEngagementQuery, SchoolEngagementQueryVariables>;
export const GetSurveyChangeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSurveyChange' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'schoolsIds' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'calculateSurveyResponseChange' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'schoolsIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'schoolsIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCurrentWeek' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalPreviousWeek' } },
                { kind: 'Field', name: { kind: 'Name', value: 'increase' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSurveyChangeQuery, GetSurveyChangeQueryVariables>;
export const FetchSearchPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchSearchPage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchPage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'searchBtn' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'yourResultsTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'noRecordsFoundText' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'moreBtn' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchSearchPageQuery, FetchSearchPageQueryVariables>;
export const FetchSearchCoursesPageableDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchSearchCoursesPageable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'courses' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'pageSize' },
                      value: { kind: 'IntValue', value: '4' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'page' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'or' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'title' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'containsi' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'description' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'containsi' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'publicationState' },
                value: { kind: 'EnumValue', value: 'LIVE' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'thumbnail' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'course_category' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'modules' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lessons' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'authors' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'avatar' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'data' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageFragment' },
                                                                      },
                                                                    ],
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'meta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pagination' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pageCount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchSearchCoursesPageableQuery, FetchSearchCoursesPageableQueryVariables>;
export const FetchSearchLatestResourcesWithoutMetaPageableDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchSearchLatestResourcesWithoutMetaPageable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resources' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'pageSize' },
                      value: { kind: 'IntValue', value: '4' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'page' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'or' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'title' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'containsi' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'briefDescription' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'containsi' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ResourceBaseFragment' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'meta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pagination' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pageCount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ResourceBaseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Resource' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resourceType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'themes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'theme' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'topic' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'topic' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cover' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DefaultContentTemplate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ComponentCommonAuthorDetailed' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'authors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'data' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'avatar' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: { kind: 'Name', value: 'ImageFragment' },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchSearchLatestResourcesWithoutMetaPageableQuery,
  FetchSearchLatestResourcesWithoutMetaPageableQueryVariables
>;
export const FetchSearchPodcastsPageableDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchSearchPodcastsPageable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'podcasts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'page' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'pageSize' },
                      value: { kind: 'IntValue', value: '4' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'or' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'title' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'containsi' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'briefDescription' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'containsi' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'StringValue', value: 'publicationDate:desc', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PodcastBaseFragment' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'meta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pagination' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pageCount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PodcastBaseFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Podcast' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'publicationDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'guests' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listenings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'listeningTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'subHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'themes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'theme' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'topic' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'topic' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cover' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DefaultContentTemplate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ComponentCommonAuthorDetailed' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'authors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'data' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'avatar' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'FragmentSpread',
                                                      name: { kind: 'Name', value: 'ImageFragment' },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchSearchPodcastsPageableQuery, FetchSearchPodcastsPageableQueryVariables>;
export const FetchSearchCoursesPredictPageableDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchSearchCoursesPredictPageable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'courses' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'pageSize' },
                      value: { kind: 'IntValue', value: '4' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'page' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'containsi' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'publicationState' },
                value: { kind: 'EnumValue', value: 'LIVE' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchSearchCoursesPredictPageableQuery, FetchSearchCoursesPredictPageableQueryVariables>;
export const FetchSearchLatestResourcesPageableDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchSearchLatestResourcesPageable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'topic' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resources' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'pageSize' },
                      value: { kind: 'IntValue', value: '4' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'page' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'containsi' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'themes' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'topic' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'topic' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'eq' },
                                        value: { kind: 'Variable', name: { kind: 'Name', value: 'topic' } },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'meta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pagination' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'page' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pageCount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchSearchLatestResourcesPageableQuery, FetchSearchLatestResourcesPageableQueryVariables>;
export const FetchSearchPodcastsWihoutMetaPageableDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchSearchPodcastsWihoutMetaPageable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'podcasts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'page' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'pageSize' },
                      value: { kind: 'IntValue', value: '4' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'containsi' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'StringValue', value: 'publicationDate:desc', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'briefDescription' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchSearchPodcastsWihoutMetaPageableQuery,
  FetchSearchPodcastsWihoutMetaPageableQueryVariables
>;
export const SurveyMethodologyPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'surveyMethodologyPage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'surveyMethodology' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'pageTitle' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'DefaultContentTemplate' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonH3' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'text' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonMedia' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'media' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'alternativeText' },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonTitle' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonAuthor' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'author' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'publicationDate' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonAuthorDetailed' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'authors' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'avatar' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'data' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageFragment' },
                                                                      },
                                                                    ],
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonDivider' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonEmbedded' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'link' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonTextEditor' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'markdownText' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonEmbedded' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'link' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonBullet' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'item' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'text' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonQuote' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'quote' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonFaqComponent' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'faq' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonDownloadableContentList' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'list' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'content' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'data' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'attributes' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SurveyMethodologyPageQuery, SurveyMethodologyPageQueryVariables>;
export const SurveysResponsesQuestionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'surveysResponsesQuestions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'surveyId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'schoolIds' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'surveysResponsesQuestions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'surveyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'surveyId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'schoolIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'schoolIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'captions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'schools' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uniqueId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'question' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'measure' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'responses' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'answers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'answer' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SurveysResponsesQuestionsQuery, SurveysResponsesQuestionsQueryVariables>;
export const SurveysResponsesCategoriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'surveysResponsesCategories' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'surveyId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'schoolIds' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'surveysResponsesCategories' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'surveyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'surveyId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'schoolIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'schoolIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'captions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'schools' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'responses' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'questions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'measure' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'answers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'answer' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SurveysResponsesCategoriesQuery, SurveysResponsesCategoriesQueryVariables>;
export const ListAllSurveysDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'listAllSurveys' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'surveysByUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListAllSurveysQuery, ListAllSurveysQueryVariables>;
export const SurveyDashboardPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'surveyDashboardPage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'surveyDashboardPage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'schoolsFilter' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'allSchools' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'schoolsSelected' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tabs' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'surveyResponses' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'responseTable' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tableQuestion' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'day' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'questions' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'responses' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'answers' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tableCategories' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'questionCategory' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'responses' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'questions' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'answers' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tableResponses' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'question' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'toggle' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'questions' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'categories' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'downloadButton' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'text' } }],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'notFoundMessage' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SurveyDashboardPageQuery, SurveyDashboardPageQueryVariables>;
export const GetSurveyUsersDashboardDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getSurveyUsersDashboard' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'surveyUsers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'answerDate' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'gte' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'lte' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'page' },
                      value: { kind: 'IntValue', value: '1' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'pageSize' },
                      value: { kind: 'IntValue', value: '1' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'meta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pagination' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'total' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSurveyUsersDashboardQuery, GetSurveyUsersDashboardQueryVariables>;
export const TermsAndConditionsPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'termsAndConditionsPage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termsAndConditionsPage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'DefaultContentTemplate' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonH3' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'text' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonMedia' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'media' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'alternativeText' },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonTitle' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonAuthor' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'author' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'publicationDate' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonAuthorDetailed' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'authors' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'data' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'attributes' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'avatar' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'data' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      {
                                                                        kind: 'FragmentSpread',
                                                                        name: { kind: 'Name', value: 'ImageFragment' },
                                                                      },
                                                                    ],
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonDivider' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonEmbedded' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'link' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonTextEditor' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'markdownText' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonEmbedded' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'link' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonBullet' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'item' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'text' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonQuote' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'quote' } }],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonFaqComponent' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'faq' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'ComponentCommonDownloadableContentList' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'list' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'content' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'data' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'attributes' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TermsAndConditionsPageQuery, TermsAndConditionsPageQueryVariables>;
export const CurrentQuestionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'currentQuestions' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentSurvey' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'survey' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'questions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'question' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'scale' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'options' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'scale' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'option' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CurrentQuestionsQuery, CurrentQuestionsQueryVariables>;
export const SubmitAnswerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'submitAnswer' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'AnswerInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAnswer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubmitAnswerMutation, SubmitAnswerMutationVariables>;
export const SubmitSurveyUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'submitSurveyUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SurveyUserInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createSurveyUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubmitSurveyUserMutation, SubmitSurveyUserMutationVariables>;
export const WellbeingAwarenessDaysCalendarPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'wellbeingAwarenessDaysCalendarPage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wellbeingAwarenessDaysCalendarPage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'downloadButtonText' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'file' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'calendarFeedbackMessage' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'calendarPermissionDenied' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'calendarNotFound' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'eventAlreadyExists' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'eventAddedSuccessGoogle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'eventAddedSuccessApple' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'eventAddedSuccessGeneric' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'NoAwarenessDaysMonthText' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WellbeingAwarenessDaysCalendarPageQuery, WellbeingAwarenessDaysCalendarPageQueryVariables>;
export const CalendarByYearDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'calendarByYear' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'year' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'calendars' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'year' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'year' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'eventDays' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'wholeMonth' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'related_resource' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'data' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'attributes' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'related_podcast' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'data' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'attributes' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CalendarByYearQuery, CalendarByYearQueryVariables>;
export const GetWildcardAdminPageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetWildcardAdminPage' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wildcardAdminPage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'subHeader' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'listTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'listDescription' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'form' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'schoolsTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'schoolsDescription' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'datesTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'datesDescription' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'logoTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'logoDescription' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'logoSelected' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'logoUploadPrompt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'logoUploadBtn' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'descriptionTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'descriptionSubtitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'descriptionPlaceholder' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'charactersLabel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'savingBtn' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updateBtn' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createBtn' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createSuccess' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createSuccessDescription' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createError' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updateSuccess' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updateSuccessDescription' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updateError' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'logoRequired' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'logoRequiredDescription' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultSchoolTitle' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'validations' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'startDateFuture' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'endDateValid' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'descriptionRequired' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'descriptionMaxLength' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'schoolRequired' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'logoRequired' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'logoSize' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'logoDimensions' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'endDateAfterStart' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'dateRangeLimit' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'actions' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'unpublishBtn' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'publishBtn' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'editBtn' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'duplicateBtn' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'deleteBtn' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'deleteDialog' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'confirmBtn' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'cancelBtn' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'preview' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'like' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'liveLabel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'scheduledLabel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'liveFromLabel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'untilLabel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'totalLikesLabel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'publishSuccess' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'publishSuccessDescription' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'publishError' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'publishErrorDescription' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'unpublishSuccess' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'unpublishSuccessDescription' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'unpublishError' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'unpublishErrorDescription' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'deleteSuccess' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'deleteSuccessDescription' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'deleteError' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'deleteErrorDescription' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetWildcardAdminPageQuery, GetWildcardAdminPageQueryVariables>;
export const FetchMySchoolsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchMySchools' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'asRegularUser' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchMySchools' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'asRegularUser' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'asRegularUser' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchMySchoolsQuery, FetchMySchoolsQueryVariables>;
export const ListWildCardsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListWildCards' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchWildcard' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attributes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'likes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'data' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'internal' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'schools' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'data' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'attributes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cta' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'podcast' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mindfulExercise' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'course' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resource' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'attributes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'slug' } }],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'redirectToCurrentInsight' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'redirectToCurrentMindfulMinute' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'redirectToCalendar' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'redirectToEmotionWheel' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListWildCardsQuery, ListWildCardsQueryVariables>;
export const FetchWildcardsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchWildcards' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'today' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wildcards' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'startDate' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'lte' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'today' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'endDate' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'gte' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'today' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'StringValue', value: 'PUBLISHED', block: false },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'likes' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ctaText' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'internal' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'podcast' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'data' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'attributes' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'mindfulExercise' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'data' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'attributes' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'course' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'data' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'attributes' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'resource' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'data' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'attributes' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'redirectToCurrentInsight' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'redirectToCurrentMindfulMinute' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'redirectToCalendar' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'redirectToEmotionWheel' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ImageFragment' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ImageFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileEntity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attributes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'alternativeText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchWildcardsQuery, FetchWildcardsQueryVariables>;
